// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/rsuite/dist/rsuite.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23636f83%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 21, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%237a2ba3%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232eb85c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2831, 18, 36, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--cui-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23360051%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844.4, 55.5, 74, 0.95%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27currentColor%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.38%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.92%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.65%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.92%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --thrana-color-primary-darkest: #2a0040;
  --thrana-color-primary: #3c005a;
  --thrana-color-primary-strong: #5c1680;
  --thrana-color-primary-light: #7a2ba3;
  --thrana-color-primary-tint: #f3ecf7;
  --thrana-color-primary-tint-2: #faf5fc;
  --thrana-color-canvas: #fafafa;
  --thrana-color-canvas-alt: #f8f7fa;
  --thrana-color-surface: #ffffff;
  --thrana-color-border: #eeeeee;
  --thrana-color-border-strong: #e0e0e0;
  --thrana-color-text: #1f1224;
  --thrana-color-text-secondary: #6b6470;
  --thrana-color-text-muted: #9a93a0;
  --thrana-color-success: #1a7f4b;
  --thrana-color-success-tint: #e6f4ec;
  --thrana-color-danger: #b3261e;
  --thrana-color-danger-tint: #fbeceb;
  --thrana-color-warning: #9a6700;
  --thrana-color-warning-tint: #fdf3d9;
  --thrana-color-neutral-tint: #eef0f2;
  --thrana-color-neutral-text: #5f6368;
  --thrana-space-1: 4px;
  --thrana-space-2: 8px;
  --thrana-space-3: 12px;
  --thrana-space-4: 16px;
  --thrana-space-5: 24px;
  --thrana-space-6: 32px;
  --thrana-radius-sm: 6px;
  --thrana-radius-md: 8px;
  --thrana-radius-lg: 12px;
  --thrana-radius-pill: 999px;
  --thrana-shadow-xs: 0 1px 2px rgba(20, 0, 30, 0.04);
  --thrana-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --thrana-shadow-md: 0 4px 12px rgba(60, 0, 90, 0.08);
  --thrana-shadow-lg: 0 8px 24px rgba(60, 0, 90, 0.14);
  --thrana-shadow-focus-ring: 0 0 0 3px rgba(60, 0, 90, 0.18);
  --thrana-font-family-base: Inter, Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  --thrana-transition-fast: 150ms ease;
  --thrana-transition-base: 200ms ease;
}

/* RSuite Checkbox Overrides */
:root {
  --rs-primary-500: #3c005a !important;
  --rs-primary-600: #3c005a !important;
  --rs-primary-700: #3c005a !important;
}

.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker::before {
  background-color: var(--rs-primary-500) !important;
}

.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker:hover {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker:focus {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker:active {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

/* Override the checkmark */
.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker::before {
  background-color: var(--rs-primary-500) !important;
}

/* Override the checkbox input */
.rs-checkbox-wrapper .rs-checkbox input[type=checkbox]:checked + .rs-checkbox-checker {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

/* Override any inline styles */
[style*="background-color: rgb(51, 153, 255)"],
[style*="background-color: #3399ff"],
[style*="border-color: rgb(51, 153, 255)"],
[style*="border-color: #3399ff"] {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

/* RSuite Radio Button Overrides */
.rs-radio-wrapper .rs-radio-checked .rs-radio-checker {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

.rs-radio-wrapper .rs-radio-checked .rs-radio-checker::before {
  background-color: var(--rs-primary-500) !important;
}

.rs-radio-wrapper .rs-radio-checked .rs-radio-checker:hover {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

.rs-radio-wrapper .rs-radio-checked .rs-radio-checker:focus {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

.rs-radio-wrapper .rs-radio-checked .rs-radio-checker:active {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

/* Override the radio input */
.rs-radio-wrapper .rs-radio input[type=radio]:checked + .rs-radio-checker {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

/* Override radio button inline styles */
.rs-radio-wrapper [style*="background-color: rgb(51, 153, 255)"],
.rs-radio-wrapper [style*="background-color: #3399ff"],
.rs-radio-wrapper [style*="border-color: rgb(51, 153, 255)"],
.rs-radio-wrapper [style*="border-color: #3399ff"] {
  background-color: var(--rs-primary-500) !important;
  border-color: var(--rs-primary-500) !important;
}

/*!
 * CoreUI  v4.3.0 (https://coreui.io)
 * Copyright (c) 2023 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
 */
:root {
  --cui-blue: #0d6efd;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #dc3545;
  --cui-orange: #fd7e14;
  --cui-yellow: #ffc107;
  --cui-green: #198754;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #000015;
  --cui-white: #fff;
  --cui-gray: #8a93a2;
  --cui-gray-dark: #636f83;
  --cui-gray-100: #ebedef;
  --cui-gray-200: #d8dbe0;
  --cui-gray-300: #c4c9d0;
  --cui-gray-400: #b1b7c1;
  --cui-gray-500: #9da5b1;
  --cui-gray-600: #8a93a2;
  --cui-gray-700: #768192;
  --cui-gray-800: #636f83;
  --cui-gray-900: #4f5d73;
  --cui-primary: #3c005a;
  --cui-secondary: #8a8388;
  --cui-success: #2eb85c;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #ebedef;
  --cui-dark: #4f5d73;
  --cui-primary-rgb: 60, 0, 90;
  --cui-secondary-rgb: 138, 131, 136;
  --cui-success-rgb: 46, 184, 92;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 235, 237, 239;
  --cui-dark-rgb: 79, 93, 115;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 0, 0, 21;
  --cui-body-color-rgb: 31, 18, 36;
  --cui-body-bg-rgb: 250, 250, 250;
  --cui-font-sans-serif: "Inter", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: "Inter", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  --cui-body-font-size: 0.875rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: #1f1224;
  --cui-body-color-rgb: 31, 18, 36;
  --cui-body-bg: #fafafa;
  --cui-body-bg-rgb: 250, 250, 250;
  --cui-emphasis-color: #000015;
  --cui-emphasis-color-rgb: 0, 0, 21;
  --cui-secondary-color: rgba(44.4, 55.5, 74, 0.681);
  --cui-secondary-color-rgb: 44, 56, 74;
  --cui-secondary-bg: #d8dbe0;
  --cui-secondary-bg-rgb: 216, 219, 224;
  --cui-tertiary-color: rgba(44.4, 55.5, 74, 0.38);
  --cui-tertiary-color-rgb: 44, 56, 74;
  --cui-tertiary-bg: #ebedef;
  --cui-tertiary-bg-rgb: 235, 237, 239;
  --cui-high-emphasis: rgba(44.4, 55.5, 74, 0.95);
  --cui-medium-emphasis: rgba(44.4, 55.5, 74, 0.681);
  --cui-disabled: rgba(44.4, 55.5, 74, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #3c005a;
  --cui-link-color-rgb: 60, 0, 90;
  --cui-link-decoration: underline;
  --cui-link-hover-color: #300048;
  --cui-link-hover-color-rgb: 48, 0, 72;
  --cui-code-color: #d63384;
  --cui-highlight-bg: rgb(255, 242.6, 205.4);
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #eeeeee;
  --cui-border-color-translucent: rgba(0, 0, 21, 0.175);
  --cui-border-radius: 8px;
  --cui-border-radius-sm: 6px;
  --cui-border-radius-lg: 12px;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 999px;
  --cui-box-shadow: 0 4px 12px rgba(60, 0, 90, 0.08);
  --cui-box-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --cui-box-shadow-lg: 0 8px 24px rgba(60, 0, 90, 0.14);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 21, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(60, 0, 90, 0.25);
  --cui-form-valid-color: #2eb85c;
  --cui-form-valid-border-color: #2eb85c;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--cui-body-font-family);
  font-size: var(--cui-body-font-size);
  font-weight: var(--cui-body-font-weight);
  line-height: var(--cui-body-line-height);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 21, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--cui-heading-color);
}

h1, .h1 {
  font-size: calc(1.34375rem + 1.125vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.1875rem;
  }
}

h2, .h2 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.75rem;
  }
}

h3, .h3 {
  font-size: calc(1.278125rem + 0.3375vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.53125rem;
  }
}

h4, .h4 {
  font-size: calc(1.25625rem + 0.075vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.3125rem;
  }
}

h5, .h5 {
  font-size: 1.09375rem;
}

h6, .h6 {
  font-size: 0.875rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
}
html:not([dir=rtl]) dd {
  margin-left: 0;
}
*[dir=rtl] dd {
  margin-right: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--cui-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --cui-link-color-rgb: var(--cui-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--cui-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, );
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--cui-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 6px;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: left;
}

th {
  font-weight: 600;
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

html:not([dir=rtl]) legend {
  float: left;
}
*[dir=rtl] legend {
  float: right;
}
legend {
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend {
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

*[dir=rtl] [type=tel],
*[dir=rtl] [type=url],
*[dir=rtl] [type=email],
*[dir=rtl] [type=number] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-1 {
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.2;
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.2;
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.2;
}

html:not([dir=rtl]) .list-unstyled {
  padding-left: 0;
}
*[dir=rtl] .list-unstyled {
  padding-right: 0;
}
.list-unstyled {
  list-style: none;
}

html:not([dir=rtl]) .list-inline {
  padding-left: 0;
}
*[dir=rtl] .list-inline {
  padding-right: 0;
}
.list-inline {
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
html:not([dir=rtl]) .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
*[dir=rtl] .list-inline-item:not(:last-child) {
  margin-left: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #8a93a2;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--cui-figure-caption-color, var(--cui-secondary-color));
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: md;
}

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-0.5 * var(--cui-gutter-x));
  margin-left: calc(-0.5 * var(--cui-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-top: var(--cui-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

html:not([dir=rtl]) .offset-1 {
  margin-left: 8.33333333%;
}
*[dir=rtl] .offset-1 {
  margin-right: 8.33333333%;
}

html:not([dir=rtl]) .offset-2 {
  margin-left: 16.66666667%;
}
*[dir=rtl] .offset-2 {
  margin-right: 16.66666667%;
}

html:not([dir=rtl]) .offset-3 {
  margin-left: 25%;
}
*[dir=rtl] .offset-3 {
  margin-right: 25%;
}

html:not([dir=rtl]) .offset-4 {
  margin-left: 33.33333333%;
}
*[dir=rtl] .offset-4 {
  margin-right: 33.33333333%;
}

html:not([dir=rtl]) .offset-5 {
  margin-left: 41.66666667%;
}
*[dir=rtl] .offset-5 {
  margin-right: 41.66666667%;
}

html:not([dir=rtl]) .offset-6 {
  margin-left: 50%;
}
*[dir=rtl] .offset-6 {
  margin-right: 50%;
}

html:not([dir=rtl]) .offset-7 {
  margin-left: 58.33333333%;
}
*[dir=rtl] .offset-7 {
  margin-right: 58.33333333%;
}

html:not([dir=rtl]) .offset-8 {
  margin-left: 66.66666667%;
}
*[dir=rtl] .offset-8 {
  margin-right: 66.66666667%;
}

html:not([dir=rtl]) .offset-9 {
  margin-left: 75%;
}
*[dir=rtl] .offset-9 {
  margin-right: 75%;
}

html:not([dir=rtl]) .offset-10 {
  margin-left: 83.33333333%;
}
*[dir=rtl] .offset-10 {
  margin-right: 83.33333333%;
}

html:not([dir=rtl]) .offset-11 {
  margin-left: 91.66666667%;
}
*[dir=rtl] .offset-11 {
  margin-right: 91.66666667%;
}

.g-0,
.gx-0 {
  --cui-gutter-x: 0;
}

.g-0,
.gy-0 {
  --cui-gutter-y: 0;
}

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-sm-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-sm-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-sm-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-sm-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-sm-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-sm-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-sm-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-sm-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-sm-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-sm-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-sm-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-sm-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-sm-11 {
    margin-right: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-md-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-md-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-md-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-md-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-md-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-md-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-md-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-md-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-md-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-md-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-md-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-md-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-md-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-md-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-md-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-md-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-md-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-md-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-md-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-md-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-md-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-md-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-md-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-md-11 {
    margin-right: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-lg-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-lg-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-lg-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-lg-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-lg-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-lg-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-lg-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-lg-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-lg-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-lg-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-lg-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-lg-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-lg-11 {
    margin-right: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-xl-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-xl-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-xl-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-xl-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-xl-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-xl-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-xl-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-xl-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-xl-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-xl-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-xl-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-xl-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-xl-11 {
    margin-right: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-xxl-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-xxl-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-xxl-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-xxl-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-xxl-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-xxl-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-xxl-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-xxl-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-xxl-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-xxl-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-xxl-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-xxl-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-xxl-11 {
    margin-right: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem;
  }
}
.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-body-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: #eeeeee;
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-body-color);
  --cui-table-striped-bg: rgba(0, 0, 21, 0.05);
  --cui-table-active-color: var(--cui-body-color);
  --cui-table-active-bg: rgba(0, 0, 21, 0.1);
  --cui-table-hover-color: var(--cui-body-color);
  --cui-table-hover-bg: #faf5fc;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.875rem 1rem;
  color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
  background-color: var(--cui-table-bg);
  border-bottom-width: var(--cui-border-width);
  box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--cui-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--cui-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg);
}

.table-primary {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: #d8ccde;
  --cui-table-border-color: rgba(200.325, 190.4350961538, 208.4807692308, 0.995);
  --cui-table-striped-bg: rgba(208.2, 197.25, 215.2727272727, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(200.325, 190.4350961538, 208.4807692308, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(204.271942446, 193.8507194245, 211.8848920863, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-secondary {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: rgb(231.6, 230.2, 231.2);
  --cui-table-border-color: rgba(214.5, 214.2418269231, 216.8403846154, 0.995);
  --cui-table-striped-bg: rgba(223.0909090909, 222.2590909091, 224.0545454545, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(214.5, 214.2418269231, 216.8403846154, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(218.8057553957, 218.2600719424, 220.4561151079, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-success {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: rgb(213.2, 240.8, 222.4);
  --cui-table-border-color: rgba(197.7807692308, 223.8735576923, 208.8442307692, 0.995);
  --cui-table-striped-bg: rgba(205.5272727273, 232.3772727273, 215.6545454545, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(197.7807692308, 223.8735576923, 208.8442307692, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(201.6633093525, 228.1356115108, 212.2575539568, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-info {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: rgb(214.2, 234.6, 255);
  --cui-table-border-color: rgba(198.6894230769, 218.2399038462, 238.4663461538, 0.995);
  --cui-table-striped-bg: rgba(206.4818181818, 226.4590909091, 246.7727272727, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(198.6894230769, 218.2399038462, 238.4663461538, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(202.5949640288, 222.359352518, 242.6294964029, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-warning {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: rgb(253.8, 239.4, 208.2);
  --cui-table-border-color: rgba(234.6721153846, 222.6014423077, 195.9413461538, 0.995);
  --cui-table-striped-bg: rgba(244.2818181818, 231.0409090909, 202.1, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(234.6721153846, 222.6014423077, 195.9413461538, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(239.4884892086, 226.831294964, 199.028057554, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-danger {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: rgb(249.8, 220.6, 220.6);
  --cui-table-border-color: rgba(231.0375, 205.51875, 207.2086538462, 0.995);
  --cui-table-striped-bg: rgba(240.4636363636, 213.0954545455, 213.9363636364, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(231.0375, 205.51875, 207.2086538462, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(235.7618705036, 209.3161870504, 210.5805755396, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-light {
  --cui-table-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(217.5894230769, 220.4206730769, 223.9278846154, 0.995);
  --cui-table-striped-bg: rgba(226.3363636364, 228.75, 231.5, 0.9975);
  --cui-table-striped-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-active-bg: rgba(217.5894230769, 220.4206730769, 223.9278846154, 0.995);
  --cui-table-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-table-hover-bg: rgba(221.973381295, 224.595323741, 227.7230215827, 0.99625);
  --cui-table-hover-color: rgba(44.4, 55.5, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-dark {
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-bg: #4f5d73;
  --cui-table-border-color: rgba(92.8695652174, 105.7663043478, 126.0326086957, 0.987);
  --cui-table-striped-bg: rgba(85.8540734109, 99.308863026, 120.4521038496, 0.9935);
  --cui-table-striped-color: rgba(255, 255, 255, 0.87);
  --cui-table-active-bg: rgba(92.8695652174, 105.7663043478, 126.0326086957, 0.987);
  --cui-table-active-color: rgba(255, 255, 255, 0.87);
  --cui-table-hover-bg: rgba(89.3412877082, 102.5186852769, 123.2260243134, 0.99025);
  --cui-table-hover-color: rgba(255, 255, 255, 0.87);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  color: var(--cui-form-label-color, );
}

.col-form-label {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  color: var(--cui-form-label-color, );
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.09375rem;
}

.col-form-label-sm {
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  font-size: 0.75rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-text-color, var(--cui-secondary-color));
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-input-bg, var(--cui-body-bg));
  background-clip: padding-box;
  border: var(--cui-border-width) solid var(--cui-input-border-color, #e0e0e0);
  border-radius: 8px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--cui-input-focus-color, var(--cui-body-color));
  background-color: var(--cui-input-focus-bg, var(--cui-body-bg));
  border-color: var(--cui-input-focus-border-color, #7a2ba3);
  outline: 0;
  box-shadow: 0 0 0 3px rgba(60, 0, 90, 0.18);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
  opacity: 1;
}
.form-control:disabled {
  background-color: #f2f0f3;
  border-color: #e0e0e0;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
  color: var(--cui-form-file-button-color, var(--cui-body-color));
  background-color: var(--cui-form-file-button-bg, var(--cui-tertiary-bg));
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--cui-border-width);
  border-radius: 0;
  transition: color 150ms ease, background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--cui-form-file-button-hover-bg, var(--cui-secondary-bg));
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-input-plaintext-color, var(--cui-body-color));
  background-color: transparent;
  border: solid transparent;
  border-width: var(--cui-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 6px;
}
.form-control-sm::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 12px;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 8px;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 8px;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
}
html:not([dir=rtl]) .form-select {
  padding: 0.5rem 3rem 0.5rem 1rem;
}
*[dir=rtl] .form-select {
  padding: 0.5rem 1rem 0.5rem 3rem;
}
.form-select {
  -moz-padding-start: calc(1rem - 3px);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-form-select-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-form-select-bg, var(--cui-body-bg));
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
}
html:not([dir=rtl]) .form-select {
  background-position: right 1rem center;
}
*[dir=rtl] .form-select {
  background-position: left 1rem center;
}
.form-select {
  background-size: 16px 12px;
  border: var(--cui-border-width) solid var(--cui-form-select-border-color, #e0e0e0);
  border-radius: 8px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--cui-form-select-focus-border-color, #7a2ba3);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(60, 0, 90, 0.18);
}
html:not([dir=rtl]) .form-select[multiple], html:not([dir=rtl]) .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
}
*[dir=rtl] .form-select[multiple], *[dir=rtl] .form-select[size]:not([size="1"]) {
  padding-left: 1rem;
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  background-image: none;
}
.form-select:disabled {
  color: var(--cui-form-select-disabled-color, );
  background-color: var(--cui-form-select-disabled-bg, #f2f0f3);
  border-color: #e0e0e0;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--cui-form-select-color, var(--cui-body-color));
}

.form-select-sm {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
html:not([dir=rtl]) .form-select-sm {
  padding-left: 0.75rem;
}
*[dir=rtl] .form-select-sm {
  padding-right: 0.75rem;
}
.form-select-sm {
  font-size: 0.75rem;
  border-radius: 6px;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
html:not([dir=rtl]) .form-select-lg {
  padding-left: 1rem;
}
*[dir=rtl] .form-select-lg {
  padding-right: 1rem;
}
.form-select-lg {
  font-size: 1.09375rem;
  border-radius: 12px;
}

.form-check {
  display: block;
  min-height: 1.3125rem;
}
html:not([dir=rtl]) .form-check {
  padding-left: 1.5em;
}
*[dir=rtl] .form-check {
  padding-right: 1.5em;
}
.form-check {
  margin-bottom: 0.125rem;
}
html:not([dir=rtl]) .form-check .form-check-input {
  float: left;
}
*[dir=rtl] .form-check .form-check-input {
  float: right;
}
html:not([dir=rtl]) .form-check .form-check-input {
  margin-left: -1.5em;
}
*[dir=rtl] .form-check .form-check-input {
  margin-right: -1.5em;
}

html:not([dir=rtl]) .form-check-reverse {
  padding-right: 1.5em;
}
*[dir=rtl] .form-check-reverse {
  padding-left: 1.5em;
}
html:not([dir=rtl]) .form-check-reverse {
  padding-left: 0;
}
*[dir=rtl] .form-check-reverse {
  padding-right: 0;
}
html:not([dir=rtl]) .form-check-reverse {
  text-align: right;
}
*[dir=rtl] .form-check-reverse {
  text-align: left;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  float: right;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  float: left;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  margin-right: -1.5em;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  margin-left: -1.5em;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  margin-left: 0;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  margin-right: 0;
}

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-border-width) solid var(--cui-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #7a2ba3;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(60, 0, 90, 0.25);
}
.form-check-input:checked {
  background-color: var(--cui-form-check-input-checked-bg-color, #3c005a);
  border-color: var(--cui-form-check-input-checked-border-color, #3c005a);
}
.form-check-input:checked[type=checkbox] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #3c005a;
  border-color: #3c005a;
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--cui-form-check-label-color, );
}

html:not([dir=rtl]) .form-switch {
  padding-left: 2.5em;
}
*[dir=rtl] .form-switch {
  padding-right: 2.5em;
}
.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 2em;
}
html:not([dir=rtl]) .form-switch .form-check-input {
  margin-left: -2.5em;
}
*[dir=rtl] .form-switch .form-check-input {
  margin-right: -2.5em;
}
.form-switch .form-check-input {
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
html:not([dir=rtl]) .form-switch.form-check-reverse {
  padding-right: 1.5em;
}
*[dir=rtl] .form-switch.form-check-reverse {
  padding-left: 1.5em;
}
html:not([dir=rtl]) .form-switch.form-check-reverse {
  padding-left: 0;
}
*[dir=rtl] .form-switch.form-check-reverse {
  padding-right: 0;
}
html:not([dir=rtl]) .form-switch.form-check-reverse .form-check-input {
  margin-right: -1.5em;
}
*[dir=rtl] .form-switch.form-check-reverse .form-check-input {
  margin-left: -1.5em;
}
html:not([dir=rtl]) .form-switch.form-check-reverse .form-check-input {
  margin-left: 0;
}
*[dir=rtl] .form-switch.form-check-reverse .form-check-input {
  margin-right: 0;
}

.form-switch-lg {
  min-height: 1.25em;
}
html:not([dir=rtl]) .form-switch-lg {
  padding-left: 2.25em;
}
*[dir=rtl] .form-switch-lg {
  padding-right: 2.25em;
}
.form-switch-lg .form-check-input {
  width: 1.75em;
  height: 1.25em;
}
html:not([dir=rtl]) .form-switch-lg .form-check-input {
  margin-left: -2.25em;
}
*[dir=rtl] .form-switch-lg .form-check-input {
  margin-right: -2.25em;
}
.form-switch-lg .form-check-label {
  padding-top: calc((1.25em - 0.875rem) / 2);
}

.form-switch-xl {
  min-height: 1.5em;
}
html:not([dir=rtl]) .form-switch-xl {
  padding-left: 2.5em;
}
*[dir=rtl] .form-switch-xl {
  padding-right: 2.5em;
}
.form-switch-xl .form-check-input {
  width: 2em;
  height: 1.5em;
}
html:not([dir=rtl]) .form-switch-xl .form-check-input {
  margin-left: -2.5em;
}
*[dir=rtl] .form-switch-xl .form-check-input {
  margin-right: -2.5em;
}
.form-switch-xl .form-check-label {
  padding-top: calc((1.5em - 0.875rem) / 2);
}

.form-check-inline {
  display: inline-block;
}
html:not([dir=rtl]) .form-check-inline {
  margin-right: 1rem;
}
*[dir=rtl] .form-check-inline {
  margin-left: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fafafa, 0 0 0 3px rgba(60, 0, 90, 0.18);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fafafa, 0 0 0 3px rgba(60, 0, 90, 0.18);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #3c005a);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, rgb(196.5, 178.5, 205.5));
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #3c005a);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, rgb(196.5, 178.5, 205.5));
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
}
html:not([dir=rtl]) .form-floating > label {
  left: 0;
}
*[dir=rtl] .form-floating > label {
  right: 0;
}
.form-floating > label {
  z-index: 2;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--cui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.5rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--cui-body-bg);
  border-radius: 8px;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--cui-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #8a93a2;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #f2f0f3;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, #e0e0e0);
  border-radius: 8px;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 12px;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 6px;
}

html:not([dir=rtl]) .input-group-lg > .form-select,
html:not([dir=rtl]) .input-group-sm > .form-select {
  padding-right: 4rem;
}
*[dir=rtl] .input-group-lg > .form-select,
*[dir=rtl] .input-group-sm > .form-select {
  padding-left: 4rem;
}

html:not([dir=rtl]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
}
*[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
}
*[dir=rtl] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: 0;
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-right-radius: 0;
}
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-control,
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
}
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-control,
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-control,
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-control,
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-right-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  color: #fff;
  background-color: var(--cui-success);
  border-radius: var(--cui-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
html:not([dir=rtl]) .was-validated .form-control:valid, html:not([dir=rtl]) .form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
}
*[dir=rtl] .was-validated .form-control:valid, *[dir=rtl] .form-control.is-valid {
  padding-left: calc(1.5em + 1rem);
}
.was-validated .form-control:valid, .form-control.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
}
html:not([dir=rtl]) .was-validated .form-control:valid, html:not([dir=rtl]) .form-control.is-valid {
  background-position: right calc(0.375em + 0.25rem) center;
}
*[dir=rtl] .was-validated .form-control:valid, *[dir=rtl] .form-control.is-valid {
  background-position: left calc(0.375em + 0.25rem) center;
}
.was-validated .form-control:valid, .form-control.is-valid {
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

html:not([dir=rtl]) .was-validated textarea.form-control:valid, html:not([dir=rtl]) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
}
*[dir=rtl] .was-validated textarea.form-control:valid, *[dir=rtl] textarea.form-control.is-valid {
  padding-left: calc(1.5em + 1rem);
}
html:not([dir=rtl]) .was-validated textarea.form-control:valid, html:not([dir=rtl]) textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}
*[dir=rtl] .was-validated textarea.form-control:valid, *[dir=rtl] textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.25rem) left calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 5.5rem;
}
*[dir=rtl] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-valid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-valid:not([multiple])[size="1"] {
  padding-left: 5.5rem;
}
html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-valid:not([multiple])[size="1"] {
  background-position: right 1rem center, center right 3rem;
}
*[dir=rtl] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-valid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-valid:not([multiple])[size="1"] {
  background-position: left 1rem center, center left 3rem;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--cui-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--cui-form-valid-color);
}

html:not([dir=rtl]) .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
*[dir=rtl] .form-check-inline .form-check-input ~ .valid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  color: #fff;
  background-color: var(--cui-danger);
  border-radius: var(--cui-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
html:not([dir=rtl]) .was-validated .form-control:invalid, html:not([dir=rtl]) .form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
}
*[dir=rtl] .was-validated .form-control:invalid, *[dir=rtl] .form-control.is-invalid {
  padding-left: calc(1.5em + 1rem);
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
}
html:not([dir=rtl]) .was-validated .form-control:invalid, html:not([dir=rtl]) .form-control.is-invalid {
  background-position: right calc(0.375em + 0.25rem) center;
}
*[dir=rtl] .was-validated .form-control:invalid, *[dir=rtl] .form-control.is-invalid {
  background-position: left calc(0.375em + 0.25rem) center;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

html:not([dir=rtl]) .was-validated textarea.form-control:invalid, html:not([dir=rtl]) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
}
*[dir=rtl] .was-validated textarea.form-control:invalid, *[dir=rtl] textarea.form-control.is-invalid {
  padding-left: calc(1.5em + 1rem);
}
html:not([dir=rtl]) .was-validated textarea.form-control:invalid, html:not([dir=rtl]) textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}
*[dir=rtl] .was-validated textarea.form-control:invalid, *[dir=rtl] textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.25rem) left calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 5.5rem;
}
*[dir=rtl] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-invalid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-invalid:not([multiple])[size="1"] {
  padding-left: 5.5rem;
}
html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-invalid:not([multiple])[size="1"] {
  background-position: right 1rem center, center right 3rem;
}
*[dir=rtl] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-invalid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-invalid:not([multiple])[size="1"] {
  background-position: left 1rem center, center left 3rem;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--cui-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--cui-form-invalid-color);
}

html:not([dir=rtl]) .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
*[dir=rtl] .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --cui-btn-padding-x: 1rem;
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: 8px;
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 21, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  transition: color 150ms ease, background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--cui-btn-color);
  background-color: var(--cui-btn-bg);
  border-color: var(--cui-btn-border-color);
}
.btn:focus-visible {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--cui-btn-active-color);
  background-color: var(--cui-btn-active-bg);
  border-color: var(--cui-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--cui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--cui-btn-disabled-bg);
  border-color: var(--cui-btn-disabled-border-color);
  opacity: var(--cui-btn-disabled-opacity);
}

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent;
}

.btn-primary {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #3c005a;
  --cui-btn-border-color: #3c005a;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: rgb(89.25, 38.25, 114.75);
  --cui-btn-hover-border-color: rgb(79.5, 25.5, 106.5);
  --cui-btn-focus-shadow-rgb: 83, 31, 110;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #63337b;
  --cui-btn-active-border-color: rgb(79.5, 25.5, 106.5);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #3c005a;
  --cui-btn-disabled-border-color: #3c005a;
}

.btn-secondary {
  --cui-btn-color: #000015;
  --cui-btn-bg: #8a8388;
  --cui-btn-border-color: #8a8388;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(155.55, 149.6, 153.85);
  --cui-btn-hover-border-color: rgb(149.7, 143.4, 147.9);
  --cui-btn-focus-shadow-rgb: 117, 111, 119;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(161.4, 155.8, 159.8);
  --cui-btn-active-border-color: rgb(149.7, 143.4, 147.9);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #8a8388;
  --cui-btn-disabled-border-color: #8a8388;
}

.btn-success {
  --cui-btn-color: #000015;
  --cui-btn-bg: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-hover-bg: rgb(77.35, 194.65, 116.45);
  --cui-btn-hover-border-color: rgb(66.9, 191.1, 108.3);
  --cui-btn-focus-shadow-rgb: 39, 156, 81;
  --cui-btn-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-active-bg: rgb(87.8, 198.2, 124.6);
  --cui-btn-active-border-color: rgb(66.9, 191.1, 108.3);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #2eb85c;
  --cui-btn-disabled-border-color: #2eb85c;
}

.btn-danger {
  --cui-btn-color: #000015;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(232.9, 108.8, 108.8);
  --cui-btn-hover-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-focus-shadow-rgb: 195, 71, 74;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(234.2, 117.4, 117.4);
  --cui-btn-active-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353;
}

.btn-warning {
  --cui-btn-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(211.65, 150.45, 17.85);
  --cui-btn-hover-border-color: rgb(199.2, 141.6, 16.8);
  --cui-btn-focus-shadow-rgb: 221, 160, 28;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(199.2, 141.6, 16.8);
  --cui-btn-active-border-color: rgb(186.75, 132.75, 15.75);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115;
}

.btn-info {
  --cui-btn-color: #000015;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(81.6, 168.3, 255);
  --cui-btn-hover-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-focus-shadow-rgb: 43, 130, 220;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(91.8, 173.4, 255);
  --cui-btn-active-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f;
}

.btn-light {
  --cui-btn-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-bg: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-hover-bg: rgb(199.75, 201.45, 203.15);
  --cui-btn-hover-border-color: rgb(188, 189.6, 191.2);
  --cui-btn-focus-shadow-rgb: 209, 212, 216;
  --cui-btn-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-active-bg: rgb(188, 189.6, 191.2);
  --cui-btn-active-border-color: rgb(176.25, 177.75, 179.25);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-disabled-bg: #ebedef;
  --cui-btn-disabled-border-color: #ebedef;
}

.btn-dark {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(105.4, 117.3, 136);
  --cui-btn-hover-border-color: rgb(96.6, 109.2, 129);
  --cui-btn-focus-shadow-rgb: 100, 112, 132;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(114.2, 125.4, 143);
  --cui-btn-active-border-color: rgb(96.6, 109.2, 129);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #4f5d73;
  --cui-btn-disabled-border-color: #4f5d73;
}

.btn-outline-primary {
  --cui-btn-color: #3c005a;
  --cui-btn-border-color: #3c005a;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #63337b;
  --cui-btn-hover-border-color: rgb(79.5, 25.5, 106.5);
  --cui-btn-focus-shadow-rgb: 60, 0, 90;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #63337b;
  --cui-btn-active-border-color: rgb(79.5, 25.5, 106.5);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #3c005a;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-secondary {
  --cui-btn-color: #8a8388;
  --cui-btn-border-color: #8a8388;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(161.4, 155.8, 159.8);
  --cui-btn-hover-border-color: rgb(149.7, 143.4, 147.9);
  --cui-btn-focus-shadow-rgb: 138, 131, 136;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(161.4, 155.8, 159.8);
  --cui-btn-active-border-color: rgb(149.7, 143.4, 147.9);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #8a8388;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-hover-bg: rgb(87.8, 198.2, 124.6);
  --cui-btn-hover-border-color: rgb(66.9, 191.1, 108.3);
  --cui-btn-focus-shadow-rgb: 46, 184, 92;
  --cui-btn-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-active-bg: rgb(87.8, 198.2, 124.6);
  --cui-btn-active-border-color: rgb(66.9, 191.1, 108.3);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(234.2, 117.4, 117.4);
  --cui-btn-hover-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(234.2, 117.4, 117.4);
  --cui-btn-active-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(199.2, 141.6, 16.8);
  --cui-btn-hover-border-color: rgb(186.75, 132.75, 15.75);
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(199.2, 141.6, 16.8);
  --cui-btn-active-border-color: rgb(186.75, 132.75, 15.75);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: rgb(91.8, 173.4, 255);
  --cui-btn-hover-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: rgb(91.8, 173.4, 255);
  --cui-btn-active-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-light {
  --cui-btn-color: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-hover-bg: rgb(188, 189.6, 191.2);
  --cui-btn-hover-border-color: rgb(176.25, 177.75, 179.25);
  --cui-btn-focus-shadow-rgb: 235, 237, 239;
  --cui-btn-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-active-bg: rgb(188, 189.6, 191.2);
  --cui-btn-active-border-color: rgb(176.25, 177.75, 179.25);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(114.2, 125.4, 143);
  --cui-btn-hover-border-color: rgb(96.6, 109.2, 129);
  --cui-btn-focus-shadow-rgb: 79, 93, 115;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(114.2, 125.4, 143);
  --cui-btn-active-border-color: rgb(96.6, 109.2, 129);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-ghost-primary {
  --cui-btn-color: #3c005a;
  --cui-btn-hover-bg: rgb(89.25, 38.25, 114.75);
  --cui-btn-hover-border-color: rgb(79.5, 25.5, 106.5);
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #63337b;
  --cui-btn-active-border-color: rgb(79.5, 25.5, 106.5);
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-color: #3c005a;
  --cui-btn-shadow: rgba(60, 0, 90, 0.5);
}

.btn-ghost-secondary {
  --cui-btn-color: #8a8388;
  --cui-btn-hover-bg: rgb(155.55, 149.6, 153.85);
  --cui-btn-hover-border-color: rgb(149.7, 143.4, 147.9);
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: rgb(161.4, 155.8, 159.8);
  --cui-btn-active-border-color: rgb(149.7, 143.4, 147.9);
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #8a8388;
  --cui-btn-shadow: rgba(138, 131, 136, 0.5);
}

.btn-ghost-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-hover-bg: rgb(77.35, 194.65, 116.45);
  --cui-btn-hover-border-color: rgb(66.9, 191.1, 108.3);
  --cui-btn-hover-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-active-bg: rgb(87.8, 198.2, 124.6);
  --cui-btn-active-border-color: rgb(66.9, 191.1, 108.3);
  --cui-btn-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-shadow: rgba(46, 184, 92, 0.5);
}

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-hover-bg: rgb(232.9, 108.8, 108.8);
  --cui-btn-hover-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: rgb(234.2, 117.4, 117.4);
  --cui-btn-active-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-shadow: rgba(229, 83, 83, 0.5);
}

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-hover-bg: rgb(211.65, 150.45, 17.85);
  --cui-btn-hover-border-color: rgb(199.2, 141.6, 16.8);
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: rgb(199.2, 141.6, 16.8);
  --cui-btn-active-border-color: rgb(186.75, 132.75, 15.75);
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-shadow: rgba(249, 177, 21, 0.5);
}

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-hover-bg: rgb(81.6, 168.3, 255);
  --cui-btn-hover-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: rgb(91.8, 173.4, 255);
  --cui-btn-active-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #39f;
  --cui-btn-shadow: rgba(51, 153, 255, 0.5);
}

.btn-ghost-light {
  --cui-btn-color: #ebedef;
  --cui-btn-hover-bg: rgb(199.75, 201.45, 203.15);
  --cui-btn-hover-border-color: rgb(188, 189.6, 191.2);
  --cui-btn-hover-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-active-bg: rgb(188, 189.6, 191.2);
  --cui-btn-active-border-color: rgb(176.25, 177.75, 179.25);
  --cui-btn-active-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-shadow: rgba(235, 237, 239, 0.5);
}

.btn-ghost-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-hover-bg: rgb(105.4, 117.3, 136);
  --cui-btn-hover-border-color: rgb(96.6, 109.2, 129);
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: rgb(114.2, 125.4, 143);
  --cui-btn-active-border-color: rgb(96.6, 109.2, 129);
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-shadow: rgba(79, 93, 115, 0.5);
}

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #8a93a2;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 83, 31, 110;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--cui-btn-color);
}

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.09375rem;
  --cui-btn-border-radius: 12px;
}

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-font-size: 0.75rem;
  --cui-btn-border-radius: 6px;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
}
html:not([dir=rtl]) .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropdown-toggle::after {
  margin-right: 0.255em;
}
.dropdown-toggle::after {
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 0.875rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: #eeeeee;
  --cui-dropdown-border-radius: 8px;
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(8px - var(--cui-border-width));
  --cui-dropdown-divider-bg: #eeeeee;
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: 0 4px 12px rgba(60, 0, 90, 0.08);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: #faf5fc;
  --cui-dropdown-link-active-color: #3c005a;
  --cui-dropdown-link-active-bg: #f3ecf7;
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #8a93a2;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius);
}
.dropdown-menu[data-coreui-popper] {
  top: 100%;
}
html:not([dir=rtl]) .dropdown-menu[data-coreui-popper] {
  left: 0;
}
*[dir=rtl] .dropdown-menu[data-coreui-popper] {
  right: 0;
}
.dropdown-menu[data-coreui-popper] {
  margin-top: var(--cui-dropdown-spacer);
}

.dropdown-menu-start {
  --cui-position: start;
}
html:not([dir=rtl]) .dropdown-menu-start[data-coreui-popper] {
  right: auto;
}
*[dir=rtl] .dropdown-menu-start[data-coreui-popper] {
  left: auto;
}
html:not([dir=rtl]) .dropdown-menu-start[data-coreui-popper] {
  left: 0;
}
*[dir=rtl] .dropdown-menu-start[data-coreui-popper] {
  right: 0;
}

.dropdown-menu-end {
  --cui-position: end;
}
html:not([dir=rtl]) .dropdown-menu-end[data-coreui-popper] {
  right: 0;
}
*[dir=rtl] .dropdown-menu-end[data-coreui-popper] {
  left: 0;
}
html:not([dir=rtl]) .dropdown-menu-end[data-coreui-popper] {
  left: auto;
}
*[dir=rtl] .dropdown-menu-end[data-coreui-popper] {
  right: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-sm-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-sm-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-sm-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-sm-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-sm-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-md-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-md-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-md-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-md-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-md-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-md-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-md-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-md-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-md-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-lg-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-lg-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-lg-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-lg-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-lg-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-xl-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-xl-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-xl-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-xl-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-xl-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-xxl-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-xxl-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-xxl-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-xxl-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-xxl-end[data-coreui-popper] {
    right: auto;
  }
}
.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
}
html:not([dir=rtl]) .dropup .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropup .dropdown-toggle::after {
  margin-right: 0.255em;
}
.dropup .dropdown-toggle::after {
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropup .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropend .dropdown-menu[data-coreui-popper] {
  top: 0;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  right: auto;
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  left: auto;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  left: 100%;
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  right: 100%;
}
.dropend .dropdown-menu[data-coreui-popper] {
  margin-top: 0;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  margin-left: var(--cui-dropdown-spacer);
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  margin-right: var(--cui-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
}
html:not([dir=rtl]) .dropend .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropend .dropdown-toggle::after {
  margin-right: 0.255em;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
html:not([dir=rtl]) .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropend .dropdown-toggle:empty::after {
  margin-right: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-coreui-popper] {
  top: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  right: 100%;
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  left: 100%;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  left: auto;
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  right: auto;
}
.dropstart .dropdown-menu[data-coreui-popper] {
  margin-top: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  margin-right: var(--cui-dropdown-spacer);
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  margin-left: var(--cui-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropstart .dropdown-toggle::after {
  margin-right: 0.255em;
}
.dropstart .dropdown-toggle::after {
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle::before {
  margin-right: 0.255em;
}
*[dir=rtl] .dropstart .dropdown-toggle::before {
  margin-left: 0.255em;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropstart .dropdown-toggle:empty::after {
  margin-right: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--cui-dropdown-link-hover-color);
  background-color: var(--cui-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--cui-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--cui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.75rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color);
}

.dropdown-menu-dark {
  --cui-dropdown-color: #c4c9d0;
  --cui-dropdown-bg: #636f83;
  --cui-dropdown-border-color: #eeeeee;
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #c4c9d0;
  --cui-dropdown-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-divider-bg: #eeeeee;
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: #3c005a;
  --cui-dropdown-link-active-bg: #f3ecf7;
  --cui-dropdown-link-disabled-color: #9da5b1;
  --cui-dropdown-header-color: #9da5b1;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 8px;
}
html:not([dir=rtl]) .btn-group > :not(.btn-check:first-child) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .btn-group > :not(.btn-check:first-child) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir=rtl]) .btn-group > .btn.dropdown-toggle-split:first-child,
html:not([dir=rtl]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
}
*[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir=rtl] .btn-group > .btn.dropdown-toggle-split:first-child,
*[dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir=rtl]) .btn-group > .btn.dropdown-toggle-split:first-child,
html:not([dir=rtl]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir=rtl] .btn-group > .btn.dropdown-toggle-split:first-child,
*[dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:nth-child(n+3),
html:not([dir=rtl]) .btn-group > :not(.btn-check) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
}
*[dir=rtl] .btn-group > .btn:nth-child(n+3),
*[dir=rtl] .btn-group > :not(.btn-check) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:nth-child(n+3),
html:not([dir=rtl]) .btn-group > :not(.btn-check) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .btn-group > .btn:nth-child(n+3),
*[dir=rtl] .btn-group > :not(.btn-check) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
  border-bottom-right-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
html:not([dir=rtl]) .dropdown-toggle-split::after, html:not([dir=rtl]) .dropup .dropdown-toggle-split::after, html:not([dir=rtl]) .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
*[dir=rtl] .dropdown-toggle-split::after, *[dir=rtl] .dropup .dropdown-toggle-split::after, *[dir=rtl] .dropend .dropdown-toggle-split::after {
  margin-right: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}
*[dir=rtl] .dropstart .dropdown-toggle-split::before {
  margin-left: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--cui-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
}
html:not([dir=rtl]) .nav {
  padding-left: 0;
}
*[dir=rtl] .nav {
  padding-right: 0;
}
.nav {
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--cui-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(60, 0, 90, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--cui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
  border: var(--cui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--cui-nav-tabs-border-radius);
  border-top-right-radius: var(--cui-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--cui-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--cui-nav-tabs-link-active-color);
  background-color: var(--cui-nav-tabs-link-active-bg);
  border-color: var(--cui-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: #3c005a;
}
.nav-pills .nav-link {
  border-radius: var(--cui-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--cui-nav-pills-link-active-color);
  background-color: var(--cui-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3359375rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.09375rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.09375rem;
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: 8px;
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x);
}
.navbar .header > .container,
.navbar .header > .container-fluid,
.navbar .header > .container-sm,
.navbar .header > .container-md,
.navbar .header > .container-lg,
.navbar .header > .container-xl,
.navbar .header > .container-xxl, .navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
}
html:not([dir=rtl]) .navbar-brand {
  margin-right: var(--cui-navbar-brand-margin-end);
}
*[dir=rtl] .navbar-brand {
  margin-left: var(--cui-navbar-brand-margin-end);
}
.navbar-brand {
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--cui-navbar-brand-hover-color);
}

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
}
html:not([dir=rtl]) .navbar-nav {
  padding-left: 0;
}
*[dir=rtl] .navbar-nav {
  padding-right: 0;
}
.navbar-nav {
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--cui-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--cui-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--cui-navbar-nav-link-padding-x);
  padding-left: var(--cui-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #fff;
  --cui-navbar-brand-color: #fff;
  --cui-navbar-brand-hover-color: #fff;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --cui-card-spacer-y: 24px;
  --cui-card-spacer-x: 24px;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: #eeeeee;
  --cui-card-border-radius: 12px;
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(12px - (var(--cui-border-width)));
  --cui-card-cap-padding-y: 12px;
  --cui-card-cap-padding-x: 24px;
  --cui-card-cap-bg: #ffffff;
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: #ffffff;
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color);
}

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

html:not([dir=rtl]) .card-link + .card-link {
  margin-left: var(--cui-card-spacer-x);
}
*[dir=rtl] .card-link + .card-link {
  margin-right: var(--cui-card-spacer-x);
}

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-header:first-child {
  border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--cui-card-bg);
  border-bottom-color: var(--cui-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  html:not([dir=rtl]) .card-group > .card + .card {
    margin-left: 0;
  }
  *[dir=rtl] .card-group > .card + .card {
    margin-right: 0;
  }
  html:not([dir=rtl]) .card-group > .card + .card {
    border-left: 0;
  }
  *[dir=rtl] .card-group > .card + .card {
    border-right: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:last-child) {
    border-bottom-right-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:last-child) {
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:first-child) {
    border-top-right-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 150ms ease, background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --cui-accordion-btn-focus-border-color: #7a2ba3;
  --cui-accordion-btn-focus-box-shadow: 0 0 0 3px rgba(60, 0, 90, 0.18);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: #360051;
  --cui-accordion-active-bg: rgb(235.5, 229.5, 238.5);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--cui-accordion-btn-color);
  text-align: left;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--cui-accordion-active-color);
  background-color: var(--cui-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--cui-accordion-btn-active-icon);
  transform: var(--cui-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--cui-accordion-btn-icon-width);
  height: var(--cui-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--cui-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--cui-accordion-btn-icon-width);
  transition: var(--cui-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--cui-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--cui-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--cui-accordion-border-radius);
  border-top-right-radius: var(--cui-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--cui-accordion-inner-border-radius);
  border-top-right-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
  border-bottom-left-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: #9a93a0;
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: #3c005a;
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius);
}

html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item {
  padding-right: var(--cui-breadcrumb-item-padding-x);
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  float: left;
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  float: right;
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  padding-right: var(--cui-breadcrumb-item-padding-x);
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  color: var(--cui-breadcrumb-divider-color);
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  content: var(--cui-breadcrumb-divider, "/");
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  content: var(--cui-breadcrumb-divider-flipped, "/");
}
.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color);
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-color: #3c005a;
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: #e0e0e0;
  --cui-pagination-border-radius: 8px;
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: #f3ecf7;
  --cui-pagination-hover-border-color: #f3ecf7;
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(60, 0, 90, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: #3c005a;
  --cui-pagination-active-border-color: #3c005a;
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
}
html:not([dir=rtl]) .pagination {
  padding-left: 0;
}
*[dir=rtl] .pagination {
  padding-right: 0;
}
.pagination {
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--cui-pagination-hover-color);
  background-color: var(--cui-pagination-hover-bg);
  border-color: var(--cui-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--cui-pagination-focus-color);
  background-color: var(--cui-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--cui-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--cui-pagination-active-color);
  background-color: var(--cui-pagination-active-bg);
  border-color: var(--cui-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--cui-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--cui-pagination-disabled-bg);
  border-color: var(--cui-pagination-disabled-border-color);
}

html:not([dir=rtl]) .page-item:not(:first-child) .page-link {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .page-item:not(:first-child) .page-link {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .page-item:first-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:first-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:first-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:first-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:last-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:last-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:last-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:last-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.09375rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg);
}

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.75rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm);
}

.badge {
  --cui-badge-padding-x: 0.75em;
  --cui-badge-padding-y: 0.3em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 600;
  --cui-badge-color: rgba(255, 255, 255, 0.87);
  --cui-badge-border-radius: 999px;
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--cui-badge-border-radius, 0);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em;
}

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color);
}

html:not([dir=rtl]) .alert-dismissible {
  padding-right: 3rem;
}
*[dir=rtl] .alert-dismissible {
  padding-left: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
}
html:not([dir=rtl]) .alert-dismissible .btn-close {
  right: 0;
}
*[dir=rtl] .alert-dismissible .btn-close {
  left: 0;
}
.alert-dismissible .btn-close {
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --cui-alert-color: #240036;
  --cui-alert-bg: #d8ccde;
  --cui-alert-border-color: rgb(196.5, 178.5, 205.5);
  --cui-alert-link-color: rgb(28.8, 0, 43.2);
}

.alert-secondary {
  --cui-alert-color: rgb(82.8, 78.6, 81.6);
  --cui-alert-bg: rgb(231.6, 230.2, 231.2);
  --cui-alert-border-color: rgb(219.9, 217.8, 219.3);
  --cui-alert-link-color: rgb(66.24, 62.88, 65.28);
}

.alert-success {
  --cui-alert-color: rgb(27.6, 110.4, 55.2);
  --cui-alert-bg: rgb(213.2, 240.8, 222.4);
  --cui-alert-border-color: rgb(192.3, 233.7, 206.1);
  --cui-alert-link-color: rgb(22.08, 88.32, 44.16);
}

.alert-info {
  --cui-alert-color: rgb(30.6, 91.8, 153);
  --cui-alert-bg: rgb(214.2, 234.6, 255);
  --cui-alert-border-color: rgb(193.8, 224.4, 255);
  --cui-alert-link-color: rgb(24.48, 73.44, 122.4);
}

.alert-warning {
  --cui-alert-color: rgb(149.4, 106.2, 12.6);
  --cui-alert-bg: rgb(253.8, 239.4, 208.2);
  --cui-alert-border-color: rgb(253.2, 231.6, 184.8);
  --cui-alert-link-color: rgb(119.52, 84.96, 10.08);
}

.alert-danger {
  --cui-alert-color: rgb(137.4, 49.8, 49.8);
  --cui-alert-bg: rgb(249.8, 220.6, 220.6);
  --cui-alert-border-color: rgb(247.2, 203.4, 203.4);
  --cui-alert-link-color: rgb(109.92, 39.84, 39.84);
}

.alert-light {
  --cui-alert-color: rgb(141, 142.2, 143.4);
  --cui-alert-bg: rgb(251, 251.4, 251.8);
  --cui-alert-border-color: rgb(249, 249.6, 250.2);
  --cui-alert-link-color: rgb(112.8, 113.76, 114.72);
}

.alert-dark {
  --cui-alert-color: rgb(47.4, 55.8, 69);
  --cui-alert-bg: rgb(219.8, 222.6, 227);
  --cui-alert-border-color: rgb(202.2, 206.4, 213);
  --cui-alert-link-color: rgb(37.92, 44.64, 55.2);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.65625rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: rgba(255, 255, 255, 0.87);
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.progress-thin {
  height: 4px;
}

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2);
}
.progress.progress-white .progress-bar {
  background-color: #fff;
}

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;
}

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center;
}

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem;
}

.progress-group-bars {
  flex-grow: 1;
  align-self: center;
}
.progress-group-bars .progress:not(:last-child) {
  margin-bottom: 2px;
}

.progress-group-header + .progress-group-bars {
  flex-basis: 100%;
}

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: #3c005a;
  --cui-list-group-active-border-color: #3c005a;
  display: flex;
  flex-direction: column;
}
html:not([dir=rtl]) .list-group {
  padding-left: 0;
}
*[dir=rtl] .list-group {
  padding-right: 0;
}
.list-group {
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--cui-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--cui-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--cui-list-group-action-active-color);
  background-color: var(--cui-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--cui-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--cui-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--cui-list-group-active-color);
  background-color: var(--cui-list-group-active-bg);
  border-color: var(--cui-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--cui-list-group-border-width));
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--cui-list-group-border-radius);
}
*[dir=rtl] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-right-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-top-right-radius: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--cui-list-group-border-radius);
}
*[dir=rtl] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-left-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-bottom-right-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--cui-list-group-border-width);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item {
  border-left-width: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item {
  border-right-width: 0;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--cui-list-group-border-width));
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-right: calc(-1 * var(--cui-list-group-border-width));
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item.active {
  border-left-width: var(--cui-list-group-border-width);
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
  border-right-width: var(--cui-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--cui-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --cui-list-group-color: contrast-ratio-correction(#240036, #d8ccde, 40%, "primary");
  --cui-list-group-bg: #d8ccde;
  --cui-list-group-hover-bg: #360051;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#240036, #d8ccde, 40%, "primary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#240036, #d8ccde, 40%, "primary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#240036, #d8ccde, 40%, "primary");
}

.list-group-item-secondary {
  --cui-list-group-color: contrast-ratio-correction(rgb(82.8, 78.6, 81.6), rgb(231.6, 230.2, 231.2), 40%, "secondary");
  --cui-list-group-bg: rgb(231.6, 230.2, 231.2);
  --cui-list-group-hover-bg: rgb(124.2, 117.9, 122.4);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(82.8, 78.6, 81.6), rgb(231.6, 230.2, 231.2), 40%, "secondary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(82.8, 78.6, 81.6), rgb(231.6, 230.2, 231.2), 40%, "secondary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(82.8, 78.6, 81.6), rgb(231.6, 230.2, 231.2), 40%, "secondary");
}

.list-group-item-success {
  --cui-list-group-color: contrast-ratio-correction(rgb(27.6, 110.4, 55.2), rgb(213.2, 240.8, 222.4), 40%, "success");
  --cui-list-group-bg: rgb(213.2, 240.8, 222.4);
  --cui-list-group-hover-bg: rgb(41.4, 165.6, 82.8);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(27.6, 110.4, 55.2), rgb(213.2, 240.8, 222.4), 40%, "success");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(27.6, 110.4, 55.2), rgb(213.2, 240.8, 222.4), 40%, "success");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(27.6, 110.4, 55.2), rgb(213.2, 240.8, 222.4), 40%, "success");
}

.list-group-item-danger {
  --cui-list-group-color: contrast-ratio-correction(rgb(137.4, 49.8, 49.8), rgb(249.8, 220.6, 220.6), 40%, "danger");
  --cui-list-group-bg: rgb(249.8, 220.6, 220.6);
  --cui-list-group-hover-bg: rgb(206.1, 74.7, 74.7);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(137.4, 49.8, 49.8), rgb(249.8, 220.6, 220.6), 40%, "danger");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(137.4, 49.8, 49.8), rgb(249.8, 220.6, 220.6), 40%, "danger");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(137.4, 49.8, 49.8), rgb(249.8, 220.6, 220.6), 40%, "danger");
}

.list-group-item-warning {
  --cui-list-group-color: contrast-ratio-correction(rgb(149.4, 106.2, 12.6), rgb(253.8, 239.4, 208.2), 40%, "warning");
  --cui-list-group-bg: rgb(253.8, 239.4, 208.2);
  --cui-list-group-hover-bg: rgb(224.1, 159.3, 18.9);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(149.4, 106.2, 12.6), rgb(253.8, 239.4, 208.2), 40%, "warning");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(149.4, 106.2, 12.6), rgb(253.8, 239.4, 208.2), 40%, "warning");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(149.4, 106.2, 12.6), rgb(253.8, 239.4, 208.2), 40%, "warning");
}

.list-group-item-info {
  --cui-list-group-color: contrast-ratio-correction(rgb(30.6, 91.8, 153), rgb(214.2, 234.6, 255), 40%, "info");
  --cui-list-group-bg: rgb(214.2, 234.6, 255);
  --cui-list-group-hover-bg: rgb(45.9, 137.7, 229.5);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(30.6, 91.8, 153), rgb(214.2, 234.6, 255), 40%, "info");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(30.6, 91.8, 153), rgb(214.2, 234.6, 255), 40%, "info");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(30.6, 91.8, 153), rgb(214.2, 234.6, 255), 40%, "info");
}

.list-group-item-light {
  --cui-list-group-color: contrast-ratio-correction(rgb(141, 142.2, 143.4), rgb(251, 251.4, 251.8), 40%, "light");
  --cui-list-group-bg: rgb(251, 251.4, 251.8);
  --cui-list-group-hover-bg: rgb(211.5, 213.3, 215.1);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(141, 142.2, 143.4), rgb(251, 251.4, 251.8), 40%, "light");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(141, 142.2, 143.4), rgb(251, 251.4, 251.8), 40%, "light");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(141, 142.2, 143.4), rgb(251, 251.4, 251.8), 40%, "light");
}

.list-group-item-dark {
  --cui-list-group-color: contrast-ratio-correction(rgb(47.4, 55.8, 69), rgb(219.8, 222.6, 227), 40%, "dark");
  --cui-list-group-bg: rgb(219.8, 222.6, 227);
  --cui-list-group-hover-bg: rgb(71.1, 83.7, 103.5);
  --cui-list-group-action-hover-color: contrast-ratio-correction(rgb(47.4, 55.8, 69), rgb(219.8, 222.6, 227), 40%, "dark");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(rgb(47.4, 55.8, 69), rgb(219.8, 222.6, 227), 40%, "dark");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(rgb(47.4, 55.8, 69), rgb(219.8, 222.6, 227), 40%, "dark");
}

.btn-close {
  --cui-btn-close-color: rgba(44.4, 55.5, 74, 0.95);
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(60, 0, 90, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  --cui-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 8px;
  opacity: var(--cui-btn-close-opacity);
}
.btn-close:hover {
  color: var(--cui-btn-close-color);
  text-decoration: none;
  opacity: var(--cui-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--cui-btn-close-focus-shadow);
  opacity: var(--cui-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--cui-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--cui-btn-close-white-filter);
}

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--cui-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
}
html:not([dir=rtl]) .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-toast-padding-x));
}
*[dir=rtl] .toast-header .btn-close {
  margin-left: calc(-0.5 * var(--cui-toast-padding-x));
}
html:not([dir=rtl]) .toast-header .btn-close {
  margin-left: var(--cui-toast-padding-x);
}
*[dir=rtl] .toast-header .btn-close {
  margin-right: var(--cui-toast-padding-x);
}

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: ;
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: 12px;
  --cui-modal-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  --cui-modal-inner-border-radius: calc(12px - (var(--cui-border-width)));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: #eeeeee;
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: #eeeeee;
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  top: 0;
}
html:not([dir=rtl]) .modal {
  left: 0;
}
*[dir=rtl] .modal {
  right: 0;
}
.modal {
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--cui-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--cui-modal-header-padding-y) * 0.5) calc(var(--cui-modal-header-padding-x) * 0.5);
}
html:not([dir=rtl]) .modal-header .btn-close {
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x)) calc(-0.5 * var(--cui-modal-header-padding-y)) auto;
}
*[dir=rtl] .modal-header .btn-close {
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) auto calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x));
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * 0.5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--cui-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: 0 8px 24px rgba(60, 0, 90, 0.14);
  }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --cui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.75rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: "Inter", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--cui-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--cui-tooltip-arrow-width);
  height: var(--cui-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-bottom-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-left-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius);
}

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.75rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: 12px;
  --cui-popover-inner-border-radius: calc(12px - var(--cui-border-width));
  --cui-popover-box-shadow: 0 8px 24px rgba(60, 0, 90, 0.14);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 0.875rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: "Inter", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--cui-popover-arrow-width);
  height: var(--cui-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--cui-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--cui-popover-border-width);
  border-top-color: var(--cui-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--cui-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--cui-popover-border-width);
  border-right-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--cui-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--cui-popover-border-width);
  border-bottom-color: var(--cui-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-0.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--cui-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--cui-popover-border-width);
  border-left-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-coreui-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--cui-carousel-indicator-active-bg, #fff);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-coreui-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--cui-carousel-caption-color, rgba(255, 255, 255, 0.87));
  text-align: center;
}

.carousel-dark {
  --cui-carousel-indicator-active-bg: #000015;
  --cui-carousel-caption-color: rgba(44.4, 55.5, 74, 0.95);
}
.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-coreui-target] {
  background-color: #000015;
}
.carousel-dark .carousel-caption {
  color: rgba(44.4, 55.5, 74, 0.95);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    right: 0;
  }
  .offcanvas-sm.offcanvas-start {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-end {
    left: 0;
  }
  .offcanvas-sm.offcanvas-end {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-sm.offcanvas-end {
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    right: 0;
  }
  .offcanvas-md.offcanvas-start {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-md.offcanvas-end {
    left: 0;
  }
  .offcanvas-md.offcanvas-end {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-md.offcanvas-end {
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    right: 0;
  }
  .offcanvas-lg.offcanvas-start {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-end {
    left: 0;
  }
  .offcanvas-lg.offcanvas-end {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-lg.offcanvas-end {
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    right: 0;
  }
  .offcanvas-xl.offcanvas-start {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-end {
    left: 0;
  }
  .offcanvas-xl.offcanvas-end {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-xl.offcanvas-end {
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    right: 0;
  }
  .offcanvas-xxl.offcanvas-start {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-end {
    left: 0;
  }
  .offcanvas-xxl.offcanvas-end {
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-xxl.offcanvas-end {
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--cui-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  left: 0;
}
*[dir=rtl] .offcanvas.offcanvas-start {
  right: 0;
}
.offcanvas.offcanvas-start {
  width: var(--cui-offcanvas-width);
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
*[dir=rtl] .offcanvas.offcanvas-start {
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  transform: translateX(-100%);
}
*[dir=rtl] .offcanvas.offcanvas-start {
  transform: translateX(100%);
}
.offcanvas.offcanvas-end {
  top: 0;
}
html:not([dir=rtl]) .offcanvas.offcanvas-end {
  right: 0;
}
*[dir=rtl] .offcanvas.offcanvas-end {
  left: 0;
}
.offcanvas.offcanvas-end {
  width: var(--cui-offcanvas-width);
}
html:not([dir=rtl]) .offcanvas.offcanvas-end {
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
*[dir=rtl] .offcanvas.offcanvas-end {
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
.offcanvas.offcanvas-end {
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none !important;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-offcanvas-backdrop-bg, #000015);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--cui-offcanvas-padding-y) * 0.5) calc(var(--cui-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--cui-offcanvas-padding-y));
}
html:not([dir=rtl]) .offcanvas-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-offcanvas-padding-x));
}
*[dir=rtl] .offcanvas-header .btn-close {
  margin-left: calc(-0.5 * var(--cui-offcanvas-padding-x));
}
.offcanvas-header .btn-close {
  margin-bottom: calc(-0.5 * var(--cui-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000015 55%, rgba(0, 0, 0, 0.8) 75%, #000015 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50em;
  transition: margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .avatar {
    transition: none;
  }
}
.avatar {
  width: 2rem;
  height: 2rem;
  font-size: 0.8rem;
}
.avatar .avatar-status {
  width: 0.5333333333rem;
  height: 0.5333333333rem;
}

.avatar-img {
  width: 100%;
  height: auto;
  border-radius: 50em;
}

.avatar-status {
  position: absolute;
}
html:not([dir=rtl]) .avatar-status {
  right: 0;
}
*[dir=rtl] .avatar-status {
  left: 0;
}
.avatar-status {
  bottom: 0;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em;
}

.avatar-sm {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.6rem;
}
.avatar-sm .avatar-status {
  width: 0.4rem;
  height: 0.4rem;
}

.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
}
.avatar-md .avatar-status {
  width: 0.6666666667rem;
  height: 0.6666666667rem;
}

.avatar-lg {
  width: 3rem;
  height: 3rem;
  font-size: 1.2rem;
}
.avatar-lg .avatar-status {
  width: 0.8rem;
  height: 0.8rem;
}

.avatar-xl {
  width: 4rem;
  height: 4rem;
  font-size: 1.6rem;
}
.avatar-xl .avatar-status {
  width: 1.0666666667rem;
  height: 1.0666666667rem;
}

.avatars-stack {
  display: flex;
}
html:not([dir=rtl]) .avatars-stack .avatar {
  margin-right: -0.8rem;
}
*[dir=rtl] .avatars-stack .avatar {
  margin-left: -0.8rem;
}
html:not([dir=rtl]) .avatars-stack .avatar:hover {
  margin-right: 0;
}
*[dir=rtl] .avatars-stack .avatar:hover {
  margin-left: 0;
}
html:not([dir=rtl]) .avatars-stack .avatar-sm {
  margin-right: -0.6rem;
}
*[dir=rtl] .avatars-stack .avatar-sm {
  margin-left: -0.6rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-md {
  margin-right: -1rem;
}
*[dir=rtl] .avatars-stack .avatar-md {
  margin-left: -1rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-lg {
  margin-right: -1.2rem;
}
*[dir=rtl] .avatars-stack .avatar-lg {
  margin-left: -1.2rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-xl {
  margin-right: -1.6rem;
}
*[dir=rtl] .avatars-stack .avatar-xl {
  margin-left: -1.6rem;
}

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(var(--cui-border-width) * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
}
html:not([dir=rtl]) .callout {
  border-left-width: var(--cui-callout-border-left-width);
}
*[dir=rtl] .callout {
  border-right-width: var(--cui-callout-border-right-width);
}
html:not([dir=rtl]) .callout {
  border-left-color: var(--cui-callout-border-left-color);
}
*[dir=rtl] .callout {
  border-right-color: var(--cui-callout-border-right-color);
}
.callout {
  border-radius: var(--cui-callout-border-radius);
}

.callout-primary {
  --cui-callout-border-left-color: #3c005a;
}

.callout-secondary {
  --cui-callout-border-left-color: #8a8388;
}

.callout-success {
  --cui-callout-border-left-color: #2eb85c;
}

.callout-danger {
  --cui-callout-border-left-color: #e55353;
}

.callout-warning {
  --cui-callout-border-left-color: #f9b115;
}

.callout-info {
  --cui-callout-border-left-color: #39f;
}

.callout-light {
  --cui-callout-border-left-color: #ebedef;
}

.callout-dark {
  --cui-callout-border-left-color: #4f5d73;
}

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border);
}

.footer-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}

.header {
  --cui-header-min-height: 4rem;
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: #ffffff;
  --cui-header-color: #6b6470;
  --cui-header-border-color: #eeeeee;
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: #3c005a;
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: #3c005a;
  --cui-header-brand-padding-y: 0.3359375rem;
  --cui-header-brand-color: #4f5d73;
  --cui-header-brand-hover-color: rgb(71.1, 83.7, 103.5);
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: 8px;
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  --cui-subheader-min-height: 3rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-header-min-height);
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border);
}
.header > .container,
.header > .container-fluid,
.header > .container-sm,
.header > .container-md,
.header > .container-lg,
.header > .container-xl,
.header > .container-xxl, .header .navbar > .container,
.header .navbar > .container-fluid,
.header .navbar > .container-sm,
.header .navbar > .container-md,
.header .navbar > .container-lg,
.header .navbar > .container-xl,
.header .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.header .container:first-child,
.header .container-fluid:first-child,
.header .container-sm:first-child,
.header .container-md:first-child,
.header .container-lg:first-child,
.header .container-xl:first-child,
.header .container-xxl:first-child {
  min-height: calc(var(--cui-header-min-height) - 2 * var(--cui-header-padding-y));
}
.header .container:nth-child(n+2),
.header .container-fluid:nth-child(n+2),
.header .container-sm:nth-child(n+2),
.header .container-md:nth-child(n+2),
.header .container-lg:nth-child(n+2),
.header .container-xl:nth-child(n+2),
.header .container-xxl:nth-child(n+2) {
  min-height: calc(var(--cui-subheader-min-height) - 2 * var(--cui-header-padding-y));
}
.header.header-sticky {
  position: sticky;
  top: 0;
  z-index: 1029;
}

.header-divider {
  flex-basis: calc(100% + 2 * var(--cui-header-padding-x));
  height: 0;
  margin: var(--cui-header-padding-y) calc(var(--cui-header-padding-x) * -1);
  border-top: var(--cui-header-divider-border);
}

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
}
html:not([dir=rtl]) .header-brand {
  margin-right: 1rem;
}
*[dir=rtl] .header-brand {
  margin-left: 1rem;
}
.header-brand {
  font-size: 1.09375rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.header-brand:hover, .header-brand:focus {
  color: var(--cui-header-brand-hover-color);
}

.header-nav {
  display: flex;
  flex-direction: row;
}
html:not([dir=rtl]) .header-nav {
  padding-left: 0;
}
*[dir=rtl] .header-nav {
  padding-right: 0;
}
.header-nav {
  margin-bottom: 0;
  list-style: none;
}
.header-nav .nav-link {
  padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
  color: var(--cui-header-color);
}
.header-nav .nav-link:hover, .header-nav .nav-link:focus {
  color: var(--cui-header-hover-color);
}
.header-nav .nav-link.disabled {
  color: var(--cui-header-disabled-color);
}
.header-nav .show > .nav-link,
.header-nav .nav-link.active {
  color: var(--cui-header-active-color);
}
.header-nav .dropdown-menu {
  position: absolute;
}

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color);
}
.header-text a {
  color: var(--cui-header-active-color);
}
.header-text a:hover, .header-text a:focus {
  color: var(--cui-header-active-color);
}

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.09375rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius);
}
.header-toggler:hover {
  color: var(--cui-header-toggler-hover-color);
  text-decoration: none;
}
.header-toggler:focus {
  outline: 0;
}
.header-toggler:not(:disabled) {
  cursor: pointer;
}

.header-toggler-icon {
  display: block;
  height: 1.3671875rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}
.header-toggler-icon:hover {
  background-image: var(--cui-header-toggler-hover-icon-bg);
}

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -0.125rem;
  fill: currentcolor;
}
.icon:not(.icon-c-s):not(.icon-custom-size) {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
  width: 4rem;
  height: 4rem;
  font-size: 4rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
  width: 5rem;
  height: 5rem;
  font-size: 5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
  width: 6rem;
  height: 6rem;
  font-size: 6rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
  width: 7rem;
  height: 7rem;
  font-size: 7rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
  width: 8rem;
  height: 8rem;
  font-size: 8rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
  width: 9rem;
  height: 9rem;
  font-size: 9rem;
}

.sidebar {
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: #2a0040;
  --cui-sidebar-padding-x: 0;
  --cui-sidebar-padding-y: 0;
  --cui-sidebar-color: rgba(255, 255, 255, 0.92);
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: rgba(255, 255, 255, 0.92);
  --cui-sidebar-brand-height: 4rem;
  --cui-sidebar-brand-bg: #2a0040;
  --cui-sidebar-header-height: 4rem;
  --cui-sidebar-header-bg: rgba(0, 0, 0, 0.15);
  --cui-sidebar-header-padding-x: 1rem;
  --cui-sidebar-header-padding-y: 0.75rem;
  --cui-sidebar-footer-bg: rgba(0, 0, 0, 0.15);
  --cui-sidebar-footer-height: auto;
  --cui-sidebar-footer-padding-x: 1rem;
  --cui-sidebar-footer-padding-y: 0.75rem;
  --cui-sidebar-toggler-bg: rgba(0, 0, 0, 0.15);
  --cui-sidebar-toggler-height: 3rem;
  --cui-sidebar-toggler-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --cui-sidebar-toggler-indicator-width: 4rem;
  --cui-sidebar-toggler-indicator-height: 3rem;
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 0, 0.3);
  --cui-sidebar-toggler-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: rgba(255, 255, 255, 0.65);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.8445rem;
  --cui-sidebar-nav-link-color: rgba(255, 255, 255, 0.65);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border: 0 solid var(--cui-sidebar-nav-link-border-color);
  --cui-sidebar-nav-link-border-radius: 0;
  --cui-sidebar-nav-link-active-color: rgba(255, 255, 255, 0.92);
  --cui-sidebar-nav-link-active-bg: #5c1680;
  --cui-sidebar-nav-link-active-icon-color: rgba(255, 255, 255, 0.92);
  --cui-sidebar-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(255, 255, 255, 0.65);
  --cui-sidebar-nav-link-hover-color: rgba(255, 255, 255, 0.92);
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.08);
  --cui-sidebar-nav-link-hover-icon-color: rgba(255, 255, 255, 0.92);
  --cui-sidebar-nav-icon-width: 4rem;
  --cui-sidebar-nav-icon-height: 1.25rem;
  --cui-sidebar-nav-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-icon-color: rgba(255, 255, 255, 0.65);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.12);
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --cui-sidebar-nav-group-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --cui-sidebar-nav-group-toggle-show-color: rgba(255, 255, 255, 0.92);
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
}
html:not([dir=rtl]) .sidebar {
  border-right: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
}
*[dir=rtl] .sidebar {
  border-left: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
}
.sidebar {
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
  margin-left: 0;
}
*[dir=rtl] .sidebar:not(.sidebar-end) {
  margin-right: 0;
}
.sidebar:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 16rem;
}
.sidebar.sidebar-end {
  order: 99;
}
html:not([dir=rtl]) .sidebar.sidebar-end {
  margin-right: 0;
}
*[dir=rtl] .sidebar.sidebar-end {
  margin-left: 0;
}
.sidebar.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 16rem;
}
.sidebar[class*=bg-] {
  border-color: rgba(0, 0, 21, 0.1);
}
.sidebar.sidebar-sm {
  --cui-sidebar-width: 12rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-sm:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 12rem;
  }
  .sidebar.sidebar-sm.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 12rem;
  }
}
.sidebar.sidebar-lg {
  --cui-sidebar-width: 20rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-lg:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 20rem;
  }
  .sidebar.sidebar-lg.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 20rem;
  }
}
.sidebar.sidebar-xl {
  --cui-sidebar-width: 24rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-xl:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 24rem;
  }
  .sidebar.sidebar-xl.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 24rem;
  }
}
@media (min-width: 768px) {
  html:not([dir=rtl]) .sidebar.hide:not(.sidebar-end) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.hide:not(.sidebar-end) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0;
  }
  html:not([dir=rtl]) .sidebar.hide.sidebar-end {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.hide.sidebar-end {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0;
  }
}
@media (min-width: 768px) {
  .sidebar.sidebar-fixed {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1030;
  }
  html:not([dir=rtl]) .sidebar.sidebar-fixed:not(.sidebar-end) {
    left: 0;
  }
  *[dir=rtl] .sidebar.sidebar-fixed:not(.sidebar-end) {
    right: 0;
  }
  html:not([dir=rtl]) .sidebar.sidebar-fixed.sidebar-end {
    right: 0;
  }
  *[dir=rtl] .sidebar.sidebar-fixed.sidebar-end {
    left: 0;
  }
}
@media (min-width: 768px) {
  .sidebar.sidebar-sticky {
    position: sticky;
    top: 0;
    height: 100vh;
  }
}
.sidebar.sidebar-overlaid {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1032;
}
html:not([dir=rtl]) .sidebar.sidebar-overlaid:not(.sidebar-end) {
  left: 0;
}
*[dir=rtl] .sidebar.sidebar-overlaid:not(.sidebar-end) {
  right: 0;
}
.sidebar.sidebar-overlaid:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 0;
}
html:not([dir=rtl]) .sidebar.sidebar-overlaid.sidebar-end {
  right: 0;
}
*[dir=rtl] .sidebar.sidebar-overlaid.sidebar-end {
  left: 0;
}
.sidebar.sidebar-overlaid.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 0;
}
@media (max-width: 767.98px) {
  .sidebar {
    --cui-is-mobile: true;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1031;
  }
  html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
    left: 0;
  }
  *[dir=rtl] .sidebar:not(.sidebar-end) {
    right: 0;
  }
  .sidebar:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0 !important;
  }
  html:not([dir=rtl]) .sidebar:not(.sidebar-end):not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar:not(.sidebar-end):not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  html:not([dir=rtl]) .sidebar.sidebar-end {
    right: 0;
  }
  *[dir=rtl] .sidebar.sidebar-end {
    left: 0;
  }
  .sidebar.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0 !important;
  }
  html:not([dir=rtl]) .sidebar.sidebar-end:not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.sidebar-end:not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
}

.sidebar-close {
  position: absolute;
  top: 0;
}
html:not([dir=rtl]) .sidebar-close {
  right: 0;
}
*[dir=rtl] .sidebar-close {
  left: 0;
}
.sidebar-close {
  width: var(--cui-sidebar-width);
  height: var(--cui-sidebar-header-height);
  color: var(--cui-sidebar-color);
  background: transparent;
  border: 0;
}
.sidebar-close:hover {
  text-decoration: none;
}
.sidebar-close:focus {
  outline: 0;
}

.sidebar-brand {
  display: flex;
  flex: 0 0 var(--cui-sidebar-brand-height);
  align-items: center;
  justify-content: center;
  color: var(--cui-sidebar-brand-color);
  background: var(--cui-sidebar-brand-bg);
}
.sidebar-brand .sidebar-brand-narrow {
  display: none;
}

.sidebar-header {
  flex: 0 0 var(--cui-sidebar-header-height);
  padding: var(--cui-sidebar-header-padding-y) var(--cui-sidebar-header-padding-x);
  text-align: center;
  background: var(--cui-sidebar-header-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-header {
    transition: none;
  }
}
.sidebar-header .nav-link {
  display: flex;
  align-items: center;
  min-height: var(--cui-sidebar-header-height);
}

.sidebar-footer {
  flex: 0 0 var(--cui-sidebar-footer-height);
  padding: var(--cui-sidebar-footer-padding-y) var(--cui-sidebar-footer-padding-x);
  background: var(--cui-sidebar-footer-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-footer {
    transition: none;
  }
}

.sidebar-toggler {
  display: flex;
  flex: 0 0 var(--cui-sidebar-toggler-height);
  justify-content: flex-end;
  width: inherit;
  padding: 0;
  cursor: pointer;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0;
}
@media (max-width: 767.98px) {
  .sidebar-toggler {
    display: none;
  }
}
.sidebar-toggler::before {
  display: block;
  width: var(--cui-sidebar-toggler-indicator-width);
  height: var(--cui-sidebar-toggler-indicator-height);
  content: "";
  background-image: var(--cui-sidebar-toggler-indicator);
  background-repeat: no-repeat;
  background-position: center;
  background-size: calc(var(--cui-sidebar-toggler-indicator-height) * 0.25);
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-toggler::before {
    transition: none;
  }
}
*[dir=rtl] .sidebar-toggler::before {
  transform: rotate(-180deg);
}
.sidebar-toggler:focus {
  outline: 0;
}
.sidebar-toggler:hover {
  background-color: var(--cui-sidebar-toggler-hover-bg);
}
.sidebar-toggler:hover::before {
  background-image: var(--cui-sidebar-toggler-indicator-hover);
}
.sidebar-end .sidebar-toggler {
  justify-content: flex-start;
}
.sidebar-end .sidebar-toggler::before {
  transform: rotate(-180deg);
}

.sidebar-backdrop {
  --cui-backdrop-zindex: 1030;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
}
@media (max-width: 767.98px) {
  .sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--cui-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--cui-backdrop-bg);
  }
  .sidebar-backdrop.fade {
    opacity: 0;
  }
  .sidebar-backdrop.show {
    opacity: var(--cui-backdrop-opacity);
  }
}

.sidebar-nav {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}
.sidebar-nav .nav-title {
  padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
  margin-top: var(--cui-sidebar-nav-title-margin-top);
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-sidebar-nav-title-color);
  text-transform: uppercase;
  transition: height 0.15s, margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-title {
    transition: none;
  }
}
.sidebar-nav .nav-link {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
  color: var(--cui-sidebar-nav-link-color);
  text-decoration: none;
  white-space: nowrap;
  background: var(--cui-sidebar-nav-link-bg);
  border: var(--cui-sidebar-nav-link-border);
  border-radius: var(--cui-sidebar-nav-link-border-radius);
  transition: background 200ms ease, color 200ms ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-link {
    transition: none;
  }
}
.sidebar-nav .nav-link.active {
  color: var(--cui-sidebar-nav-link-active-color);
  background: var(--cui-sidebar-nav-link-active-bg);
}
.sidebar-nav .nav-link.active .nav-icon {
  color: var(--cui-sidebar-nav-link-active-icon-color);
}
.sidebar-nav .nav-link.disabled {
  color: var(--cui-sidebar-nav-link-disabled-color);
  pointer-events: none;
  cursor: not-allowed;
  background: transparent;
}
.sidebar-nav .nav-link.disabled .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover {
  color: var(--cui-sidebar-nav-link-disabled-color);
}
.sidebar-nav .nav-link.disabled:hover .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover.nav-dropdown-toggle::after {
  background-image: var(--cui-sidebar-nav-group-indicator-hover);
}
@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-link:hover {
    color: var(--cui-sidebar-nav-link-hover-color);
    text-decoration: none;
    background: var(--cui-sidebar-nav-link-hover-bg);
  }
  .sidebar-nav .nav-link:hover .nav-icon {
    color: var(--cui-sidebar-nav-link-hover-icon-color);
  }
  .sidebar-nav .nav-link:hover.nav-group-toggle::after {
    background-image: var(--cui-sidebar-nav-group-indicator-hover);
  }
}
.sidebar-nav .nav-icon {
  flex: 0 0 var(--cui-sidebar-nav-icon-width);
  height: var(--cui-sidebar-nav-icon-height);
  font-size: var(--cui-sidebar-nav-icon-font-size);
  color: var(--cui-sidebar-nav-link-icon-color);
  text-align: center;
  pointer-events: none;
  fill: currentcolor;
  transition: inherit;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-icon {
    transition: none;
  }
}
html:not([dir=rtl]) .sidebar-nav .nav-icon:first-child {
  margin-left: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
*[dir=rtl] .sidebar-nav .nav-icon:first-child {
  margin-right: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
.sidebar-nav svg.nav-icon {
  overflow: hidden;
}
.sidebar-nav .nav-group {
  position: relative;
  transition: background 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group {
    transition: none;
  }
}
.sidebar-nav .nav-group .nav-group-items {
  padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
  overflow: hidden;
  transition: height 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group .nav-group-items {
    transition: none;
  }
}
.sidebar-nav .nav-group:not(.show) .nav-group-items {
  display: none;
}
.sidebar-nav .nav-group.show {
  background: var(--cui-sidebar-nav-group-bg);
}
.sidebar-nav .nav-group.show .nav-group-toggle {
  color: var(--cui-sidebar-nav-group-toggle-show-color);
}
.sidebar-nav .nav-group.show > .nav-group-toggle::after {
  transform: rotate(180deg);
}
.sidebar-nav .nav-group.show + .show {
  margin-top: 1px;
}
.sidebar-nav .nav-group-toggle {
  cursor: pointer;
}
.sidebar-nav .nav-group-toggle::after {
  display: block;
  flex: 0 1 12px;
  height: 12px;
}
html:not([dir=rtl]) .sidebar-nav .nav-group-toggle::after {
  margin-left: auto;
}
*[dir=rtl] .sidebar-nav .nav-group-toggle::after {
  margin-right: auto;
}
.sidebar-nav .nav-group-toggle::after {
  content: "";
  background-image: var(--cui-sidebar-nav-group-indicator);
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-toggle::after {
    transition: none;
  }
}
.sidebar-nav .nav-group-items {
  padding: 0;
  list-style: none;
}
html:not([dir=rtl]) .sidebar-nav .nav-group-items .nav-link {
  padding-left: var(--cui-sidebar-nav-icon-width);
}
*[dir=rtl] .sidebar-nav .nav-group-items .nav-link {
  padding-right: var(--cui-sidebar-nav-icon-width);
}
html:not([dir=rtl]) .sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-left: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
*[dir=rtl] .sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-right: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
.sidebar-nav.compact .nav-link,
.sidebar-nav .compact .nav-link {
  padding-top: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
  padding-bottom: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
}

@media (min-width: 768px) {
  .sidebar-narrow-unfoldable:not(:hover), .sidebar-narrow {
    z-index: 1031;
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible;
  }
  .sidebar-fixed.sidebar-narrow-unfoldable:not(:hover), .sidebar-fixed.sidebar-narrow {
    z-index: 1031;
    width: var(--cui-sidebar-narrow-width);
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full, .sidebar-narrow .sidebar-brand-full {
    display: none;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-narrow, .sidebar-narrow .sidebar-brand-narrow {
    display: block;
  }
  .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none, .sidebar-narrow .d-narrow-none,
  .sidebar-narrow-unfoldable:not(:hover) .nav-label,
  .sidebar-narrow .nav-label,
  .sidebar-narrow-unfoldable:not(:hover) .nav-title,
  .sidebar-narrow .nav-title,
  .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
  .sidebar-narrow .nav-group-items,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-footer,
  .sidebar-narrow .sidebar-footer,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-form,
  .sidebar-narrow .sidebar-form,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-header,
  .sidebar-narrow .sidebar-header {
    height: 0 !important;
    padding: 0;
    margin: 0;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler, .sidebar-narrow .sidebar-toggler {
    position: fixed;
    bottom: 0;
  }
  html:not([dir=rtl]) .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, html:not([dir=rtl]) .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(-180deg);
  }
  *[dir=rtl] .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, *[dir=rtl] .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
  .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, .sidebar-end.sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}

.sidebar-narrow:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}

.sidebar-narrow-unfoldable {
  position: fixed;
  z-index: 1031;
}
.sidebar-narrow-unfoldable:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow-unfoldable.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}
html:not([dir=rtl]) .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(-180deg);
}
*[dir=rtl] .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(0deg);
}
.sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
  transform: rotate(0deg);
}

html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}
*[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}
html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}
*[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}

@media (max-width: 575.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 767.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 991.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1199.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1399.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
.subheader {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.5rem 1rem;
  background: var(--cui-subheader-bg, #fff);
  border-bottom: var(--cui-subheader-border-width, var(--cui-border-width)) solid var(--cui-subheader-border-color, var(--cui-border-color));
}

.subheader-sticky {
  position: sticky;
  top: 0;
  z-index: 1029;
}

.subheader-nav {
  display: flex;
  flex-direction: row;
}
html:not([dir=rtl]) .subheader-nav {
  padding-left: 0;
}
*[dir=rtl] .subheader-nav {
  padding-right: 0;
}
.subheader-nav {
  margin-bottom: 0;
  list-style: none;
}
.subheader-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-nav .nav-link:hover, .subheader-nav .nav-link:focus {
  color: var(--cui-subheader-hover-color, var(--cui-body-color));
}
.subheader-nav .nav-link.disabled {
  color: var(--cui-subheader-disabled-color, rgba(44.4, 55.5, 74, 0.38));
}
.subheader-nav .show > .nav-link,
.subheader-nav .nav-link.active {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-nav .dropdown-menu {
  position: absolute;
}

.subheader-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-text a {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-text a:hover, .subheader-text a:focus {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000015 !important;
  background-color: RGBA(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000015 !important;
  background-color: RGBA(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000015 !important;
  background-color: RGBA(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: rgba(44.4, 55.5, 74, 0.95) !important;
  background-color: RGBA(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000015 !important;
  background-color: RGBA(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: rgba(44.4, 55.5, 74, 0.95) !important;
  background-color: RGBA(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(99, 51, 123, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(99, 51, 123, var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(161, 156, 160, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(161, 156, 160, var(--cui-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(88, 198, 125, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(88, 198, 125, var(--cui-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(92, 173, 255, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(92, 173, 255, var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(199, 142, 17, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(199, 142, 17, var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(234, 117, 117, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(234, 117, 117, var(--cui-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(188, 190, 191, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(188, 190, 191, var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(114, 125, 143, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(114, 125, 143, var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--cui-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
}
html:not([dir=rtl]) .ratio > * {
  left: 0;
}
*[dir=rtl] .ratio > * {
  right: 0;
}
.ratio > * {
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --cui-aspect-ratio: 100%;
}

.ratio-4x3 {
  --cui-aspect-ratio: 75%;
}

.ratio-16x9 {
  --cui-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --cui-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

html:not([dir=rtl]) .float-start {
  float: left !important;
}
*[dir=rtl] .float-start {
  float: right !important;
}

html:not([dir=rtl]) .float-end {
  float: right !important;
}
*[dir=rtl] .float-end {
  float: left !important;
}

html:not([dir=rtl]) .float-none {
  float: none !important;
}
*[dir=rtl] .float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 4px 12px rgba(60, 0, 90, 0.08) !important;
}

.shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
}

.shadow-lg {
  box-shadow: 0 8px 24px rgba(60, 0, 90, 0.14) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

html:not([dir=rtl]) .border-end {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}
*[dir=rtl] .border-end {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

html:not([dir=rtl]) .border-end-0 {
  border-right: 0 !important;
}
*[dir=rtl] .border-end-0 {
  border-left: 0 !important;
}

.border-bottom {
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

html:not([dir=rtl]) .border-start {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}
*[dir=rtl] .border-start {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

html:not([dir=rtl]) .border-start-0 {
  border-left: 0 !important;
}
*[dir=rtl] .border-start-0 {
  border-right: 0 !important;
}

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important;
}

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important;
}

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important;
}

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important;
}

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important;
}

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important;
}

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important;
}

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important;
}

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important;
}

.border-top-primary {
  border-top-color: #3c005a !important;
}

.border-top-secondary {
  border-top-color: #8a8388 !important;
}

.border-top-success {
  border-top-color: #2eb85c !important;
}

.border-top-info {
  border-top-color: #39f !important;
}

.border-top-warning {
  border-top-color: #f9b115 !important;
}

.border-top-danger {
  border-top-color: #e55353 !important;
}

.border-top-light {
  border-top-color: #ebedef !important;
}

.border-top-dark {
  border-top-color: #4f5d73 !important;
}

.border-top-white {
  border-top-color: #fff !important;
}

html:not([dir=rtl]) .border-end-primary {
  border-right-color: #3c005a !important;
}
*[dir=rtl] .border-end-primary {
  border-left-color: #3c005a !important;
}

html:not([dir=rtl]) .border-end-secondary {
  border-right-color: #8a8388 !important;
}
*[dir=rtl] .border-end-secondary {
  border-left-color: #8a8388 !important;
}

html:not([dir=rtl]) .border-end-success {
  border-right-color: #2eb85c !important;
}
*[dir=rtl] .border-end-success {
  border-left-color: #2eb85c !important;
}

html:not([dir=rtl]) .border-end-info {
  border-right-color: #39f !important;
}
*[dir=rtl] .border-end-info {
  border-left-color: #39f !important;
}

html:not([dir=rtl]) .border-end-warning {
  border-right-color: #f9b115 !important;
}
*[dir=rtl] .border-end-warning {
  border-left-color: #f9b115 !important;
}

html:not([dir=rtl]) .border-end-danger {
  border-right-color: #e55353 !important;
}
*[dir=rtl] .border-end-danger {
  border-left-color: #e55353 !important;
}

html:not([dir=rtl]) .border-end-light {
  border-right-color: #ebedef !important;
}
*[dir=rtl] .border-end-light {
  border-left-color: #ebedef !important;
}

html:not([dir=rtl]) .border-end-dark {
  border-right-color: #4f5d73 !important;
}
*[dir=rtl] .border-end-dark {
  border-left-color: #4f5d73 !important;
}

html:not([dir=rtl]) .border-end-white {
  border-right-color: #fff !important;
}
*[dir=rtl] .border-end-white {
  border-left-color: #fff !important;
}

.border-bottom-primary {
  border-bottom-color: #3c005a !important;
}

.border-bottom-secondary {
  border-bottom-color: #8a8388 !important;
}

.border-bottom-success {
  border-bottom-color: #2eb85c !important;
}

.border-bottom-info {
  border-bottom-color: #39f !important;
}

.border-bottom-warning {
  border-bottom-color: #f9b115 !important;
}

.border-bottom-danger {
  border-bottom-color: #e55353 !important;
}

.border-bottom-light {
  border-bottom-color: #ebedef !important;
}

.border-bottom-dark {
  border-bottom-color: #4f5d73 !important;
}

.border-bottom-white {
  border-bottom-color: #fff !important;
}

html:not([dir=rtl]) .border-start-primary {
  border-left-color: #3c005a !important;
}
*[dir=rtl] .border-start-primary {
  border-right-color: #3c005a !important;
}

html:not([dir=rtl]) .border-start-secondary {
  border-left-color: #8a8388 !important;
}
*[dir=rtl] .border-start-secondary {
  border-right-color: #8a8388 !important;
}

html:not([dir=rtl]) .border-start-success {
  border-left-color: #2eb85c !important;
}
*[dir=rtl] .border-start-success {
  border-right-color: #2eb85c !important;
}

html:not([dir=rtl]) .border-start-info {
  border-left-color: #39f !important;
}
*[dir=rtl] .border-start-info {
  border-right-color: #39f !important;
}

html:not([dir=rtl]) .border-start-warning {
  border-left-color: #f9b115 !important;
}
*[dir=rtl] .border-start-warning {
  border-right-color: #f9b115 !important;
}

html:not([dir=rtl]) .border-start-danger {
  border-left-color: #e55353 !important;
}
*[dir=rtl] .border-start-danger {
  border-right-color: #e55353 !important;
}

html:not([dir=rtl]) .border-start-light {
  border-left-color: #ebedef !important;
}
*[dir=rtl] .border-start-light {
  border-right-color: #ebedef !important;
}

html:not([dir=rtl]) .border-start-dark {
  border-left-color: #4f5d73 !important;
}
*[dir=rtl] .border-start-dark {
  border-right-color: #4f5d73 !important;
}

html:not([dir=rtl]) .border-start-white {
  border-left-color: #fff !important;
}
*[dir=rtl] .border-start-white {
  border-right-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

html:not([dir=rtl]) .border-end-1 {
  border-right-width: 1px !important;
}
*[dir=rtl] .border-end-1 {
  border-left-width: 1px !important;
}

html:not([dir=rtl]) .border-end-2 {
  border-right-width: 2px !important;
}
*[dir=rtl] .border-end-2 {
  border-left-width: 2px !important;
}

html:not([dir=rtl]) .border-end-3 {
  border-right-width: 3px !important;
}
*[dir=rtl] .border-end-3 {
  border-left-width: 3px !important;
}

html:not([dir=rtl]) .border-end-4 {
  border-right-width: 4px !important;
}
*[dir=rtl] .border-end-4 {
  border-left-width: 4px !important;
}

html:not([dir=rtl]) .border-end-5 {
  border-right-width: 5px !important;
}
*[dir=rtl] .border-end-5 {
  border-left-width: 5px !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

html:not([dir=rtl]) .border-start-1 {
  border-left-width: 1px !important;
}
*[dir=rtl] .border-start-1 {
  border-right-width: 1px !important;
}

html:not([dir=rtl]) .border-start-2 {
  border-left-width: 2px !important;
}
*[dir=rtl] .border-start-2 {
  border-right-width: 2px !important;
}

html:not([dir=rtl]) .border-start-3 {
  border-left-width: 3px !important;
}
*[dir=rtl] .border-start-3 {
  border-right-width: 3px !important;
}

html:not([dir=rtl]) .border-start-4 {
  border-left-width: 4px !important;
}
*[dir=rtl] .border-start-4 {
  border-right-width: 4px !important;
}

html:not([dir=rtl]) .border-start-5 {
  border-left-width: 5px !important;
}
*[dir=rtl] .border-start-5 {
  border-right-width: 5px !important;
}

.border-opacity-10 {
  --cui-border-opacity: 0.1;
}

.border-opacity-25 {
  --cui-border-opacity: 0.25;
}

.border-opacity-50 {
  --cui-border-opacity: 0.5;
}

.border-opacity-75 {
  --cui-border-opacity: 0.75;
}

.border-opacity-100 {
  --cui-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

html:not([dir=rtl]) .me-0 {
  margin-right: 0 !important;
}
*[dir=rtl] .me-0 {
  margin-left: 0 !important;
}

html:not([dir=rtl]) .me-1 {
  margin-right: 0.25rem !important;
}
*[dir=rtl] .me-1 {
  margin-left: 0.25rem !important;
}

html:not([dir=rtl]) .me-2 {
  margin-right: 0.5rem !important;
}
*[dir=rtl] .me-2 {
  margin-left: 0.5rem !important;
}

html:not([dir=rtl]) .me-3 {
  margin-right: 1rem !important;
}
*[dir=rtl] .me-3 {
  margin-left: 1rem !important;
}

html:not([dir=rtl]) .me-4 {
  margin-right: 1.5rem !important;
}
*[dir=rtl] .me-4 {
  margin-left: 1.5rem !important;
}

html:not([dir=rtl]) .me-5 {
  margin-right: 3rem !important;
}
*[dir=rtl] .me-5 {
  margin-left: 3rem !important;
}

html:not([dir=rtl]) .me-auto {
  margin-right: auto !important;
}
*[dir=rtl] .me-auto {
  margin-left: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

html:not([dir=rtl]) .ms-0 {
  margin-left: 0 !important;
}
*[dir=rtl] .ms-0 {
  margin-right: 0 !important;
}

html:not([dir=rtl]) .ms-1 {
  margin-left: 0.25rem !important;
}
*[dir=rtl] .ms-1 {
  margin-right: 0.25rem !important;
}

html:not([dir=rtl]) .ms-2 {
  margin-left: 0.5rem !important;
}
*[dir=rtl] .ms-2 {
  margin-right: 0.5rem !important;
}

html:not([dir=rtl]) .ms-3 {
  margin-left: 1rem !important;
}
*[dir=rtl] .ms-3 {
  margin-right: 1rem !important;
}

html:not([dir=rtl]) .ms-4 {
  margin-left: 1.5rem !important;
}
*[dir=rtl] .ms-4 {
  margin-right: 1.5rem !important;
}

html:not([dir=rtl]) .ms-5 {
  margin-left: 3rem !important;
}
*[dir=rtl] .ms-5 {
  margin-right: 3rem !important;
}

html:not([dir=rtl]) .ms-auto {
  margin-left: auto !important;
}
*[dir=rtl] .ms-auto {
  margin-right: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

html:not([dir=rtl]) .pe-0 {
  padding-right: 0 !important;
}
*[dir=rtl] .pe-0 {
  padding-left: 0 !important;
}

html:not([dir=rtl]) .pe-1 {
  padding-right: 0.25rem !important;
}
*[dir=rtl] .pe-1 {
  padding-left: 0.25rem !important;
}

html:not([dir=rtl]) .pe-2 {
  padding-right: 0.5rem !important;
}
*[dir=rtl] .pe-2 {
  padding-left: 0.5rem !important;
}

html:not([dir=rtl]) .pe-3 {
  padding-right: 1rem !important;
}
*[dir=rtl] .pe-3 {
  padding-left: 1rem !important;
}

html:not([dir=rtl]) .pe-4 {
  padding-right: 1.5rem !important;
}
*[dir=rtl] .pe-4 {
  padding-left: 1.5rem !important;
}

html:not([dir=rtl]) .pe-5 {
  padding-right: 3rem !important;
}
*[dir=rtl] .pe-5 {
  padding-left: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

html:not([dir=rtl]) .ps-0 {
  padding-left: 0 !important;
}
*[dir=rtl] .ps-0 {
  padding-right: 0 !important;
}

html:not([dir=rtl]) .ps-1 {
  padding-left: 0.25rem !important;
}
*[dir=rtl] .ps-1 {
  padding-right: 0.25rem !important;
}

html:not([dir=rtl]) .ps-2 {
  padding-left: 0.5rem !important;
}
*[dir=rtl] .ps-2 {
  padding-right: 0.5rem !important;
}

html:not([dir=rtl]) .ps-3 {
  padding-left: 1rem !important;
}
*[dir=rtl] .ps-3 {
  padding-right: 1rem !important;
}

html:not([dir=rtl]) .ps-4 {
  padding-left: 1.5rem !important;
}
*[dir=rtl] .ps-4 {
  padding-right: 1.5rem !important;
}

html:not([dir=rtl]) .ps-5 {
  padding-left: 3rem !important;
}
*[dir=rtl] .ps-5 {
  padding-right: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--cui-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.34375rem + 1.125vw) !important;
}

.fs-2 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-3 {
  font-size: calc(1.278125rem + 0.3375vw) !important;
}

.fs-4 {
  font-size: calc(1.25625rem + 0.075vw) !important;
}

.fs-5 {
  font-size: 1.09375rem !important;
}

.fs-6 {
  font-size: 0.875rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

html:not([dir=rtl]) .text-start {
  text-align: left !important;
}
*[dir=rtl] .text-start {
  text-align: right !important;
}

html:not([dir=rtl]) .text-end {
  text-align: right !important;
}
*[dir=rtl] .text-end {
  text-align: left !important;
}

html:not([dir=rtl]) .text-center {
  text-align: center !important;
}
*[dir=rtl] .text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}

.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}

.text-success {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}

.text-info {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}

.text-warning {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}

.text-danger {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}

.text-light {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}

.text-dark {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}

.text-black {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}

.text-white {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}

.text-body {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}

.text-muted {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(0, 0, 21, 0.5) !important;
}

.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-body-tertiary {
  --cui-text-opacity: 1;
  color: var(--cui-tertiary-color) !important;
}

.text-body-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-emphasis-color) !important;
}

.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important;
}

.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis-inverse) !important;
}

.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis-inverse) !important;
}

.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-disabled-inverse) !important;
}

.text-high-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis) !important;
}

.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis) !important;
}

.text-disabled {
  --cui-text-opacity: 1;
  color: var(--cui-disabled) !important;
}

.text-opacity-25 {
  --cui-text-opacity: 0.25;
}

.text-opacity-50 {
  --cui-text-opacity: 0.5;
}

.text-opacity-75 {
  --cui-text-opacity: 0.75;
}

.text-opacity-100 {
  --cui-text-opacity: 1;
}

.link-opacity-10 {
  --cui-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1;
}

.link-opacity-25 {
  --cui-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25;
}

.link-opacity-50 {
  --cui-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5;
}

.link-opacity-75 {
  --cui-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75;
}

.link-opacity-100 {
  --cui-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-success {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-info {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-light {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1;
}

.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}

.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}

.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}

.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}

.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}

.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}

.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}

.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-opacity-10 {
  --cui-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --cui-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --cui-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --cui-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --cui-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--cui-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--cui-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--cui-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--cui-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--cui-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

html:not([dir=rtl]) .rounded-end {
  border-top-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end {
  border-top-left-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-end {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-end-0 {
  border-top-right-radius: 0 !important;
}
*[dir=rtl] .rounded-end-0 {
  border-top-left-radius: 0 !important;
}
html:not([dir=rtl]) .rounded-end-0 {
  border-bottom-right-radius: 0 !important;
}
*[dir=rtl] .rounded-end-0 {
  border-bottom-left-radius: 0 !important;
}

html:not([dir=rtl]) .rounded-end-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-end-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}
html:not([dir=rtl]) .rounded-end-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-end-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

html:not([dir=rtl]) .rounded-end-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-end-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-end-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-end-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}
html:not([dir=rtl]) .rounded-end-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-end-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

html:not([dir=rtl]) .rounded-end-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-end-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}
html:not([dir=rtl]) .rounded-end-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-end-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

html:not([dir=rtl]) .rounded-end-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-end-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}
html:not([dir=rtl]) .rounded-end-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-end-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

html:not([dir=rtl]) .rounded-end-circle {
  border-top-right-radius: 50% !important;
}
*[dir=rtl] .rounded-end-circle {
  border-top-left-radius: 50% !important;
}
html:not([dir=rtl]) .rounded-end-circle {
  border-bottom-right-radius: 50% !important;
}
*[dir=rtl] .rounded-end-circle {
  border-bottom-left-radius: 50% !important;
}

html:not([dir=rtl]) .rounded-end-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-end-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}
html:not([dir=rtl]) .rounded-end-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-end-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

html:not([dir=rtl]) .rounded-start {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-start {
  border-top-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start {
  border-top-right-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
}
*[dir=rtl] .rounded-start-0 {
  border-bottom-right-radius: 0 !important;
}
html:not([dir=rtl]) .rounded-start-0 {
  border-top-left-radius: 0 !important;
}
*[dir=rtl] .rounded-start-0 {
  border-top-right-radius: 0 !important;
}

html:not([dir=rtl]) .rounded-start-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-start-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}
html:not([dir=rtl]) .rounded-start-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-start-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

html:not([dir=rtl]) .rounded-start-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-start-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-start-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-start-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}
html:not([dir=rtl]) .rounded-start-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-start-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

html:not([dir=rtl]) .rounded-start-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-start-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}
html:not([dir=rtl]) .rounded-start-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-start-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

html:not([dir=rtl]) .rounded-start-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-start-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}
html:not([dir=rtl]) .rounded-start-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-start-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

html:not([dir=rtl]) .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
}
*[dir=rtl] .rounded-start-circle {
  border-bottom-right-radius: 50% !important;
}
html:not([dir=rtl]) .rounded-start-circle {
  border-top-left-radius: 50% !important;
}
*[dir=rtl] .rounded-start-circle {
  border-top-right-radius: 50% !important;
}

html:not([dir=rtl]) .rounded-start-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-start-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}
html:not([dir=rtl]) .rounded-start-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-start-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  html:not([dir=rtl]) .float-sm-start {
    float: left !important;
  }
  *[dir=rtl] .float-sm-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-sm-end {
    float: right !important;
  }
  *[dir=rtl] .float-sm-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-sm-none {
    float: none !important;
  }
  *[dir=rtl] .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-sm-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-sm-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-sm-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-sm-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-sm-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-sm-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-sm-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-sm-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-sm-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-sm-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-sm-auto {
    margin-left: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-sm-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-sm-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-sm-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-sm-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-sm-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-sm-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-sm-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-sm-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-sm-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-sm-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-sm-auto {
    margin-right: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-sm-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-sm-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-sm-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-sm-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-sm-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-sm-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-sm-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-sm-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-sm-5 {
    padding-left: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-sm-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-sm-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-sm-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-sm-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-sm-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-sm-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-sm-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-sm-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-sm-5 {
    padding-right: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-sm-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-sm-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-sm-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-sm-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-sm-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  html:not([dir=rtl]) .float-md-start {
    float: left !important;
  }
  *[dir=rtl] .float-md-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-md-end {
    float: right !important;
  }
  *[dir=rtl] .float-md-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-md-none {
    float: none !important;
  }
  *[dir=rtl] .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-md-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-md-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-md-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-md-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-md-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-md-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-md-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-md-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-md-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-md-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-md-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-md-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-md-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-md-auto {
    margin-left: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-md-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-md-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-md-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-md-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-md-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-md-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-md-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-md-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-md-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-md-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-md-auto {
    margin-right: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-md-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-md-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-md-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-md-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-md-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-md-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-md-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-md-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-md-5 {
    padding-left: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-md-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-md-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-md-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-md-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-md-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-md-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-md-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-md-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-md-5 {
    padding-right: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-md-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-md-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-md-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-md-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-md-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  html:not([dir=rtl]) .float-lg-start {
    float: left !important;
  }
  *[dir=rtl] .float-lg-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-lg-end {
    float: right !important;
  }
  *[dir=rtl] .float-lg-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-lg-none {
    float: none !important;
  }
  *[dir=rtl] .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-lg-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-lg-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-lg-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-lg-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-lg-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-lg-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-lg-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-lg-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-lg-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-lg-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-lg-auto {
    margin-left: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-lg-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-lg-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-lg-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-lg-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-lg-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-lg-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-lg-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-lg-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-lg-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-lg-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-lg-auto {
    margin-right: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-lg-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-lg-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-lg-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-lg-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-lg-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-lg-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-lg-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-lg-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-lg-5 {
    padding-left: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-lg-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-lg-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-lg-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-lg-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-lg-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-lg-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-lg-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-lg-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-lg-5 {
    padding-right: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-lg-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-lg-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-lg-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-lg-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-lg-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  html:not([dir=rtl]) .float-xl-start {
    float: left !important;
  }
  *[dir=rtl] .float-xl-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-xl-end {
    float: right !important;
  }
  *[dir=rtl] .float-xl-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-xl-none {
    float: none !important;
  }
  *[dir=rtl] .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-xl-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-xl-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-xl-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-xl-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-xl-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-xl-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-xl-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-xl-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-xl-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-xl-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-xl-auto {
    margin-left: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-xl-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-xl-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-xl-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-xl-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-xl-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-xl-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-xl-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-xl-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-xl-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-xl-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-xl-auto {
    margin-right: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-xl-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-xl-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-xl-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-xl-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-xl-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-xl-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-xl-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-xl-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-xl-5 {
    padding-left: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-xl-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-xl-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-xl-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-xl-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-xl-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-xl-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-xl-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-xl-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-xl-5 {
    padding-right: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-xl-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-xl-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-xl-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-xl-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-xl-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  html:not([dir=rtl]) .float-xxl-start {
    float: left !important;
  }
  *[dir=rtl] .float-xxl-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-xxl-end {
    float: right !important;
  }
  *[dir=rtl] .float-xxl-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-xxl-none {
    float: none !important;
  }
  *[dir=rtl] .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-xxl-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-xxl-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-xxl-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-xxl-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-xxl-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-xxl-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-xxl-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-xxl-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-xxl-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-xxl-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-xxl-auto {
    margin-left: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-xxl-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-xxl-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-xxl-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-xxl-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-xxl-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-xxl-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-xxl-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-xxl-auto {
    margin-right: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-xxl-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-xxl-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-xxl-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-xxl-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-xxl-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-xxl-5 {
    padding-left: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-xxl-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-xxl-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-xxl-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-xxl-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-xxl-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-xxl-5 {
    padding-right: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-xxl-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-xxl-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-xxl-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-xxl-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-xxl-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.1875rem !important;
  }
  .fs-2 {
    font-size: 1.75rem !important;
  }
  .fs-3 {
    font-size: 1.53125rem !important;
  }
  .fs-4 {
    font-size: 1.3125rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * CoreUI Plugins - Chart.js for CoreUI 3
 * @version v3.1.2
 * @link https://coreui.io
 * Copyright (c) 2021 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 */
.chartjs-tooltip {
  position: absolute;
  z-index: 1021;
  padding: 0.25rem 0.5rem;
  color: #fff;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .chartjs-tooltip {
    transition: none;
  }
}
.chartjs-tooltip {
  transform: translate(-50%, 0);
  border-radius: 8px;
}

.chartjs-tooltip-header {
  margin-bottom: 0.5rem;
}

.chartjs-tooltip-header-item {
  font-size: 12px;
  font-weight: 700;
}

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: 12px;
  white-space: nowrap;
}

.wrapper {
  width: 100%;
}
html:not([dir=rtl]) .wrapper {
  padding-left: var(--cui-sidebar-occupy-start, 0);
}
*[dir=rtl] .wrapper {
  padding-right: var(--cui-sidebar-occupy-start, 0);
}
.wrapper {
  will-change: auto;
  transition: padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}

.example:not(:first-child) {
  margin-top: 1.5rem;
}
.example .tab-content {
  background-color: rgb(249, 249.6, 250.2) !important;
}
.dark-theme .example .tab-content {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.example code[class*=language-],
.example pre[class*=language-] {
  font-size: 0.875rem !important;
}
.example :not(pre) > code[class*=language-],
.example pre[class*=language-] {
  background: transparent;
}
.example + p {
  margin-top: 1.5rem;
}
.example .preview + p,
.example .preview .col + p {
  margin-top: 2rem;
}
.example .preview > .form-control + .form-control,
.example .preview .col > .form-control + .form-control {
  margin-top: 0.5rem;
}
.example .preview > .nav + .nav,
.example .preview > .alert + .alert,
.example .preview > .navbar + .navbar,
.example .preview > .progress + .progress,
.example .preview .col > .nav + .nav,
.example .preview .col > .alert + .alert,
.example .preview .col > .navbar + .navbar,
.example .preview .col > .progress + .progress {
  margin-top: 1rem;
}
.example .preview > .dropdown-menu,
.example .preview .col > .dropdown-menu {
  position: static;
  display: block;
}
.example .preview > :last-child,
.example .preview .col > :last-child {
  margin-bottom: 0;
}
.example .preview > svg + svg,
.example .preview > img + img,
.example .preview .col > svg + svg,
.example .preview .col > img + img {
  margin-left: 0.5rem;
}
.example .preview > .btn,
.example .preview > .btn-group,
.example .preview .col > .btn,
.example .preview .col > .btn-group {
  margin: 0.25rem 0.125rem;
}
.example .preview > .btn-toolbar + .btn-toolbar,
.example .preview .col > .btn-toolbar + .btn-toolbar {
  margin-top: 0.5rem;
}
.example .preview > .list-group,
.example .preview .col > .list-group {
  max-width: 400px;
}
.example .preview > [class*=list-group-horizontal],
.example .preview .col > [class*=list-group-horizontal] {
  max-width: 100%;
}
.example .preview .fixed-top,
.example .preview .sticky-top,
.example .preview .col .fixed-top,
.example .preview .col .sticky-top {
  position: static;
  margin: -1rem -1rem 1rem;
}
.example .preview .fixed-bottom,
.example .preview .col .fixed-bottom {
  position: static;
  margin: 1rem -1rem -1rem;
}
@media (min-width: 576px) {
  .example .preview .fixed-top,
  .example .preview .sticky-top,
  .example .preview .col .fixed-top,
  .example .preview .col .sticky-top {
    margin: -1.5rem -1.5rem 1rem;
  }
  .example .preview .fixed-bottom,
  .example .preview .col .fixed-bottom {
    margin: 1rem -1.5rem -1.5rem;
  }
}
.example .preview .pagination,
.example .preview .col .pagination {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.meddra-preview .preview-summary .summary-card {
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.meddra-preview .preview-summary .summary-card h3, .meddra-preview .preview-summary .summary-card .h3 {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  color: #333;
}
.meddra-preview .preview-summary .summary-card p {
  margin: 8px 0 0 0;
  color: #666;
  font-size: 0.9rem;
}
.meddra-preview .impact-level {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}
.meddra-preview .impact-level.low {
  background-color: #e3f2fd;
  color: #1976d2;
}
.meddra-preview .impact-level.medium {
  background-color: #fff3e0;
  color: #f57c00;
}
.meddra-preview .impact-level.high {
  background-color: #ffebee;
  color: #d32f2f;
}
.meddra-preview .impact-level.none {
  background-color: #e8f5e8;
  color: #388e3c;
}
.meddra-preview .change-table .rs-table .rs-table-row:hover {
  background-color: #f5f5f5;
}
.meddra-preview .action-buttons {
  margin-top: 24px;
}
.meddra-preview .action-buttons .rs-btn {
  margin-right: 8px;
}
.meddra-preview .warning-alert {
  margin-bottom: 16px;
}
.meddra-preview .warning-alert .rs-alert-icon {
  margin-right: 8px;
}
.meddra-preview .case-types-selection {
  margin: 16px 0;
}
.meddra-preview .case-types-selection .rs-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.meddra-preview .detailed-changes-modal .rs-modal-body {
  max-height: 60vh;
  overflow-y: auto;
}
.meddra-preview .form-label {
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
  color: #333;
}
.meddra-preview .text-muted {
  color: #666;
  font-size: 0.9rem;
}
.meddra-preview .card-header h4, .meddra-preview .card-header .h4 {
  margin: 0 0 8px 0;
  color: #333;
}

body.rtl {
  direction: rtl;
  text-align: right;
}
body.rtl .sidebar {
  right: 0;
  left: auto;
}
body.rtl .wrapper {
  margin-right: 0;
  margin-left: 0;
}
body.rtl .header .ms-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}
body.rtl .header .me-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}
body.rtl .form-label {
  text-align: right;
}
body.rtl .form-control,
body.rtl .form-select {
  text-align: right;
}
body.rtl .dropdown-menu {
  text-align: right;
}
body.rtl .btn-group {
  direction: rtl;
}
body.rtl table {
  direction: rtl;
  text-align: right;
}
body.rtl .modal-header .btn-close {
  margin-left: 0;
  margin-right: auto;
}
body.rtl .nav {
  direction: rtl;
}
body.rtl .breadcrumb {
  direction: rtl;
}
body.rtl .card {
  text-align: right;
}
body.rtl .list-group {
  text-align: right;
}
body.rtl .badge,
body.rtl .label {
  direction: rtl;
}
body.rtl .icon {
  margin-left: 0.5rem;
  margin-right: 0;
}
body.rtl .input-group {
  direction: rtl;
}
body.rtl .input-group .input-group-text {
  border-left: 0;
  border-right: 1px solid #ced4da;
}
body.rtl .input-group .form-control {
  border-right: 0;
  border-left: 1px solid #ced4da;
}
body.rtl .flex-row-reverse {
  flex-direction: row-reverse;
}
body.rtl .text-start {
  text-align: right !important;
}
body.rtl .text-end {
  text-align: left !important;
}
body.rtl .ms-auto {
  margin-right: auto !important;
  margin-left: 0 !important;
}
body.rtl .me-auto {
  margin-left: auto !important;
  margin-right: 0 !important;
}
body.rtl .float-start {
  float: right !important;
}
body.rtl .float-end {
  float: left !important;
}
body.rtl .ms-1 {
  margin-right: 0.25rem !important;
  margin-left: 0 !important;
}
body.rtl .me-1 {
  margin-left: 0.25rem !important;
  margin-right: 0 !important;
}
body.rtl .ps-1 {
  padding-right: 0.25rem !important;
  padding-left: 0 !important;
}
body.rtl .pe-1 {
  padding-left: 0.25rem !important;
  padding-right: 0 !important;
}
body.rtl .ms-2 {
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}
body.rtl .me-2 {
  margin-left: 0.5rem !important;
  margin-right: 0 !important;
}
body.rtl .ps-2 {
  padding-right: 0.5rem !important;
  padding-left: 0 !important;
}
body.rtl .pe-2 {
  padding-left: 0.5rem !important;
  padding-right: 0 !important;
}
body.rtl .ms-3 {
  margin-right: 0.75rem !important;
  margin-left: 0 !important;
}
body.rtl .me-3 {
  margin-left: 0.75rem !important;
  margin-right: 0 !important;
}
body.rtl .ps-3 {
  padding-right: 0.75rem !important;
  padding-left: 0 !important;
}
body.rtl .pe-3 {
  padding-left: 0.75rem !important;
  padding-right: 0 !important;
}
body.rtl .ms-4 {
  margin-right: 1rem !important;
  margin-left: 0 !important;
}
body.rtl .me-4 {
  margin-left: 1rem !important;
  margin-right: 0 !important;
}
body.rtl .ps-4 {
  padding-right: 1rem !important;
  padding-left: 0 !important;
}
body.rtl .pe-4 {
  padding-left: 1rem !important;
  padding-right: 0 !important;
}
body.rtl .ms-5 {
  margin-right: 1.25rem !important;
  margin-left: 0 !important;
}
body.rtl .me-5 {
  margin-left: 1.25rem !important;
  margin-right: 0 !important;
}
body.rtl .ps-5 {
  padding-right: 1.25rem !important;
  padding-left: 0 !important;
}
body.rtl .pe-5 {
  padding-left: 1.25rem !important;
  padding-right: 0 !important;
}

body.ltr {
  direction: ltr;
  text-align: left;
}

:root {
  --thrana-color-primary-darkest: #2a0040;
  --thrana-color-primary: #3c005a;
  --thrana-color-primary-strong: #5c1680;
  --thrana-color-primary-light: #7a2ba3;
  --thrana-color-primary-tint: #f3ecf7;
  --thrana-color-primary-tint-2: #faf5fc;
  --thrana-color-canvas: #fafafa;
  --thrana-color-canvas-alt: #f8f7fa;
  --thrana-color-surface: #ffffff;
  --thrana-color-border: #eeeeee;
  --thrana-color-border-strong: #e0e0e0;
  --thrana-color-text: #1f1224;
  --thrana-color-text-secondary: #6b6470;
  --thrana-color-text-muted: #9a93a0;
  --thrana-color-success: #1a7f4b;
  --thrana-color-success-tint: #e6f4ec;
  --thrana-color-danger: #b3261e;
  --thrana-color-danger-tint: #fbeceb;
  --thrana-color-warning: #9a6700;
  --thrana-color-warning-tint: #fdf3d9;
  --thrana-color-neutral-tint: #eef0f2;
  --thrana-color-neutral-text: #5f6368;
  --thrana-space-1: 4px;
  --thrana-space-2: 8px;
  --thrana-space-3: 12px;
  --thrana-space-4: 16px;
  --thrana-space-5: 24px;
  --thrana-space-6: 32px;
  --thrana-radius-sm: 6px;
  --thrana-radius-md: 8px;
  --thrana-radius-lg: 12px;
  --thrana-radius-pill: 999px;
  --thrana-shadow-xs: 0 1px 2px rgba(20, 0, 30, 0.04);
  --thrana-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --thrana-shadow-md: 0 4px 12px rgba(60, 0, 90, 0.08);
  --thrana-shadow-lg: 0 8px 24px rgba(60, 0, 90, 0.14);
  --thrana-shadow-focus-ring: 0 0 0 3px rgba(60, 0, 90, 0.18);
  --thrana-font-family-base: Inter, Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  --thrana-transition-fast: 150ms ease;
  --thrana-transition-base: 200ms ease;
}

.rs-table {
  --rs-table-border-color: #eeeeee;
  font-size: 14px;
}
.rs-table .rs-table-row-header {
  background-color: #f8f7fa;
}
.rs-table .rs-table-row-header .rs-table-cell {
  background-color: #f8f7fa;
  font-weight: 600;
  color: #6b6470;
  letter-spacing: 0.02em;
}
.rs-table .rs-table-cell {
  border-bottom-color: #eeeeee;
}
.rs-table .rs-table-cell-content {
  display: flex;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.rs-table-hover .rs-table-row:not(.rs-table-row-header):hover .rs-table-cell,
.rs-table-hover .rs-table-row:not(.rs-table-row-header):hover .rs-table-cell-group {
  background-color: #faf5fc !important;
  transition: background-color 150ms ease;
}

.rs-table-row:not(.rs-table-row-header) {
  min-height: 48px;
}

.rs-pagination .rs-pagination-btn {
  border-radius: 6px;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}
.rs-pagination .rs-pagination-btn:hover {
  background-color: #f3ecf7;
  color: #3c005a;
}

.rs-btn-icon:not(.rs-btn-icon-placement-left):not(.rs-btn-icon-placement-right) {
  border-radius: 999px;
  transition: background-color 150ms ease, color 150ms ease;
}
.rs-btn-icon:not(.rs-btn-icon-placement-left):not(.rs-btn-icon-placement-right):hover {
  background-color: #f3ecf7;
  color: #3c005a;
}

.rs-btn-primary:not(.add_new_btn),
.submit_btn,
.add-button,
.base_button {
  background-image: linear-gradient(180deg, #5c1680 0%, #3c005a 100%);
  border-color: #3c005a !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: box-shadow 150ms ease, transform 150ms ease, background-color 150ms ease;
}
.rs-btn-primary:not(.add_new_btn):hover:not(:disabled),
.submit_btn:hover:not(:disabled),
.add-button:hover:not(:disabled),
.base_button:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(60, 0, 90, 0.08);
  background-image: linear-gradient(180deg, #7a2ba3 0%, #5c1680 100%);
}
.rs-btn-primary:not(.add_new_btn):active:not(:disabled),
.submit_btn:active:not(:disabled),
.add-button:active:not(:disabled),
.base_button:active:not(:disabled) {
  transform: translateY(1px);
}
.rs-btn-primary:not(.add_new_btn):disabled, .rs-btn-primary:not(.add_new_btn).disabled,
.submit_btn:disabled,
.submit_btn.disabled,
.add-button:disabled,
.add-button.disabled,
.base_button:disabled,
.base_button.disabled {
  background-image: none;
  background-color: #eeebef !important;
  border-color: #eeebef !important;
  color: #9a93a0 !important;
  box-shadow: none;
  cursor: not-allowed;
}

.rs-btn-ghost,
.rs-btn-subtle,
.close_btn {
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}

.badge,
.rs-badge-content,
.status-badge {
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  font-size: 12px;
  background-color: #eef0f2;
  color: #5f6368;
}
.status-badge.processing {
  background-color: #fdf3d9;
  color: #9a6700;
}
.status-badge.active, .status-badge.success, .status-badge.completed {
  background-color: #e6f4ec;
  color: #1a7f4b;
}
.status-badge.inactive, .status-badge.failed, .status-badge.error {
  background-color: #fbeceb;
  color: #b3261e;
}

.form-body-field-label,
.rs-form-control-label {
  font-size: 13px;
  font-weight: 500;
  color: #6b6470;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
  display: inline-block;
}

.rs-form-group {
  margin-bottom: 16px;
}

.rs-input,
.rs-input-number,
.rs-textarea,
.rs-picker-toggle.rs-btn,
.rs-picker-toggle.rs-picker-toggle-md,
.form-control {
  border-radius: 0 !important;
  border-color: #e0e0e0 !important;
  transition: border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease;
}

.rs-input,
.form-control {
  padding: 8px 12px;
  font-size: 14px;
}

.rs-input::placeholder,
.rs-picker-toggle-placeholder {
  color: #9a93a0 !important;
}

.rs-picker-date:focus,
.rs-input-number:hover,
.rs-textarea:hover,
.rs-picker:not(.rs-picker-disabled):hover .rs-picker-toggle,
.form-control:hover {
  border-color: #7a2ba3 !important;
}

.rs-picker-input-group,
.rs-input-group,
.rs-input-group-sm,
.rs-input-group-inside {
  border-color: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rs-picker-date:focus,
.rs-input-number:focus-within,
.rs-textarea:focus,
.rs-picker-focused .rs-picker-toggle,
.form-control:focus {
  border-color: #7a2ba3 !important;
  box-shadow: 0 0 0 3px rgba(60, 0, 90, 0.18) !important;
  outline: none !important;
}

.rs-textarea:disabled,
.rs-picker-disabled .rs-picker-toggle,
.form-control:disabled {
  border: 1px solid #eeeeee !important;
  background-color: #f8f7fa !important;
  color: #9a93a0 !important;
  cursor: not-allowed;
  opacity: 1;
}

.rs-picker-menu {
  border-radius: 0 !important;
  box-shadow: 0 4px 12px rgba(60, 0, 90, 0.08);
  overflow: hidden;
}

.rs-picker-select-menu-item.rs-picker-select-menu-item-active,
.rs-picker-select-menu-item.rs-picker-select-menu-item-focus,
.rs-picker-select-menu-item:hover {
  background-color: #faf5fc !important;
  color: #3c005a !important;
}

.rs-calendar-table-cell-content:hover {
  border-radius: 6px;
}

.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {
  border-radius: 6px;
  font-weight: 600;
}

.rs-checkbox-checker,
.rs-radio-checker {
  transition: background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease;
}

.rs-checkbox-inner {
  border-radius: 6px !important;
}

.rs-checkbox:hover .rs-checkbox-inner::before,
.rs-radio:hover .rs-radio-inner::before {
  border-color: #7a2ba3 !important;
}

.rs-input-group {
  border-radius: 0 !important;
  border-color: #e0e0e0 !important;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}
.rs-input-group.rs-input-group-focus {
  border-color: #7a2ba3 !important;
  box-shadow: 0 0 0 3px rgba(60, 0, 90, 0.18) !important;
}
.rs-input-group .rs-input-group-addon {
  background-color: #f8f7fa;
  color: #6b6470;
}

.react-international-phone-input-container .react-international-phone-country-selector-button {
  height: 36px;
  border: 1px solid #e0e0e0;
  border-right: none;
  border-radius: 0px;
}
.react-international-phone-input-container .react-international-phone-input {
  height: 36px;
  border: 1px solid #e0e0e0;
  border-radius: 0 6px 6px 0;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}
.react-international-phone-input-container:hover, .react-international-phone-input-container:focus-within {
  box-shadow: 0 0 0 3px rgba(60, 0, 90, 0.18);
}
.react-international-phone-input-container:hover .react-international-phone-input,
.react-international-phone-input-container:hover .react-international-phone-country-selector-button, .react-international-phone-input-container:focus-within .react-international-phone-input,
.react-international-phone-input-container:focus-within .react-international-phone-country-selector-button {
  border-color: #7a2ba3;
}

.card,
.rs-panel {
  transition: box-shadow 200ms ease, transform 200ms ease;
}

@keyframes thrana-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.body.flex-grow-1 .container-fluid > *, .body.flex-grow-1 .container-sm > *, .body.flex-grow-1 .container-md > *, .body.flex-grow-1 .container-lg > *, .body.flex-grow-1 .container-xl > *, .body.flex-grow-1 .container-xxl > * {
  animation: thrana-fade-in 220ms ease both;
}

@media (prefers-reduced-motion: reduce) {
  .body.flex-grow-1 .container-fluid > *, .body.flex-grow-1 .container-sm > *, .body.flex-grow-1 .container-md > *, .body.flex-grow-1 .container-lg > *, .body.flex-grow-1 .container-xl > *, .body.flex-grow-1 .container-xxl > * {
    animation: none;
  }
}
.toaster {
  display: flex;
  align-items: center;
}
.toaster .toaster-msg {
  margin-left: 8px;
}

html,
body,
#app,
#app > div {
  height: 100%;
  width: 100%;
  margin: 0;
}

#root {
  height: 100%;
  width: 100%;
  margin: 0;
}

.base_button {
  background-color: #3c005a;
}

body {
  font-family: "Source Sans Pro" !important;
}
body .rs-table-cell-content:hover {
  border: 0px #efc7f5 solid !important;
}
body .rs-table-cell-full-text:hover {
  box-shadow: none !important;
  box-shadow: none !important;
}
body .avatar-img {
  width: 100%;
  height: inherit !important;
}
body .common-loader-wrapper.delayed {
  animation-delay: 2s forwards;
}
body .common-loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 2000;
}
body .comon-excel-download {
  background-color: white !important;
  color: #3c005a !important;
  box-shadow: 0 6px 6px 0 rgba(106, 44, 118, 0.4) !important;
}
body .rs-picker-select-menu-item {
  color: #3c005a !important;
}
body .rs-picker-toggle-placeholder {
  font-size: 12px !important;
}
body .tooltip-fields {
  background-color: #fff;
  color: #dc3545;
  z-index: 0;
  padding: 0px;
}
body .rs-pagination-btn.rs-pagination-btn-active {
  border: 1px #3c005a solid !important;
  color: #3c005a !important;
  box-shadow: 0 0 0 0 #3c005a !important;
}
body .rs-pagination-btn.rs-pagination-btn-active:hover {
  border: 1px #3c005a solid !important;
  color: #3c005a !important;
  box-shadow: 0 0 0 0 #3c005a !important;
}
body .rs-picker-toggle-value {
  font-size: 12px !important;
  color: #3c005a !important;
  outline-color: #efc7f5 !important;
}
body .rs-checkbox-inner {
  background-color: #47114d;
}
body .submit_btn {
  background-color: #3c005a !important;
  color: #fff !important;
  border: 1px solid #3c005a !important;
  box-shadow: 0 6px 6px 0 rgba(106, 44, 118, 0.4);
  font-size: 14px;
}
body .submit_btn:hover {
  background-color: #fff !important;
  color: #3c005a !important;
  border: 1px solid #3c005a;
}
body .close_btn {
  background-color: rgb(255, 255, 255);
  border: #3c005a 1px solid;
  color: #3c005a;
}
body .close_btn:hover {
  background-color: #3c005a;
  color: rgb(255, 255, 255) !important;
  border: #3c005a 1px solid;
}
body .medDra-close-btn[type=button]:not(:disabled) {
  background-color: #fff;
  color: #3c005a;
  border: 1px #3c005a solid;
  margin-right: 10px;
}
body .rs-table-hover .rs-table-row:hover .rs-table-cell,
body .rs-table-hover .rs-table-row:hover .rs-table-cell-group,
body .rs-table-hover .rs-table-row:not(.rs-table-row-header):hover {
  background-color: #faf0fb;
}
body .rs-form-group .rs-input {
  display: inline-block;
  font-size: 12px !important;
  color: #3c005a;
}
body .rs-btn-close .rs-icon {
  color: #3c005a;
  font-weight: bolder;
}
body .rs-panel-header {
  color: #3c005a;
}
body .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input {
  display: inline-block;
  font-size: 12px !important;
  color: #3c005a !important;
  outline-color: #efc7f5 !important;
  border: 1px #3c005a solid !important;
}
body .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-search-icon {
  color: #3c005a;
}
body .message_box {
  background-color: #efc7f5;
}
body .rs-checkbox-checked .rs-checkbox-wrapper .rs-checkbox-inner:before,
body .rs-checkbox-indeterminate .rs-checkbox-wrapper .rs-checkbox-inner:before {
  border-color: #3c005a !important;
  background-color: #3c005a !important;
}
body .tooltip {
  color: white;
}
body {
  /* Apply the custom class to the tooltip */
}
body .tooltip-inner {
  background-color: #3c005a;
  color: #fff !important;
  border: 1px solid #fff;
  box-shadow: 0 6px 6px 0 rgba(106, 44, 118, 0.4);
  border: 1px solid white;
}
body .tooltip-arrow {
  display: none !important;
}
body .group-input-fields.rs-picker.rs-picker-input.rs-picker-default.rs-picker-toggle-wrapper.rs-picker-cleanable.rs-picker-block.rs-picker-focused {
  color: #3c005a;
  outline-color: #efc7f5 !important;
  border: 1px #3c005a solid !important;
  box-shadow: #3c005a;
}
body .button:not(:disabled),
body [type=button]:not(:disabled),
body [type=reset]:not(:disabled),
body [type=submit]:not(:disabled) {
  color: #3c005a;
}
body .breadcrumb-item.active.breadCrumb-path-name {
  color: #3c005a;
}
body .rs-message.rs-message-has-title .rs-message-icon-wrapper .rs-icon {
  color: #3c005a;
}
body .rs-message-info .rs-message-body {
  color: #3c005a;
}
body .rs-message-info .rs-message-header {
  color: #3c005a !important;
}
body .icon_size {
  color: white !important;
}
body .rs-navbar-default .rs-dropdown .rs-dropdown-menu-active ~ .rs-dropdown-toggle,
body .rs-navbar-default .rs-navbar-item.rs-navbar-item-active {
  color: #3c005a;
}
body .rs-steps-item-icon-wrapper > .rs-steps-item-icon .rs-icon {
  color: #fff !important;
}
body .rs-drawer-title {
  color: #3c005a;
}
body .header-nav .dropdown-menu {
  border: 1px solid #3c005a !important;
}
body .rs-badge-independent,
body .rs-badge-content {
  background-color: #3c005a !important;
}
body .sidebar-brand {
  border-bottom: 1px solid #3c005a;
  background: #fff;
}

.loader_common_style {
  z-index: 2000 !important;
  position: fixed !important;
  color: #3c005a !important;
}

.tooltip-arrow {
  display: none !important;
}

.group-input-fields.rs-picker.rs-picker-input.rs-picker-default.rs-picker-toggle-wrapper.rs-picker-cleanable.rs-picker-block.rs-picker-focused {
  color: #3c005a;
  outline-color: #efc7f5 !important;
  border: 1px #3c005a solid !important;
  box-shadow: #3c005a;
}

.button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  color: #3c005a;
}

.breadcrumb-item.active.breadCrumb-path-name {
  color: #3c005a !important;
}

.rs-message.rs-message-has-title .rs-message-icon-wrapper .rs-icon {
  color: #3c005a;
}

.rs-message-info .rs-message-body {
  color: #3c005a;
}

.rs-message-info .rs-message-header {
  color: #3c005a !important;
}

.header-nav .nav-link {
  color: #3c005a !important;
}

.rs-navbar-default .rs-dropdown .rs-dropdown-menu-active ~ .rs-dropdown-toggle,
.rs-navbar-default .rs-navbar-item.rs-navbar-item-active {
  color: #3c005a;
}

.rs-steps-item-icon-wrapper > .rs-steps-item-icon .rs-icon {
  color: #fff !important;
}

.rs-drawer-title {
  color: #3c005a;
}

.header-nav .dropdown-menu {
  border: 1px solid #3c005a !important;
}

.rs-badge-independent,
.rs-badge-content {
  background-color: #3c005a !important;
}

.rs-modal-title {
  color: #3c005a !important;
  font-weight: bolder;
}

.react-flow__node-default,
.react-flow__node-input,
.react-flow__node-output,
.react-flow__node-group {
  color: #3c005a !important;
  font-weight: bolder;
  border-color: #3c005a !important;
}

.view-wrapper {
  background-color: #3c005a !important;
  color: #fff !important;
  border: 1px solid #3c005a !important;
  box-shadow: 0 6px 6px 0 rgba(106, 44, 118, 0.4);
  font-size: 14px;
  cursor: pointer;
}

.view-wrapper:hover {
  background-color: #fff !important;
  color: #3c005a !important;
  border: #3c005a 1px solid;
}

#root .light {
  background-color: #fff;
  color: #000;
}

#root .dark {
  background-color: #333;
  color: #fff;
}

.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover,
.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus,
.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active {
  outline-width: 4px !important;
  opacity: 0.9;
  border: 1px solid #3c005a !important;
  border-radius: 0px !important;
}

.iconbtn_outline_clr:hover {
  outline-color: #efc7f5 !important;
  border-color: #efc7f5 !important;
  width: 100% !important;
}

.iconbtn_outline_clr:focus {
  outline-color: #efc7f5 !important;
  border-color: #efc7f5 !important;
  width: 100% !important;
}

.iconbtn_outline_clr {
  outline-color: #efc7f5 !important;
  border-color: #efc7f5 !important;
  width: 100% !important;
}

.sidebar-brand.d-none.d-md-flex {
  min-width: 100%;
}

.rs-table-cell.rs-table-cell-full-text {
  height: 46px !important;
}

.rs-picker-check-menu-items .rs-check-item.rs-checkbox-checked .rs-checkbox-checker > label,
.rs-picker-check-menu-items .rs-check-item.rs-checkbox-checked .rs-checkbox-checker > label:hover {
  background-color: #efc7f5 !important;
}

.rs-picker-check-menu-items .rs-check-item.rs-checkbox-uncheck .rs-checkbox-checker > label,
.rs-picker-check-menu-items .rs-check-item.rs-checkbox-uncheck .rs-checkbox-checker > label:hover {
  background-color: #efc7f5 !important;
}

.rs-check-item .rs-checkbox-checker > label:hover {
  cursor: pointer;
  display: block;
  line-height: 20px;
  padding: 8px 12px 8px 38px;
  position: relative;
  background-color: #efc7f5 !important;
}

.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {
  background-color: #efc7f5 !important;
}

.rs-calendar-table-cell-selected .rs-calendar-table-cell-content:hover {
  background-color: #efc7f5 !important;
}

.rs-calendar-month-dropdown-year-active {
  color: #efc7f5 !important;
}

.rs-check-item-rs-check-item-focus-rs-checkbox {
  border-color: red !important;
}

.rs-picker-select-menu-item.rs-picker-select-menu-item-active {
  background-color: #faf0fb !important;
  opacity: 20px !important;
}

.rs-picker-select-menu-item:hover {
  background-color: #faf0fb !important;
  opacity: 40px !important;
}

.rs-picker-select-menu-item.rs-picker-select-menu-item-focus,
.rs-picker-select-menu-item:focus,
.rs-picker-select-menu-item:hover {
  background-color: #faf0fb !important;
}

.rs-radio [type=radio]:focus ~ .rs-radio-inner::before {
  box-shadow: 0 0 0 3px #efc7f5;
}

.rs-picker-menu .rs-calender .rs-calender-table-cell-content:hover {
  background-color: #efc7f5 !important;
}

.rs-check-item .rs-checkbox-checker > label:hover {
  background-color: #efc7f5 !important;
}

.rs-checkbox-inner:hover {
  border-color: #efc7f5;
}

label:hover .rs-checkbox-wrapper .rs-checkbox-inner::before {
  border-color: #3c005a !important;
}

.rs-search-box .rs-input-group.rs-input-group-inside {
  color: #3c005a !important;
  outline-color: #efc7f5 !important;
  border: 1px #3c005a solid !important;
  box-shadow: #3c005a !important;
  border-radius: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/_tokens.scss","webpack://./src/scss/components/rsuite-overrides.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_banner.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./src/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/_containers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-check.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui/scss/_subheader.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_api.scss","webpack://./node_modules/@coreui/chartjs/scss/coreui-chartjs.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./src/scss/_layout.scss","webpack://./src/scss/_example.scss","webpack://./src/scss/components/_meddra-preview.scss","webpack://./src/scss/rtl.scss","webpack://./src/scss/components/_premium-ui.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC4GhB;EACE,uCAAA;EACA,+BAAA;EACA,sCAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EAEA,8BAAA;EACA,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,qCAAA;EAEA,4BAAA;EACA,sCAAA;EACA,kCAAA;EAEA,+BAAA;EACA,oCAAA;EACA,8BAAA;EACA,mCAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,oCAAA;EAEA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EAEA,mDAAA;EACA,iDAAA;EACA,oDAAA;EACA,oDAAA;EACA,2DAAA;EAEA,uKAAA;EACA,oCAAA;EACA,oCAAA;ADhHF;;AE3CA,8BAAA;AACA;EACE,oCAAA;EACA,oCAAA;EACA,oCAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA;EACE,kDAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA,2BAAA;AACA;EACE,kDAAA;AF8CF;;AE3CA,gCAAA;AACA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA,+BAAA;AACA;;;;EAIE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA,kCAAA;AACA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA;EACE,kDAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA,6BAAA;AACA;EACE,kDAAA;EACA,8CAAA;AF8CF;;AE3CA,wCAAA;AACA;;;;EAIE,kDAAA;EACA,8CAAA;AF8CF;;AGrIE;;;;EAAA;ACDF;EAQI,mBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,wBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,4BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,2BAAA;EAGF,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,gCAAA;EAMA,6KAAA;EACA,0GAAA;EACA,0FAAA;EAOA,8KAAA;ECsPI,8BALI;ED/OR,2BAAA;EACA,2BAAA;EAKA,yBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,kCAAA;EAEA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,qCAAA;EAEA,gDAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAGA,+CAAA;EACA,kDAAA;EACA,0CAAA;EAEA,sDAAA;EACA,uDAAA;EACA,iDAAA;EAEA,4BAAA;EAEA,yBAAA;EACA,+BAAA;EACA,gCAAA;EAEA,+BAAA;EACA,qCAAA;EAMA,yBAAA;EACA,0CAAA;EAGA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,qDAAA;EAEA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,+BAAA;EAGA,kDAAA;EACA,kDAAA;EACA,qDAAA;EACA,6DAAA;EAIA,+BAAA;EACA,8BAAA;EACA,6CAAA;EAIA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,wCAAA;AJuHF;;AMnOA;;;EAGE,sBAAA;ANsOF;;AMvNI;EANJ;IAOM,uBAAA;EN2NJ;AACF;;AM9MA;EACE,SAAA;EACA,wCAAA;ED6OI,oCALI;ECtOR,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8BAAA;EACA,8CAAA;ANiNF;;AMxMA;EACE,cAAA;EACA,cC6qB4B;ED5qB5B,SAAA;EACA,yCAAA;EACA,aCmrB4B;APxe9B;;AMjMA;EACE,aAAA;EACA,qBC0mB4B;EDvmB5B,gBLIqB;EKHrB,gBC0mB4B;EDzmB5B,+BAAA;ANkMF;;AM/LA;EDuMQ,qCAAA;ALJR;AKxJI;EC3CJ;ID8MQ,oBAAA;ELPN;AACF;;AMnMA;EDkMQ,+BAAA;ALKR;AKjKI;ECtCJ;IDyMQ,kBAAA;ELEN;AACF;;AMvMA;ED6LQ,uCAAA;ALcR;AK1KI;ECjCJ;IDoMQ,qBAAA;ELWN;AACF;;AM3MA;EDwLQ,qCAAA;ALuBR;AKnLI;EC5BJ;ID+LQ,oBAAA;ELoBN;AACF;;AM/MA;ED+KM,qBALI;ALyCV;;AM9MA;ED0KM,mBALI;AL6CV;;AMvMA;EACE,aAAA;EACA,mBCyY0B;AP/L5B;;AMhMA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ANmMF;;AM7LA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ANgMF;;AMrLA;;;EAGE,aAAA;EACA,mBAAA;ANwLF;;AMrLA;;;;EAIE,gBAAA;ANwLF;;AMrLA;EACE,gBLtFiB;AD8QnB;;AMnLA;EACE,qBAAA;ANsLF;AQ5WI;EAgCE,cAAA;AR+UN;AQvWI;EA+BI,eAAA;AR2UR;;AMrLA;EACE,gBAAA;ANwLF;;AMhLA;;EAEE,mBCwd4B;APrS9B;;AM3KA;ED6EM,kBALI;ALuGV;;AMxKA;EACE,iBC+iB4B;ED9iB5B,yCAAA;AN2KF;;AMlKA;;EAEE,kBAAA;EDyDI,iBALI;EClDR,cAAA;EACA,wBAAA;ANqKF;;AMlKA;EAAM,eAAA;ANsKN;;AMrKA;EAAM,WAAA;ANyKN;;AMpKA;EACE,kEAAA;EACA,0BCkQwC;AP3F1C;AMrKE;EACE,qDAAA;ANuKJ;;AM7JE;EAEE,cAAA;EACA,qBAAA;AN+JJ;;AMxJA;;;;EAIE,sCCoY4B;EFpXxB,cALI;ALiJV;;AMpJA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDII,kBALI;ECGR,6BAAA;ANuJF;AMpJE;EDDI,kBALI;ECQN,cAAA;EACA,kBAAA;ANsJJ;;AMlJA;EDRM,kBALI;ECeR,4BAAA;EACA,qBAAA;ANqJF;AMlJE;EACE,cAAA;ANoJJ;;AMhJA;EACE,2BAAA;EDpBI,kBALI;EC2BR,+CAAA;EACA,0DAAA;EGnSE,kBAAA;ATubJ;AMjJE;EACE,UAAA;ED3BE,cALI;ALoLV;;AMzIA;EACE,gBAAA;AN4IF;;AMtIA;;EAEE,sBAAA;ANyIF;;AMjIA;EACE,oBAAA;EACA,yBAAA;ANoIF;;AMjIA;EACE,qBInNqB;EJoNrB,wBIpNqB;EJqNrB,iEAAA;EACA,gBAAA;ANoIF;;AM7HA;EACE,gBL5QqB;EK6QrB,mBAAA;EACA,gCAAA;ANgIF;;AM7HA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ANgIF;;AMxHA;EACE,qBAAA;AN2HF;;AMrHA;EAEE,gBAAA;ANuHF;;AM/GA;EACE,UAAA;ANkHF;;AM7GA;;;;;EAKE,SAAA;EACA,oBAAA;ED1HI,kBALI;ECiIR,oBAAA;ANgHF;;AM5GA;;EAEE,oBAAA;AN+GF;;AM1GA;EACE,eAAA;AN6GF;;AM1GA;EAGE,iBAAA;AN2GF;AMxGE;EACE,UAAA;AN0GJ;;AMnGA;EACE,wBAAA;ANsGF;;AM9FA;;;;EAIE,0BAAA;ANiGF;AM9FI;;;;EACE,eAAA;ANmGN;;AM5FA;EACE,UAAA;EACA,kBAAA;AN+FF;;AM1FA;EACE,gBAAA;AN6FF;;AMnFA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ANsFF;;AQ1jBI;EAgCE,WAAA;AR8hBN;AQtjBI;EA+BI,YAAA;AR0hBR;AMrFA;EAEE,WAAA;EACA,UAAA;EACA,qBC+Q4B;EF9dtB,iCAAA;ALsSR;AKlcI;ECuWJ;IDpMQ,iBAAA;ELmSN;AACF;AMhGA;EAOE,oBAAA;AN4FF;AM1FE;EACE,WAAA;AN4FJ;;AMrFA;;;;;;;EAOE,UAAA;ANwFF;;AMrFA;EACE,YAAA;ANwFF;;AM/EA;EACE,6BAAA;EACA,oBAAA;ANkFF;;AM3EE;;;;EAIE,cAAA;AN8EJ;;AMvEA;EACE,wBAAA;AN0EF;;AMrEA;EACE,UAAA;ANwEF;;AMjEA;EACE,aAAA;EACA,0BAAA;ANoEF;;AM/DA;EACE,qBAAA;ANkEF;;AM7DA;EACE,SAAA;ANgEF;;AMzDA;EACE,kBAAA;EACA,eAAA;AN4DF;;AMpDA;EACE,wBAAA;ANuDF;;AM/CA;EACE,wBAAA;ANkDF;;AWpnBA;ENmQM,qBALI;EM5PR,gBJ0rB8B;APnEhC;;AWlnBE;ENgQM,iCAAA;ALsXR;AKlhBI;EMpGF;INuQM,eAAA;ELmXN;AACF;AW3nBE;EAIE,gBJ2qBkB;EI1qBlB,gBJ0pB0B;APhC9B;;AW/nBE;ENgQM,iCAAA;ALmYR;AK/hBI;EMpGF;INuQM,iBAAA;ELgYN;AACF;AWxoBE;EAIE,gBJ2qBkB;EI1qBlB,gBJ0pB0B;APnB9B;;AW5oBE;ENgQM,iCAAA;ALgZR;AK5iBI;EMpGF;INuQM,eAAA;EL6YN;AACF;AWrpBE;EAIE,gBJ2qBkB;EI1qBlB,gBJ0pB0B;APN9B;;AWzpBE;ENgQM,iCAAA;AL6ZR;AKzjBI;EMpGF;INuQM,iBAAA;EL0ZN;AACF;AWlqBE;EAIE,gBJ2qBkB;EI1qBlB,gBJ0pB0B;APO9B;;AWtqBE;ENgQM,iCAAA;AL0aR;AKtkBI;EMpGF;INuQM,eAAA;ELuaN;AACF;AW/qBE;EAIE,gBJ2qBkB;EI1qBlB,gBJ0pB0B;APoB9B;;AWnrBE;ENgQM,iCAAA;ALubR;AKnlBI;EMpGF;INuQM,iBAAA;ELobN;AACF;AW5rBE;EAIE,gBJ2qBkB;EI1qBlB,gBJ0pB0B;APiC9B;;AQjuBI;EAgCE,eAAA;ARqsBN;AQ7tBI;EA+BI,gBAAA;ARisBR;AW/qBA;ECtDE,gBAAA;AZwuBF;;AQ3uBI;EAgCE,eAAA;AR+sBN;AQvuBI;EA+BI,gBAAA;AR2sBR;AWprBA;EC3DE,gBAAA;AZkvBF;;AWprBA;EACE,qBAAA;AXurBF;AQzvBI;EAgCE,oBAAA;AR4tBN;AQpvBI;EA+BI,mBAAA;ARwtBR;;AWhrBA;EN8MM,kBALI;EMvMR,yBAAA;AXmrBF;;AW/qBA;EACE,mBJkXO;EF3KH,qBALI;ALifV;AWhrBE;EACE,gBAAA;AXkrBJ;;AW9qBA;EACE,iBAAA;EACA,mBJwWO;EF3KH,kBALI;EMtLR,cJrFU;APswBZ;AW/qBE;EACE,aAAA;AXirBJ;;AajxBA;ECIE,eAAA;EAGA,YAAA;Ad+wBF;;AahxBA;EACE,gBNqxDkC;EMpxDlC,6DAAA;EACA,gGAAA;EJGE,uCAAA;EKRF,eAAA;EAGA,YAAA;AdwxBF;;Aa1wBA;EAEE,qBAAA;Ab4wBF;;AazwBA;EACE,qBAAA;EACA,cAAA;Ab4wBF;;AazwBA;ERyPM,kBALI;EQlPR,kEAAA;Ab4wBF;;Ae9yBE;;;;;;;ECHA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;AhB2zBF;;AiBrwBI;EF5CE;IACE,gBRmhBe;EPkSrB;AACF;AiB3wBI;EF5CE;IACE,gBRmhBe;EPuSrB;AACF;AiBhxBI;EF5CE;IACE,gBRmhBe;EP4SrB;AACF;AiBrxBI;EF5CE;IACE,iBRmhBe;EPiTrB;AACF;AiB1xBI;EF5CE;IACE,iBRmhBe;EPsTrB;AACF;AkB11BA;EAEI,sBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAGF,2BAAA;AlB81BF;;AkB11BE;ECRA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,0CAAA;EACA,8CAAA;EACA,6CAAA;AnBq2BF;AkBj2BI;ECKF,cAAA;EACA,WAAA;EACA,eAAA;EACA,8CAAA;EACA,6CAAA;EACA,+BAAA;AnB+1BF;;AmBhzBM;EACE,SAAA;AnBmzBR;;AmBhzBM;EApCJ,cAAA;EACA,WAAA;AnBw1BF;;AmB10BE;EACE,cAAA;EACA,WAAA;AnB60BJ;;AmB/0BE;EACE,cAAA;EACA,UAAA;AnBk1BJ;;AmBp1BE;EACE,cAAA;EACA,qBAAA;AnBu1BJ;;AmBz1BE;EACE,cAAA;EACA,UAAA;AnB41BJ;;AmB91BE;EACE,cAAA;EACA,UAAA;AnBi2BJ;;AmBn2BE;EACE,cAAA;EACA,qBAAA;AnBs2BJ;;AmBv0BM;EAhDJ,cAAA;EACA,WAAA;AnB23BF;;AmBt0BU;EAhEN,cAAA;EACA,kBAAA;AnB04BJ;;AmB30BU;EAhEN,cAAA;EACA,mBAAA;AnB+4BJ;;AmBh1BU;EAhEN,cAAA;EACA,UAAA;AnBo5BJ;;AmBr1BU;EAhEN,cAAA;EACA,mBAAA;AnBy5BJ;;AmB11BU;EAhEN,cAAA;EACA,mBAAA;AnB85BJ;;AmB/1BU;EAhEN,cAAA;EACA,UAAA;AnBm6BJ;;AmBp2BU;EAhEN,cAAA;EACA,mBAAA;AnBw6BJ;;AmBz2BU;EAhEN,cAAA;EACA,mBAAA;AnB66BJ;;AmB92BU;EAhEN,cAAA;EACA,UAAA;AnBk7BJ;;AmBn3BU;EAhEN,cAAA;EACA,mBAAA;AnBu7BJ;;AmBx3BU;EAhEN,cAAA;EACA,mBAAA;AnB47BJ;;AmB73BU;EAhEN,cAAA;EACA,WAAA;AnBi8BJ;;AQ/9BI;EAgCE,wBAAA;ARm8BN;AQ39BI;EA+BI,yBAAA;AR+7BR;;AQt+BI;EAgCE,yBAAA;AR08BN;AQl+BI;EA+BI,0BAAA;ARs8BR;;AQ7+BI;EAgCE,gBAAA;ARi9BN;AQz+BI;EA+BI,iBAAA;AR68BR;;AQp/BI;EAgCE,yBAAA;ARw9BN;AQh/BI;EA+BI,0BAAA;ARo9BR;;AQ3/BI;EAgCE,yBAAA;AR+9BN;AQv/BI;EA+BI,0BAAA;AR29BR;;AQlgCI;EAgCE,gBAAA;ARs+BN;AQ9/BI;EA+BI,iBAAA;ARk+BR;;AQzgCI;EAgCE,yBAAA;AR6+BN;AQrgCI;EA+BI,0BAAA;ARy+BR;;AQhhCI;EAgCE,yBAAA;ARo/BN;AQ5gCI;EA+BI,0BAAA;ARg/BR;;AQvhCI;EAgCE,gBAAA;AR2/BN;AQnhCI;EA+BI,iBAAA;ARu/BR;;AQ9hCI;EAgCE,yBAAA;ARkgCN;AQ1hCI;EA+BI,0BAAA;AR8/BR;;AQriCI;EAgCE,yBAAA;ARygCN;AQjiCI;EA+BI,0BAAA;ARqgCR;;AmB57BQ;;EAEE,iBAAA;AnB+7BV;;AmB57BQ;;EAEE,iBAAA;AnB+7BV;;AmBt8BQ;;EAEE,uBAAA;AnBy8BV;;AmBt8BQ;;EAEE,uBAAA;AnBy8BV;;AmBh9BQ;;EAEE,sBAAA;AnBm9BV;;AmBh9BQ;;EAEE,sBAAA;AnBm9BV;;AmB19BQ;;EAEE,oBAAA;AnB69BV;;AmB19BQ;;EAEE,oBAAA;AnB69BV;;AmBp+BQ;;EAEE,sBAAA;AnBu+BV;;AmBp+BQ;;EAEE,sBAAA;AnBu+BV;;AmB9+BQ;;EAEE,oBAAA;AnBi/BV;;AmB9+BQ;;EAEE,oBAAA;AnBi/BV;;AiB3iCI;EEUE;IACE,SAAA;EnBqiCN;EmBliCI;IApCJ,cAAA;IACA,WAAA;EnBykCA;EmB3jCA;IACE,cAAA;IACA,WAAA;EnB6jCF;EmB/jCA;IACE,cAAA;IACA,UAAA;EnBikCF;EmBnkCA;IACE,cAAA;IACA,qBAAA;EnBqkCF;EmBvkCA;IACE,cAAA;IACA,UAAA;EnBykCF;EmB3kCA;IACE,cAAA;IACA,UAAA;EnB6kCF;EmB/kCA;IACE,cAAA;IACA,qBAAA;EnBilCF;EmBljCI;IAhDJ,cAAA;IACA,WAAA;EnBqmCA;EmBhjCQ;IAhEN,cAAA;IACA,kBAAA;EnBmnCF;EmBpjCQ;IAhEN,cAAA;IACA,mBAAA;EnBunCF;EmBxjCQ;IAhEN,cAAA;IACA,UAAA;EnB2nCF;EmB5jCQ;IAhEN,cAAA;IACA,mBAAA;EnB+nCF;EmBhkCQ;IAhEN,cAAA;IACA,mBAAA;EnBmoCF;EmBpkCQ;IAhEN,cAAA;IACA,UAAA;EnBuoCF;EmBxkCQ;IAhEN,cAAA;IACA,mBAAA;EnB2oCF;EmB5kCQ;IAhEN,cAAA;IACA,mBAAA;EnB+oCF;EmBhlCQ;IAhEN,cAAA;IACA,UAAA;EnBmpCF;EmBplCQ;IAhEN,cAAA;IACA,mBAAA;EnBupCF;EmBxlCQ;IAhEN,cAAA;IACA,mBAAA;EnB2pCF;EmB5lCQ;IAhEN,cAAA;IACA,WAAA;EnB+pCF;EQ7rCE;IAgCE,cAAA;ERgqCJ;EQxrCE;IA+BI,eAAA;ER4pCN;EQnsCE;IAgCE,wBAAA;ERsqCJ;EQ9rCE;IA+BI,yBAAA;ERkqCN;EQzsCE;IAgCE,yBAAA;ER4qCJ;EQpsCE;IA+BI,0BAAA;ERwqCN;EQ/sCE;IAgCE,gBAAA;ERkrCJ;EQ1sCE;IA+BI,iBAAA;ER8qCN;EQrtCE;IAgCE,yBAAA;ERwrCJ;EQhtCE;IA+BI,0BAAA;ERorCN;EQ3tCE;IAgCE,yBAAA;ER8rCJ;EQttCE;IA+BI,0BAAA;ER0rCN;EQjuCE;IAgCE,gBAAA;ERosCJ;EQ5tCE;IA+BI,iBAAA;ERgsCN;EQvuCE;IAgCE,yBAAA;ER0sCJ;EQluCE;IA+BI,0BAAA;ERssCN;EQ7uCE;IAgCE,yBAAA;ERgtCJ;EQxuCE;IA+BI,0BAAA;ER4sCN;EQnvCE;IAgCE,gBAAA;ERstCJ;EQ9uCE;IA+BI,iBAAA;ERktCN;EQzvCE;IAgCE,yBAAA;ER4tCJ;EQpvCE;IA+BI,0BAAA;ERwtCN;EQ/vCE;IAgCE,yBAAA;ERkuCJ;EQ1vCE;IA+BI,0BAAA;ER8tCN;EmBrpCM;;IAEE,iBAAA;EnBupCR;EmBppCM;;IAEE,iBAAA;EnBspCR;EmB7pCM;;IAEE,uBAAA;EnB+pCR;EmB5pCM;;IAEE,uBAAA;EnB8pCR;EmBrqCM;;IAEE,sBAAA;EnBuqCR;EmBpqCM;;IAEE,sBAAA;EnBsqCR;EmB7qCM;;IAEE,oBAAA;EnB+qCR;EmB5qCM;;IAEE,oBAAA;EnB8qCR;EmBrrCM;;IAEE,sBAAA;EnBurCR;EmBprCM;;IAEE,sBAAA;EnBsrCR;EmB7rCM;;IAEE,oBAAA;EnB+rCR;EmB5rCM;;IAEE,oBAAA;EnB8rCR;AACF;AiBzvCI;EEUE;IACE,SAAA;EnBkvCN;EmB/uCI;IApCJ,cAAA;IACA,WAAA;EnBsxCA;EmBxwCA;IACE,cAAA;IACA,WAAA;EnB0wCF;EmB5wCA;IACE,cAAA;IACA,UAAA;EnB8wCF;EmBhxCA;IACE,cAAA;IACA,qBAAA;EnBkxCF;EmBpxCA;IACE,cAAA;IACA,UAAA;EnBsxCF;EmBxxCA;IACE,cAAA;IACA,UAAA;EnB0xCF;EmB5xCA;IACE,cAAA;IACA,qBAAA;EnB8xCF;EmB/vCI;IAhDJ,cAAA;IACA,WAAA;EnBkzCA;EmB7vCQ;IAhEN,cAAA;IACA,kBAAA;EnBg0CF;EmBjwCQ;IAhEN,cAAA;IACA,mBAAA;EnBo0CF;EmBrwCQ;IAhEN,cAAA;IACA,UAAA;EnBw0CF;EmBzwCQ;IAhEN,cAAA;IACA,mBAAA;EnB40CF;EmB7wCQ;IAhEN,cAAA;IACA,mBAAA;EnBg1CF;EmBjxCQ;IAhEN,cAAA;IACA,UAAA;EnBo1CF;EmBrxCQ;IAhEN,cAAA;IACA,mBAAA;EnBw1CF;EmBzxCQ;IAhEN,cAAA;IACA,mBAAA;EnB41CF;EmB7xCQ;IAhEN,cAAA;IACA,UAAA;EnBg2CF;EmBjyCQ;IAhEN,cAAA;IACA,mBAAA;EnBo2CF;EmBryCQ;IAhEN,cAAA;IACA,mBAAA;EnBw2CF;EmBzyCQ;IAhEN,cAAA;IACA,WAAA;EnB42CF;EQ14CE;IAgCE,cAAA;ER62CJ;EQr4CE;IA+BI,eAAA;ERy2CN;EQh5CE;IAgCE,wBAAA;ERm3CJ;EQ34CE;IA+BI,yBAAA;ER+2CN;EQt5CE;IAgCE,yBAAA;ERy3CJ;EQj5CE;IA+BI,0BAAA;ERq3CN;EQ55CE;IAgCE,gBAAA;ER+3CJ;EQv5CE;IA+BI,iBAAA;ER23CN;EQl6CE;IAgCE,yBAAA;ERq4CJ;EQ75CE;IA+BI,0BAAA;ERi4CN;EQx6CE;IAgCE,yBAAA;ER24CJ;EQn6CE;IA+BI,0BAAA;ERu4CN;EQ96CE;IAgCE,gBAAA;ERi5CJ;EQz6CE;IA+BI,iBAAA;ER64CN;EQp7CE;IAgCE,yBAAA;ERu5CJ;EQ/6CE;IA+BI,0BAAA;ERm5CN;EQ17CE;IAgCE,yBAAA;ER65CJ;EQr7CE;IA+BI,0BAAA;ERy5CN;EQh8CE;IAgCE,gBAAA;ERm6CJ;EQ37CE;IA+BI,iBAAA;ER+5CN;EQt8CE;IAgCE,yBAAA;ERy6CJ;EQj8CE;IA+BI,0BAAA;ERq6CN;EQ58CE;IAgCE,yBAAA;ER+6CJ;EQv8CE;IA+BI,0BAAA;ER26CN;EmBl2CM;;IAEE,iBAAA;EnBo2CR;EmBj2CM;;IAEE,iBAAA;EnBm2CR;EmB12CM;;IAEE,uBAAA;EnB42CR;EmBz2CM;;IAEE,uBAAA;EnB22CR;EmBl3CM;;IAEE,sBAAA;EnBo3CR;EmBj3CM;;IAEE,sBAAA;EnBm3CR;EmB13CM;;IAEE,oBAAA;EnB43CR;EmBz3CM;;IAEE,oBAAA;EnB23CR;EmBl4CM;;IAEE,sBAAA;EnBo4CR;EmBj4CM;;IAEE,sBAAA;EnBm4CR;EmB14CM;;IAEE,oBAAA;EnB44CR;EmBz4CM;;IAEE,oBAAA;EnB24CR;AACF;AiBt8CI;EEUE;IACE,SAAA;EnB+7CN;EmB57CI;IApCJ,cAAA;IACA,WAAA;EnBm+CA;EmBr9CA;IACE,cAAA;IACA,WAAA;EnBu9CF;EmBz9CA;IACE,cAAA;IACA,UAAA;EnB29CF;EmB79CA;IACE,cAAA;IACA,qBAAA;EnB+9CF;EmBj+CA;IACE,cAAA;IACA,UAAA;EnBm+CF;EmBr+CA;IACE,cAAA;IACA,UAAA;EnBu+CF;EmBz+CA;IACE,cAAA;IACA,qBAAA;EnB2+CF;EmB58CI;IAhDJ,cAAA;IACA,WAAA;EnB+/CA;EmB18CQ;IAhEN,cAAA;IACA,kBAAA;EnB6gDF;EmB98CQ;IAhEN,cAAA;IACA,mBAAA;EnBihDF;EmBl9CQ;IAhEN,cAAA;IACA,UAAA;EnBqhDF;EmBt9CQ;IAhEN,cAAA;IACA,mBAAA;EnByhDF;EmB19CQ;IAhEN,cAAA;IACA,mBAAA;EnB6hDF;EmB99CQ;IAhEN,cAAA;IACA,UAAA;EnBiiDF;EmBl+CQ;IAhEN,cAAA;IACA,mBAAA;EnBqiDF;EmBt+CQ;IAhEN,cAAA;IACA,mBAAA;EnByiDF;EmB1+CQ;IAhEN,cAAA;IACA,UAAA;EnB6iDF;EmB9+CQ;IAhEN,cAAA;IACA,mBAAA;EnBijDF;EmBl/CQ;IAhEN,cAAA;IACA,mBAAA;EnBqjDF;EmBt/CQ;IAhEN,cAAA;IACA,WAAA;EnByjDF;EQvlDE;IAgCE,cAAA;ER0jDJ;EQllDE;IA+BI,eAAA;ERsjDN;EQ7lDE;IAgCE,wBAAA;ERgkDJ;EQxlDE;IA+BI,yBAAA;ER4jDN;EQnmDE;IAgCE,yBAAA;ERskDJ;EQ9lDE;IA+BI,0BAAA;ERkkDN;EQzmDE;IAgCE,gBAAA;ER4kDJ;EQpmDE;IA+BI,iBAAA;ERwkDN;EQ/mDE;IAgCE,yBAAA;ERklDJ;EQ1mDE;IA+BI,0BAAA;ER8kDN;EQrnDE;IAgCE,yBAAA;ERwlDJ;EQhnDE;IA+BI,0BAAA;ERolDN;EQ3nDE;IAgCE,gBAAA;ER8lDJ;EQtnDE;IA+BI,iBAAA;ER0lDN;EQjoDE;IAgCE,yBAAA;ERomDJ;EQ5nDE;IA+BI,0BAAA;ERgmDN;EQvoDE;IAgCE,yBAAA;ER0mDJ;EQloDE;IA+BI,0BAAA;ERsmDN;EQ7oDE;IAgCE,gBAAA;ERgnDJ;EQxoDE;IA+BI,iBAAA;ER4mDN;EQnpDE;IAgCE,yBAAA;ERsnDJ;EQ9oDE;IA+BI,0BAAA;ERknDN;EQzpDE;IAgCE,yBAAA;ER4nDJ;EQppDE;IA+BI,0BAAA;ERwnDN;EmB/iDM;;IAEE,iBAAA;EnBijDR;EmB9iDM;;IAEE,iBAAA;EnBgjDR;EmBvjDM;;IAEE,uBAAA;EnByjDR;EmBtjDM;;IAEE,uBAAA;EnBwjDR;EmB/jDM;;IAEE,sBAAA;EnBikDR;EmB9jDM;;IAEE,sBAAA;EnBgkDR;EmBvkDM;;IAEE,oBAAA;EnBykDR;EmBtkDM;;IAEE,oBAAA;EnBwkDR;EmB/kDM;;IAEE,sBAAA;EnBilDR;EmB9kDM;;IAEE,sBAAA;EnBglDR;EmBvlDM;;IAEE,oBAAA;EnBylDR;EmBtlDM;;IAEE,oBAAA;EnBwlDR;AACF;AiBnpDI;EEUE;IACE,SAAA;EnB4oDN;EmBzoDI;IApCJ,cAAA;IACA,WAAA;EnBgrDA;EmBlqDA;IACE,cAAA;IACA,WAAA;EnBoqDF;EmBtqDA;IACE,cAAA;IACA,UAAA;EnBwqDF;EmB1qDA;IACE,cAAA;IACA,qBAAA;EnB4qDF;EmB9qDA;IACE,cAAA;IACA,UAAA;EnBgrDF;EmBlrDA;IACE,cAAA;IACA,UAAA;EnBorDF;EmBtrDA;IACE,cAAA;IACA,qBAAA;EnBwrDF;EmBzpDI;IAhDJ,cAAA;IACA,WAAA;EnB4sDA;EmBvpDQ;IAhEN,cAAA;IACA,kBAAA;EnB0tDF;EmB3pDQ;IAhEN,cAAA;IACA,mBAAA;EnB8tDF;EmB/pDQ;IAhEN,cAAA;IACA,UAAA;EnBkuDF;EmBnqDQ;IAhEN,cAAA;IACA,mBAAA;EnBsuDF;EmBvqDQ;IAhEN,cAAA;IACA,mBAAA;EnB0uDF;EmB3qDQ;IAhEN,cAAA;IACA,UAAA;EnB8uDF;EmB/qDQ;IAhEN,cAAA;IACA,mBAAA;EnBkvDF;EmBnrDQ;IAhEN,cAAA;IACA,mBAAA;EnBsvDF;EmBvrDQ;IAhEN,cAAA;IACA,UAAA;EnB0vDF;EmB3rDQ;IAhEN,cAAA;IACA,mBAAA;EnB8vDF;EmB/rDQ;IAhEN,cAAA;IACA,mBAAA;EnBkwDF;EmBnsDQ;IAhEN,cAAA;IACA,WAAA;EnBswDF;EQpyDE;IAgCE,cAAA;ERuwDJ;EQ/xDE;IA+BI,eAAA;ERmwDN;EQ1yDE;IAgCE,wBAAA;ER6wDJ;EQryDE;IA+BI,yBAAA;ERywDN;EQhzDE;IAgCE,yBAAA;ERmxDJ;EQ3yDE;IA+BI,0BAAA;ER+wDN;EQtzDE;IAgCE,gBAAA;ERyxDJ;EQjzDE;IA+BI,iBAAA;ERqxDN;EQ5zDE;IAgCE,yBAAA;ER+xDJ;EQvzDE;IA+BI,0BAAA;ER2xDN;EQl0DE;IAgCE,yBAAA;ERqyDJ;EQ7zDE;IA+BI,0BAAA;ERiyDN;EQx0DE;IAgCE,gBAAA;ER2yDJ;EQn0DE;IA+BI,iBAAA;ERuyDN;EQ90DE;IAgCE,yBAAA;ERizDJ;EQz0DE;IA+BI,0BAAA;ER6yDN;EQp1DE;IAgCE,yBAAA;ERuzDJ;EQ/0DE;IA+BI,0BAAA;ERmzDN;EQ11DE;IAgCE,gBAAA;ER6zDJ;EQr1DE;IA+BI,iBAAA;ERyzDN;EQh2DE;IAgCE,yBAAA;ERm0DJ;EQ31DE;IA+BI,0BAAA;ER+zDN;EQt2DE;IAgCE,yBAAA;ERy0DJ;EQj2DE;IA+BI,0BAAA;ERq0DN;EmB5vDM;;IAEE,iBAAA;EnB8vDR;EmB3vDM;;IAEE,iBAAA;EnB6vDR;EmBpwDM;;IAEE,uBAAA;EnBswDR;EmBnwDM;;IAEE,uBAAA;EnBqwDR;EmB5wDM;;IAEE,sBAAA;EnB8wDR;EmB3wDM;;IAEE,sBAAA;EnB6wDR;EmBpxDM;;IAEE,oBAAA;EnBsxDR;EmBnxDM;;IAEE,oBAAA;EnBqxDR;EmB5xDM;;IAEE,sBAAA;EnB8xDR;EmB3xDM;;IAEE,sBAAA;EnB6xDR;EmBpyDM;;IAEE,oBAAA;EnBsyDR;EmBnyDM;;IAEE,oBAAA;EnBqyDR;AACF;AiBh2DI;EEUE;IACE,SAAA;EnBy1DN;EmBt1DI;IApCJ,cAAA;IACA,WAAA;EnB63DA;EmB/2DA;IACE,cAAA;IACA,WAAA;EnBi3DF;EmBn3DA;IACE,cAAA;IACA,UAAA;EnBq3DF;EmBv3DA;IACE,cAAA;IACA,qBAAA;EnBy3DF;EmB33DA;IACE,cAAA;IACA,UAAA;EnB63DF;EmB/3DA;IACE,cAAA;IACA,UAAA;EnBi4DF;EmBn4DA;IACE,cAAA;IACA,qBAAA;EnBq4DF;EmBt2DI;IAhDJ,cAAA;IACA,WAAA;EnBy5DA;EmBp2DQ;IAhEN,cAAA;IACA,kBAAA;EnBu6DF;EmBx2DQ;IAhEN,cAAA;IACA,mBAAA;EnB26DF;EmB52DQ;IAhEN,cAAA;IACA,UAAA;EnB+6DF;EmBh3DQ;IAhEN,cAAA;IACA,mBAAA;EnBm7DF;EmBp3DQ;IAhEN,cAAA;IACA,mBAAA;EnBu7DF;EmBx3DQ;IAhEN,cAAA;IACA,UAAA;EnB27DF;EmB53DQ;IAhEN,cAAA;IACA,mBAAA;EnB+7DF;EmBh4DQ;IAhEN,cAAA;IACA,mBAAA;EnBm8DF;EmBp4DQ;IAhEN,cAAA;IACA,UAAA;EnBu8DF;EmBx4DQ;IAhEN,cAAA;IACA,mBAAA;EnB28DF;EmB54DQ;IAhEN,cAAA;IACA,mBAAA;EnB+8DF;EmBh5DQ;IAhEN,cAAA;IACA,WAAA;EnBm9DF;EQj/DE;IAgCE,cAAA;ERo9DJ;EQ5+DE;IA+BI,eAAA;ERg9DN;EQv/DE;IAgCE,wBAAA;ER09DJ;EQl/DE;IA+BI,yBAAA;ERs9DN;EQ7/DE;IAgCE,yBAAA;ERg+DJ;EQx/DE;IA+BI,0BAAA;ER49DN;EQngEE;IAgCE,gBAAA;ERs+DJ;EQ9/DE;IA+BI,iBAAA;ERk+DN;EQzgEE;IAgCE,yBAAA;ER4+DJ;EQpgEE;IA+BI,0BAAA;ERw+DN;EQ/gEE;IAgCE,yBAAA;ERk/DJ;EQ1gEE;IA+BI,0BAAA;ER8+DN;EQrhEE;IAgCE,gBAAA;ERw/DJ;EQhhEE;IA+BI,iBAAA;ERo/DN;EQ3hEE;IAgCE,yBAAA;ER8/DJ;EQthEE;IA+BI,0BAAA;ER0/DN;EQjiEE;IAgCE,yBAAA;ERogEJ;EQ5hEE;IA+BI,0BAAA;ERggEN;EQviEE;IAgCE,gBAAA;ER0gEJ;EQliEE;IA+BI,iBAAA;ERsgEN;EQ7iEE;IAgCE,yBAAA;ERghEJ;EQxiEE;IA+BI,0BAAA;ER4gEN;EQnjEE;IAgCE,yBAAA;ERshEJ;EQ9iEE;IA+BI,0BAAA;ERkhEN;EmBz8DM;;IAEE,iBAAA;EnB28DR;EmBx8DM;;IAEE,iBAAA;EnB08DR;EmBj9DM;;IAEE,uBAAA;EnBm9DR;EmBh9DM;;IAEE,uBAAA;EnBk9DR;EmBz9DM;;IAEE,sBAAA;EnB29DR;EmBx9DM;;IAEE,sBAAA;EnB09DR;EmBj+DM;;IAEE,oBAAA;EnBm+DR;EmBh+DM;;IAEE,oBAAA;EnBk+DR;EmBz+DM;;IAEE,sBAAA;EnB2+DR;EmBx+DM;;IAEE,sBAAA;EnB0+DR;EmBj/DM;;IAEE,oBAAA;EnBm/DR;EmBh/DM;;IAEE,oBAAA;EnBk/DR;AACF;AoBxmEA;EAEE,+BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,wCAAA;EACA,kCAAA;EACA,iCAAA;EACA,kCAAA;EACA,gDAAA;EACA,4CAAA;EACA,+CAAA;EACA,0CAAA;EACA,8CAAA;EACA,6BAAA;EAEA,WAAA;EACA,mBbmbO;EalbP,mBbuwB4B;EatwB5B,2CAAA;ApBumEF;AoBhmEE;EACE,sBAAA;EAEA,wFAAA;EACA,qCAAA;EACA,4Cb+wB0B;Ea9wB1B,8GAAA;ApBimEJ;AoB9lEE;EACE,uBAAA;ApBgmEJ;AoB7lEE;EACE,sBAAA;ApB+lEJ;;AoB3lEA;EACE,gEAAA;ApB8lEF;;AoBvlEA;EACE,iBAAA;ApB0lEF;;AoBhlEE;EACE,wBAAA;ApBmlEJ;;AoBpkEE;EACE,uCAAA;ApBukEJ;AoBpkEI;EACE,uCAAA;ApBskEN;;AoB/jEE;EACE,sBAAA;ApBkkEJ;AoB/jEE;EACE,mBAAA;ApBikEJ;;AoBvjEE;EACE,sDAAA;EACA,gDAAA;ApB0jEJ;;AoBpjEE;EACE,sDAAA;EACA,gDAAA;ApBujEJ;;AoB/iEA;EACE,sDAAA;EACA,gDAAA;ApBkjEF;;AoB1iEE;EACE,qDAAA;EACA,+CAAA;ApB6iEJ;;AqBzrEE;EAOE,6CAAA;EACA,uBAAA;EACA,8EAAA;EACA,mEAAA;EACA,qDAAA;EACA,2EAAA;EACA,oDAAA;EACA,kFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArBqrEJ;;AqBvsEE;EAOE,6CAAA;EACA,wCAAA;EACA,4EAAA;EACA,oFAAA;EACA,qDAAA;EACA,yEAAA;EACA,oDAAA;EACA,mFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArBmsEJ;;AqBrtEE;EAOE,6CAAA;EACA,wCAAA;EACA,qFAAA;EACA,oFAAA;EACA,qDAAA;EACA,kFAAA;EACA,oDAAA;EACA,mFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArBitEJ;;AqBnuEE;EAOE,6CAAA;EACA,sCAAA;EACA,qFAAA;EACA,oFAAA;EACA,qDAAA;EACA,kFAAA;EACA,oDAAA;EACA,kFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArB+tEJ;;AqBjvEE;EAOE,6CAAA;EACA,wCAAA;EACA,qFAAA;EACA,2EAAA;EACA,qDAAA;EACA,kFAAA;EACA,oDAAA;EACA,iFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArB6uEJ;;AqB/vEE;EAOE,6CAAA;EACA,wCAAA;EACA,0EAAA;EACA,oFAAA;EACA,qDAAA;EACA,uEAAA;EACA,oDAAA;EACA,mFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArB2vEJ;;AqB7wEE;EAOE,6CAAA;EACA,uBAAA;EACA,qFAAA;EACA,mEAAA;EACA,qDAAA;EACA,kFAAA;EACA,oDAAA;EACA,iFAAA;EACA,mDAAA;EAEA,6BAAA;EACA,2CAAA;ArBywEJ;;AqB3xEE;EAOE,4CAAA;EACA,uBAAA;EACA,oFAAA;EACA,iFAAA;EACA,oDAAA;EACA,iFAAA;EACA,mDAAA;EACA,kFAAA;EACA,kDAAA;EAEA,6BAAA;EACA,2CAAA;ArBuxEJ;;AoBtoEI;EACE,gBAAA;EACA,iCAAA;ApByoEN;;AiBpuEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpB+oEJ;AACF;AiB3uEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBqpEJ;AACF;AiBjvEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpB2pEJ;AACF;AiBvvEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBiqEJ;AACF;AiB7vEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBuqEJ;AACF;AsB30EA;EACE,qBf87BsC;Ee17BtC,oCAAA;AtB00EF;;AsBr0EA;EACE,mDAAA;EACA,sDAAA;EACA,gBAAA;EjB8QI,kBALI;EiBrQR,gBrByEiB;EqBxEjB,oCAAA;AtBs0EF;;AsBn0EA;EACE,mDAAA;EACA,sDAAA;EjBoQI,qBALI;ALwkEV;;AsBn0EA;EACE,qDAAA;EACA,wDAAA;EjB8PI,kBALI;AL8kEV;;AuBp2EA;EACE,mBhBs7BsC;EF5pBlC,kBALI;EkBjRR,6DAAA;AvBq2EF;;AwB12EA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EnBwRI,mBALI;EmBhRR,gBjBopB4B;EiBnpB5B,gBvBmFiB;EuBlFjB,oDAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,4EAAA;EfGE,kBAAA;EgBHE,wEDMJ;AxBw2EF;AyB12EM;EDhBN;ICiBQ,gBAAA;EzB62EN;AACF;AwB32EE;EACE,gBAAA;AxB62EJ;AwB32EI;EACE,eAAA;AxB62EN;AwBx2EE;EACE,0DAAA;EACA,+DAAA;EACA,0DAAA;EACA,UAAA;EAKE,2CvBkCc;ADo0EpB;AwB/1EE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AxBm1EJ;AwB90EE;EACE,cAAA;EACA,UAAA;AxBg1EJ;AwB50EE;EACE,qEAAA;EAEA,UAAA;AxB60EJ;AwBr0EE;EAEE,yBdCgB;EcAhB,qBvB7DqB;EuB+DrB,UAAA;AxBq0EJ;AwBj0EE;EACE,oBAAA;EACA,qBAAA;EACA,uBd1BkB;Ec2BlB,+DAAA;EEjGF,wEFkGuB;EACrB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gDjB6vB0B;EiB5vB1B,gBAAA;EC5FE,+HD6FF;AxBm0EJ;AyB55EM;ED6EJ;IC5EM,gBAAA;EzB+5EN;AACF;AwBr0EE;EACE,+EAAA;AxBu0EJ;;AwB9zEA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBvBjCiB;EuBkCjB,8DAAA;EACA,6BAAA;EACA,yBAAA;EACA,uCAAA;AxBi0EF;AwB/zEE;EACE,UAAA;AxBi0EJ;AwB9zEE;EAEE,gBAAA;EACA,eAAA;AxB+zEJ;;AwBpzEA;EACE,qEjBg2BsC;EiB/1BtC,yBAAA;EnBsII,kBALI;EIvQN,kBAAA;AT+7EJ;AwBrzEE;EACE,yBAAA;EACA,0BAAA;EACA,0BdpFqB;AV24EzB;;AwBnzEA;EACE,kEjBo1BsC;EiBn1BtC,oBAAA;EnByHI,qBALI;EIvQN,mBAAA;AT28EJ;AwBpzEE;EACE,oBAAA;EACA,qBAAA;EACA,uBjBwrB0B;AP8nD9B;;AwB9yEE;EACE,kEjBi0BoC;APg/CxC;AwB9yEE;EACE,qEjB8zBoC;APk/CxC;AwB7yEE;EACE,kEjB2zBoC;APo/CxC;;AwB1yEA;EACE,WjByzBsC;EiBxzBtC,8DjBkzBsC;EiBjzBtC,ed7HoB;AV06EtB;AwB3yEE;EACE,eAAA;AxB6yEJ;AwB1yEE;EACE,oBAAA;Ef1LA,kBAAA;ATu+EJ;AwBzyEE;EACE,oBAAA;Ef/LA,kBAAA;AT2+EJ;AwBxyEE;EAAoB,iEjBkyBkB;APygDxC;AwB1yEE;EAAoB,8DjBkyBkB;AP2gDxC;;A2B//EA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;A3BigFF;AQxgFI;EA+DE,gCAAA;AR48EN;AQngFI;EA2DI,gCAAA;AR28ER;A2B3gFA;EAME,oCAAA;EtBoRI,mBALI;EsB5QR,gBpBgpB4B;EoB/oB5B,gB1B+EiB;E0B9EjB,0DAAA;EACA,gBAAA;EACA,+DAAA;EACA,qFAAA;EACA,4BAAA;A3BugFF;AQzhFI;EA+DE,sCAAA;AR69EN;AQphFI;EA6DI,qCAAA;AR09ER;A2B5hFA;EAiBE,0BpBkkCkC;EoBjkClC,kFAAA;ElBJE,kBAAA;EgBHE,wEEUJ;A3B6gFF;AyBnhFM;EEfN;IFgBQ,gBAAA;EzBshFN;AACF;A2BhhFE;EACE,gEAAA;EACA,UAAA;EAKE,+CpBokC4B;AP08ClC;AQ/iFI;EAgCE,mBAAA;ARkhFN;AQ1iFI;EA+BI,kBAAA;AR8gFR;A2BhhFE;EAGE,sBAAA;A3BghFJ;A2B7gFE;EACE,8CAAA;EACA,6DAAA;EACA,qB1BlBqB;ADiiFzB;A2B3gFE;EACE,kBAAA;EACA,sEAAA;A3B6gFJ;;A2BzgFA;EACE,qBjBgBuB;EiBfvB,wBjBeuB;AV6/EzB;AQtkFI;EAgCE,qBAAA;ARyiFN;AQjkFI;EA+BI,sBAAA;ARqiFR;A2BphFA;EtBqOM,kBALI;EIvQN,kBAAA;AT+jFJ;;A2BhhFA;EACE,mBpBiyB4B;EoBhyB5B,sBpBgyB4B;APmvD9B;AQrlFI;EAgCE,kBAAA;ARwjFN;AQhlFI;EA+BI,mBAAA;ARojFR;A2B3hFA;EtB6NM,qBALI;EIvQN,mBAAA;AT8kFJ;;A4B7lFA;EACE,cAAA;EACA,qBrB4/BwC;APomD1C;AQpmFI;EAgCE,mBAAA;ARukFN;AQ/lFI;EA+BI,oBAAA;ARmkFR;A4BxmFA;EAIE,uBrB4/BwC;AP2mD1C;AQ7mFI;EAgCE,WAAA;ARglFN;AQxmFI;EA+BI,YAAA;AR4kFR;AQnnFI;EAgCE,mBAAA;ARslFN;AQ9mFI;EA+BI,oBAAA;ARklFR;;AQznFI;EAgCE,oBAAA;AR6lFN;AQrnFI;EA+BI,mBAAA;ARylFR;AQhoFI;EAgCE,eAAA;ARmmFN;AQ3nFI;EA+BI,gBAAA;AR+lFR;AQtoFI;EAgCE,iBAAA;ARymFN;AQjoFI;EA+BI,gBAAA;ARqmFR;AQ5oFI;EAgCE,YAAA;AR+mFN;AQvoFI;EA+BI,WAAA;AR2mFR;AQlpFI;EAgCE,oBAAA;ARqnFN;AQ7oFI;EA+BI,mBAAA;ARinFR;AQxpFI;EAgCE,cAAA;AR2nFN;AQnpFI;EA+BI,eAAA;ARunFR;;A4BpoFA;EACE,uCAAA;EAEA,UrBk+BwC;EqBj+BxC,WrBi+BwC;EqBh+BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,6DrBm+BwC;EqBl+BxC,yBAAA;A5BsoFF;A4BnoFE;EnB1BE,qBAAA;ATgqFJ;A4BloFE;EAEE,kBrB29BsC;APwqD1C;A4BhoFE;EACE,uBrBk9BsC;APgrD1C;A4B/nFE;EACE,qB3BvCqB;E2BwCrB,UAAA;EACA,+CrBijBoB;APglExB;A4B9nFE;EACE,uEAAA;EACA,uEAAA;A5BgoFJ;A4B9nFI;EAII,kEAAA;A5B6nFR;A4BznFI;EAII,kEAAA;A5BwnFR;A4BnnFE;EACE,yB3BpEqB;E2BqErB,qB3BrEqB;E2B0EnB,kEAAA;A5BinFN;A4B7mFE;EACE,oBAAA;EACA,YAAA;EACA,YrB07BuC;APqrD3C;A4BxmFI;EACE,eAAA;EACA,YrBi7BqC;APyrD3C;;A4BrmFA;EACE,0CAAA;A5BwmFF;;AQxtFI;EAgCE,mBAAA;AR4rFN;AQptFI;EA+BI,oBAAA;ARwrFR;A4BpmFE;EACE,6DAAA;EAEA,UrBs6B8B;AP+rDlC;AQnuFI;EAgCE,mBAAA;ARssFN;AQ9tFI;EA+BI,oBAAA;ARksFR;A4B9mFE;EAKE,2CAAA;EACA,gCAAA;EnBhHA,kBAAA;EgBHE,iDGqHF;A5B4mFJ;AyB7tFM;EGyGJ;IHxGM,gBAAA;EzBguFN;AACF;A4B/mFI;EACE,6DAAA;A5BinFN;A4B9mFI;EACE,iCrBq6B4B;EqBh6B1B,6DAAA;A5B4mFR;AQ3vFI;EAgCE,oBAAA;AR8tFN;AQtvFI;EA+BI,mBAAA;AR0tFR;AQjwFI;EAgCE,eAAA;ARouFN;AQ5vFI;EA+BI,gBAAA;ARguFR;AQvwFI;EAgCE,oBAAA;AR0uFN;AQlwFI;EA+BI,mBAAA;ARsuFR;AQ7wFI;EAgCE,cAAA;ARgvFN;AQxwFI;EA+BI,eAAA;AR4uFR;;A4BhnFE;EACE,kBAHO;A5BsnFX;AQvxFI;EAgCE,oBAAA;AR0vFN;AQlxFI;EA+BI,qBAAA;ARsvFR;A4BtnFI;EACE,aARI;EASJ,cARK;A5BgoFX;AQjyFI;EAgCE,oBAAA;ARowFN;AQ5xFI;EA+BI,qBAAA;ARgwFR;A4B1nFI;EAEE,0CAAA;A5B2nFN;;A4BvoFE;EACE,iBAHO;A5B6oFX;AQ9yFI;EAgCE,mBAAA;ARixFN;AQzyFI;EA+BI,oBAAA;AR6wFR;A4B7oFI;EACE,UARI;EASJ,aARK;A5BupFX;AQxzFI;EAgCE,mBAAA;AR2xFN;AQnzFI;EA+BI,oBAAA;ARuxFR;A4BjpFI;EAEE,yCAAA;A5BkpFN;;A4B7oFA;EACE,qBAAA;A5BgpFF;AQr0FI;EAgCE,kBAAA;ARwyFN;AQh0FI;EA+BI,iBAAA;ARoyFR;;A4BlpFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A5BqpFF;A4BjpFI;EACE,oBAAA;EACA,YAAA;EACA,arBksBwB;APi9D9B;;A6Bl1FA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A7Bq1FF;A6Bn1FE;EACE,UAAA;A7Bq1FJ;A6Bj1FI;EAA0B,8DtBknCa;APkuD3C;A6Bn1FI;EAA0B,8DtBinCa;APquD3C;A6Bn1FE;EACE,SAAA;A7Bq1FJ;A6Bl1FE;EACE,WtBmmCuC;EsBlmCvC,YtBkmCuC;EsBjmCvC,oBAAA;EACA,gBAAA;EH1BF,yDG2BuB;EACrB,StBimCuC;EE9mCvC,mBAAA;EgBHE,oHImBF;EJnBE,4GImBF;A7Bm1FJ;AyBl2FM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EzBq2FN;AACF;A6Bt1FI;EHjCF,iFGkCyB;A7Bw1F3B;A6Bp1FE;EACE,WtB4kC8B;EsB3kC9B,ctB4kC8B;EsB3kC9B,kBAAA;EACA,etB2kC8B;EsB1kC9B,wEAAA;EACA,yBAAA;EpB7BA,mBAAA;ATo3FJ;A6Bl1FE;EACE,WtBwkCuC;EsBvkCvC,YtBukCuC;EsBtkCvC,gBAAA;EHpDF,yDGqDuB;EACrB,StBukCuC;EE9mCvC,mBAAA;EgBHE,iHI6CF;EJ7CE,4GI6CF;A7Bm1FJ;AyB53FM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EzB+3FN;AACF;A6Bt1FI;EH3DF,iFG4DyB;A7Bw1F3B;A6Bp1FE;EACE,WtBkjC8B;EsBjjC9B,ctBkjC8B;EsBjjC9B,kBAAA;EACA,etBijC8B;EsBhjC9B,wEAAA;EACA,yBAAA;EpBvDA,mBAAA;AT84FJ;A6Bl1FE;EACE,oBAAA;A7Bo1FJ;A6Bl1FI;EACE,qFAAA;A7Bo1FN;A6Bj1FI;EACE,qFAAA;A7Bm1FN;;A8B16FA;EACE,kBAAA;A9B66FF;A8B36FE;;;EAGE,wDvB4oCoC;EuB3oCpC,4DvB2oCoC;EuB1oCpC,iBvB2oCoC;APkyDxC;A8B16FE;EACE,kBAAA;EACA,MAAA;A9B46FJ;AQv7FI;EAgCE,OAAA;AR05FN;AQl7FI;EA+BI,QAAA;ARs5FR;A8Bp7FE;EAIE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;ELRE,gEKSF;A9Bm7FJ;AyBx7FM;EKTJ;ILUM,gBAAA;EzB27FN;AACF;A8Br7FE;;EAEE,kBAAA;A9Bu7FJ;A8Br7FI;;EACE,kBAAA;A9Bw7FN;A8Br7FI;;;EAEE,qBvBgnCkC;EuB/mClC,wBvBgnCkC;APw0DxC;A8Br7FI;;EACE,qBvB2mCkC;EuB1mClC,wBvB2mCkC;AP60DxC;A8Bp7FE;EACE,qBvBqmCoC;EuBpmCpC,wBvBqmCoC;APi1DxC;A8B/6FI;;;;EACE,4CAAA;EACA,8DvB+lCkC;APq1DxC;A8Bl7FM;;;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,avBulCgC;EuBtlChC,WAAA;EACA,oCvBu5BgC;EEv8BpC,kBAAA;ATw+FJ;A8Bj7FI;EACE,4CAAA;EACA,8DvB8kCkC;APq2DxC;A8B96FI;EACE,uCAAA;A9Bg7FN;A8B56FE;;EAEE,cvBzEQ;APu/FZ;A8B56FI;;EACE,yBAAA;A9B+6FN;;A+BtgGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/BygGF;A+BvgGE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A/BygGJ;A+BrgGE;;;EAGE,UAAA;A/BugGJ;A+BjgGE;EACE,kBAAA;EACA,UAAA;A/BmgGJ;A+BjgGI;EACE,UAAA;A/BmgGN;;A+Bx/FA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;E1B8OI,mBALI;E0BvOR,gBxB2mB4B;EwB1mB5B,gB9B0CiB;E8BzCjB,gEAAA;EACA,kBAAA;EACA,mBAAA;EACA,yEAAA;EACA,wFAAA;EtBtCE,kBAAA;ATkiGJ;;A+Bl/FA;;;;EAIE,oBAAA;E1BwNI,qBALI;EIvQN,mBAAA;AT2iGJ;;A+Bl/FA;;;;EAIE,yBAAA;E1B+MI,kBALI;EIvQN,kBAAA;ATojGJ;;AQrkGI;;EAgCE,mBAAA;AR0iGN;AQlkGI;;EA+BI,kBAAA;ARuiGR;;AQ9kGI;;;;EAgCE,0BAAA;ARqjGN;AQ7kGI;;;;EA+BI,yBAAA;ARojGR;AQ3lGI;;;;EAgCE,6BAAA;ARikGN;AQzlGI;;;;EA+BI,4BAAA;ARgkGR;AQvmGI;;;;EAgCE,0BAAA;AR6kGN;AQrmGI;;;;EA+BI,yBAAA;AR4kGR;AQnnGI;;;;EAgCE,6BAAA;ARylGN;AQjnGI;;;;EA+BI,4BAAA;ARwlGR;AQ/nGI;EAgCE,+CAAA;ARkmGN;AQ1nGI;EA+BI,gDAAA;AR8lGR;AQroGI;EAgCE,yBAAA;ARwmGN;AQhoGI;EA+BI,0BAAA;ARomGR;AQ3oGI;EAgCE,4BAAA;AR8mGN;AQtoGI;EA+BI,6BAAA;AR0mGR;AQjpGI;;EAgCE,yBAAA;ARqnGN;AQ7oGI;;EA+BI,0BAAA;ARknGR;AQzpGI;;EAgCE,4BAAA;AR6nGN;AQrpGI;;EA+BI,6BAAA;AR0nGR;;AgCzoGE;EACE,aAAA;EACA,WAAA;EACA,mBzB85BoC;EF5pBlC,kBALI;E2B1PN,kCzBspCqB;APq/DzB;;AgCxoGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,kBALI;E2B7ON,WzByoCqB;EyBxoCrB,oCzBwoCqB;EEnqCrB,uCAAA;ATsqGJ;;AgCtoGI;;;;EAEE,cAAA;AhC2oGN;;AgC1rGI;EAqDE,gDzB2nCmB;AP8gEzB;AQlsGI;EAgCE,iCAAA;ARqqGN;AQ7rGI;EA+BI,gCAAA;ARiqGR;AgCpsGI;EAyDI,yDAAA;EACA,4BAAA;AhC8oGR;AQ5sGI;EA+DE,yDAAA;ARgpGN;AQvsGI;EA2DI,wDAAA;AR+oGR;AgC9sGI;EA4DI,4DAAA;AhCqpGR;AgClpGM;EACE,gDzBgnCiB;EyB/mCjB,4DzB+mCiB;APqiEzB;;AQztGI;EAgCE,iCAAA;AR6rGN;AQrtGI;EA+BI,gCAAA;ARyrGR;AQhuGI;EA+DE,8EAAA;ARoqGN;AQ3tGI;EA2DI,6EAAA;ARmqGR;;AgCluGI;EAkFE,gDzB8lCmB;APsjEzB;AgCjpGQ;EAEE,kEAAA;AhCkpGV;AQ7uGI;EAgCE,qBAAA;ARgtGN;AQxuGI;EA+BI,oBAAA;AR4sGR;AQnvGI;EA+DE,yDAAA;ARurGN;AQ9uGI;EA6DI,uDAAA;ARorGR;AgChqGQ;EAKE,uEAAA;AhC8pGV;AgC1pGM;EACE,gDzBilCiB;EyBhlCjB,4DzBglCiB;AP4kEzB;;AgC5vGI;EAwGI,sCAAA;AhCwpGR;;AgChwGI;EA+GE,gDzBikCmB;APolEzB;AgCnpGM;EACE,6CzB8jCiB;APulEzB;AgClpGM;EACE,4DzB0jCiB;AP0lEzB;AgCjpGM;EACE,kCzBsjCiB;AP6lEzB;;AQjxGI;EAgCE,kBAAA;ARqvGN;AQ7wGI;EA+BI,mBAAA;ARivGR;;AgCpxGI;;;;;EA0IM,UAAA;AhCkpGV;;AgCxwGE;EACE,aAAA;EACA,WAAA;EACA,mBzB85BoC;EF5pBlC,kBALI;E2B1PN,oCzBspCqB;APonEzB;;AgCvwGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,kBALI;E2B7ON,WzByoCqB;EyBxoCrB,mCzBwoCqB;EEnqCrB,uCAAA;ATqyGJ;;AgCrwGI;;;;EAEE,cAAA;AhC0wGN;;AgCzzGI;EAqDE,kDzB2nCmB;AP6oEzB;AQj0GI;EAgCE,iCAAA;ARoyGN;AQ5zGI;EA+BI,gCAAA;ARgyGR;AgCn0GI;EAyDI,yDAAA;EACA,4BAAA;AhC6wGR;AQ30GI;EA+DE,yDAAA;AR+wGN;AQt0GI;EA2DI,wDAAA;AR8wGR;AgC70GI;EA4DI,4DAAA;AhCoxGR;AgCjxGM;EACE,kDzBgnCiB;EyB/mCjB,2DzB+mCiB;APoqEzB;;AQx1GI;EAgCE,iCAAA;AR4zGN;AQp1GI;EA+BI,gCAAA;ARwzGR;AQ/1GI;EA+DE,8EAAA;ARmyGN;AQ11GI;EA2DI,6EAAA;ARkyGR;;AgCj2GI;EAkFE,kDzB8lCmB;APqrEzB;AgChxGQ;EAEE,kEAAA;AhCixGV;AQ52GI;EAgCE,qBAAA;AR+0GN;AQv2GI;EA+BI,oBAAA;AR20GR;AQl3GI;EA+DE,yDAAA;ARszGN;AQ72GI;EA6DI,uDAAA;ARmzGR;AgC/xGQ;EAKE,uEAAA;AhC6xGV;AgCzxGM;EACE,kDzBilCiB;EyBhlCjB,2DzBglCiB;AP2sEzB;;AgC33GI;EAwGI,sCAAA;AhCuxGR;;AgC/3GI;EA+GE,kDzBikCmB;APmtEzB;AgClxGM;EACE,+CzB8jCiB;APstEzB;AgCjxGM;EACE,2DzB0jCiB;APytEzB;AgChxGM;EACE,oCzBsjCiB;AP4tEzB;;AQh5GI;EAgCE,kBAAA;ARo3GN;AQ54GI;EA+BI,mBAAA;ARg3GR;;AgCn5GI;;;;;EA4IM,UAAA;AhC+wGV;;AiC75GA;EAEE,yBAAA;EACA,2BAAA;EACA,uBAAA;E5BuRI,6BALI;E4BhRR,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,+CAAA;EACA,mCAAA;EACA,4BAAA;EACA,yCAAA;EACA,8FAAA;EACA,gCAAA;EACA,mFAAA;EAGA,qBAAA;EACA,0DAAA;EACA,uCAAA;E5BsQI,mCALI;E4B/PR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qEAAA;ExBjBE,2CAAA;EiBfF,mCOkCqB;ERtBjB,+HQwBJ;AjC25GF;AyB/6GM;EQhBN;IRiBQ,gBAAA;EzBk7GN;AACF;AiC95GE;EACE,iCAAA;EAEA,yCAAA;EACA,+CAAA;AjC+5GJ;AiC55GE;EAEE,2BAAA;EACA,mCAAA;EACA,yCAAA;AjC65GJ;AiC15GE;EACE,iCAAA;EPrDF,yCOsDuB;EACrB,+CAAA;EACA,UAAA;EAKE,2CAAA;AjCw5GN;AiCp5GE;EACE,+CAAA;EACA,UAAA;EAKE,2CAAA;AjCk5GN;AiC94GE;EAKE,kCAAA;EACA,0CAAA;EAGA,gDAAA;AjC04GJ;AiCv4GI;EAKI,2CAAA;AjCq4GR;AiCh4GE;EAGE,oCAAA;EACA,oBAAA;EACA,4CAAA;EAEA,kDAAA;EACA,wCAAA;AjC+3GJ;;AiCr3GA;EACE,0CAAA;EACA,4CAAA;EACA,yCAAA;AjCw3GF;;AiCn3GE;EC3GA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,gDAAA;EACA,6CAAA;EACA,oDAAA;EACA,uCAAA;EACA,iDAAA;EACA,4BAAA;EACA,qDAAA;EACA,8DAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;AlCk+GF;;AiCp4GE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,8CAAA;EACA,sDAAA;EACA,yCAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlCm/GF;;AiCr5GE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,iDAAA;EACA,8CAAA;EACA,qDAAA;EACA,uCAAA;EACA,kDAAA;EACA,4CAAA;EACA,sDAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlCogHF;;AiCt6GE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlCqhHF;;AiCv7GE;EC3GA,2CAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,+BAAA;EACA,4CAAA;EACA,yDAAA;EACA,8DAAA;EACA,oDAAA;EACA,8BAAA;EACA,wCAAA;AlCsiHF;;AiCx8GE;EC3GA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,+BAAA;EACA,0CAAA;EACA,oDAAA;EACA,8DAAA;EACA,iCAAA;EACA,2BAAA;EACA,qCAAA;AlCujHF;;AiCz9GE;EC3GA,2CAAA;EACA,qBAAA;EACA,+BAAA;EACA,iDAAA;EACA,+CAAA;EACA,oDAAA;EACA,yCAAA;EACA,kDAAA;EACA,2CAAA;EACA,0DAAA;EACA,8DAAA;EACA,oDAAA;EACA,8BAAA;EACA,wCAAA;AlCwkHF;;AiC1+GE;EC3GA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,yCAAA;EACA,4BAAA;EACA,2CAAA;EACA,oDAAA;EACA,8DAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;AlCylHF;;AiCr/GE;ECpFA,wBAAA;EACA,+BAAA;EACA,gDAAA;EACA,2BAAA;EACA,oDAAA;EACA,qCAAA;EACA,iDAAA;EACA,4BAAA;EACA,qDAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6kHF;;AiCrgHE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,yCAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6lHF;;AiCrhHE;ECpFA,wBAAA;EACA,+BAAA;EACA,iDAAA;EACA,2CAAA;EACA,qDAAA;EACA,uCAAA;EACA,kDAAA;EACA,4CAAA;EACA,sDAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6mHF;;AiCriHE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6nHF;;AiCrjHE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2CAAA;EACA,wDAAA;EACA,wCAAA;EACA,+BAAA;EACA,4CAAA;EACA,yDAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6oHF;;AiCrkHE;ECpFA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,+BAAA;EACA,0CAAA;EACA,oDAAA;EACA,8DAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;AlC6pHF;;AiCrlHE;ECpFA,wBAAA;EACA,+BAAA;EACA,iDAAA;EACA,0CAAA;EACA,yDAAA;EACA,yCAAA;EACA,kDAAA;EACA,2CAAA;EACA,0DAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6qHF;;AiCrmHE;ECpFA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,uCAAA;EACA,4BAAA;EACA,2CAAA;EACA,oDAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AlC6rHF;;AiC/mHE;EC9DA,wBAAA;EACA,6CAAA;EACA,oDAAA;EACA,gDAAA;EACA,4BAAA;EACA,qDAAA;EACA,iDAAA;EACA,iCAAA;EACA,sCAAA;AlCirHF;;AiC3nHE;EC9DA,wBAAA;EACA,8CAAA;EACA,sDAAA;EACA,8BAAA;EACA,6CAAA;EACA,uDAAA;EACA,+BAAA;EACA,iCAAA;EACA,0CAAA;AlC6rHF;;AiCvoHE;EC9DA,wBAAA;EACA,8CAAA;EACA,qDAAA;EACA,iDAAA;EACA,4CAAA;EACA,sDAAA;EACA,kDAAA;EACA,iCAAA;EACA,wCAAA;AlCysHF;;AiCnpHE;EC9DA,wBAAA;EACA,4CAAA;EACA,sDAAA;EACA,8BAAA;EACA,6CAAA;EACA,uDAAA;EACA,+BAAA;EACA,iCAAA;EACA,wCAAA;AlCqtHF;;AiC/pHE;EC9DA,wBAAA;EACA,8CAAA;EACA,qDAAA;EACA,8BAAA;EACA,4CAAA;EACA,yDAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AlCiuHF;;AiC3qHE;EC9DA,qBAAA;EACA,yCAAA;EACA,mDAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,+BAAA;EACA,8BAAA;EACA,yCAAA;AlC6uHF;;AiCvrHE;EC9DA,wBAAA;EACA,+CAAA;EACA,oDAAA;EACA,iDAAA;EACA,2CAAA;EACA,0DAAA;EACA,kDAAA;EACA,iCAAA;EACA,0CAAA;AlCyvHF;;AiCnsHE;EC9DA,wBAAA;EACA,0CAAA;EACA,mDAAA;EACA,2BAAA;EACA,2CAAA;EACA,oDAAA;EACA,4BAAA;EACA,iCAAA;EACA,wCAAA;AlCqwHF;;AiCnsHA;EACE,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0BAAA;EACA,uCAAA;EAEA,0B1BiVwC;APo3G1C;AiC3rHE;EACE,2BAAA;AjC6rHJ;;AiClrHA;EC9FE,2BAAA;EACA,yBAAA;E7BiMI,+BALI;E6B1LR,6BAAA;AlCoxHF;;AiCrrHA;EClGE,6BAAA;EACA,4BAAA;E7BiMI,4BALI;E6B1LR,4BAAA;AlC2xHF;;AmC33HA;EVgBM,gCUfJ;AnC83HF;AyB32HM;EUpBN;IVqBQ,gBAAA;EzB82HN;AACF;AmCj4HE;EACE,UAAA;AnCm4HJ;;AmC73HE;EACE,aAAA;AnCg4HJ;;AmC53HA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AnC+3HF;AyB73HM;EULN;IVMQ,gBAAA;EzBg4HN;AACF;AmCl4HE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AnCo4HJ;AyBv4HM;EUAJ;IVCM,gBAAA;EzB04HN;AACF;;AoC/5HA;;;;;;EAME,kBAAA;ApCk6HF;;AoC/5HA;EACE,mBAAA;ApCk6HF;AqC14HI;EACE,qBAAA;ArC44HN;AQ96HI;EAgCE,oBAAA;ARi5HN;AQz6HI;EA+BI,qBAAA;AR64HR;AqCn5HI;EAGE,uB9B6kBwB;E8B5kBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ArCy7HF;AQ57HI;EAgCE,cAAA;AR+5HN;AQv7HI;EA+BI,eAAA;AR25HR;;AoCl7HA;EAEE,2BAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;E/BuQI,kCALI;E+BhQR,2CAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;EACA,oDAAA;EACA,uEAAA;EACA,kCAAA;EACA,uCAAA;EACA,2DAAA;EACA,gDAAA;EACA,sDAAA;EACA,qCAAA;EACA,yCAAA;EACA,sCAAA;EACA,6DAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,wCAAA;EACA,oEAAA;EACA,SAAA;E/B0OI,wCALI;E+BnOR,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+EAAA;E3BzCE,gDAAA;AT49HJ;AoC/6HE;EACE,SAAA;ApCi7HJ;AQh/HI;EAgCE,OAAA;ARm9HN;AQ3+HI;EA+BI,QAAA;AR+8HR;AoCx7HE;EAGE,sCAAA;ApCw7HJ;;AoCh6HI;EACE,qBAAA;ApCm6HN;AQ7/HI;EAgCE,WAAA;ARg+HN;AQx/HI;EA+BI,UAAA;AR49HR;AQngII;EAgCE,OAAA;ARs+HN;AQ9/HI;EA+BI,QAAA;ARk+HR;;AoCv6HI;EACE,mBAAA;ApC06HN;AQ7gII;EAgCE,QAAA;ARg/HN;AQxgII;EA+BI,OAAA;AR4+HR;AQnhII;EAgCE,UAAA;ARs/HN;AQ9gII;EA+BI,WAAA;ARk/HR;;AiB59HI;EmB4BA;IACE,qBAAA;EpCo8HJ;EQ9hIE;IAgCE,WAAA;ERigIJ;EQzhIE;IA+BI,UAAA;ER6/HN;EQpiIE;IAgCE,OAAA;ERugIJ;EQ/hIE;IA+BI,QAAA;ERmgIN;EoCx8HE;IACE,mBAAA;EpC08HJ;EQ7iIE;IAgCE,QAAA;ERghIJ;EQxiIE;IA+BI,OAAA;ER4gIN;EQnjIE;IAgCE,UAAA;ERshIJ;EQ9iIE;IA+BI,WAAA;ERkhIN;AACF;AiB7/HI;EmB4BA;IACE,qBAAA;EpCo+HJ;EQ9jIE;IAgCE,WAAA;ERiiIJ;EQzjIE;IA+BI,UAAA;ER6hIN;EQpkIE;IAgCE,OAAA;ERuiIJ;EQ/jIE;IA+BI,QAAA;ERmiIN;EoCx+HE;IACE,mBAAA;EpC0+HJ;EQ7kIE;IAgCE,QAAA;ERgjIJ;EQxkIE;IA+BI,OAAA;ER4iIN;EQnlIE;IAgCE,UAAA;ERsjIJ;EQ9kIE;IA+BI,WAAA;ERkjIN;AACF;AiB7hII;EmB4BA;IACE,qBAAA;EpCogIJ;EQ9lIE;IAgCE,WAAA;ERikIJ;EQzlIE;IA+BI,UAAA;ER6jIN;EQpmIE;IAgCE,OAAA;ERukIJ;EQ/lIE;IA+BI,QAAA;ERmkIN;EoCxgIE;IACE,mBAAA;EpC0gIJ;EQ7mIE;IAgCE,QAAA;ERglIJ;EQxmIE;IA+BI,OAAA;ER4kIN;EQnnIE;IAgCE,UAAA;ERslIJ;EQ9mIE;IA+BI,WAAA;ERklIN;AACF;AiB7jII;EmB4BA;IACE,qBAAA;EpCoiIJ;EQ9nIE;IAgCE,WAAA;ERimIJ;EQznIE;IA+BI,UAAA;ER6lIN;EQpoIE;IAgCE,OAAA;ERumIJ;EQ/nIE;IA+BI,QAAA;ERmmIN;EoCxiIE;IACE,mBAAA;EpC0iIJ;EQ7oIE;IAgCE,QAAA;ERgnIJ;EQxoIE;IA+BI,OAAA;ER4mIN;EQnpIE;IAgCE,UAAA;ERsnIJ;EQ9oIE;IA+BI,WAAA;ERknIN;AACF;AiB7lII;EmB4BA;IACE,qBAAA;EpCokIJ;EQ9pIE;IAgCE,WAAA;ERioIJ;EQzpIE;IA+BI,UAAA;ER6nIN;EQpqIE;IAgCE,OAAA;ERuoIJ;EQ/pIE;IA+BI,QAAA;ERmoIN;EoCxkIE;IACE,mBAAA;EpC0kIJ;EQ7qIE;IAgCE,QAAA;ERgpIJ;EQxqIE;IA+BI,OAAA;ER4oIN;EQnrIE;IAgCE,UAAA;ERspIJ;EQ9qIE;IA+BI,WAAA;ERkpIN;AACF;AoCzkIE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;ApC2kIJ;AqC/pII;EACE,qBAAA;ArCiqIN;AQnsII;EAgCE,oBAAA;ARsqIN;AQ9rII;EA+BI,qBAAA;ARkqIR;AqCxqII;EAGE,uB9B6kBwB;E8B5kBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ArCusIF;AQjtII;EAgCE,cAAA;ARorIN;AQ5sII;EA+BI,eAAA;ARgrIR;;AoCzlIE;EACE,MAAA;ApC4lIJ;AQ3tII;EAgCE,WAAA;AR8rIN;AQttII;EA+BI,UAAA;AR0rIR;AQjuII;EAgCE,UAAA;ARosIN;AQ5tII;EA+BI,WAAA;ARgsIR;AoCzmIE;EAIE,aAAA;ApCwmIJ;AQ1uII;EAgCE,uCAAA;AR6sIN;AQruII;EA+BI,wCAAA;ARysIR;AqC/sII;EACE,qBAAA;ArCitIN;AQnvII;EAgCE,oBAAA;ARstIN;AQ9uII;EA+BI,qBAAA;ARktIR;AqCxtII;EAGE,uB9B6kBwB;E8B5kBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ArCgvIF;AQjwII;EAgCE,cAAA;ARouIN;AQ5vII;EA+BI,eAAA;ARguIR;AoC/nII;EACE,iBAAA;ApCioIN;;AoC3nIE;EACE,MAAA;ApC8nIJ;AQ9wII;EAgCE,WAAA;ARivIN;AQzwII;EA+BI,UAAA;AR6uIR;AQpxII;EAgCE,UAAA;ARuvIN;AQ/wII;EA+BI,WAAA;ARmvIR;AoC3oIE;EAIE,aAAA;ApC0oIJ;AQ7xII;EAgCE,wCAAA;ARgwIN;AQxxII;EA+BI,uCAAA;AR4vIR;AqClwII;EACE,qBAAA;ArCowIN;AQtyII;EAgCE,oBAAA;ARywIN;AQjyII;EA+BI,qBAAA;ARqwIR;AqC3wII;EAGE,uB9B6kBwB;E8B5kBxB,WAAA;ArC2wIN;AqChwIM;EACE,aAAA;ArCkwIR;AqC/vIM;EACE,qBAAA;ArCiwIR;AQtzII;EAgCE,qBAAA;ARyxIN;AQjzII;EA+BI,oBAAA;ARqxIR;AqCxwIM;EAGE,uB9B0jBsB;E8BzjBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ArC4yIF;AQn0II;EAgCE,cAAA;ARsyIN;AQ9zII;EA+BI,eAAA;ARkyIR;AoChrII;EACE,iBAAA;ApCkrIN;;AoC3qIA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,oDAAA;EACA,UAAA;ApC8qIF;;AoCxqIA;EACE,cAAA;EACA,WAAA;EACA,8EAAA;EACA,WAAA;EACA,gB7B2e4B;E6B1e5B,qCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,wDAAA;ATk1IJ;AoCzqIE;EAEE,2CAAA;EV1LF,mDU4LuB;ApCyqIzB;AoCtqIE;EAEE,4CAAA;EACA,qBAAA;EVlMF,oDUmMuB;ApCuqIzB;AoCpqIE;EAEE,8CAAA;EACA,oBAAA;EACA,6BAAA;ApCqqIJ;;AoC/pIA;EACE,cAAA;ApCkqIF;;AoC9pIA;EACE,cAAA;EACA,kFAAA;EACA,gBAAA;E/BmEI,kBALI;E+B5DR,uCAAA;EACA,mBAAA;ApCiqIF;;AoC7pIA;EACE,cAAA;EACA,8EAAA;EACA,qCAAA;ApCgqIF;;AoC5pIA;EAEE,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,kCAAA;EACA,0DAAA;EACA,kCAAA;EACA,uDAAA;EACA,yCAAA;EACA,sCAAA;EACA,2CAAA;EACA,oCAAA;ApC8pIF;;AsCp5IA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AtCu5IF;AsCr5IE;;EACE,kBAAA;EACA,cAAA;AtCw5IJ;AsCn5IE;;;;;;;;;;;;EAME,UAAA;AtC25IJ;;AsCt5IA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AtCy5IF;AsCv5IE;EACE,WAAA;AtCy5IJ;;AsCr5IA;E7BhBI,kBAAA;ATy6IJ;AQ17II;;EAgCE,+CAAA;AR85IN;AQt7II;;EA+BI,gDAAA;AR25IR;AQl8II;;;EAgCE,0BAAA;ARu6IN;AQ/7II;;;EA+BI,yBAAA;ARq6IR;AQ58II;;;EAgCE,6BAAA;ARi7IN;AQz8II;;;EA+BI,4BAAA;AR+6IR;AQt9II;;;EAgCE,yBAAA;AR27IN;AQn9II;;;EA+BI,0BAAA;ARy7IR;AQh+II;;;EAgCE,4BAAA;ARq8IN;AQ79II;;;EA+BI,6BAAA;ARm8IR;;AsCl6IA;EACE,sBAAA;EACA,qBAAA;AtCq6IF;AQ/+II;EAgCE,cAAA;ARk9IN;AQ1+II;EA+BI,eAAA;AR88IR;AQr/II;EAgCE,eAAA;ARw9IN;AQh/II;EA+BI,cAAA;ARo9IR;;AsCp6IA;EACE,wBAAA;EACA,uBAAA;AtCu6IF;;AsCp6IA;EACE,sBAAA;EACA,qBAAA;AtCu6IF;;AsCn5IA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AtCs5IF;AsCp5IE;;EAEE,WAAA;AtCs5IJ;AsCn5IE;;EAEE,8CAAA;AtCq5IJ;AsCj5IE;;E7B1FE,6BAAA;EACA,4BAAA;AT++IJ;AsCj5IE;;E7B7GE,yBAAA;EACA,0BAAA;ATkgJJ;;AuC1hJA;EAEE,8BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,yDAAA;EAGA,aAAA;EACA,eAAA;AvCyhJF;AQxiJI;EAgCE,eAAA;AR2gJN;AQniJI;EA+BI,gBAAA;ARugJR;AuC3iJA;EAcE,gBAAA;EACA,gBAAA;AvCgiJF;;AuC7hJA;EACE,cAAA;EACA,oEAAA;ElCsQI,wCALI;EkC/PR,4CAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AvCgiJF;AyB5iJM;EcGN;IdFQ,gBAAA;EzB+iJN;AACF;AuCniJE;EAEE,sCAAA;AvCoiJJ;AuChiJE;EACE,UAAA;EACA,+ChCokBoB;AP89HxB;AuC9hJE;EAEE,yCAAA;EACA,oBAAA;EACA,eAAA;AvC+hJJ;;AuCvhJA;EAEE,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,+GAAA;EACA,2DAAA;EACA,iDAAA;EACA,2GAAA;EAGA,sFAAA;AvCuhJF;AuCrhJE;EACE,0DAAA;EACA,0DAAA;E9B7CA,yDAAA;EACA,0DAAA;ATqkJJ;AuCthJI;EAGE,kBAAA;EACA,yDAAA;AvCshJN;AuClhJE;;EAEE,4CAAA;EACA,oDAAA;EACA,0DAAA;AvCohJJ;AuCjhJE;EAEE,uDAAA;E9BjEA,yBAAA;EACA,0BAAA;ATolJJ;;AuCzgJA;EAEE,uDAAA;EACA,4DAAA;EACA,uCAAA;AvC2gJF;AuCxgJE;E9B5FE,iDAAA;ATumJJ;AuCvgJE;;EAEE,6CAAA;EbjHF,qDakHuB;AvCygJzB;;AuC//IE;;EAEE,cAAA;EACA,kBAAA;AvCkgJJ;;AuC7/IE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AvCggJJ;;AuC1/IE;;EACE,WAAA;AvC8/IJ;;AuCp/IE;EACE,aAAA;AvCu/IJ;AuCr/IE;EACE,cAAA;AvCu/IJ;;AwCnpJA;EAEE,yBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,0CAAA;EACA,mCAAA;EACA,wCAAA;EACA,gEAAA;EACA,sEAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,0CAAA;EACA,qEAAA;EACA,4EAAA;EACA,uCAAA;EACA,yCAAA;EACA,6DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;AxCmpJF;AwC7oJE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AxC2pJJ;AwCvoJA;EACE,8CAAA;EACA,iDAAA;AxCyoJF;AQzsJI;EAgCE,gDAAA;AR4qJN;AQpsJI;EA+BI,+CAAA;ARwqJR;AwCjpJA;EnC+NM,4CALI;EmCrNR,oCAAA;EACA,qBAAA;EACA,mBAAA;AxCgpJF;AwC9oJE;EAEE,0CAAA;AxC+oJJ;;AwCroJA;EAEE,2BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,6CAAA;EACA,yDAAA;EACA,+DAAA;EAGA,aAAA;EACA,sBAAA;AxCooJF;AQnuJI;EAgCE,eAAA;ARssJN;AQ9tJI;EA+BI,gBAAA;ARksJR;AwCtpJA;EAcE,gBAAA;EACA,gBAAA;AxC2oJF;AwCxoJI;EAEE,qCAAA;AxCyoJN;AwCroJE;EACE,gBAAA;AxCuoJJ;;AwC/nJA;EACE,mBjCqnCkC;EiCpnClC,sBjConCkC;EiCnnClC,8BAAA;AxCkoJF;AwChoJE;;;EAGE,qCAAA;AxCkoJJ;;AwCrnJA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AxCsnJF;;AwClnJA;EACE,gFAAA;EnC0II,8CALI;EmCnIR,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4EAAA;E/BvIE,sDAAA;EgBHE,gDe4IJ;AxCqnJF;AyB7vJM;EegIN;If/HQ,gBAAA;EzBgwJN;AACF;AwCxnJE;EACE,qBAAA;AxC0nJJ;AwCvnJE;EACE,qBAAA;EACA,UAAA;EACA,uDAAA;AxCynJJ;;AwCnnJA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AxCsnJF;;AwCnnJA;EACE,0CAAA;EACA,gBAAA;AxCsnJF;;AiB/uJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ExC6mJN;EwC3mJM;IACE,mBAAA;ExC6mJR;EwC3mJQ;IACE,kBAAA;ExC6mJV;EwC1mJQ;IACE,mDAAA;IACA,kDAAA;ExC4mJV;EwCxmJM;IACE,iBAAA;ExC0mJR;EwCvmJM;IACE,wBAAA;IACA,gBAAA;ExCymJR;EwCtmJM;IACE,aAAA;ExCwmJR;EwCrmJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ExCqmJR;EwClmJQ;IACE,aAAA;ExComJV;EwCjmJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCmmJV;AACF;AiB/xJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ExC4pJN;EwC1pJM;IACE,mBAAA;ExC4pJR;EwC1pJQ;IACE,kBAAA;ExC4pJV;EwCzpJQ;IACE,mDAAA;IACA,kDAAA;ExC2pJV;EwCvpJM;IACE,iBAAA;ExCypJR;EwCtpJM;IACE,wBAAA;IACA,gBAAA;ExCwpJR;EwCrpJM;IACE,aAAA;ExCupJR;EwCppJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ExCopJR;EwCjpJQ;IACE,aAAA;ExCmpJV;EwChpJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCkpJV;AACF;AiB90JI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ExC2sJN;EwCzsJM;IACE,mBAAA;ExC2sJR;EwCzsJQ;IACE,kBAAA;ExC2sJV;EwCxsJQ;IACE,mDAAA;IACA,kDAAA;ExC0sJV;EwCtsJM;IACE,iBAAA;ExCwsJR;EwCrsJM;IACE,wBAAA;IACA,gBAAA;ExCusJR;EwCpsJM;IACE,aAAA;ExCssJR;EwCnsJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ExCmsJR;EwChsJQ;IACE,aAAA;ExCksJV;EwC/rJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCisJV;AACF;AiB73JI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ExC0vJN;EwCxvJM;IACE,mBAAA;ExC0vJR;EwCxvJQ;IACE,kBAAA;ExC0vJV;EwCvvJQ;IACE,mDAAA;IACA,kDAAA;ExCyvJV;EwCrvJM;IACE,iBAAA;ExCuvJR;EwCpvJM;IACE,wBAAA;IACA,gBAAA;ExCsvJR;EwCnvJM;IACE,aAAA;ExCqvJR;EwClvJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ExCkvJR;EwC/uJQ;IACE,aAAA;ExCivJV;EwC9uJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCgvJV;AACF;AiB56JI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ExCyyJN;EwCvyJM;IACE,mBAAA;ExCyyJR;EwCvyJQ;IACE,kBAAA;ExCyyJV;EwCtyJQ;IACE,mDAAA;IACA,kDAAA;ExCwyJV;EwCpyJM;IACE,iBAAA;ExCsyJR;EwCnyJM;IACE,wBAAA;IACA,gBAAA;ExCqyJR;EwClyJM;IACE,aAAA;ExCoyJR;EwCjyJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ExCiyJR;EwC9xJQ;IACE,aAAA;ExCgyJV;EwC7xJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExC+xJV;AACF;AwCt1JI;EAEI,iBAAA;EACA,2BAAA;AxCu1JR;AwCr1JQ;EACE,mBAAA;AxCu1JV;AwCr1JU;EACE,kBAAA;AxCu1JZ;AwCp1JU;EACE,mDAAA;EACA,kDAAA;AxCs1JZ;AwCl1JQ;EACE,iBAAA;AxCo1JV;AwCj1JQ;EACE,wBAAA;EACA,gBAAA;AxCm1JV;AwCh1JQ;EACE,aAAA;AxCk1JV;AwC/0JQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef7NJ,gBe+NI;AxC+0JV;AwC50JU;EACE,aAAA;AxC80JZ;AwC30JU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AxC60JZ;;AwC5zJA;EAEE,6CAAA;EACA,mDAAA;EACA,sDAAA;EACA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,2DAAA;EACA,sEAAA;AxC8zJF;;AyC9kKA;EAEE,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,gDAAA;EACA,gCAAA;EACA,8BAAA;EACA,uBAAA;EACA,sEAAA;EACA,8BAAA;EACA,8BAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,uEAAA;EhCjBE,4CAAA;ATgmKJ;AyC3kKE;EACE,eAAA;EACA,cAAA;AzC6kKJ;AyC1kKE;EACE,mBAAA;EACA,sBAAA;AzC4kKJ;AyC1kKI;EACE,mBAAA;EhCtBF,2DAAA;EACA,4DAAA;ATmmKJ;AyC1kKI;EACE,sBAAA;EhCbF,+DAAA;EACA,8DAAA;AT0lKJ;AyCvkKE;;EAEE,aAAA;AzCykKJ;;AyCrkKA;EAGE,cAAA;EACA,0DAAA;EACA,4BAAA;AzCskKF;;AyCnkKA;EACE,6CAAA;EACA,kCAAA;AzCskKF;;AyCnkKA;EACE,uDAAA;EACA,gBAAA;EACA,qCAAA;AzCskKF;;AyCnkKA;EACE,gBAAA;AzCskKF;;AQ5pKI;EAgCE,qCAAA;ARgoKN;AQxpKI;EA+BI,sCAAA;AR4nKR;;AyC5jKA;EACE,oEAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,8EAAA;AzC+jKF;AyC7jKE;EhC7FE,0FAAA;AT6pKJ;;AyC3jKA;EACE,oEAAA;EACA,gCAAA;EACA,wCAAA;EACA,2EAAA;AzC8jKF;AyC5jKE;EhCxGE,0FAAA;ATuqKJ;;AyCrjKA;EACE,wDAAA;EACA,uDAAA;EACA,uDAAA;EACA,gBAAA;AzCwjKF;AyCtjKE;EACE,oCAAA;EACA,uCAAA;AzCwjKJ;;AyCpjKA;EACE,wDAAA;EACA,uDAAA;AzCujKF;;AyCnjKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4CAAA;EhC1IE,kDAAA;ATisKJ;;AyCnjKA;;;EAGE,WAAA;AzCsjKF;;AyCnjKA;;EhC3II,2DAAA;EACA,4DAAA;ATmsKJ;;AyCpjKA;;EhClII,+DAAA;EACA,8DAAA;AT2rKJ;;AyC7iKE;EACE,2CAAA;AzCgjKJ;AiB3qKI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EzCgjKF;EyC7iKE;IAEE,SAAA;IACA,gBAAA;EzC8iKJ;EQjvKE;IAgCE,cAAA;ERotKJ;EQ5uKE;IA+BI,eAAA;ERgtKN;EQvvKE;IAgCE,cAAA;ER0tKJ;EQlvKE;IA+BI,eAAA;ERstKN;EQ7vKE;IAgCE,0BAAA;ERguKJ;EQxvKE;IA+BI,yBAAA;ER4tKN;EQnwKE;IAgCE,6BAAA;ERsuKJ;EQ9vKE;IA+BI,4BAAA;ERkuKN;EyC1jKQ;;IAGE,0BAAA;EzC2jKV;EyCzjKQ;;IAGE,6BAAA;EzC0jKV;EQjxKE;IAgCE,yBAAA;ERovKJ;EQ5wKE;IA+BI,0BAAA;ERgvKN;EQvxKE;IAgCE,4BAAA;ER0vKJ;EQlxKE;IA+BI,6BAAA;ERsvKN;EyC/jKQ;;IAGE,yBAAA;EzCgkKV;EyC9jKQ;;IAGE,4BAAA;EzC+jKV;AACF;;A0CpyKA;EAEE,4CAAA;EACA,sCAAA;EACA,yKAAA;EACA,qDAAA;EACA,qDAAA;EACA,uDAAA;EACA,+FAAA;EACA,sCAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,kEAAA;EACA,uCAAA;EACA,mDAAA;EACA,+DAAA;EACA,yEAAA;EACA,+CAAA;EACA,qEAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mDAAA;A1CsyKF;;A0ClyKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8EAAA;ErC2PI,mBALI;EqCpPR,qCAAA;EACA,gBAAA;EACA,6CAAA;EACA,SAAA;EjCtBE,gBAAA;EiCwBF,qBAAA;EjB3BI,2CiB4BJ;A1CqyKF;AyB7zKM;EiBWN;IjBVQ,gBAAA;EzBg0KN;AACF;A0CxyKE;EACE,wCAAA;EACA,gDAAA;EACA,oGAAA;A1C0yKJ;A0CxyKI;EACE,sDAAA;EACA,kDAAA;A1C0yKN;A0CryKE;EACE,cAAA;EACA,0CAAA;EACA,2CAAA;EACA,iBAAA;EACA,WAAA;EACA,+CAAA;EACA,4BAAA;EACA,oDAAA;EjBlDE,oDiBmDF;A1CuyKJ;AyBt1KM;EiBsCJ;IjBrCM,gBAAA;EzBy1KN;AACF;A0CzyKE;EACE,UAAA;A1C2yKJ;A0CxyKE;EACE,UAAA;EACA,yDAAA;EACA,UAAA;EACA,qDAAA;A1C0yKJ;;A0CtyKA;EACE,gBAAA;A1CyyKF;;A0CtyKA;EACE,iCAAA;EACA,yCAAA;EACA,iFAAA;A1CyyKF;A0CvyKE;EjC/DE,0DAAA;EACA,2DAAA;ATy2KJ;A0CxyKI;EjClEA,gEAAA;EACA,iEAAA;AT62KJ;A0CvyKE;EACE,aAAA;A1CyyKJ;A0CryKE;EjC9DE,8DAAA;EACA,6DAAA;ATs2KJ;A0CryKM;EjClEF,oEAAA;EACA,mEAAA;AT02KJ;A0CpyKI;EjCvEA,8DAAA;EACA,6DAAA;AT82KJ;;A0ClyKA;EACE,gFAAA;A1CqyKF;;A0C5xKE;EACE,eAAA;A1C+xKJ;A0C5xKE;EACE,eAAA;EACA,cAAA;EjCpHA,gBAAA;ATm5KJ;A0C5xKI;EAAgB,aAAA;A1C+xKpB;A0C9xKI;EAAe,gBAAA;A1CiyKnB;A0C9xKM;EjC3HF,gBAAA;AT45KJ;;A2C/6KA;EAEE,6BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qBAAA;EACA,gCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2CAAA;EAGA,aAAA;EACA,eAAA;EACA,wEAAA;EACA,kDAAA;EtC+QI,0CALI;EsCxQR,gBAAA;EACA,0CAAA;ElCAE,kDAAA;AT+6KJ;;AQh8KI;EAgCE,kDAAA;ARo6KN;AQ57KI;EA+BI,mDAAA;ARg6KR;AQv8KI;EAgCE,WAAA;AR06KN;AQl8KI;EA+BI,YAAA;ARs6KR;AQ78KI;EAgCE,mDAAA;ARg7KN;AQx8KI;EA+BI,kDAAA;AR46KR;A2Cz7KI;EAGE,0CAAA;A3Cy7KN;AQt9KI;EAgCE,2CAAA;ARy7KN;AQj9KI;EA4BI,mDAAA;ARw7KR;A2Cr7KE;EACE,8CAAA;A3Cu7KJ;;A4Cj+KA;EAEE,mCAAA;EACA,oCAAA;EvC4RI,oCALI;EuCrRR,+BAAA;EACA,uCAAA;EACA,sDAAA;EACA,sCAAA;EACA,mCAAA;EACA,yDAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,kDAAA;EACA,sEAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EACA,2DAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;A5Ci+KF;AQv/KI;EAgCE,eAAA;AR09KN;AQl/KI;EA+BI,gBAAA;ARs9KR;A4C//KA;EhCKE,gBAAA;AZ6/KF;;A4Ct+KA;EACE,kBAAA;EACA,cAAA;EACA,wEAAA;EvCgQI,0CALI;EuCzPR,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;EnBpBI,qImBqBJ;A5Cy+KF;AyB1/KM;EmBQN;InBPQ,gBAAA;EzB6/KN;AACF;A4C5+KE;EACE,UAAA;EACA,wCAAA;EAEA,gDAAA;EACA,sDAAA;A5C6+KJ;A4C1+KE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,UrC40CgC;EqC30ChC,kDAAA;A5C4+KJ;A4Cz+KE;EAEE,UAAA;EACA,yCAAA;ElBtDF,iDkBuDuB;EACrB,uDAAA;A5C0+KJ;A4Cv+KE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;EACA,yDAAA;A5Cw+KJ;;AQ1iLI;EAgCE,+CAAA;AR8gLN;AQtiLI;EA+BI,gDAAA;AR0gLR;AQjjLI;EAgCE,2DAAA;ARohLN;AQ5iLI;EA+BI,4DAAA;ARghLR;AQvjLI;EAgCE,8DAAA;AR0hLN;AQljLI;EA+BI,+DAAA;ARshLR;AQ7jLI;EAgCE,4DAAA;ARgiLN;AQxjLI;EA+BI,2DAAA;AR4hLR;AQnkLI;EAgCE,+DAAA;ARsiLN;AQ9jLI;EA+BI,8DAAA;ARkiLR;;A4Cr+KA;EClGE,kCAAA;EACA,mCAAA;ExC0RI,sCALI;EwCnRR,2DAAA;A7C2kLF;;A4Cx+KA;ECtGE,kCAAA;EACA,mCAAA;ExC0RI,mCALI;EwCnRR,2DAAA;A7CklLF;;A8CplLA;EAEE,6BAAA;EACA,4BAAA;EzCuRI,6BALI;EyChRR,4BAAA;EACA,4CAAA;EACA,gCAAA;EAGA,qBAAA;EACA,8DAAA;EzC+QI,qCALI;EyCxQR,yCAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gDAAA;A9ColLF;A8ChlLE;EACE,aAAA;A9CklLJ;;A8C7kLA;EACE,kBAAA;EACA,SAAA;A9CglLF;;A8CzkLA;EACE,4BAAA;EACA,4BAAA;EzCkPI,iBALI;ALg2KV;;A+CtnLA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,+EAAA;EACA,mDAAA;EACA,+BAAA;EAGA,kBAAA;EACA,8DAAA;EACA,6CAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;EtCHE,6CAAA;AT0nLJ;;A+ClnLA;EAEE,cAAA;A/ConLF;;A+ChnLA;EACE,gB9C0DiB;E8CzDjB,kCAAA;A/CmnLF;;AQppLI;EAgCE,mBAAA;ARwnLN;AQhpLI;EA+BI,kBAAA;ARonLR;A+C9mLE;EACE,kBAAA;EACA,MAAA;A/CgnLJ;AQ/pLI;EAgCE,QAAA;ARkoLN;AQ1pLI;EA+BI,OAAA;AR8nLR;A+CxnLE;EAIE,UAAA;EACA,qBAAA;A/CunLJ;;A+C/mLE;EACE,0BAAA;EACA,uBAAA;EACA,kDAAA;EACA,0CAAA;A/CknLJ;;A+CtnLE;EACE,wCAAA;EACA,wCAAA;EACA,kDAAA;EACA,gDAAA;A/CynLJ;;A+C7nLE;EACE,yCAAA;EACA,wCAAA;EACA,kDAAA;EACA,gDAAA;A/CgoLJ;;A+CpoLE;EACE,uCAAA;EACA,sCAAA;EACA,gDAAA;EACA,gDAAA;A/CuoLJ;;A+C3oLE;EACE,0CAAA;EACA,wCAAA;EACA,kDAAA;EACA,iDAAA;A/C8oLJ;;A+ClpLE;EACE,yCAAA;EACA,wCAAA;EACA,kDAAA;EACA,iDAAA;A/CqpLJ;;A+CzpLE;EACE,yCAAA;EACA,sCAAA;EACA,gDAAA;EACA,kDAAA;A/C4pLJ;;A+ChqLE;EACE,sCAAA;EACA,sCAAA;EACA,gDAAA;EACA,+CAAA;A/CmqLJ;;AgD/tLE;EACE;IAAK,2BzCoqD2B;EP+jIlC;AACF;AgD/tLA;;EAGE,2BAAA;E3CkRI,oCALI;E2C3QR,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yCAAA;EACA,8CAAA;EAGA,aAAA;EACA,kCAAA;EACA,gBAAA;E3CsQI,wCALI;E2C/PR,wCAAA;EvCRE,gDAAA;ATuuLJ;;AgD1tLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EvBxBI,8CuByBJ;AhD6tLF;AyBlvLM;EuBYN;IvBXQ,gBAAA;EzBqvLN;AACF;;AgD/tLA;EtBAE,qMAAA;EsBEA,sEAAA;AhDkuLF;;AgD/tLA;EACE,iBAAA;AhDkuLF;;AgD/tLA;EACE,WAAA;AhDkuLF;;AgD9tLE;EACE,kDAAA;AhDiuLJ;AgD9tLM;EAJJ;IAKM,eAAA;EhDiuLN;AACF;;AgD5tLA;EACE,WAAA;AhD+tLF;;AgD3tLA;EACE,0CAAA;AhD8tLF;AgD7tLE;EACE,sBtCjEI;AVgyLR;;AgD3tLA;EACE,aAAA;EACA,mBAAA;EACA,mBzCsXO;APw2KT;;AgD3tLA;EACE,eAAA;EACA,kBAAA;AhD8tLF;;AgD3tLA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBzColDqC;AP0oIvC;;AgD3tLA;EACE,YAAA;EACA,kBAAA;AhD8tLF;AgD5tLE;EACE,kBAAA;AhD8tLJ;;AgD1tLA;EACE,gBAAA;AhD6tLF;;AiDt0LA;EAEE,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,qCAAA;EACA,uCAAA;EACA,yDAAA;EACA,8DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EAGA,aAAA;EACA,sBAAA;AjDs0LF;AQ91LI;EAgCE,eAAA;ARi0LN;AQz1LI;EA+BI,gBAAA;AR6zLR;AiDl2LA;EA0BE,gBAAA;ExCXE,kDAAA;ATu1LJ;;AiDx0LA;EACE,qBAAA;EACA,sBAAA;AjD20LF;AiDz0LE;EAEE,oCAAA;EACA,0BAAA;AjD00LJ;;AiDj0LA;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;AjDo0LF;AiDj0LE;EAEE,UAAA;EACA,+CAAA;EACA,qBAAA;EACA,uDAAA;AjDk0LJ;AiD/zLE;EACE,gDAAA;EACA,wDAAA;AjDi0LJ;;AiDzzLA;EACE,kBAAA;EACA,cAAA;EACA,kFAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;AjD4zLF;AiD1zLE;ExCvDE,+BAAA;EACA,gCAAA;ATo3LJ;AiD1zLE;ExC7CE,mCAAA;EACA,kCAAA;AT02LJ;AiD1zLE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;AjD2zLJ;AiDvzLE;EACE,UAAA;EACA,yCAAA;EACA,iDAAA;EACA,uDAAA;AjDyzLJ;AiDrzLE;EACE,mBAAA;AjDuzLJ;AiDrzLI;EACE,yDAAA;EACA,oDAAA;AjDuzLN;;AiD1yLI;EACE,mBAAA;AjD6yLN;AQz6LI;EAgCE,8DAAA;AR44LN;AQp6LI;EA+BI,+DAAA;ARw4LR;AQ/6LI;EAgCE,0BAAA;ARk5LN;AQ16LI;EA+BI,yBAAA;AR84LR;AQr7LI;EAgCE,4DAAA;ARw5LN;AQh7LI;EA+BI,2DAAA;ARo5LR;AQ37LI;EAgCE,4BAAA;AR85LN;AQt7LI;EA+BI,6BAAA;AR05LR;AiDxzLQ;EACE,aAAA;AjD0zLV;AiDvzLQ;EACE,oDAAA;AjDyzLV;AQv8LI;EAgCE,oBAAA;AR06LN;AQl8LI;EA+BI,qBAAA;ARs6LR;AQ78LI;EAgCE,0DAAA;ARg7LN;AQx8LI;EA+BI,2DAAA;AR46LR;AQn9LI;EAgCE,qDAAA;ARs7LN;AQ98LI;EA+BI,sDAAA;ARk7LR;;AiB55LI;EgC8DA;IACE,mBAAA;EjDk2LJ;EQ99LE;IAgCE,8DAAA;ERi8LJ;EQz9LE;IA+BI,+DAAA;ER67LN;EQp+LE;IAgCE,0BAAA;ERu8LJ;EQ/9LE;IA+BI,yBAAA;ERm8LN;EQ1+LE;IAgCE,4DAAA;ER68LJ;EQr+LE;IA+BI,2DAAA;ERy8LN;EQh/LE;IAgCE,4BAAA;ERm9LJ;EQ3+LE;IA+BI,6BAAA;ER+8LN;EiD72LM;IACE,aAAA;EjD+2LR;EiD52LM;IACE,oDAAA;EjD82LR;EQ5/LE;IAgCE,oBAAA;ER+9LJ;EQv/LE;IA+BI,qBAAA;ER29LN;EQlgME;IAgCE,0DAAA;ERq+LJ;EQ7/LE;IA+BI,2DAAA;ERi+LN;EQxgME;IAgCE,qDAAA;ER2+LJ;EQngME;IA+BI,sDAAA;ERu+LN;AACF;AiBl9LI;EgC8DA;IACE,mBAAA;EjDu5LJ;EQnhME;IAgCE,8DAAA;ERs/LJ;EQ9gME;IA+BI,+DAAA;ERk/LN;EQzhME;IAgCE,0BAAA;ER4/LJ;EQphME;IA+BI,yBAAA;ERw/LN;EQ/hME;IAgCE,4DAAA;ERkgMJ;EQ1hME;IA+BI,2DAAA;ER8/LN;EQriME;IAgCE,4BAAA;ERwgMJ;EQhiME;IA+BI,6BAAA;ERogMN;EiDl6LM;IACE,aAAA;EjDo6LR;EiDj6LM;IACE,oDAAA;EjDm6LR;EQjjME;IAgCE,oBAAA;ERohMJ;EQ5iME;IA+BI,qBAAA;ERghMN;EQvjME;IAgCE,0DAAA;ER0hMJ;EQljME;IA+BI,2DAAA;ERshMN;EQ7jME;IAgCE,qDAAA;ERgiMJ;EQxjME;IA+BI,sDAAA;ER4hMN;AACF;AiBvgMI;EgC8DA;IACE,mBAAA;EjD48LJ;EQxkME;IAgCE,8DAAA;ER2iMJ;EQnkME;IA+BI,+DAAA;ERuiMN;EQ9kME;IAgCE,0BAAA;ERijMJ;EQzkME;IA+BI,yBAAA;ER6iMN;EQplME;IAgCE,4DAAA;ERujMJ;EQ/kME;IA+BI,2DAAA;ERmjMN;EQ1lME;IAgCE,4BAAA;ER6jMJ;EQrlME;IA+BI,6BAAA;ERyjMN;EiDv9LM;IACE,aAAA;EjDy9LR;EiDt9LM;IACE,oDAAA;EjDw9LR;EQtmME;IAgCE,oBAAA;ERykMJ;EQjmME;IA+BI,qBAAA;ERqkMN;EQ5mME;IAgCE,0DAAA;ER+kMJ;EQvmME;IA+BI,2DAAA;ER2kMN;EQlnME;IAgCE,qDAAA;ERqlMJ;EQ7mME;IA+BI,sDAAA;ERilMN;AACF;AiB5jMI;EgC8DA;IACE,mBAAA;EjDigMJ;EQ7nME;IAgCE,8DAAA;ERgmMJ;EQxnME;IA+BI,+DAAA;ER4lMN;EQnoME;IAgCE,0BAAA;ERsmMJ;EQ9nME;IA+BI,yBAAA;ERkmMN;EQzoME;IAgCE,4DAAA;ER4mMJ;EQpoME;IA+BI,2DAAA;ERwmMN;EQ/oME;IAgCE,4BAAA;ERknMJ;EQ1oME;IA+BI,6BAAA;ER8mMN;EiD5gMM;IACE,aAAA;EjD8gMR;EiD3gMM;IACE,oDAAA;EjD6gMR;EQ3pME;IAgCE,oBAAA;ER8nMJ;EQtpME;IA+BI,qBAAA;ER0nMN;EQjqME;IAgCE,0DAAA;ERooMJ;EQ5pME;IA+BI,2DAAA;ERgoMN;EQvqME;IAgCE,qDAAA;ER0oMJ;EQlqME;IA+BI,sDAAA;ERsoMN;AACF;AiBjnMI;EgC8DA;IACE,mBAAA;EjDsjMJ;EQlrME;IAgCE,8DAAA;ERqpMJ;EQ7qME;IA+BI,+DAAA;ERipMN;EQxrME;IAgCE,0BAAA;ER2pMJ;EQnrME;IA+BI,yBAAA;ERupMN;EQ9rME;IAgCE,4DAAA;ERiqMJ;EQzrME;IA+BI,2DAAA;ER6pMN;EQpsME;IAgCE,4BAAA;ERuqMJ;EQ/rME;IA+BI,6BAAA;ERmqMN;EiDjkMM;IACE,aAAA;EjDmkMR;EiDhkMM;IACE,oDAAA;EjDkkMR;EQhtME;IAgCE,oBAAA;ERmrMJ;EQ3sME;IA+BI,qBAAA;ER+qMN;EQttME;IAgCE,0DAAA;ERyrMJ;EQjtME;IA+BI,2DAAA;ERqrMN;EQ5tME;IAgCE,qDAAA;ER+rMJ;EQvtME;IA+BI,sDAAA;ER2rMN;AACF;AiDlkMA;ExChJI,gBAAA;ATqtMJ;AiDlkME;EACE,oDAAA;AjDokMJ;AiDlkMI;EACE,sBAAA;AjDokMN;;AiDvjME;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlDyuMF;;AiDjkME;EC9KA,oHAAA;EACA,6CAAA;EACA,mDAAA;EACA,iIAAA;EACA,0CAAA;EACA,+HAAA;EACA,yIAAA;AlDmvMF;;AiD3kME;EC9KA,mHAAA;EACA,6CAAA;EACA,iDAAA;EACA,gIAAA;EACA,0CAAA;EACA,8HAAA;EACA,wIAAA;AlD6vMF;;AiDrlME;EC9KA,kHAAA;EACA,6CAAA;EACA,iDAAA;EACA,+HAAA;EACA,0CAAA;EACA,6HAAA;EACA,uIAAA;AlDuwMF;;AiD/lME;EC9KA,oHAAA;EACA,6CAAA;EACA,kDAAA;EACA,iIAAA;EACA,0CAAA;EACA,+HAAA;EACA,yIAAA;AlDixMF;;AiDzmME;EC9KA,4GAAA;EACA,2CAAA;EACA,kDAAA;EACA,yHAAA;EACA,0CAAA;EACA,uHAAA;EACA,iIAAA;AlD2xMF;;AiDnnME;EC9KA,+GAAA;EACA,2CAAA;EACA,mDAAA;EACA,4HAAA;EACA,0CAAA;EACA,0HAAA;EACA,oIAAA;AlDqyMF;;AiD7nME;EC9KA,2GAAA;EACA,2CAAA;EACA,iDAAA;EACA,wHAAA;EACA,0CAAA;EACA,sHAAA;EACA,gIAAA;AlD+yMF;;AmDzzMA;EAEE,iDAAA;EACA,4DAAA;EACA,4BAAA;EACA,mCAAA;EACA,iEAAA;EACA,gCAAA;EACA,sCAAA;EACA,wEAAA;EAGA,uBAAA;EACA,U5C+8D2B;E4C98D3B,W5C88D2B;E4C78D3B,sBAAA;EACA,iCAAA;EACA,yEAAA;EACA,SAAA;E1CJE,kBAAA;E0CMF,qCAAA;AnDyzMF;AmDtzME;EACE,iCAAA;EACA,qBAAA;EACA,2CAAA;AnDwzMJ;AmDrzME;EACE,UAAA;EACA,6CAAA;EACA,2CAAA;AnDuzMJ;AmDpzME;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AnDqzMJ;;AmDjzMA;EACE,yCAAA;AnDozMF;;AoDr2MA;EAEE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;E/CyRI,+BALI;E+ClRR,mBAAA;EACA,kDAAA;EACA,iDAAA;EACA,6DAAA;EACA,mDAAA;EACA,6CAAA;EACA,oDAAA;EACA,yDAAA;EACA,oEAAA;EAGA,iCAAA;EACA,eAAA;E/C2QI,qCALI;E+CpQR,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;EACA,uCAAA;E3CRE,6CAAA;AT82MJ;AoDn2ME;EACE,UAAA;ApDq2MJ;AoDl2ME;EACE,aAAA;ApDo2MJ;;AoDh2MA;EACE,wBAAA;EAEA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;ApDk2MF;AoDh2ME;EACE,uCAAA;ApDk2MJ;;AoD91MA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,oCAAA;EACA,4CAAA;EACA,4BAAA;EACA,uFAAA;E3ChCE,4FAAA;EACA,6FAAA;ATk4MJ;AQ75MI;EAgCE,qDAAA;ARg4MN;AQx5MI;EA+BI,oDAAA;AR43MR;AQn6MI;EAgCE,uCAAA;ARs4MN;AQ95MI;EA+BI,wCAAA;ARk4MR;;AoDt2MA;EACE,mCAAA;EACA,qBAAA;ApDy2MF;;AqDv6MA;EAEE,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kCAAA;EACA,6DAAA;EACA,iDAAA;EACA,+BAAA;EACA,qDAAA;EACA,uEAAA;EACA,kCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wCAAA;EACA,wDAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,wCAAA;EACA,wDAAA;EAGA,eAAA;EACA,MAAA;ArDu6MF;AQx8MI;EAgCE,OAAA;AR26MN;AQn8MI;EA+BI,QAAA;ARu6MR;AqDv8MA;EA4BE,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ArD46MF;;AqDr6MA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EAEA,oBAAA;ArDu6MF;AqDp6ME;E5B5CI,mC4B6CF;ArDs6MJ;AyB/8MM;E4BwCJ;I5BvCM,gBAAA;EzBk9MN;AACF;AqD56ME;EAEE,8B9CmiDgC;AP04JpC;AqD36ME;EACE,e9CiiDgC;AP44JpC;AqDz6ME;EACE,sB9C8hDgC;AP64JpC;;AqDv6MA;EACE,gDAAA;ArD06MF;AqDx6ME;EACE,gBAAA;EACA,gBAAA;ArD06MJ;AqDv6ME;EACE,gBAAA;ArDy6MJ;;AqDr6MA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;ArDw6MF;;AqDp6MA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;E5CrFE,6CAAA;E4CyFF,UAAA;ArDo6MF;;AqDh6MA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,wCD+G4D;ArDs6M9D;AsDlhNE;EAAS,UAAA;AtDqhNX;AsDphNE;EAAS,oCD2GiF;ArD46M5F;;AqDv6MA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,8FAAA;E5CtGE,4DAAA;EACA,6DAAA;ATihNJ;AqDz6ME;EACE,oGAAA;ArD26MJ;AQ/iNI;EA+DE,yJAAA;ARm/MN;AQ1iNI;EA2DI,yJAAA;ARk/MR;;AqD36MA;EACE,gBAAA;EACA,+CAAA;ArD86MF;;AqDz6MA;EACE,kBAAA;EAGA,cAAA;EACA,iCAAA;ArD06MF;;AqDt6MA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2EAAA;EACA,4CAAA;EACA,2FAAA;E5C1HE,gEAAA;EACA,+DAAA;AToiNJ;AqDr6ME;EACE,+CAAA;ArDu6MJ;;AiBnhNI;EoCkHF;IACE,2BAAA;IACA,wDAAA;ErDq6MF;EqDj6MA;IACE,iCAAA;IACA,kBAAA;IACA,iBAAA;ErDm6MF;EqDh6MA;IACE,wBAAA;ErDk6MF;AACF;AiBliNI;EoCoIF;;IAEE,wBAAA;ErDi6MF;AACF;AiBxiNI;EoC2IF;IACE,yBAAA;ErDg6MF;AACF;AqDv5MI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ArDy5MN;AqDv5MM;EACE,YAAA;EACA,SAAA;E5C1MJ,gBAAA;ATomNJ;AqDt5MM;;E5C9MF,gBAAA;ATwmNJ;AqDr5MM;EACE,gBAAA;ArDu5MR;;AiBljNI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD66MJ;EqD36MI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ETwnNF;EqD16MI;;I5C9MF,gBAAA;ET4nNF;EqDz6MI;IACE,gBAAA;ErD26MN;AACF;AiBvkNI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDi8MJ;EqD/7MI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ET4oNF;EqD97MI;;I5C9MF,gBAAA;ETgpNF;EqD77MI;IACE,gBAAA;ErD+7MN;AACF;AiB3lNI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDq9MJ;EqDn9MI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ETgqNF;EqDl9MI;;I5C9MF,gBAAA;EToqNF;EqDj9MI;IACE,gBAAA;ErDm9MN;AACF;AiB/mNI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDy+MJ;EqDv+MI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ETorNF;EqDt+MI;;I5C9MF,gBAAA;ETwrNF;EqDr+MI;IACE,gBAAA;ErDu+MN;AACF;AiBnoNI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD6/MJ;EqD3/MI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ETwsNF;EqD1/MI;;I5C9MF,gBAAA;ET4sNF;EqDz/MI;IACE,gBAAA;ErD2/MN;AACF;AuDluNA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;ElDwRI,gCALI;EkDjRR,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,0BAAA;EACA,iCAAA;EACA,kCAAA;EAGA,kCAAA;EACA,cAAA;EACA,iCAAA;EClBA,mKvDgFiB;EuD9EjB,kBAAA;EACA,gBjD0pB4B;EiDzpB5B,gBvDyFiB;EuDxFjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnDgRI,uCALI;EkDhQR,qBAAA;EACA,UAAA;AvD0uNF;AuDxuNE;EAAS,mCAAA;AvD2uNX;AuDzuNE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AvD2uNJ;AuDzuNI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvD2uNN;;AuDtuNA;EACE,kDAAA;AvDyuNF;AuDvuNE;EACE,SAAA;EACA,0FAAA;EACA,uCAAA;AvDyuNJ;;AuDruNA,qBAAA;AACA;EACE,gDAAA;EACA,sCAAA;EACA,sCAAA;AvDwuNF;AuDtuNE;EACE,WAAA;EACA,qIAAA;EACA,yCAAA;AvDwuNJ;;AuDpuNA,mBAAA;AAEA;EACE,+CAAA;AvDsuNF;AuDpuNE;EACE,YAAA;EACA,0FAAA;EACA,0CAAA;AvDsuNJ;;AuDluNA,qBAAA;AACA;EACE,iDAAA;EACA,sCAAA;EACA,sCAAA;AvDquNF;AuDnuNE;EACE,UAAA;EACA,qIAAA;EACA,wCAAA;AvDquNJ;;AuDjuNA,mBAAA;AAkBA;EACE,uCAAA;EACA,kEAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;E9CjGE,+CAAA;ATqzNJ;;AyDx0NA;EAEE,0BAAA;EACA,8BAAA;EpD4RI,gCALI;EoDrRR,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,iCAAA;EACA,uEAAA;EACA,0DAAA;EACA,oCAAA;EACA,sCAAA;EpDmRI,wCALI;EoD5QR,mCAAA;EACA,gDAAA;EACA,kCAAA;EACA,kCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,2DAAA;EAGA,kCAAA;EACA,cAAA;EACA,uCAAA;EDzBA,mKvDgFiB;EuD9EjB,kBAAA;EACA,gBjD0pB4B;EiDzpB5B,gBvDyFiB;EuDxFjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnDgRI,uCALI;EoD1PR,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EhDhBE,+CAAA;ATm2NJ;AyD/0NE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AzDi1NJ;AyD/0NI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AzDg1NN;;AyD10NE;EACE,sFAAA;AzD60NJ;AyD30NI;EAEE,0FAAA;AzD40NN;AyDz0NI;EACE,SAAA;EACA,iDAAA;AzD20NN;AyDx0NI;EACE,uCAAA;EACA,uCAAA;AzD00NN;;AyDr0NA,qBAAA;AAEE;EACE,oFAAA;EACA,sCAAA;EACA,sCAAA;AzDu0NJ;AyDr0NI;EAEE,qIAAA;AzDs0NN;AyDn0NI;EACE,OAAA;EACA,mDAAA;AzDq0NN;AyDl0NI;EACE,qCAAA;EACA,yCAAA;AzDo0NN;;AyD/zNA,mBAAA;AAGE;EACE,mFAAA;AzDg0NJ;AyD9zNI;EAEE,0FAAA;AzD+zNN;AyD5zNI;EACE,MAAA;EACA,oDAAA;AzD8zNN;AyD3zNI;EACE,oCAAA;EACA,0CAAA;AzD6zNN;AyDxzNE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,iFAAA;AzD0zNJ;;AyDtzNA,qBAAA;AAEE;EACE,qFAAA;EACA,sCAAA;EACA,sCAAA;AzDwzNJ;AyDtzNI;EAEE,qIAAA;AzDuzNN;AyDpzNI;EACE,QAAA;EACA,kDAAA;AzDszNN;AyDnzNI;EACE,sCAAA;EACA,wCAAA;AzDqzNN;;AyDhzNA,mBAAA;AAkBA;EACE,gFAAA;EACA,gBAAA;EpD2GI,8CALI;EoDpGR,sCAAA;EACA,8CAAA;EACA,oFAAA;EhD5JE,8DAAA;EACA,+DAAA;AT+7NJ;AyDjyNE;EACE,aAAA;AzDmyNJ;;AyD/xNA;EACE,4EAAA;EACA,oCAAA;AzDkyNF;;A0Dv9NA;EACE,kBAAA;A1D09NF;;A0Dv9NA;EACE,mBAAA;A1D09NF;;A0Dv9NA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A1D09NF;A2Dh/NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3Dk/NJ;;A0D39NA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;A1D89NF;AyB7+NM;EiCQN;IjCPQ,gBAAA;EzBg/NN;AACF;;A0Dh+NA;;;EAGE,cAAA;A1Dm+NF;;A0Dh+NA;;EAEE,2BAAA;A1Dm+NF;;A0Dh+NA;;EAEE,4BAAA;A1Dm+NF;;A0D19NE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A1D69NJ;A0D19NE;;;EAGE,UAAA;EACA,UAAA;A1D49NJ;A0Dz9NE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;A1D29NJ;AyBphOM;EiCqDJ;;IjCpDM,gBAAA;EzBwhON;AACF;;A0Dx9NA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UnDsuDmC;EmDruDnC,UAAA;EACA,mEAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YnDiuDmC;EkBvzD/B,8BiCuFJ;A1D09NF;AyB7iOM;EiCkEN;;IjCjEQ,gBAAA;EzBijON;AACF;A0D79NE;;;EAEE,mEAAA;EACA,qBAAA;EACA,UAAA;EACA,YnDytDiC;APuwKrC;;A0D79NA;EACE,OAAA;A1Dg+NF;;A0D79NA;EACE,QAAA;A1Dg+NF;;A0D39NA;;EAEE,qBAAA;EACA,WnD0tDmC;EmDztDnC,YnDytDmC;EmDxtDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;A1D89NF;;A0D39NA;;;;;;;GAAA;AAQA;EACE,0DAAA;A1D89NF;;A0D59NA;EACE,0DAAA;A1D+9NF;;A0Dv9NA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBnDkqDmC;EmDjqDnC,mBAAA;EACA,gBnDgqDmC;EmD/pDnC,gBAAA;A1Dy9NF;A0Dv9NE;EACE,uBAAA;EACA,cAAA;EACA,WnD+pDiC;EmD9pDjC,WnD+pDiC;EmD9pDjC,UAAA;EACA,iBnD+pDiC;EmD9pDjC,gBnD8pDiC;EmD7pDjC,mBAAA;EACA,eAAA;EACA,+DAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YnDspDiC;EkB/zD/B,6BiC0KF;A1Dw9NJ;AyB9nOM;EiCqJJ;IjCpJM,gBAAA;EzBioON;AACF;A0D19NE;EACE,UnDmpDiC;APy0KrC;;A0Dn9NA;EACE,kBAAA;EACA,UAAA;EACA,enD6oDmC;EmD5oDnC,SAAA;EACA,oBnD0oDmC;EmDzoDnC,uBnDyoDmC;EmDxoDnC,mEAAA;EACA,kBAAA;A1Ds9NF;;A0Dj9NA;EACE,2CAAA;EACA,wDAAA;A1Do9NF;A0Dn9NE;;EAEE,gCnD4oDiC;APy0KrC;A0Dl9NE;EACE,yBhDhNI;AVoqOR;A0Dj9NE;EACE,iCnD3LuB;AP8oO3B;;A4DhrOA;;EAEE,qBAAA;EACA,+BAAA;EACA,iCAAA;EACA,iDAAA;EAEA,kBAAA;EACA,+FAAA;A5DkrOF;;A4D9qOA;EACE;IAAK,0CAAA;E5DkrOL;AACF;A4D/qOA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4CAAA;EAGA,0DAAA;EACA,+BAAA;A5D8qOF;;A4D3qOA;EAEE,yBAAA;EACA,0BAAA;EACA,iCAAA;A5D6qOF;;A4DpqOA;EACE;IACE,mBAAA;E5DuqOF;E4DrqOA;IACE,UAAA;IACA,eAAA;E5DuqOF;AACF;A4DnqOA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EAGA,8BAAA;EACA,UAAA;A5DkqOF;;A4D/pOA;EACE,yBAAA;EACA,0BAAA;A5DkqOF;;A4D9pOE;EACE;;IAEE,mCAAA;E5DiqOJ;AACF;A6DjvOA;EAEE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sCAAA;EACA,qDAAA;EACA,iEAAA;EACA,yDAAA;EACA,sDAAA;EACA,sCAAA;A7DkvOF;;AiBrrOI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,2CoC8BA;E7DmuOJ;AACF;AyB9vOM;EoCYJ;IpCXM,gBAAA;EzBiwON;AACF;AiB3sOI;E4C5BE;IACE,MAAA;E7D0uON;EQzxOE;IAgCE,OAAA;ER4vOJ;EQpxOE;IA+BI,QAAA;ERwvON;E6DjvOI;IAGE,iCAAA;E7DivON;EQlyOE;IAgCE,uFAAA;ERqwOJ;EQ7xOE;IA+BI,sFAAA;ERiwON;EQxyOE;IA+DE,4BAAA;ER4uOJ;EQnyOE;IA2DI,2BAAA;ER2uON;E6DxvOI;IACE,MAAA;E7D0vON;EQjzOE;IAgCE,QAAA;ERoxOJ;EQ5yOE;IA+BI,OAAA;ERgxON;E6DjwOI;IAGE,iCAAA;E7DiwON;EQ1zOE;IAgCE,sFAAA;ER6xOJ;EQrzOE;IA+BI,uFAAA;ERyxON;E6D1wOI;IAKE,2BAAA;E7DwwON;E6DrwOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7DuwON;E6DpwOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7DswON;E6DnwOI;IAEE,0BAAA;E7DowON;E6DjwOI;IAGE,mBAAA;E7DiwON;AACF;AiB9xOI;E4C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7DgwON;E6D9vOM;IACE,aAAA;E7DgwOR;E6D7vOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D8vOR;AACF;;AiBlyOI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,2CoC8BA;E7Dg1OJ;AACF;AyB32OM;EoCYJ;IpCXM,gBAAA;EzB82ON;AACF;AiBxzOI;E4C5BE;IACE,MAAA;E7Du1ON;EQt4OE;IAgCE,OAAA;ERy2OJ;EQj4OE;IA+BI,QAAA;ERq2ON;E6D91OI;IAGE,iCAAA;E7D81ON;EQ/4OE;IAgCE,uFAAA;ERk3OJ;EQ14OE;IA+BI,sFAAA;ER82ON;EQr5OE;IA+DE,4BAAA;ERy1OJ;EQh5OE;IA2DI,2BAAA;ERw1ON;E6Dr2OI;IACE,MAAA;E7Du2ON;EQ95OE;IAgCE,QAAA;ERi4OJ;EQz5OE;IA+BI,OAAA;ER63ON;E6D92OI;IAGE,iCAAA;E7D82ON;EQv6OE;IAgCE,sFAAA;ER04OJ;EQl6OE;IA+BI,uFAAA;ERs4ON;E6Dv3OI;IAKE,2BAAA;E7Dq3ON;E6Dl3OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7Do3ON;E6Dj3OI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7Dm3ON;E6Dh3OI;IAEE,0BAAA;E7Di3ON;E6D92OI;IAGE,mBAAA;E7D82ON;AACF;AiB34OI;E4C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7D62ON;E6D32OM;IACE,aAAA;E7D62OR;E6D12OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D22OR;AACF;;AiB/4OI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,2CoC8BA;E7D67OJ;AACF;AyBx9OM;EoCYJ;IpCXM,gBAAA;EzB29ON;AACF;AiBr6OI;E4C5BE;IACE,MAAA;E7Do8ON;EQn/OE;IAgCE,OAAA;ERs9OJ;EQ9+OE;IA+BI,QAAA;ERk9ON;E6D38OI;IAGE,iCAAA;E7D28ON;EQ5/OE;IAgCE,uFAAA;ER+9OJ;EQv/OE;IA+BI,sFAAA;ER29ON;EQlgPE;IA+DE,4BAAA;ERs8OJ;EQ7/OE;IA2DI,2BAAA;ERq8ON;E6Dl9OI;IACE,MAAA;E7Do9ON;EQ3gPE;IAgCE,QAAA;ER8+OJ;EQtgPE;IA+BI,OAAA;ER0+ON;E6D39OI;IAGE,iCAAA;E7D29ON;EQphPE;IAgCE,sFAAA;ERu/OJ;EQ/gPE;IA+BI,uFAAA;ERm/ON;E6Dp+OI;IAKE,2BAAA;E7Dk+ON;E6D/9OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7Di+ON;E6D99OI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7Dg+ON;E6D79OI;IAEE,0BAAA;E7D89ON;E6D39OI;IAGE,mBAAA;E7D29ON;AACF;AiBx/OI;E4C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7D09ON;E6Dx9OM;IACE,aAAA;E7D09OR;E6Dv9OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7Dw9OR;AACF;;AiB5/OI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,2CoC8BA;E7D0iPJ;AACF;AyBrkPM;EoCYJ;IpCXM,gBAAA;EzBwkPN;AACF;AiBlhPI;E4C5BE;IACE,MAAA;E7DijPN;EQhmPE;IAgCE,OAAA;ERmkPJ;EQ3lPE;IA+BI,QAAA;ER+jPN;E6DxjPI;IAGE,iCAAA;E7DwjPN;EQzmPE;IAgCE,uFAAA;ER4kPJ;EQpmPE;IA+BI,sFAAA;ERwkPN;EQ/mPE;IA+DE,4BAAA;ERmjPJ;EQ1mPE;IA2DI,2BAAA;ERkjPN;E6D/jPI;IACE,MAAA;E7DikPN;EQxnPE;IAgCE,QAAA;ER2lPJ;EQnnPE;IA+BI,OAAA;ERulPN;E6DxkPI;IAGE,iCAAA;E7DwkPN;EQjoPE;IAgCE,sFAAA;ERomPJ;EQ5nPE;IA+BI,uFAAA;ERgmPN;E6DjlPI;IAKE,2BAAA;E7D+kPN;E6D5kPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7D8kPN;E6D3kPI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7D6kPN;E6D1kPI;IAEE,0BAAA;E7D2kPN;E6DxkPI;IAGE,mBAAA;E7DwkPN;AACF;AiBrmPI;E4C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7DukPN;E6DrkPM;IACE,aAAA;E7DukPR;E6DpkPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DqkPR;AACF;;AiBzmPI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,2CoC8BA;E7DupPJ;AACF;AyBlrPM;EoCYJ;IpCXM,gBAAA;EzBqrPN;AACF;AiB/nPI;E4C5BE;IACE,MAAA;E7D8pPN;EQ7sPE;IAgCE,OAAA;ERgrPJ;EQxsPE;IA+BI,QAAA;ER4qPN;E6DrqPI;IAGE,iCAAA;E7DqqPN;EQttPE;IAgCE,uFAAA;ERyrPJ;EQjtPE;IA+BI,sFAAA;ERqrPN;EQ5tPE;IA+DE,4BAAA;ERgqPJ;EQvtPE;IA2DI,2BAAA;ER+pPN;E6D5qPI;IACE,MAAA;E7D8qPN;EQruPE;IAgCE,QAAA;ERwsPJ;EQhuPE;IA+BI,OAAA;ERosPN;E6DrrPI;IAGE,iCAAA;E7DqrPN;EQ9uPE;IAgCE,sFAAA;ERitPJ;EQzuPE;IA+BI,uFAAA;ER6sPN;E6D9rPI;IAKE,2BAAA;E7D4rPN;E6DzrPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7D2rPN;E6DxrPI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7D0rPN;E6DvrPI;IAEE,0BAAA;E7DwrPN;E6DrrPI;IAGE,mBAAA;E7DqrPN;AACF;AiBltPI;E4C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7DorPN;E6DlrPM;IACE,aAAA;E7DorPR;E6DjrPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DkrPR;AACF;;A6DlwPE;EAEI,eAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yCAAA;EACA,4BAAA;EACA,UAAA;EpC5BA,2CoC8BA;A7DmwPN;AyB7xPM;EoCYJ;IpCXM,gBAAA;EzBgyPN;AACF;A6DtwPM;EACE,MAAA;A7DwwPR;AQvzPI;EAgCE,OAAA;AR0xPN;AQlzPI;EA+BI,QAAA;ARsxPR;A6D/wPM;EAGE,iCAAA;A7D+wPR;AQh0PI;EAgCE,uFAAA;ARmyPN;AQ3zPI;EA+BI,sFAAA;AR+xPR;AQt0PI;EA+DE,4BAAA;AR0wPN;AQj0PI;EA2DI,2BAAA;ARywPR;A6DtxPM;EACE,MAAA;A7DwxPR;AQ/0PI;EAgCE,QAAA;ARkzPN;AQ10PI;EA+BI,OAAA;AR8yPR;A6D/xPM;EAGE,iCAAA;A7D+xPR;AQx1PI;EAgCE,sFAAA;AR2zPN;AQn1PI;EA+BI,uFAAA;ARuzPR;A6DxyPM;EAKE,2BAAA;A7DsyPR;A6DnyPM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,wFAAA;EACA,4BAAA;A7DqyPR;A6DlyPM;EACE,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,qFAAA;EACA,2BAAA;A7DoyPR;A6DjyPM;EAEE,0BAAA;A7DkyPR;A6D/xPM;EAGE,mBAAA;A7D+xPR;;A6DpwPA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a/CgtCkC;E+C/sClC,YAAA;EACA,aAAA;EACA,2DO+GsD;A7D6wPxD;AsDz3PE;EAAS,UAAA;AtD43PX;AsD33PE;EAAS,Y/CokDyB;AP0zMpC;;A6DhxPA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sEAAA;A7DmxPF;A6DjxPE;EACE,8FAAA;EACA,uDAAA;A7DmxPJ;AQn5PI;EAgCE,yDAAA;ARs3PN;AQ94PI;EA+BI,wDAAA;ARk3PR;A6D3xPE;EAIE,0DAAA;A7D0xPJ;;A6DtxPA;EACE,gBAAA;EACA,mDAAA;A7DyxPF;;A6DtxPA;EACE,YAAA;EACA,sEAAA;EACA,gBAAA;A7DyxPF;;A8Dz6PA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YvDi5CkC;AP2hNpC;A8D16PE;EACE,qBAAA;EACA,WAAA;A9D46PJ;;A8Dv6PA;EACE,iBAAA;A9D06PF;;A8Dv6PA;EACE,iBAAA;A9D06PF;;A8Dv6PA;EACE,iBAAA;A9D06PF;;A8Dr6PE;EACE,mDAAA;A9Dw6PJ;;A8Dp6PA;EACE;IACE,YvDo3CgC;EPmjNlC;AACF;A8Dp6PA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A9Ds6PF;;A8Dn6PA;EACE;IACE,uBAAA;E9Ds6PF;AACF;A+Dv9PA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EtDcE,mBAAA;EgBHE,wBsCTJ;A/Dy9PF;AyB58PM;EsCpBN;ItCqBQ,gBAAA;EzB+8PN;AACF;A+Dr+PA;ECCE,WzDymDc;EyDxmDd,YzDwmDc;EyDvmDd,iBAAA;AhEu+PF;AgEr+PE;EACE,sBAAA;EACA,uBAAA;AhEu+PJ;;A+Dn+PA;EACE,WAAA;EACA,YAAA;EtDME,mBAAA;ATi+PJ;;A+Dn+PA;EACE,kBAAA;A/Ds+PF;AQt/PI;EAgCE,QAAA;ARy9PN;AQj/PI;EA+BI,OAAA;ARq9PR;A+D7+PA;EAGE,SAAA;EACA,cAAA;EACA,sBAAA;EtDHE,mBAAA;ATi/PJ;;A+Dz+PE;EC1BA,azD2mDc;EyD1mDd,czD0mDc;EyDzmDd,iBAAA;AhEugQF;AgErgQE;EACE,aAAA;EACA,cAAA;AhEugQJ;;A+Dn/PE;EC1BA,azD2mDc;EyD1mDd,czD0mDc;EyDzmDd,eAAA;AhEihQF;AgE/gQE;EACE,sBAAA;EACA,uBAAA;AhEihQJ;;A+D7/PE;EC1BA,WzD2mDc;EyD1mDd,YzD0mDc;EyDzmDd,iBAAA;AhE2hQF;AgEzhQE;EACE,aAAA;EACA,cAAA;AhE2hQJ;;A+DvgQE;EC1BA,WzD2mDc;EyD1mDd,YzD0mDc;EyDzmDd,iBAAA;AhEqiQF;AgEniQE;EACE,sBAAA;EACA,uBAAA;AhEqiQJ;;A+D5gQA;EACE,aAAA;A/D+gQF;AQ9iQI;EAgCE,qBAAA;ARihQN;AQziQI;EA+BI,oBAAA;AR6gQR;AQpjQI;EAgCE,eAAA;ARuhQN;AQ/iQI;EA+BI,cAAA;ARmhQR;AQ1jQI;EAgCE,qBAAA;AR6hQN;AQrjQI;EA+BI,oBAAA;ARyhQR;AQhkQI;EAgCE,mBAAA;ARmiQN;AQ3jQI;EA+BI,kBAAA;AR+hQR;AQtkQI;EAgCE,qBAAA;ARyiQN;AQjkQI;EA+BI,oBAAA;ARqiQR;AQ5kQI;EAgCE,qBAAA;AR+iQN;AQvkQI;EA+BI,oBAAA;AR2iQR;;AiEplQA;EAEE,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EAGA,kEAAA;EACA,+DAAA;EACA,6EAAA;AjEolQF;AQhmQI;EAgCE,uDAAA;ARmkQN;AQ3lQI;EA+BI,yDAAA;AR+jQR;AQtmQI;EAgCE,uDAAA;ARykQN;AQjmQI;EA+BI,yDAAA;ARqkQR;AiE9mQA;ExDmBI,+CAAA;AT8lQJ;;AiE1lQE;EACE,wCAAA;AjE6lQJ;;AiE9lQE;EACE,wCAAA;AjEimQJ;;AiElmQE;EACE,wCAAA;AjEqmQJ;;AiEtmQE;EACE,wCAAA;AjEymQJ;;AiE1mQE;EACE,wCAAA;AjE6mQJ;;AiE9mQE;EACE,qCAAA;AjEinQJ;;AiElnQE;EACE,wCAAA;AjEqnQJ;;AiEtnQE;EACE,wCAAA;AjEynQJ;;AkEjpQA;EAEE,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,uCAAA;EACA,kDAAA;EACA,iFAAA;EAGA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;AlEipQF;;AkE9oQA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3DwrCkC;APy9NpC;;AkE9oQA;EACE,gBAAA;EACA,SAAA;EACA,a3DkrCkC;AP+9NpC;;AmElrQA;EAEE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,kCAAA;EACA,iFAAA;EACA,iCAAA;EACA,qEAAA;EACA,kCAAA;EACA,0CAAA;EACA,iCAAA;EACA,sDAAA;EACA,uCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qEAAA;EACA,uCAAA;EACA,wEAAA;EACA,sEAAA;EACA,4EAAA;EACA,uCAAA;EACA,uCAAA;EACA,0DAAA;EACA,iGAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,gCAAA;EACA,uCAAA;AnEkrQF;AmE7qQE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AnE2rQJ;AmE7qQE;;;;;;;EAEE,gFAAA;AnEorQJ;AmEjrQE;;;;;;;EAEE,mFAAA;AnEwrQJ;AmErrQE;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AnEurQJ;;AmEnrQA;EACE,wDAAA;EACA,SAAA;EACA,0EAAA;EACA,4CAAA;AnEsrQF;;AmE/qQA;EACE,8CAAA;EACA,iDAAA;AnEkrQF;AQ3wQI;EAgCE,kBAAA;AR8uQN;AQtwQI;EA+BI,iBAAA;AR0uQR;AmE1rQA;E9DsMM,qBALI;E8D5LR,oCAAA;EACA,qBAAA;EACA,mBAAA;AnEyrQF;AmEvrQE;EAEE,0CAAA;AnEwrQJ;;AmE/qQA;EACE,aAAA;EACA,mBAAA;AnEkrQF;AQ/xQI;EAgCE,eAAA;ARkwQN;AQ1xQI;EA+BI,gBAAA;AR8vQR;AmE1rQA;EAIE,gBAAA;EACA,gBAAA;AnEyrQF;AmEvrQE;EACE,kFAAA;EACA,8BAAA;AnEyrQJ;AmEvrQI;EAEE,oCAAA;AnEwrQN;AmErrQI;EACE,uCAAA;AnEurQN;AmEnrQE;;EAEE,qCAAA;AnEqrQJ;AmElrQE;EACE,kBAAA;AnEorQJ;;AmE3qQA;EACE,iDAAA;EACA,oDAAA;EACA,8BAAA;AnE8qQF;AmE5qQE;EACE,qCAAA;AnE8qQJ;AmE5qQI;EAEE,qCAAA;AnE6qQN;;AmExqQA;EACE,gFAAA;E9D8HI,qBALI;E8DvHR,sCAAA;EACA,8CAAA;EACA,SAAA;E1DlJE,sDAAA;AT8zQJ;AmEzqQE;EACE,4CAAA;EACA,qBAAA;AnE2qQJ;AmExqQE;EACE,UAAA;AnE0qQJ;AmEtqQE;EACE,eAAA;AnEwqQJ;;AmEpqQA;EACE,cAAA;EACA,oBAAA;EACA,mDAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;AnEuqQF;AmErqQE;EACE,yDAAA;AnEuqQJ;;AoEv2QA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;ApE02QF;AoEz2QE;ECJA,W9D4wBgB;E8D3wBhB,Y9D2wBgB;E8D1wBhB,e9D0wBgB;APsmPlB;AoE32QI;ECPF,W9DgxBgB;E8D/wBhB,Y9D+wBgB;E8D9wBhB,e9D8wBgB;APumPlB;AoE52QI;ECXF,a9D+wBgB;E8D9wBhB,c9D8wBgB;E8D7wBhB,iB9D6wBgB;AP6mPlB;AoE72QI;ECfF,c9D8wBgB;E8D7wBhB,e9D6wBgB;E8D5wBhB,kB9D4wBgB;APmnPlB;AoE92QI;ECnBF,e9D6wBgB;E8D5wBhB,gB9D4wBgB;E8D3wBhB,mB9D2wBgB;APynPlB;AoE92QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApEk3Q3B;AoEn3QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApEu3Q3B;AoEx3QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApE43Q3B;AoE73QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApEi4Q3B;AoEl4QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApEs4Q3B;AoEv4QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApE24Q3B;AoE54QM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;ApEg5Q3B;;AsE36QA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8CAAA;EACA,6BAAA;EACA,uCAAA;EACA,oDAAA;EACA,gCAAA;EACA,+BAAA;EACA,iCAAA;EACA,4CAAA;EACA,oCAAA;EACA,uCAAA;EACA,4CAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,6CAAA;EACA,kCAAA;EACA,yEAAA;EACA,2CAAA;EACA,4CAAA;EACA,kDAAA;EACA,+EAAA;EAEA,gCAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,wDAAA;EACA,sCAAA;EACA,2CAAA;EACA,uDAAA;EACA,sCAAA;EACA,gDAAA;EACA,+EAAA;EACA,uCAAA;EACA,8DAAA;EACA,yCAAA;EACA,mEAAA;EACA,gEAAA;EACA,qEAAA;EACA,6DAAA;EACA,0DAAA;EACA,kEAAA;EACA,kCAAA;EACA,sCAAA;EACA,yCAAA;EACA,4DAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,2EAAA;EACA,iFAAA;EACA,oEAAA;EAGA,kBAAA;EACA,aAAA;EAEA,kCAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;EACA,kEAAA;EACA,+BAAA;EACA,iCAAA;AtEu6QF;AQ5+QI;EAgCE,mFAAA;AR+8QN;AQv+QI;EA+BI,kFAAA;AR28QR;AsEp/QA;EAyEE,gBAAA;E7CzDI,yH6C0DJ;AtE86QF;AyBp+QM;E6CpBN;I7CqBQ,gBAAA;EzBu+QN;AACF;AQ3/QI;EAgCE,cAAA;AR89QN;AQt/QI;EA+BI,eAAA;AR09QR;AsEr7QI;EACE,iCAAA;AtEu7QN;AsEn7QE;EACE,SAAA;AtEq7QJ;AQvgRI;EAgCE,eAAA;AR0+QN;AQlgRI;EA+BI,cAAA;ARs+QR;AsEz7QI;EACE,+BAAA;AtE27QN;AsEv7QE;EACE,iCAAA;AtEy7QJ;AsEr7QI;EACE,0BAAA;AtEu7QN;AiBz9QI;EqDqCM;IACE,iCAAA;EtEu7QV;EsEn7QQ;IACE,+BAAA;EtEq7QV;AACF;AsEh8QI;EACE,0BAAA;AtEk8QN;AiBp+QI;EqDqCM;IACE,iCAAA;EtEk8QV;EsE97QQ;IACE,+BAAA;EtEg8QV;AACF;AsE38QI;EACE,0BAAA;AtE68QN;AiB/+QI;EqDqCM;IACE,iCAAA;EtE68QV;EsEz8QQ;IACE,+BAAA;EtE28QV;AACF;AiBv/QI;ET7DA;IAgCE,gDAAA;ERwhRJ;EQhjRE;IA+BI,iDAAA;ERohRN;EsEx8QM;IACE,6BAAA;EtE08QR;EQ9jRE;IAgCE,iDAAA;ERiiRJ;EQzjRE;IA+BI,gDAAA;ER6hRN;EsE38QM;IACE,2BAAA;EtE68QR;AACF;AiB3gRI;EqDmEF;IAEI,eAAA;IACA,MAAA;IACA,SAAA;IACA,a/D4kC8B;EP83OlC;EQ/kRE;IAgCE,OAAA;ERkjRJ;EQ1kRE;IA+BI,QAAA;ER8iRN;EQrlRE;IAgCE,QAAA;ERwjRJ;EQhlRE;IA+BI,OAAA;ERojRN;AACF;AiB/hRI;EqDoFF;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EtE68QJ;AACF;AsE18QE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;AtE48QJ;AQzmRI;EAgCE,OAAA;AR4kRN;AQpmRI;EA+BI,QAAA;ARwkRR;AsE98QM;EACE,6BAAA;AtEg9QR;AQlnRI;EAgCE,QAAA;ARqlRN;AQ7mRI;EA+BI,OAAA;ARilRR;AsEh9QM;EACE,2BAAA;AtEk9QR;AiBjjRI;EqD5EJ;IAkLI,qBAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,aAAA;EtE+8QF;EQnoRE;IAgCE,OAAA;ERsmRJ;EQ9nRE;IA+BI,QAAA;ERkmRN;EsEj9QI;IACE,wCAAA;EtEm9QN;EQ5oRE;IAgCE,gDAAA;ER+mRJ;EQvoRE;IA+BI,iDAAA;ER2mRN;EQlpRE;IAgCE,QAAA;ERqnRJ;EQ7oRE;IA+BI,OAAA;ERinRN;EsEt9QI;IACE,sCAAA;EtEw9QN;EQ3pRE;IAgCE,iDAAA;ER8nRJ;EQtpRE;IA+BI,gDAAA;ER0nRN;AACF;;AsEr9QA;EACE,kBAAA;EACA,MAAA;AtEw9QF;AQvqRI;EAgCE,QAAA;AR0oRN;AQlqRI;EA+BI,OAAA;ARsoRR;AsEh+QA;EAIE,+BAAA;EACA,wCAAA;EACA,+BAAA;EACA,uBAAA;EACA,SAAA;AtE+9QF;AsE79QE;EACE,qBAAA;AtE+9QJ;AsE59QE;EACE,UAAA;AtE89QJ;;AsE19QA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,uCAAA;AtE69QF;AsE39QE;EACE,aAAA;AtE69QJ;;AsEz9QA;EACE,0CAAA;EACA,gFAAA;EACA,kBAAA;EACA,wCAAA;E7CnOI,uC6CoOJ;AtE49QF;AyB5rRM;E6C2NN;I7C1NQ,gBAAA;EzB+rRN;AACF;AsE/9QE;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;AtEi+QJ;;AsE79QA;EACE,0CAAA;EACA,gFAAA;EACA,wCAAA;E7ChPI,uC6CiPJ;AtEg+QF;AyB7sRM;E6CyON;I7CxOQ,gBAAA;EzBgtRN;AACF;;AsEl+QA;EACE,aAAA;EACA,2CAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,+CAAA;EACA,SAAA;AtEq+QF;AiBrqRI;EqDwLJ;IAWI,aAAA;EtEs+QF;AACF;AsEp+QE;EACE,cAAA;EACA,iDAAA;EACA,mDAAA;EACA,WAAA;EACA,sDAAA;EACA,4BAAA;EACA,2BAAA;EACA,yEAAA;E7C1QE,2B6C2QF;AtEs+QJ;AyB7uRM;E6C8PJ;I7C7PM,gBAAA;EzBgvRN;AACF;AQ5vRI;E8DmRE,0BAAA;AtE4+QN;AsEx+QE;EACE,UAAA;AtE0+QJ;AsEv+QE;EACE,qDAAA;AtEy+QJ;AsEx+QI;EACE,4DAAA;AtE0+QN;AsEt+QE;EACE,2BAAA;AtEw+QJ;AsEv+QI;EACE,0BAAA;AtEy+QN;;AsEl+QA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;AtEo+QF;AiBltRI;EqD0OJ;IhBpTE,eAAA;IACA,MAAA;IACA,OAAA;IACA,mCgByT4B;IhBxT5B,YAAA;IACA,aAAA;IACA,wCgBsT8D;EtE0+Q9D;EsD7xRA;IAAS,UAAA;EtDgyRT;EsD/xRA;IAAS,oCgBkTmF;EtEg/Q5F;AACF;;AuE7yRA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AvEgzRF;AuE9yRE;EACE,sFAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;E9CHE,sC8CIF;AvEgzRJ;AyBhzRM;E8CPJ;I9CQM,gBAAA;EzBmzRN;AACF;AuElzRE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oFAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;E9DbA,wDAAA;EgBHE,mD8CkBF;AvEozRJ;AyBl0RM;E8CGJ;I9CFM,gBAAA;EzBq0RN;AACF;AuEvzRI;EACE,+CAAA;EACA,iDAAA;AvEyzRN;AuEvzRM;EACE,oDAAA;AvEyzRR;AuErzRI;EACE,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AvEuzRN;AuErzRM;EACE,sDAAA;AvEuzRR;AuEpzRM;EACE,iDAAA;AvEszRR;AuEpzRQ;EACE,sDAAA;AvEszRV;AuEnzRQ;EACE,8DAAA;AvEqzRV;AuEhzRI;EACE;IACE,8CAAA;IACA,qBAAA;IACA,gDAAA;EvEkzRN;EuEhzRM;IACE,mDAAA;EvEkzRR;EuE/yRM;IACE,8DAAA;EvEizRR;AACF;AuE5yRE;EACE,2CAAA;EACA,0CAAA;EACA,gDAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;E9C5EE,mB8C6EF;AvE8yRJ;AyBv3RM;E8CiEJ;I9ChEM,gBAAA;EzB03RN;AACF;AQ94RI;EAgCE,6DAAA;ARi3RN;AQz4RI;EA+BI,8DAAA;AR62RR;AuElzRE;EACE,gBAAA;AvEozRJ;AuEjzRE;EACE,kBAAA;E9CzFE,wC8C0FF;AvEmzRJ;AyBz4RM;E8CoFJ;I9CnFM,gBAAA;EzB44RN;AACF;AuEtzRI;EACE,kGAAA;EACA,gBAAA;E9C9FA,6B8C+FA;AvEwzRN;AyBn5RM;E8CwFF;I9CvFI,gBAAA;EzBs5RN;AACF;AuE1zRI;EACE,aAAA;AvE4zRN;AuEzzRI;EACE,2CAAA;AvE2zRN;AuEzzRM;EACE,qDAAA;AvE2zRR;AuExzRM;EACE,yBAAA;AvE0zRR;AuEvzRM;EACE,eAAA;AvEyzRR;AuEpzRE;EACE,eAAA;AvEszRJ;AuEpzRI;EACE,cAAA;EACA,cAAA;EACA,YAAA;AvEszRN;AQj8RI;EAgCE,iBAAA;ARo6RN;AQ57RI;EA+BI,kBAAA;ARg6RR;AuE/zRI;EAKE,WAAA;EACA,wDAAA;EACA,4BAAA;EACA,2BAAA;E9ClIA,2B8CmIA;AvE6zRN;AyB57RM;E8CsHF;I9CrHI,gBAAA;EzB+7RN;AACF;AuE9zRE;EACE,UAAA;EACA,gBAAA;AvEg0RJ;AQv9RI;EAgCE,+CAAA;AR07RN;AQl9RI;EA+BI,gDAAA;ARs7RR;AQ79RI;EAgCE,yDAAA;ARg8RN;AQx9RI;EA+BI,0DAAA;AR47RR;AuE/zRI;;EACE,8DAAA;EACA,iEAAA;AvEk0RN;;AiB36RI;EuD/DJ;IAEI,aAAA;IACA,yCAAA;IACA,sCAAA;IACA,iDAAA;IACA,iBAAA;ExE6+RF;EwE3+RE;IACE,aAAA;IACA,sCAAA;ExE6+RJ;EwE1+RE;IACE,aAAA;ExE4+RJ;EwEz+RE;IACE,cAAA;ExE2+RJ;EwEx+RE;;;;;;;;;;;;;IAQE,oBAAA;IACA,UAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;ExE++RJ;EwE5+RE;IACE,eAAA;IACA,SAAA;ExE8+RJ;EQlhSE;IAgCE,0BAAA;ERq/RJ;EQ7gSE;IA4BI,uBAAA;ERo/RN;EwE7+RE;IACE,uBAAA;ExE++RJ;AACF;;AwEz+RE;EACE,gCAAA;AxE4+RJ;AwE1+RE;EACE,8BAAA;AxE4+RJ;;AwEx+RA;EACE,eAAA;EACA,aAAA;AxE2+RF;AwEz+RE;EACE,gCAAA;AxE2+RJ;AwEz+RE;EACE,8BAAA;AxE2+RJ;AQ9iSI;EAgCE,0BAAA;ARihSN;AQziSI;EA4BI,uBAAA;ARghSR;AwEn+RI;EACE,uBAAA;AxEq+RN;;AQvjSI;EAgCE,uDAAA;AR2hSN;AQnjSI;EA+BI,wDAAA;ARuhSR;AQ9jSI;EAgCE,wDAAA;ARiiSN;AQzjSI;EA+BI,uDAAA;AR6hSR;;AiB1/RI;ET1EA;IAgCE,uDAAA;ERyiSJ;EQjkSE;IA+BI,wDAAA;ERqiSN;EQ5kSE;IAgCE,wDAAA;ER+iSJ;EQvkSE;IA+BI,uDAAA;ER2iSN;AACF;AiBzgSI;ET1EA;IAgCE,uDAAA;ERujSJ;EQ/kSE;IA+BI,wDAAA;ERmjSN;EQ1lSE;IAgCE,wDAAA;ER6jSJ;EQrlSE;IA+BI,uDAAA;ERyjSN;AACF;AiBvhSI;ET1EA;IAgCE,uDAAA;ERqkSJ;EQ7lSE;IA+BI,wDAAA;ERikSN;EQxmSE;IAgCE,wDAAA;ER2kSJ;EQnmSE;IA+BI,uDAAA;ERukSN;AACF;AiBriSI;ET1EA;IAgCE,uDAAA;ERmlSJ;EQ3mSE;IA+BI,wDAAA;ER+kSN;EQtnSE;IAgCE,wDAAA;ERylSJ;EQjnSE;IA+BI,uDAAA;ERqlSN;AACF;AiBnjSI;ET1EA;IAgCE,uDAAA;ERimSJ;EQznSE;IA+BI,wDAAA;ER6lSN;EQpoSE;IAgCE,wDAAA;ERumSJ;EQ/nSE;IA+BI,uDAAA;ERmmSN;AACF;AyE7oSA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBlEuwD+B;EkEtwD/B,oBAAA;EACA,yCAAA;EACA,0IAAA;AzE+oSF;;AyE5oSA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AzE+oSF;;AyExoSA;EACE,aAAA;EACA,mBAAA;AzE2oSF;AQjqSI;EAgCE,eAAA;ARooSN;AQ5pSI;EA+BI,gBAAA;ARgoSR;AyEnpSA;EAIE,gBAAA;EACA,gBAAA;AzEkpSF;AyEhpSE;EACE,qBlEqvD4B;EkEpvD5B,oBlEovD4B;EkEnvD5B,6DAAA;AzEkpSJ;AyEhpSI;EAEE,8DAAA;AzEipSN;AyE9oSI;EACE,sEAAA;AzEgpSN;AyE5oSE;;EAEE,+DAAA;AzE8oSJ;AyE3oSE;EACE,kBAAA;AzE6oSJ;;AyEroSA;EACE,mBlEirCkC;EkEhrClC,sBlEgrCkC;EkE/qClC,6DAAA;AzEwoSF;AyEtoSE;EACE,+DAAA;AzEwoSJ;AyEtoSI;EAEE,+DAAA;AzEuoSN;;A2DzsSE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3D4sSJ;;A0E/sSE;EACE,2CAAA;EACA,mFAAA;A1EktSJ;;A0EptSE;EACE,yBAAA;EACA,qFAAA;A1EutSJ;;A0EztSE;EACE,yBAAA;EACA,mFAAA;A1E4tSJ;;A0E9tSE;EACE,yBAAA;EACA,gFAAA;A1EiuSJ;;A0EnuSE;EACE,4CAAA;EACA,mFAAA;A1EsuSJ;;A0ExuSE;EACE,yBAAA;EACA,kFAAA;A1E2uSJ;;A0E7uSE;EACE,4CAAA;EACA,iFAAA;A1EgvSJ;;A0ElvSE;EACE,2CAAA;EACA,gFAAA;A1EqvSJ;;A2EvvSE;EACE,0EAAA;EACA,oGAAA;A3E0vSJ;A2EvvSM;EAGE,+DAAA;EACA,yFAAA;A3EuvSR;;A2EhwSE;EACE,4EAAA;EACA,sGAAA;A3EmwSJ;A2EhwSM;EAGE,iEAAA;EACA,2FAAA;A3EgwSR;;A2EzwSE;EACE,0EAAA;EACA,oGAAA;A3E4wSJ;A2EzwSM;EAGE,gEAAA;EACA,0FAAA;A3EywSR;;A2ElxSE;EACE,uEAAA;EACA,iGAAA;A3EqxSJ;A2ElxSM;EAGE,gEAAA;EACA,0FAAA;A3EkxSR;;A2E3xSE;EACE,0EAAA;EACA,oGAAA;A3E8xSJ;A2E3xSM;EAGE,gEAAA;EACA,0FAAA;A3E2xSR;;A2EpySE;EACE,yEAAA;EACA,mGAAA;A3EuySJ;A2EpySM;EAGE,iEAAA;EACA,2FAAA;A3EoySR;;A2E7ySE;EACE,wEAAA;EACA,kGAAA;A3EgzSJ;A2E7ySM;EAGE,iEAAA;EACA,2FAAA;A3E6ySR;;A2EtzSE;EACE,uEAAA;EACA,iGAAA;A3EyzSJ;A2EtzSM;EAGE,iEAAA;EACA,2FAAA;A3EszSR;;A2E/ySA;EACE,iFAAA;EACA,2GAAA;A3EkzSF;A2E/ySI;EAEE,oFAAA;EACA,8GAAA;A3EgzSN;;A4E10SA;EACE,UAAA;EAEA,uJAAA;A5E40SF;;A6E/0SA;EACE,oBAAA;EACA,atE8f4B;EsE7f5B,mBAAA;EACA,oFAAA;EACA,6BtE4f4B;EsE3f5B,2BAAA;A7Ek1SF;A6Eh1SE;EACE,cAAA;EACA,UtEwf0B;EsEvf1B,WtEuf0B;EsEtf1B,kBAAA;EpDIE,sCoDHF;A7Ek1SJ;AyB30SM;EoDZJ;IpDaM,gBAAA;EzB80SN;AACF;;A6Eh1SI;EACE,oEAAA;A7Em1SN;;A8Et2SA;EACE,kBAAA;EACA,WAAA;A9Ey2SF;A8Ev2SE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;A9Ey2SJ;A8Et2SE;EACE,kBAAA;EACA,MAAA;A9Ew2SJ;AQp3SI;EAgCE,OAAA;ARu1SN;AQ/2SI;EA+BI,QAAA;ARm1SR;A8Eh3SE;EAIE,WAAA;EACA,YAAA;A9E+2SJ;;A8E12SE;EACE,wBAAA;A9E62SJ;;A8E92SE;EACE,uBAAA;A9Ei3SJ;;A8El3SE;EACE,0BAAA;A9Eq3SJ;;A8Et3SE;EACE,kCAAA;A9Ey3SJ;;A+E94SA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,axE4sCkC;APqsQpC;;A+E94SA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,axEosCkC;AP6sQpC;;A+Ez4SI;EACE,gBAAA;EACA,MAAA;EACA,axEwrC8B;APotQpC;;A+Ez4SI;EACE,gBAAA;EACA,SAAA;EACA,axEkrC8B;AP0tQpC;;AiB72SI;E8DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EPiuQlC;E+Et5SE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EPsuQlC;AACF;AiB13SI;E8DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EP6uQlC;E+El6SE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EPkvQlC;AACF;AiBt4SI;E8DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EPyvQlC;E+E96SE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EP8vQlC;AACF;AiBl5SI;E8DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EPqwQlC;E+E17SE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EP0wQlC;AACF;AiB95SI;E8DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EPixQlC;E+Et8SE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EPsxQlC;AACF;AgFx+SA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AhF0+SF;;AgFv+SA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AhF0+SF;;AiFl/SA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AlFm/SF;AkFh/SE;;EACE,6BAAA;AlFm/SJ;;AmFjgTE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U5EifsC;E4EhftC,WAAA;AnFogTJ;;AoF5gTA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;ArFghTF;;AsFthTA;EACE,qBAAA;EACA,mBAAA;EACA,8B/E2vB4B;E+E1vB5B,eAAA;EACA,UAAA;EACA,8BAAA;EACA,a/EovB4B;APqyR9B;;AuF39SQ;EAUM,mCAAA;AvFq9Sd;;AuF/9SQ;EAUM,8BAAA;AvFy9Sd;;AuFn+SQ;EAUM,iCAAA;AvF69Sd;;AuFv+SQ;EAUM,iCAAA;AvFi+Sd;;AuF3+SQ;EAUM,sCAAA;AvFq+Sd;;AuF/+SQ;EAUM,mCAAA;AvFy+Sd;;AQtjTI;EAgCE,sBAAA;AR0hTN;AQljTI;EA+BI,uBAAA;ARshTR;;AQ7jTI;EAgCE,uBAAA;ARiiTN;AQzjTI;EA+BI,sBAAA;AR6hTR;;AQpkTI;EAgCE,sBAAA;ARwiTN;AQhkTI;EA+BI,sBAAA;ARoiTR;;AuFxgTQ;EAUM,8BAAA;AvFkgTd;;AuF5gTQ;EAUM,4BAAA;AvFsgTd;;AuFhhTQ;EAUM,2BAAA;AvF0gTd;;AuFphTQ;EAUM,iCAAA;AvF8gTd;;AuFxhTQ;EAUM,2BAAA;AvFkhTd;;AuF5hTQ;EAUM,qBAAA;AvFshTd;;AuFhiTQ;EAUM,wBAAA;AvF0hTd;;AuFpiTQ;EAUM,uBAAA;AvF8hTd;;AuFxiTQ;EAUM,wBAAA;AvFkiTd;;AuF5iTQ;EAUM,qBAAA;AvFsiTd;;AuFhjTQ;EAUM,yBAAA;AvF0iTd;;AuFpjTQ;EAUM,2BAAA;AvF8iTd;;AuFxjTQ;EAUM,4BAAA;AvFkjTd;;AuF5jTQ;EAUM,2BAAA;AvFsjTd;;AuFhkTQ;EAUM,2BAAA;AvF0jTd;;AuFpkTQ;EAUM,6BAAA;AvF8jTd;;AuFxkTQ;EAUM,8BAAA;AvFkkTd;;AuF5kTQ;EAUM,6BAAA;AvFskTd;;AuFhlTQ;EAUM,2BAAA;AvF0kTd;;AuFplTQ;EAUM,6BAAA;AvF8kTd;;AuFxlTQ;EAUM,8BAAA;AvFklTd;;AuF5lTQ;EAUM,6BAAA;AvFslTd;;AuFhmTQ;EAUM,0BAAA;AvF0lTd;;AuFpmTQ;EAUM,gCAAA;AvF8lTd;;AuFxmTQ;EAUM,yBAAA;AvFkmTd;;AuF5mTQ;EAUM,wBAAA;AvFsmTd;;AuFhnTQ;EAUM,+BAAA;AvF0mTd;;AuFpnTQ;EAUM,yBAAA;AvF8mTd;;AuFxnTQ;EAUM,6BAAA;AvFknTd;;AuF5nTQ;EAUM,8BAAA;AvFsnTd;;AuFhoTQ;EAUM,wBAAA;AvF0nTd;;AuFpoTQ;EAUM,+BAAA;AvF8nTd;;AuFxoTQ;EAUM,wBAAA;AvFkoTd;;AuF5oTQ;EAUM,uDAAA;AvFsoTd;;AuFhpTQ;EAUM,oDAAA;AvF0oTd;;AuFppTQ;EAUM,uDAAA;AvF8oTd;;AuFxpTQ;EAUM,2BAAA;AvFkpTd;;AuFtqTQ;EACE,mFAAA;AvFyqTV;;AuF1qTQ;EACE,qFAAA;AvF6qTV;;AuF9qTQ;EACE,mFAAA;AvFirTV;;AuFlrTQ;EACE,gFAAA;AvFqrTV;;AuFtrTQ;EACE,mFAAA;AvFyrTV;;AuF1rTQ;EACE,kFAAA;AvF6rTV;;AuF9rTQ;EACE,iFAAA;AvFisTV;;AuFlsTQ;EACE,gFAAA;AvFqsTV;;AuF5rTQ;EAUM,2BAAA;AvFsrTd;;AuFhsTQ;EAUM,6BAAA;AvF0rTd;;AuFpsTQ;EAUM,6BAAA;AvF8rTd;;AuFxsTQ;EAUM,0BAAA;AvFksTd;;AuF5sTQ;EAUM,2BAAA;AvFssTd;;AuFhtTQ;EAUM,iBAAA;AvF0sTd;;AuFptTQ;EAUM,mBAAA;AvF8sTd;;AuFxtTQ;EAUM,oBAAA;AvFktTd;;AuF5tTQ;EAUM,oBAAA;AvFstTd;;AuFhuTQ;EAUM,sBAAA;AvF0tTd;;AuFpuTQ;EAUM,uBAAA;AvF8tTd;;AuFxuTQ;EAUM,kBAAA;AvFkuTd;;AuF5uTQ;EAUM,oBAAA;AvFsuTd;;AuFhvTQ;EAUM,qBAAA;AvF0uTd;;AuFpvTQ;EAUM,mBAAA;AvF8uTd;;AuFxvTQ;EAUM,qBAAA;AvFkvTd;;AuF5vTQ;EAUM,sBAAA;AvFsvTd;;AuFhwTQ;EAUM,2CAAA;AvF0vTd;;AuFpwTQ;EAUM,sCAAA;AvF8vTd;;AuFxwTQ;EAUM,sCAAA;AvFkwTd;;AuF5wTQ;EAUM,0FAAA;AvFswTd;;AuFhxTQ;EAUM,oBAAA;AvF0wTd;;AuFpxTQ;EAUM,8FAAA;AvF8wTd;;AuFxxTQ;EAUM,wBAAA;AvFkxTd;;AQ/1TI;EAgCE,gGAAA;ARm0TN;AQ31TI;EA+BI,+FAAA;AR+zTR;;AQt2TI;EAgCE,0BAAA;AR00TN;AQl2TI;EA+BI,yBAAA;ARs0TR;;AuF1yTQ;EAUM,iGAAA;AvFoyTd;;AuF9yTQ;EAUM,2BAAA;AvFwyTd;;AQr3TI;EAgCE,+FAAA;ARy1TN;AQj3TI;EA+BI,gGAAA;ARq1TR;;AQ53TI;EAgCE,yBAAA;ARg2TN;AQx3TI;EA+BI,0BAAA;AR41TR;;AuFh0TQ;EAIQ,uBAAA;EAMF,gFAAA;AvF2zTd;;AuFr0TQ;EAIQ,uBAAA;EAMF,kFAAA;AvFg0Td;;AuF10TQ;EAIQ,uBAAA;EAMF,gFAAA;AvFq0Td;;AuF/0TQ;EAIQ,uBAAA;EAMF,6EAAA;AvF00Td;;AuFp1TQ;EAIQ,uBAAA;EAMF,gFAAA;AvF+0Td;;AuFz1TQ;EAIQ,uBAAA;EAMF,+EAAA;AvFo1Td;;AuF91TQ;EAIQ,uBAAA;EAMF,8EAAA;AvFy1Td;;AuFn2TQ;EAIQ,uBAAA;EAMF,6EAAA;AvF81Td;;AuFx2TQ;EAIQ,uBAAA;EAMF,8EAAA;AvFm2Td;;AuF72TQ;EAUM,oCAAA;AvFu2Td;;AuFj3TQ;EAUM,oCAAA;AvF22Td;;AuFr3TQ;EAUM,oCAAA;AvF+2Td;;AuFz3TQ;EAUM,iCAAA;AvFm3Td;;AuF73TQ;EAUM,oCAAA;AvFu3Td;;AuFj4TQ;EAUM,oCAAA;AvF23Td;;AuFr4TQ;EAUM,oCAAA;AvF+3Td;;AuFz4TQ;EAUM,oCAAA;AvFm4Td;;AuF74TQ;EAUM,iCAAA;AvFu4Td;;AQp9TI;EAgCE,sCAAA;ARw7TN;AQh9TI;EA+BI,qCAAA;ARo7TR;;AQ39TI;EAgCE,sCAAA;AR+7TN;AQv9TI;EA+BI,qCAAA;AR27TR;;AQl+TI;EAgCE,sCAAA;ARs8TN;AQ99TI;EA+BI,qCAAA;ARk8TR;;AQz+TI;EAgCE,mCAAA;AR68TN;AQr+TI;EA+BI,kCAAA;ARy8TR;;AQh/TI;EAgCE,sCAAA;ARo9TN;AQ5+TI;EA+BI,qCAAA;ARg9TR;;AQv/TI;EAgCE,sCAAA;AR29TN;AQn/TI;EA+BI,qCAAA;ARu9TR;;AQ9/TI;EAgCE,sCAAA;ARk+TN;AQ1/TI;EA+BI,qCAAA;AR89TR;;AQrgUI;EAgCE,sCAAA;ARy+TN;AQjgUI;EA+BI,qCAAA;ARq+TR;;AQ5gUI;EAgCE,mCAAA;ARg/TN;AQxgUI;EA+BI,kCAAA;AR4+TR;;AuFh9TQ;EAUM,uCAAA;AvF08Td;;AuFp9TQ;EAUM,uCAAA;AvF88Td;;AuFx9TQ;EAUM,uCAAA;AvFk9Td;;AuF59TQ;EAUM,oCAAA;AvFs9Td;;AuFh+TQ;EAUM,uCAAA;AvF09Td;;AuFp+TQ;EAUM,uCAAA;AvF89Td;;AuFx+TQ;EAUM,uCAAA;AvFk+Td;;AuF5+TQ;EAUM,uCAAA;AvFs+Td;;AuFh/TQ;EAUM,oCAAA;AvF0+Td;;AQvjUI;EAgCE,qCAAA;AR2hUN;AQnjUI;EA+BI,sCAAA;ARuhUR;;AQ9jUI;EAgCE,qCAAA;ARkiUN;AQ1jUI;EA+BI,sCAAA;AR8hUR;;AQrkUI;EAgCE,qCAAA;ARyiUN;AQjkUI;EA+BI,sCAAA;ARqiUR;;AQ5kUI;EAgCE,kCAAA;ARgjUN;AQxkUI;EA+BI,mCAAA;AR4iUR;;AQnlUI;EAgCE,qCAAA;ARujUN;AQ/kUI;EA+BI,sCAAA;ARmjUR;;AQ1lUI;EAgCE,qCAAA;AR8jUN;AQtlUI;EA+BI,sCAAA;AR0jUR;;AQjmUI;EAgCE,qCAAA;ARqkUN;AQ7lUI;EA+BI,sCAAA;ARikUR;;AQxmUI;EAgCE,qCAAA;AR4kUN;AQpmUI;EA+BI,sCAAA;ARwkUR;;AQ/mUI;EAgCE,kCAAA;ARmlUN;AQ3mUI;EA+BI,mCAAA;AR+kUR;;AuFnjUQ;EAUM,4BAAA;AvF6iUd;;AuFvjUQ;EAUM,4BAAA;AvFijUd;;AuF3jUQ;EAUM,4BAAA;AvFqjUd;;AuF/jUQ;EAUM,4BAAA;AvFyjUd;;AuFnkUQ;EAUM,4BAAA;AvF6jUd;;AuFvkUQ;EAUM,gCAAA;AvFikUd;;AuF3kUQ;EAUM,gCAAA;AvFqkUd;;AuF/kUQ;EAUM,gCAAA;AvFykUd;;AuFnlUQ;EAUM,gCAAA;AvF6kUd;;AuFvlUQ;EAUM,gCAAA;AvFilUd;;AQ9pUI;EAgCE,kCAAA;ARkoUN;AQ1pUI;EA+BI,iCAAA;AR8nUR;;AQrqUI;EAgCE,kCAAA;ARyoUN;AQjqUI;EA+BI,iCAAA;ARqoUR;;AQ5qUI;EAgCE,kCAAA;ARgpUN;AQxqUI;EA+BI,iCAAA;AR4oUR;;AQnrUI;EAgCE,kCAAA;ARupUN;AQ/qUI;EA+BI,iCAAA;ARmpUR;;AQ1rUI;EAgCE,kCAAA;AR8pUN;AQtrUI;EA+BI,iCAAA;AR0pUR;;AuF9nUQ;EAUM,mCAAA;AvFwnUd;;AuFloUQ;EAUM,mCAAA;AvF4nUd;;AuFtoUQ;EAUM,mCAAA;AvFgoUd;;AuF1oUQ;EAUM,mCAAA;AvFooUd;;AuF9oUQ;EAUM,mCAAA;AvFwoUd;;AQrtUI;EAgCE,iCAAA;ARyrUN;AQjtUI;EA+BI,kCAAA;ARqrUR;;AQ5tUI;EAgCE,iCAAA;ARgsUN;AQxtUI;EA+BI,kCAAA;AR4rUR;;AQnuUI;EAgCE,iCAAA;ARusUN;AQ/tUI;EA+BI,kCAAA;ARmsUR;;AQ1uUI;EAgCE,iCAAA;AR8sUN;AQtuUI;EA+BI,kCAAA;AR0sUR;;AQjvUI;EAgCE,iCAAA;ARqtUN;AQ7uUI;EA+BI,kCAAA;ARitUR;;AuF/rUQ;EACE,yBAAA;AvFksUV;;AuFnsUQ;EACE,0BAAA;AvFssUV;;AuFvsUQ;EACE,yBAAA;AvF0sUV;;AuF3sUQ;EACE,0BAAA;AvF8sUV;;AuF/sUQ;EACE,uBAAA;AvFktUV;;AuFzsUQ;EAUM,qBAAA;AvFmsUd;;AuF7sUQ;EAUM,qBAAA;AvFusUd;;AuFjtUQ;EAUM,qBAAA;AvF2sUd;;AuFrtUQ;EAUM,sBAAA;AvF+sUd;;AuFztUQ;EAUM,sBAAA;AvFmtUd;;AuF7tUQ;EAUM,0BAAA;AvFutUd;;AuFjuUQ;EAUM,uBAAA;AvF2tUd;;AuFruUQ;EAUM,2BAAA;AvF+tUd;;AuFzuUQ;EAUM,sBAAA;AvFmuUd;;AuF7uUQ;EAUM,sBAAA;AvFuuUd;;AuFjvUQ;EAUM,sBAAA;AvF2uUd;;AuFrvUQ;EAUM,uBAAA;AvF+uUd;;AuFzvUQ;EAUM,uBAAA;AvFmvUd;;AuF7vUQ;EAUM,2BAAA;AvFuvUd;;AuFjwUQ;EAUM,wBAAA;AvF2vUd;;AuFrwUQ;EAUM,4BAAA;AvF+vUd;;AuFzwUQ;EAUM,yBAAA;AvFmwUd;;AuF7wUQ;EAUM,8BAAA;AvFuwUd;;AuFjxUQ;EAUM,iCAAA;AvF2wUd;;AuFrxUQ;EAUM,sCAAA;AvF+wUd;;AuFzxUQ;EAUM,yCAAA;AvFmxUd;;AuF7xUQ;EAUM,uBAAA;AvFuxUd;;AuFjyUQ;EAUM,uBAAA;AvF2xUd;;AuFryUQ;EAUM,yBAAA;AvF+xUd;;AuFzyUQ;EAUM,yBAAA;AvFmyUd;;AuF7yUQ;EAUM,0BAAA;AvFuyUd;;AuFjzUQ;EAUM,4BAAA;AvF2yUd;;AuFrzUQ;EAUM,kCAAA;AvF+yUd;;AuFzzUQ;EAUM,sCAAA;AvFmzUd;;AuF7zUQ;EAUM,oCAAA;AvFuzUd;;AuFj0UQ;EAUM,kCAAA;AvF2zUd;;AuFr0UQ;EAUM,yCAAA;AvF+zUd;;AuFz0UQ;EAUM,wCAAA;AvFm0Ud;;AuF70UQ;EAUM,wCAAA;AvFu0Ud;;AuFj1UQ;EAUM,kCAAA;AvF20Ud;;AuFr1UQ;EAUM,gCAAA;AvF+0Ud;;AuFz1UQ;EAUM,8BAAA;AvFm1Ud;;AuF71UQ;EAUM,gCAAA;AvFu1Ud;;AuFj2UQ;EAUM,+BAAA;AvF21Ud;;AuFr2UQ;EAUM,oCAAA;AvF+1Ud;;AuFz2UQ;EAUM,kCAAA;AvFm2Ud;;AuF72UQ;EAUM,gCAAA;AvFu2Ud;;AuFj3UQ;EAUM,uCAAA;AvF22Ud;;AuFr3UQ;EAUM,sCAAA;AvF+2Ud;;AuFz3UQ;EAUM,iCAAA;AvFm3Ud;;AuF73UQ;EAUM,2BAAA;AvFu3Ud;;AuFj4UQ;EAUM,iCAAA;AvF23Ud;;AuFr4UQ;EAUM,+BAAA;AvF+3Ud;;AuFz4UQ;EAUM,6BAAA;AvFm4Ud;;AuF74UQ;EAUM,+BAAA;AvFu4Ud;;AuFj5UQ;EAUM,8BAAA;AvF24Ud;;AuFr5UQ;EAUM,oBAAA;AvF+4Ud;;AuFz5UQ;EAUM,mBAAA;AvFm5Ud;;AuF75UQ;EAUM,mBAAA;AvFu5Ud;;AuFj6UQ;EAUM,mBAAA;AvF25Ud;;AuFr6UQ;EAUM,mBAAA;AvF+5Ud;;AuFz6UQ;EAUM,mBAAA;AvFm6Ud;;AuF76UQ;EAUM,mBAAA;AvFu6Ud;;AuFj7UQ;EAUM,mBAAA;AvF26Ud;;AuFr7UQ;EAUM,oBAAA;AvF+6Ud;;AuFz7UQ;EAUM,0BAAA;AvFm7Ud;;AuF77UQ;EAUM,yBAAA;AvFu7Ud;;AuFj8UQ;EAUM,uBAAA;AvF27Ud;;AuFr8UQ;EAUM,yBAAA;AvF+7Ud;;AuFz8UQ;EAUM,uBAAA;AvFm8Ud;;AuF78UQ;EAUM,uBAAA;AvFu8Ud;;AuFj9UQ;EAUM,0BAAA;EAAA,yBAAA;AvF48Ud;;AuFt9UQ;EAUM,gCAAA;EAAA,+BAAA;AvFi9Ud;;AuF39UQ;EAUM,+BAAA;EAAA,8BAAA;AvFs9Ud;;AuFh+UQ;EAUM,6BAAA;EAAA,4BAAA;AvF29Ud;;AuFr+UQ;EAUM,+BAAA;EAAA,8BAAA;AvFg+Ud;;AuF1+UQ;EAUM,6BAAA;EAAA,4BAAA;AvFq+Ud;;AuF/+UQ;EAUM,6BAAA;EAAA,4BAAA;AvF0+Ud;;AuFp/UQ;EAUM,wBAAA;EAAA,2BAAA;AvF++Ud;;AuFz/UQ;EAUM,8BAAA;EAAA,iCAAA;AvFo/Ud;;AuF9/UQ;EAUM,6BAAA;EAAA,gCAAA;AvFy/Ud;;AuFngVQ;EAUM,2BAAA;EAAA,8BAAA;AvF8/Ud;;AuFxgVQ;EAUM,6BAAA;EAAA,gCAAA;AvFmgVd;;AuF7gVQ;EAUM,2BAAA;EAAA,8BAAA;AvFwgVd;;AuFlhVQ;EAUM,2BAAA;EAAA,8BAAA;AvF6gVd;;AuFvhVQ;EAUM,wBAAA;AvFihVd;;AuF3hVQ;EAUM,8BAAA;AvFqhVd;;AuF/hVQ;EAUM,6BAAA;AvFyhVd;;AuFniVQ;EAUM,2BAAA;AvF6hVd;;AuFviVQ;EAUM,6BAAA;AvFiiVd;;AuF3iVQ;EAUM,2BAAA;AvFqiVd;;AuF/iVQ;EAUM,2BAAA;AvFyiVd;;AQtnVI;EAgCE,0BAAA;AR0lVN;AQlnVI;EA+BI,yBAAA;ARslVR;;AQ7nVI;EAgCE,gCAAA;ARimVN;AQznVI;EA+BI,+BAAA;AR6lVR;;AQpoVI;EAgCE,+BAAA;ARwmVN;AQhoVI;EA+BI,8BAAA;ARomVR;;AQ3oVI;EAgCE,6BAAA;AR+mVN;AQvoVI;EA+BI,4BAAA;AR2mVR;;AQlpVI;EAgCE,+BAAA;ARsnVN;AQ9oVI;EA+BI,8BAAA;ARknVR;;AQzpVI;EAgCE,6BAAA;AR6nVN;AQrpVI;EA+BI,4BAAA;ARynVR;;AQhqVI;EAgCE,6BAAA;ARooVN;AQ5pVI;EA+BI,4BAAA;ARgoVR;;AuFpmVQ;EAUM,2BAAA;AvF8lVd;;AuFxmVQ;EAUM,iCAAA;AvFkmVd;;AuF5mVQ;EAUM,gCAAA;AvFsmVd;;AuFhnVQ;EAUM,8BAAA;AvF0mVd;;AuFpnVQ;EAUM,gCAAA;AvF8mVd;;AuFxnVQ;EAUM,8BAAA;AvFknVd;;AuF5nVQ;EAUM,8BAAA;AvFsnVd;;AQnsVI;EAgCE,yBAAA;ARuqVN;AQ/rVI;EA+BI,0BAAA;ARmqVR;;AQ1sVI;EAgCE,+BAAA;AR8qVN;AQtsVI;EA+BI,gCAAA;AR0qVR;;AQjtVI;EAgCE,8BAAA;ARqrVN;AQ7sVI;EA+BI,+BAAA;ARirVR;;AQxtVI;EAgCE,4BAAA;AR4rVN;AQptVI;EA+BI,6BAAA;ARwrVR;;AQ/tVI;EAgCE,8BAAA;ARmsVN;AQ3tVI;EA+BI,+BAAA;AR+rVR;;AQtuVI;EAgCE,4BAAA;AR0sVN;AQluVI;EA+BI,6BAAA;ARssVR;;AQ7uVI;EAgCE,4BAAA;ARitVN;AQzuVI;EA+BI,6BAAA;AR6sVR;;AuFjrVQ;EAUM,qBAAA;AvF2qVd;;AuFrrVQ;EAUM,2BAAA;AvF+qVd;;AuFzrVQ;EAUM,0BAAA;AvFmrVd;;AuF7rVQ;EAUM,wBAAA;AvFurVd;;AuFjsVQ;EAUM,0BAAA;AvF2rVd;;AuFrsVQ;EAUM,wBAAA;AvF+rVd;;AuFzsVQ;EAUM,2BAAA;EAAA,0BAAA;AvFosVd;;AuF9sVQ;EAUM,iCAAA;EAAA,gCAAA;AvFysVd;;AuFntVQ;EAUM,gCAAA;EAAA,+BAAA;AvF8sVd;;AuFxtVQ;EAUM,8BAAA;EAAA,6BAAA;AvFmtVd;;AuF7tVQ;EAUM,gCAAA;EAAA,+BAAA;AvFwtVd;;AuFluVQ;EAUM,8BAAA;EAAA,6BAAA;AvF6tVd;;AuFvuVQ;EAUM,yBAAA;EAAA,4BAAA;AvFkuVd;;AuF5uVQ;EAUM,+BAAA;EAAA,kCAAA;AvFuuVd;;AuFjvVQ;EAUM,8BAAA;EAAA,iCAAA;AvF4uVd;;AuFtvVQ;EAUM,4BAAA;EAAA,+BAAA;AvFivVd;;AuF3vVQ;EAUM,8BAAA;EAAA,iCAAA;AvFsvVd;;AuFhwVQ;EAUM,4BAAA;EAAA,+BAAA;AvF2vVd;;AuFrwVQ;EAUM,yBAAA;AvF+vVd;;AuFzwVQ;EAUM,+BAAA;AvFmwVd;;AuF7wVQ;EAUM,8BAAA;AvFuwVd;;AuFjxVQ;EAUM,4BAAA;AvF2wVd;;AuFrxVQ;EAUM,8BAAA;AvF+wVd;;AuFzxVQ;EAUM,4BAAA;AvFmxVd;;AQh2VI;EAgCE,2BAAA;ARo0VN;AQ51VI;EA+BI,0BAAA;ARg0VR;;AQv2VI;EAgCE,iCAAA;AR20VN;AQn2VI;EA+BI,gCAAA;ARu0VR;;AQ92VI;EAgCE,gCAAA;ARk1VN;AQ12VI;EA+BI,+BAAA;AR80VR;;AQr3VI;EAgCE,8BAAA;ARy1VN;AQj3VI;EA+BI,6BAAA;ARq1VR;;AQ53VI;EAgCE,gCAAA;ARg2VN;AQx3VI;EA+BI,+BAAA;AR41VR;;AQn4VI;EAgCE,8BAAA;ARu2VN;AQ/3VI;EA+BI,6BAAA;ARm2VR;;AuFv0VQ;EAUM,4BAAA;AvFi0Vd;;AuF30VQ;EAUM,kCAAA;AvFq0Vd;;AuF/0VQ;EAUM,iCAAA;AvFy0Vd;;AuFn1VQ;EAUM,+BAAA;AvF60Vd;;AuFv1VQ;EAUM,iCAAA;AvFi1Vd;;AuF31VQ;EAUM,+BAAA;AvFq1Vd;;AQl6VI;EAgCE,0BAAA;ARs4VN;AQ95VI;EA+BI,2BAAA;ARk4VR;;AQz6VI;EAgCE,gCAAA;AR64VN;AQr6VI;EA+BI,iCAAA;ARy4VR;;AQh7VI;EAgCE,+BAAA;ARo5VN;AQ56VI;EA+BI,gCAAA;ARg5VR;;AQv7VI;EAgCE,6BAAA;AR25VN;AQn7VI;EA+BI,8BAAA;ARu5VR;;AQ97VI;EAgCE,+BAAA;ARk6VN;AQ17VI;EA+BI,gCAAA;AR85VR;;AQr8VI;EAgCE,6BAAA;ARy6VN;AQj8VI;EA+BI,8BAAA;ARq6VR;;AuFz4VQ;EAUM,iBAAA;AvFm4Vd;;AuF74VQ;EAUM,uBAAA;AvFu4Vd;;AuFj5VQ;EAUM,sBAAA;AvF24Vd;;AuFr5VQ;EAUM,oBAAA;AvF+4Vd;;AuFz5VQ;EAUM,sBAAA;AvFm5Vd;;AuF75VQ;EAUM,oBAAA;AvFu5Vd;;AuFj6VQ;EAUM,qBAAA;AvF25Vd;;AuFr6VQ;EAUM,2BAAA;AvF+5Vd;;AuFz6VQ;EAUM,0BAAA;AvFm6Vd;;AuF76VQ;EAUM,wBAAA;AvFu6Vd;;AuFj7VQ;EAUM,0BAAA;AvF26Vd;;AuFr7VQ;EAUM,wBAAA;AvF+6Vd;;AuFz7VQ;EAUM,wBAAA;AvFm7Vd;;AuF77VQ;EAUM,8BAAA;AvFu7Vd;;AuFj8VQ;EAUM,6BAAA;AvF27Vd;;AuFr8VQ;EAUM,2BAAA;AvF+7Vd;;AuFz8VQ;EAUM,6BAAA;AvFm8Vd;;AuF78VQ;EAUM,2BAAA;AvFu8Vd;;AuFj9VQ;EAUM,iDAAA;AvF28Vd;;AuFr9VQ;EAUM,gDAAA;AvF+8Vd;;AuFz9VQ;EAUM,0CAAA;AvFm9Vd;;AuF79VQ;EAUM,kDAAA;AvFu9Vd;;AuFj+VQ;EAUM,gDAAA;AvF29Vd;;AuFr+VQ;EAUM,gCAAA;AvF+9Vd;;AuFz+VQ;EAUM,8BAAA;AvFm+Vd;;AuF7+VQ;EAUM,6BAAA;AvFu+Vd;;AuFj/VQ;EAUM,6BAAA;AvF2+Vd;;AuFr/VQ;EAUM,+BAAA;AvF++Vd;;AuFz/VQ;EAUM,2BAAA;AvFm/Vd;;AuF7/VQ;EAUM,2BAAA;AvFu/Vd;;AuFjgWQ;EAUM,2BAAA;AvF2/Vd;;AuFrgWQ;EAUM,2BAAA;AvF+/Vd;;AuFzgWQ;EAUM,2BAAA;AvFmgWd;;AuF7gWQ;EAUM,8BAAA;AvFugWd;;AuFjhWQ;EAUM,yBAAA;AvF2gWd;;AuFrhWQ;EAUM,4BAAA;AvF+gWd;;AuFzhWQ;EAUM,2BAAA;AvFmhWd;;AuF7hWQ;EAUM,yBAAA;AvFuhWd;;AQpmWI;EAgCE,2BAAA;ARwkWN;AQhmWI;EA+BI,4BAAA;ARokWR;;AQ3mWI;EAgCE,4BAAA;AR+kWN;AQvmWI;EA+BI,2BAAA;AR2kWR;;AQlnWI;EAgCE,6BAAA;ARslWN;AQ9mWI;EA+BI,6BAAA;ARklWR;;AuFtjWQ;EAUM,gCAAA;AvFgjWd;;AuF1jWQ;EAUM,qCAAA;AvFojWd;;AuF9jWQ;EAUM,wCAAA;AvFwjWd;;AuFlkWQ;EAUM,oCAAA;AvF4jWd;;AuFtkWQ;EAUM,oCAAA;AvFgkWd;;AuF1kWQ;EAUM,qCAAA;AvFokWd;;AuF9kWQ;EAUM,8BAAA;AvFwkWd;;AuFllWQ;EAUM,8BAAA;AvF4kWd;;AuFpmWQ,qBAAA;AAcA;EAUM,gCAAA;EAAA,iCAAA;AvFklWd;;AuF9jWQ,mBAAA;AA9BA;EAIQ,qBAAA;EAMF,uEAAA;AvFwlWd;;AuFlmWQ;EAIQ,qBAAA;EAMF,yEAAA;AvF6lWd;;AuFvmWQ;EAIQ,qBAAA;EAMF,uEAAA;AvFkmWd;;AuF5mWQ;EAIQ,qBAAA;EAMF,oEAAA;AvFumWd;;AuFjnWQ;EAIQ,qBAAA;EAMF,uEAAA;AvF4mWd;;AuFtnWQ;EAIQ,qBAAA;EAMF,sEAAA;AvFinWd;;AuF3nWQ;EAIQ,qBAAA;EAMF,qEAAA;AvFsnWd;;AuFhoWQ;EAIQ,qBAAA;EAMF,oEAAA;AvF2nWd;;AuFroWQ;EAIQ,qBAAA;EAMF,qEAAA;AvFgoWd;;AuF1oWQ;EAIQ,qBAAA;EAMF,qEAAA;AvFqoWd;;AuF/oWQ;EAIQ,qBAAA;EAMF,0EAAA;AvF0oWd;;AuFppWQ;EAIQ,qBAAA;EAMF,4CAAA;AvF+oWd;;AuFzpWQ;EAIQ,qBAAA;EAMF,qCAAA;AvFopWd;;AuF9pWQ;EAIQ,qBAAA;EAMF,0CAAA;AvFypWd;;AuFnqWQ;EAIQ,qBAAA;EAMF,4CAAA;AvF8pWd;;AuFxqWQ;EAIQ,qBAAA;EAMF,2CAAA;AvFmqWd;;AuF7qWQ;EAIQ,qBAAA;EAMF,2CAAA;AvFwqWd;;AuFlrWQ;EAIQ,qBAAA;EAMF,yBAAA;AvF6qWd;;AuFvrWQ;EAIQ,qBAAA;EAMF,kDAAA;AvFkrWd;;AuF5rWQ;EAIQ,qBAAA;EAMF,oDAAA;AvFurWd;;AuFjsWQ;EAIQ,qBAAA;EAMF,6CAAA;AvF4rWd;;AuFtsWQ;EAIQ,qBAAA;EAMF,0CAAA;AvFisWd;;AuF3sWQ;EAIQ,qBAAA;EAMF,4CAAA;AvFssWd;;AuFhtWQ;EAIQ,qBAAA;EAMF,qCAAA;AvF2sWd;;AuF/tWQ;EACE,wBAAA;AvFkuWV;;AuFnuWQ;EACE,uBAAA;AvFsuWV;;AuFvuWQ;EACE,wBAAA;AvF0uWV;;AuF3uWQ;EACE,qBAAA;AvF8uWV;;AuF/uWQ;EACE,uBAAA;AvFkvWV;;AuF9uWU;EACE,uBAAA;AvFivWZ;;AuFvvWQ;EACE,wBAAA;AvF0vWV;;AuFtvWU;EACE,wBAAA;AvFyvWZ;;AuF/vWQ;EACE,uBAAA;AvFkwWV;;AuF9vWU;EACE,uBAAA;AvFiwWZ;;AuFvwWQ;EACE,wBAAA;AvF0wWV;;AuFtwWU;EACE,wBAAA;AvFywWZ;;AuF/wWQ;EACE,qBAAA;AvFkxWV;;AuF9wWU;EACE,qBAAA;AvFixWZ;;AuF7wWQ;EAUM,yCAAA;AvFuwWd;;AuFjwWU;EAOI,yCAAA;AvF8vWd;;AuFrxWQ;EAUM,wCAAA;AvF+wWd;;AuFzwWU;EAOI,wCAAA;AvFswWd;;AuF7xWQ;EAUM,yCAAA;AvFuxWd;;AuFjxWU;EAOI,yCAAA;AvF8wWd;;AuFryWQ;EAIQ,+BAAA;EAMF,iGAAA;AvFgyWd;;AuF1yWQ;EAIQ,+BAAA;EAMF,mGAAA;AvFqyWd;;AuF/yWQ;EAIQ,+BAAA;EAMF,iGAAA;AvF0yWd;;AuFpzWQ;EAIQ,+BAAA;EAMF,8FAAA;AvF+yWd;;AuFzzWQ;EAIQ,+BAAA;EAMF,iGAAA;AvFozWd;;AuF9zWQ;EAIQ,+BAAA;EAMF,gGAAA;AvFyzWd;;AuFn0WQ;EAIQ,+BAAA;EAMF,+FAAA;AvF8zWd;;AuFx0WQ;EAIQ,+BAAA;EAMF,8FAAA;AvFm0Wd;;AuF70WQ;EAIQ,+BAAA;EAMF,uGAAA;AvFw0Wd;;AuF51WQ;EACE,+BAAA;AvF+1WV;;AuF31WU;EACE,+BAAA;AvF81WZ;;AuFp2WQ;EACE,iCAAA;AvFu2WV;;AuFn2WU;EACE,iCAAA;AvFs2WZ;;AuF52WQ;EACE,kCAAA;AvF+2WV;;AuF32WU;EACE,kCAAA;AvF82WZ;;AuFp3WQ;EACE,iCAAA;AvFu3WV;;AuFn3WU;EACE,iCAAA;AvFs3WZ;;AuF53WQ;EACE,kCAAA;AvF+3WV;;AuF33WU;EACE,kCAAA;AvF83WZ;;AuFp4WQ;EACE,+BAAA;AvFu4WV;;AuFn4WU;EACE,+BAAA;AvFs4WZ;;AuFl4WQ;EAIQ,mBAAA;EAMF,gFAAA;AvF63Wd;;AuFv4WQ;EAIQ,mBAAA;EAMF,kFAAA;AvFk4Wd;;AuF54WQ;EAIQ,mBAAA;EAMF,gFAAA;AvFu4Wd;;AuFj5WQ;EAIQ,mBAAA;EAMF,6EAAA;AvF44Wd;;AuFt5WQ;EAIQ,mBAAA;EAMF,gFAAA;AvFi5Wd;;AuF35WQ;EAIQ,mBAAA;EAMF,+EAAA;AvFs5Wd;;AuFh6WQ;EAIQ,mBAAA;EAMF,8EAAA;AvF25Wd;;AuFr6WQ;EAIQ,mBAAA;EAMF,6EAAA;AvFg6Wd;;AuF16WQ;EAIQ,mBAAA;EAMF,8EAAA;AvFq6Wd;;AuF/6WQ;EAIQ,mBAAA;EAMF,8EAAA;AvF06Wd;;AuFp7WQ;EAIQ,mBAAA;EAMF,gFAAA;AvF+6Wd;;AuFz7WQ;EAIQ,mBAAA;EAMF,wCAAA;AvFo7Wd;;AuF97WQ;EAIQ,mBAAA;EAMF,qFAAA;AvFy7Wd;;AuFn8WQ;EAIQ,mBAAA;EAMF,oFAAA;AvF87Wd;;AuFl9WQ;EACE,qBAAA;AvFq9WV;;AuFt9WQ;EACE,sBAAA;AvFy9WV;;AuF19WQ;EACE,qBAAA;AvF69WV;;AuF99WQ;EACE,sBAAA;AvFi+WV;;AuFl+WQ;EACE,mBAAA;AvFq+WV;;AuF59WQ;EAUM,gDAAA;AvFs9Wd;;AuFh+WQ;EAUM,mCAAA;UAAA,2BAAA;AvF09Wd;;AuFp+WQ;EAUM,oCAAA;UAAA,4BAAA;AvF89Wd;;AuFx+WQ;EAUM,oCAAA;UAAA,4BAAA;AvFk+Wd;;AuF5+WQ;EAUM,+BAAA;AvFs+Wd;;AuFh/WQ;EAUM,+BAAA;AvF0+Wd;;AuFp/WQ;EAUM,kDAAA;AvF8+Wd;;AuFx/WQ;EAUM,2BAAA;AvFk/Wd;;AuF5/WQ;EAUM,qDAAA;AvFs/Wd;;AuFhgXQ;EAUM,kDAAA;AvF0/Wd;;AuFpgXQ;EAUM,qDAAA;AvF8/Wd;;AuFxgXQ;EAUM,qDAAA;AvFkgXd;;AuF5gXQ;EAUM,sDAAA;AvFsgXd;;AuFhhXQ;EAUM,6BAAA;AvF0gXd;;AuFphXQ;EAUM,uDAAA;AvF8gXd;;AuFxhXQ;EAUM,2DAAA;EAAA,4DAAA;AvFmhXd;;AuF7hXQ;EAUM,oCAAA;EAAA,qCAAA;AvFwhXd;;AuFliXQ;EAUM,8DAAA;EAAA,+DAAA;AvF6hXd;;AuFviXQ;EAUM,2DAAA;EAAA,4DAAA;AvFkiXd;;AuF5iXQ;EAUM,8DAAA;EAAA,+DAAA;AvFuiXd;;AuFjjXQ;EAUM,8DAAA;EAAA,+DAAA;AvF4iXd;;AuFtjXQ;EAUM,+DAAA;EAAA,gEAAA;AvFijXd;;AuF3jXQ;EAUM,sCAAA;EAAA,uCAAA;AvFsjXd;;AuFhkXQ;EAUM,gEAAA;EAAA,iEAAA;AvF2jXd;;AQxoXI;EAgCE,4DAAA;AR4mXN;AQpoXI;EA+BI,2DAAA;ARwmXR;AQ/oXI;EAgCE,+DAAA;ARknXN;AQ1oXI;EA+BI,8DAAA;AR8mXR;;AQrpXI;EAgCE,qCAAA;ARynXN;AQjpXI;EA+BI,oCAAA;ARqnXR;AQ5pXI;EAgCE,wCAAA;AR+nXN;AQvpXI;EA+BI,uCAAA;AR2nXR;;AQlqXI;EAgCE,+DAAA;ARsoXN;AQ9pXI;EA+BI,8DAAA;ARkoXR;AQzqXI;EAgCE,kEAAA;AR4oXN;AQpqXI;EA+BI,iEAAA;ARwoXR;;AQ/qXI;EAgCE,4DAAA;ARmpXN;AQ3qXI;EA+BI,2DAAA;AR+oXR;AQtrXI;EAgCE,+DAAA;ARypXN;AQjrXI;EA+BI,8DAAA;ARqpXR;;AQ5rXI;EAgCE,+DAAA;ARgqXN;AQxrXI;EA+BI,8DAAA;AR4pXR;AQnsXI;EAgCE,kEAAA;ARsqXN;AQ9rXI;EA+BI,iEAAA;ARkqXR;;AQzsXI;EAgCE,+DAAA;AR6qXN;AQrsXI;EA+BI,8DAAA;ARyqXR;AQhtXI;EAgCE,kEAAA;ARmrXN;AQ3sXI;EA+BI,iEAAA;AR+qXR;;AQttXI;EAgCE,gEAAA;AR0rXN;AQltXI;EA+BI,+DAAA;ARsrXR;AQ7tXI;EAgCE,mEAAA;ARgsXN;AQxtXI;EA+BI,kEAAA;AR4rXR;;AQnuXI;EAgCE,uCAAA;ARusXN;AQ/tXI;EA+BI,sCAAA;ARmsXR;AQ1uXI;EAgCE,0CAAA;AR6sXN;AQruXI;EA+BI,yCAAA;ARysXR;;AQhvXI;EAgCE,iEAAA;ARotXN;AQ5uXI;EA+BI,gEAAA;ARgtXR;AQvvXI;EAgCE,oEAAA;AR0tXN;AQlvXI;EA+BI,mEAAA;ARstXR;;AuF1rXQ;EAUM,+DAAA;EAAA,8DAAA;AvFqrXd;;AuF/rXQ;EAUM,wCAAA;EAAA,uCAAA;AvF0rXd;;AuFpsXQ;EAUM,kEAAA;EAAA,iEAAA;AvF+rXd;;AuFzsXQ;EAUM,+DAAA;EAAA,8DAAA;AvFosXd;;AuF9sXQ;EAUM,kEAAA;EAAA,iEAAA;AvFysXd;;AuFntXQ;EAUM,kEAAA;EAAA,iEAAA;AvF8sXd;;AuFxtXQ;EAUM,mEAAA;EAAA,kEAAA;AvFmtXd;;AuF7tXQ;EAUM,0CAAA;EAAA,yCAAA;AvFwtXd;;AuFluXQ;EAUM,oEAAA;EAAA,mEAAA;AvF6tXd;;AQ1yXI;EAgCE,8DAAA;AR8wXN;AQtyXI;EA+BI,+DAAA;AR0wXR;AQjzXI;EAgCE,2DAAA;ARoxXN;AQ5yXI;EA+BI,4DAAA;ARgxXR;;AQvzXI;EAgCE,uCAAA;AR2xXN;AQnzXI;EA+BI,wCAAA;ARuxXR;AQ9zXI;EAgCE,oCAAA;ARiyXN;AQzzXI;EA+BI,qCAAA;AR6xXR;;AQp0XI;EAgCE,iEAAA;ARwyXN;AQh0XI;EA+BI,kEAAA;ARoyXR;AQ30XI;EAgCE,8DAAA;AR8yXN;AQt0XI;EA+BI,+DAAA;AR0yXR;;AQj1XI;EAgCE,8DAAA;ARqzXN;AQ70XI;EA+BI,+DAAA;ARizXR;AQx1XI;EAgCE,2DAAA;AR2zXN;AQn1XI;EA+BI,4DAAA;ARuzXR;;AQ91XI;EAgCE,iEAAA;ARk0XN;AQ11XI;EA+BI,kEAAA;AR8zXR;AQr2XI;EAgCE,8DAAA;ARw0XN;AQh2XI;EA+BI,+DAAA;ARo0XR;;AQ32XI;EAgCE,iEAAA;AR+0XN;AQv2XI;EA+BI,kEAAA;AR20XR;AQl3XI;EAgCE,8DAAA;ARq1XN;AQ72XI;EA+BI,+DAAA;ARi1XR;;AQx3XI;EAgCE,kEAAA;AR41XN;AQp3XI;EA+BI,mEAAA;ARw1XR;AQ/3XI;EAgCE,+DAAA;ARk2XN;AQ13XI;EA+BI,gEAAA;AR81XR;;AQr4XI;EAgCE,yCAAA;ARy2XN;AQj4XI;EA+BI,0CAAA;ARq2XR;AQ54XI;EAgCE,sCAAA;AR+2XN;AQv4XI;EA+BI,uCAAA;AR22XR;;AQl5XI;EAgCE,mEAAA;ARs3XN;AQ94XI;EA+BI,oEAAA;ARk3XR;AQz5XI;EAgCE,gEAAA;AR43XN;AQp5XI;EA+BI,iEAAA;ARw3XR;;AuF51XQ;EAUM,8BAAA;AvFs1Xd;;AuFh2XQ;EAUM,6BAAA;AvF01Xd;;AuFp2XQ;EAUM,sBAAA;AvF81Xd;;AuFx2XQ;EAUM,qBAAA;AvFk2Xd;;AuF52XQ;EAUM,qBAAA;AvFs2Xd;;AuFh3XQ;EAUM,qBAAA;AvF02Xd;;AuFp3XQ;EAUM,qBAAA;AvF82Xd;;AiB93XI;ET7DA;IAgCE,sBAAA;ERg6XJ;EQx7XE;IA+BI,uBAAA;ER45XN;EQn8XE;IAgCE,uBAAA;ERs6XJ;EQ97XE;IA+BI,sBAAA;ERk6XN;EQz8XE;IAgCE,sBAAA;ER46XJ;EQp8XE;IA+BI,sBAAA;ERw6XN;EuF54XM;IAUM,8BAAA;EvFq4XZ;EuF/4XM;IAUM,4BAAA;EvFw4XZ;EuFl5XM;IAUM,2BAAA;EvF24XZ;EuFr5XM;IAUM,iCAAA;EvF84XZ;EuFx5XM;IAUM,2BAAA;EvFi5XZ;EuF35XM;IAUM,0BAAA;EvFo5XZ;EuF95XM;IAUM,gCAAA;EvFu5XZ;EuFj6XM;IAUM,yBAAA;EvF05XZ;EuFp6XM;IAUM,wBAAA;EvF65XZ;EuFv6XM;IAUM,+BAAA;EvFg6XZ;EuF16XM;IAUM,yBAAA;EvFm6XZ;EuF76XM;IAUM,6BAAA;EvFs6XZ;EuFh7XM;IAUM,8BAAA;EvFy6XZ;EuFn7XM;IAUM,wBAAA;EvF46XZ;EuFt7XM;IAUM,+BAAA;EvF+6XZ;EuFz7XM;IAUM,wBAAA;EvFk7XZ;EuF57XM;IAUM,yBAAA;EvFq7XZ;EuF/7XM;IAUM,8BAAA;EvFw7XZ;EuFl8XM;IAUM,iCAAA;EvF27XZ;EuFr8XM;IAUM,sCAAA;EvF87XZ;EuFx8XM;IAUM,yCAAA;EvFi8XZ;EuF38XM;IAUM,uBAAA;EvFo8XZ;EuF98XM;IAUM,uBAAA;EvFu8XZ;EuFj9XM;IAUM,yBAAA;EvF08XZ;EuFp9XM;IAUM,yBAAA;EvF68XZ;EuFv9XM;IAUM,0BAAA;EvFg9XZ;EuF19XM;IAUM,4BAAA;EvFm9XZ;EuF79XM;IAUM,kCAAA;EvFs9XZ;EuFh+XM;IAUM,sCAAA;EvFy9XZ;EuFn+XM;IAUM,oCAAA;EvF49XZ;EuFt+XM;IAUM,kCAAA;EvF+9XZ;EuFz+XM;IAUM,yCAAA;EvFk+XZ;EuF5+XM;IAUM,wCAAA;EvFq+XZ;EuF/+XM;IAUM,wCAAA;EvFw+XZ;EuFl/XM;IAUM,kCAAA;EvF2+XZ;EuFr/XM;IAUM,gCAAA;EvF8+XZ;EuFx/XM;IAUM,8BAAA;EvFi/XZ;EuF3/XM;IAUM,gCAAA;EvFo/XZ;EuF9/XM;IAUM,+BAAA;EvFu/XZ;EuFjgYM;IAUM,oCAAA;EvF0/XZ;EuFpgYM;IAUM,kCAAA;EvF6/XZ;EuFvgYM;IAUM,gCAAA;EvFggYZ;EuF1gYM;IAUM,uCAAA;EvFmgYZ;EuF7gYM;IAUM,sCAAA;EvFsgYZ;EuFhhYM;IAUM,iCAAA;EvFygYZ;EuFnhYM;IAUM,2BAAA;EvF4gYZ;EuFthYM;IAUM,iCAAA;EvF+gYZ;EuFzhYM;IAUM,+BAAA;EvFkhYZ;EuF5hYM;IAUM,6BAAA;EvFqhYZ;EuF/hYM;IAUM,+BAAA;EvFwhYZ;EuFliYM;IAUM,8BAAA;EvF2hYZ;EuFriYM;IAUM,oBAAA;EvF8hYZ;EuFxiYM;IAUM,mBAAA;EvFiiYZ;EuF3iYM;IAUM,mBAAA;EvFoiYZ;EuF9iYM;IAUM,mBAAA;EvFuiYZ;EuFjjYM;IAUM,mBAAA;EvF0iYZ;EuFpjYM;IAUM,mBAAA;EvF6iYZ;EuFvjYM;IAUM,mBAAA;EvFgjYZ;EuF1jYM;IAUM,mBAAA;EvFmjYZ;EuF7jYM;IAUM,oBAAA;EvFsjYZ;EuFhkYM;IAUM,0BAAA;EvFyjYZ;EuFnkYM;IAUM,yBAAA;EvF4jYZ;EuFtkYM;IAUM,uBAAA;EvF+jYZ;EuFzkYM;IAUM,yBAAA;EvFkkYZ;EuF5kYM;IAUM,uBAAA;EvFqkYZ;EuF/kYM;IAUM,uBAAA;EvFwkYZ;EuFllYM;IAUM,0BAAA;IAAA,yBAAA;EvF4kYZ;EuFtlYM;IAUM,gCAAA;IAAA,+BAAA;EvFglYZ;EuF1lYM;IAUM,+BAAA;IAAA,8BAAA;EvFolYZ;EuF9lYM;IAUM,6BAAA;IAAA,4BAAA;EvFwlYZ;EuFlmYM;IAUM,+BAAA;IAAA,8BAAA;EvF4lYZ;EuFtmYM;IAUM,6BAAA;IAAA,4BAAA;EvFgmYZ;EuF1mYM;IAUM,6BAAA;IAAA,4BAAA;EvFomYZ;EuF9mYM;IAUM,wBAAA;IAAA,2BAAA;EvFwmYZ;EuFlnYM;IAUM,8BAAA;IAAA,iCAAA;EvF4mYZ;EuFtnYM;IAUM,6BAAA;IAAA,gCAAA;EvFgnYZ;EuF1nYM;IAUM,2BAAA;IAAA,8BAAA;EvFonYZ;EuF9nYM;IAUM,6BAAA;IAAA,gCAAA;EvFwnYZ;EuFloYM;IAUM,2BAAA;IAAA,8BAAA;EvF4nYZ;EuFtoYM;IAUM,2BAAA;IAAA,8BAAA;EvFgoYZ;EuF1oYM;IAUM,wBAAA;EvFmoYZ;EuF7oYM;IAUM,8BAAA;EvFsoYZ;EuFhpYM;IAUM,6BAAA;EvFyoYZ;EuFnpYM;IAUM,2BAAA;EvF4oYZ;EuFtpYM;IAUM,6BAAA;EvF+oYZ;EuFzpYM;IAUM,2BAAA;EvFkpYZ;EuF5pYM;IAUM,2BAAA;EvFqpYZ;EQluYE;IAgCE,0BAAA;ERqsYJ;EQ7tYE;IA+BI,yBAAA;ERisYN;EQxuYE;IAgCE,gCAAA;ER2sYJ;EQnuYE;IA+BI,+BAAA;ERusYN;EQ9uYE;IAgCE,+BAAA;ERitYJ;EQzuYE;IA+BI,8BAAA;ER6sYN;EQpvYE;IAgCE,6BAAA;ERutYJ;EQ/uYE;IA+BI,4BAAA;ERmtYN;EQ1vYE;IAgCE,+BAAA;ER6tYJ;EQrvYE;IA+BI,8BAAA;ERytYN;EQhwYE;IAgCE,6BAAA;ERmuYJ;EQ3vYE;IA+BI,4BAAA;ER+tYN;EQtwYE;IAgCE,6BAAA;ERyuYJ;EQjwYE;IA+BI,4BAAA;ERquYN;EuFzsYM;IAUM,2BAAA;EvFksYZ;EuF5sYM;IAUM,iCAAA;EvFqsYZ;EuF/sYM;IAUM,gCAAA;EvFwsYZ;EuFltYM;IAUM,8BAAA;EvF2sYZ;EuFrtYM;IAUM,gCAAA;EvF8sYZ;EuFxtYM;IAUM,8BAAA;EvFitYZ;EuF3tYM;IAUM,8BAAA;EvFotYZ;EQjyYE;IAgCE,yBAAA;ERowYJ;EQ5xYE;IA+BI,0BAAA;ERgwYN;EQvyYE;IAgCE,+BAAA;ER0wYJ;EQlyYE;IA+BI,gCAAA;ERswYN;EQ7yYE;IAgCE,8BAAA;ERgxYJ;EQxyYE;IA+BI,+BAAA;ER4wYN;EQnzYE;IAgCE,4BAAA;ERsxYJ;EQ9yYE;IA+BI,6BAAA;ERkxYN;EQzzYE;IAgCE,8BAAA;ER4xYJ;EQpzYE;IA+BI,+BAAA;ERwxYN;EQ/zYE;IAgCE,4BAAA;ERkyYJ;EQ1zYE;IA+BI,6BAAA;ER8xYN;EQr0YE;IAgCE,4BAAA;ERwyYJ;EQh0YE;IA+BI,6BAAA;ERoyYN;EuFxwYM;IAUM,qBAAA;EvFiwYZ;EuF3wYM;IAUM,2BAAA;EvFowYZ;EuF9wYM;IAUM,0BAAA;EvFuwYZ;EuFjxYM;IAUM,wBAAA;EvF0wYZ;EuFpxYM;IAUM,0BAAA;EvF6wYZ;EuFvxYM;IAUM,wBAAA;EvFgxYZ;EuF1xYM;IAUM,2BAAA;IAAA,0BAAA;EvFoxYZ;EuF9xYM;IAUM,iCAAA;IAAA,gCAAA;EvFwxYZ;EuFlyYM;IAUM,gCAAA;IAAA,+BAAA;EvF4xYZ;EuFtyYM;IAUM,8BAAA;IAAA,6BAAA;EvFgyYZ;EuF1yYM;IAUM,gCAAA;IAAA,+BAAA;EvFoyYZ;EuF9yYM;IAUM,8BAAA;IAAA,6BAAA;EvFwyYZ;EuFlzYM;IAUM,yBAAA;IAAA,4BAAA;EvF4yYZ;EuFtzYM;IAUM,+BAAA;IAAA,kCAAA;EvFgzYZ;EuF1zYM;IAUM,8BAAA;IAAA,iCAAA;EvFozYZ;EuF9zYM;IAUM,4BAAA;IAAA,+BAAA;EvFwzYZ;EuFl0YM;IAUM,8BAAA;IAAA,iCAAA;EvF4zYZ;EuFt0YM;IAUM,4BAAA;IAAA,+BAAA;EvFg0YZ;EuF10YM;IAUM,yBAAA;EvFm0YZ;EuF70YM;IAUM,+BAAA;EvFs0YZ;EuFh1YM;IAUM,8BAAA;EvFy0YZ;EuFn1YM;IAUM,4BAAA;EvF40YZ;EuFt1YM;IAUM,8BAAA;EvF+0YZ;EuFz1YM;IAUM,4BAAA;EvFk1YZ;EQ/5YE;IAgCE,2BAAA;ERk4YJ;EQ15YE;IA+BI,0BAAA;ER83YN;EQr6YE;IAgCE,iCAAA;ERw4YJ;EQh6YE;IA+BI,gCAAA;ERo4YN;EQ36YE;IAgCE,gCAAA;ER84YJ;EQt6YE;IA+BI,+BAAA;ER04YN;EQj7YE;IAgCE,8BAAA;ERo5YJ;EQ56YE;IA+BI,6BAAA;ERg5YN;EQv7YE;IAgCE,gCAAA;ER05YJ;EQl7YE;IA+BI,+BAAA;ERs5YN;EQ77YE;IAgCE,8BAAA;ERg6YJ;EQx7YE;IA+BI,6BAAA;ER45YN;EuFh4YM;IAUM,4BAAA;EvFy3YZ;EuFn4YM;IAUM,kCAAA;EvF43YZ;EuFt4YM;IAUM,iCAAA;EvF+3YZ;EuFz4YM;IAUM,+BAAA;EvFk4YZ;EuF54YM;IAUM,iCAAA;EvFq4YZ;EuF/4YM;IAUM,+BAAA;EvFw4YZ;EQr9YE;IAgCE,0BAAA;ERw7YJ;EQh9YE;IA+BI,2BAAA;ERo7YN;EQ39YE;IAgCE,gCAAA;ER87YJ;EQt9YE;IA+BI,iCAAA;ER07YN;EQj+YE;IAgCE,+BAAA;ERo8YJ;EQ59YE;IA+BI,gCAAA;ERg8YN;EQv+YE;IAgCE,6BAAA;ER08YJ;EQl+YE;IA+BI,8BAAA;ERs8YN;EQ7+YE;IAgCE,+BAAA;ERg9YJ;EQx+YE;IA+BI,gCAAA;ER48YN;EQn/YE;IAgCE,6BAAA;ERs9YJ;EQ9+YE;IA+BI,8BAAA;ERk9YN;EuFt7YM;IAUM,iBAAA;EvF+6YZ;EuFz7YM;IAUM,uBAAA;EvFk7YZ;EuF57YM;IAUM,sBAAA;EvFq7YZ;EuF/7YM;IAUM,oBAAA;EvFw7YZ;EuFl8YM;IAUM,sBAAA;EvF27YZ;EuFr8YM;IAUM,oBAAA;EvF87YZ;EuFx8YM;IAUM,qBAAA;EvFi8YZ;EuF38YM;IAUM,2BAAA;EvFo8YZ;EuF98YM;IAUM,0BAAA;EvFu8YZ;EuFj9YM;IAUM,wBAAA;EvF08YZ;EuFp9YM;IAUM,0BAAA;EvF68YZ;EuFv9YM;IAUM,wBAAA;EvFg9YZ;EuF19YM;IAUM,wBAAA;EvFm9YZ;EuF79YM;IAUM,8BAAA;EvFs9YZ;EuFh+YM;IAUM,6BAAA;EvFy9YZ;EuFn+YM;IAUM,2BAAA;EvF49YZ;EuFt+YM;IAUM,6BAAA;EvF+9YZ;EuFz+YM;IAUM,2BAAA;EvFk+YZ;EQ/iZE;IAgCE,2BAAA;ERkhZJ;EQ1iZE;IA+BI,4BAAA;ER8gZN;EQrjZE;IAgCE,4BAAA;ERwhZJ;EQhjZE;IA+BI,2BAAA;ERohZN;EQ3jZE;IAgCE,6BAAA;ER8hZJ;EQtjZE;IA+BI,6BAAA;ER0hZN;AACF;AiBrgZI;ET7DA;IAgCE,sBAAA;ERsiZJ;EQ9jZE;IA+BI,uBAAA;ERkiZN;EQzkZE;IAgCE,uBAAA;ER4iZJ;EQpkZE;IA+BI,sBAAA;ERwiZN;EQ/kZE;IAgCE,sBAAA;ERkjZJ;EQ1kZE;IA+BI,sBAAA;ER8iZN;EuFlhZM;IAUM,8BAAA;EvF2gZZ;EuFrhZM;IAUM,4BAAA;EvF8gZZ;EuFxhZM;IAUM,2BAAA;EvFihZZ;EuF3hZM;IAUM,iCAAA;EvFohZZ;EuF9hZM;IAUM,2BAAA;EvFuhZZ;EuFjiZM;IAUM,0BAAA;EvF0hZZ;EuFpiZM;IAUM,gCAAA;EvF6hZZ;EuFviZM;IAUM,yBAAA;EvFgiZZ;EuF1iZM;IAUM,wBAAA;EvFmiZZ;EuF7iZM;IAUM,+BAAA;EvFsiZZ;EuFhjZM;IAUM,yBAAA;EvFyiZZ;EuFnjZM;IAUM,6BAAA;EvF4iZZ;EuFtjZM;IAUM,8BAAA;EvF+iZZ;EuFzjZM;IAUM,wBAAA;EvFkjZZ;EuF5jZM;IAUM,+BAAA;EvFqjZZ;EuF/jZM;IAUM,wBAAA;EvFwjZZ;EuFlkZM;IAUM,yBAAA;EvF2jZZ;EuFrkZM;IAUM,8BAAA;EvF8jZZ;EuFxkZM;IAUM,iCAAA;EvFikZZ;EuF3kZM;IAUM,sCAAA;EvFokZZ;EuF9kZM;IAUM,yCAAA;EvFukZZ;EuFjlZM;IAUM,uBAAA;EvF0kZZ;EuFplZM;IAUM,uBAAA;EvF6kZZ;EuFvlZM;IAUM,yBAAA;EvFglZZ;EuF1lZM;IAUM,yBAAA;EvFmlZZ;EuF7lZM;IAUM,0BAAA;EvFslZZ;EuFhmZM;IAUM,4BAAA;EvFylZZ;EuFnmZM;IAUM,kCAAA;EvF4lZZ;EuFtmZM;IAUM,sCAAA;EvF+lZZ;EuFzmZM;IAUM,oCAAA;EvFkmZZ;EuF5mZM;IAUM,kCAAA;EvFqmZZ;EuF/mZM;IAUM,yCAAA;EvFwmZZ;EuFlnZM;IAUM,wCAAA;EvF2mZZ;EuFrnZM;IAUM,wCAAA;EvF8mZZ;EuFxnZM;IAUM,kCAAA;EvFinZZ;EuF3nZM;IAUM,gCAAA;EvFonZZ;EuF9nZM;IAUM,8BAAA;EvFunZZ;EuFjoZM;IAUM,gCAAA;EvF0nZZ;EuFpoZM;IAUM,+BAAA;EvF6nZZ;EuFvoZM;IAUM,oCAAA;EvFgoZZ;EuF1oZM;IAUM,kCAAA;EvFmoZZ;EuF7oZM;IAUM,gCAAA;EvFsoZZ;EuFhpZM;IAUM,uCAAA;EvFyoZZ;EuFnpZM;IAUM,sCAAA;EvF4oZZ;EuFtpZM;IAUM,iCAAA;EvF+oZZ;EuFzpZM;IAUM,2BAAA;EvFkpZZ;EuF5pZM;IAUM,iCAAA;EvFqpZZ;EuF/pZM;IAUM,+BAAA;EvFwpZZ;EuFlqZM;IAUM,6BAAA;EvF2pZZ;EuFrqZM;IAUM,+BAAA;EvF8pZZ;EuFxqZM;IAUM,8BAAA;EvFiqZZ;EuF3qZM;IAUM,oBAAA;EvFoqZZ;EuF9qZM;IAUM,mBAAA;EvFuqZZ;EuFjrZM;IAUM,mBAAA;EvF0qZZ;EuFprZM;IAUM,mBAAA;EvF6qZZ;EuFvrZM;IAUM,mBAAA;EvFgrZZ;EuF1rZM;IAUM,mBAAA;EvFmrZZ;EuF7rZM;IAUM,mBAAA;EvFsrZZ;EuFhsZM;IAUM,mBAAA;EvFyrZZ;EuFnsZM;IAUM,oBAAA;EvF4rZZ;EuFtsZM;IAUM,0BAAA;EvF+rZZ;EuFzsZM;IAUM,yBAAA;EvFksZZ;EuF5sZM;IAUM,uBAAA;EvFqsZZ;EuF/sZM;IAUM,yBAAA;EvFwsZZ;EuFltZM;IAUM,uBAAA;EvF2sZZ;EuFrtZM;IAUM,uBAAA;EvF8sZZ;EuFxtZM;IAUM,0BAAA;IAAA,yBAAA;EvFktZZ;EuF5tZM;IAUM,gCAAA;IAAA,+BAAA;EvFstZZ;EuFhuZM;IAUM,+BAAA;IAAA,8BAAA;EvF0tZZ;EuFpuZM;IAUM,6BAAA;IAAA,4BAAA;EvF8tZZ;EuFxuZM;IAUM,+BAAA;IAAA,8BAAA;EvFkuZZ;EuF5uZM;IAUM,6BAAA;IAAA,4BAAA;EvFsuZZ;EuFhvZM;IAUM,6BAAA;IAAA,4BAAA;EvF0uZZ;EuFpvZM;IAUM,wBAAA;IAAA,2BAAA;EvF8uZZ;EuFxvZM;IAUM,8BAAA;IAAA,iCAAA;EvFkvZZ;EuF5vZM;IAUM,6BAAA;IAAA,gCAAA;EvFsvZZ;EuFhwZM;IAUM,2BAAA;IAAA,8BAAA;EvF0vZZ;EuFpwZM;IAUM,6BAAA;IAAA,gCAAA;EvF8vZZ;EuFxwZM;IAUM,2BAAA;IAAA,8BAAA;EvFkwZZ;EuF5wZM;IAUM,2BAAA;IAAA,8BAAA;EvFswZZ;EuFhxZM;IAUM,wBAAA;EvFywZZ;EuFnxZM;IAUM,8BAAA;EvF4wZZ;EuFtxZM;IAUM,6BAAA;EvF+wZZ;EuFzxZM;IAUM,2BAAA;EvFkxZZ;EuF5xZM;IAUM,6BAAA;EvFqxZZ;EuF/xZM;IAUM,2BAAA;EvFwxZZ;EuFlyZM;IAUM,2BAAA;EvF2xZZ;EQx2ZE;IAgCE,0BAAA;ER20ZJ;EQn2ZE;IA+BI,yBAAA;ERu0ZN;EQ92ZE;IAgCE,gCAAA;ERi1ZJ;EQz2ZE;IA+BI,+BAAA;ER60ZN;EQp3ZE;IAgCE,+BAAA;ERu1ZJ;EQ/2ZE;IA+BI,8BAAA;ERm1ZN;EQ13ZE;IAgCE,6BAAA;ER61ZJ;EQr3ZE;IA+BI,4BAAA;ERy1ZN;EQh4ZE;IAgCE,+BAAA;ERm2ZJ;EQ33ZE;IA+BI,8BAAA;ER+1ZN;EQt4ZE;IAgCE,6BAAA;ERy2ZJ;EQj4ZE;IA+BI,4BAAA;ERq2ZN;EQ54ZE;IAgCE,6BAAA;ER+2ZJ;EQv4ZE;IA+BI,4BAAA;ER22ZN;EuF/0ZM;IAUM,2BAAA;EvFw0ZZ;EuFl1ZM;IAUM,iCAAA;EvF20ZZ;EuFr1ZM;IAUM,gCAAA;EvF80ZZ;EuFx1ZM;IAUM,8BAAA;EvFi1ZZ;EuF31ZM;IAUM,gCAAA;EvFo1ZZ;EuF91ZM;IAUM,8BAAA;EvFu1ZZ;EuFj2ZM;IAUM,8BAAA;EvF01ZZ;EQv6ZE;IAgCE,yBAAA;ER04ZJ;EQl6ZE;IA+BI,0BAAA;ERs4ZN;EQ76ZE;IAgCE,+BAAA;ERg5ZJ;EQx6ZE;IA+BI,gCAAA;ER44ZN;EQn7ZE;IAgCE,8BAAA;ERs5ZJ;EQ96ZE;IA+BI,+BAAA;ERk5ZN;EQz7ZE;IAgCE,4BAAA;ER45ZJ;EQp7ZE;IA+BI,6BAAA;ERw5ZN;EQ/7ZE;IAgCE,8BAAA;ERk6ZJ;EQ17ZE;IA+BI,+BAAA;ER85ZN;EQr8ZE;IAgCE,4BAAA;ERw6ZJ;EQh8ZE;IA+BI,6BAAA;ERo6ZN;EQ38ZE;IAgCE,4BAAA;ER86ZJ;EQt8ZE;IA+BI,6BAAA;ER06ZN;EuF94ZM;IAUM,qBAAA;EvFu4ZZ;EuFj5ZM;IAUM,2BAAA;EvF04ZZ;EuFp5ZM;IAUM,0BAAA;EvF64ZZ;EuFv5ZM;IAUM,wBAAA;EvFg5ZZ;EuF15ZM;IAUM,0BAAA;EvFm5ZZ;EuF75ZM;IAUM,wBAAA;EvFs5ZZ;EuFh6ZM;IAUM,2BAAA;IAAA,0BAAA;EvF05ZZ;EuFp6ZM;IAUM,iCAAA;IAAA,gCAAA;EvF85ZZ;EuFx6ZM;IAUM,gCAAA;IAAA,+BAAA;EvFk6ZZ;EuF56ZM;IAUM,8BAAA;IAAA,6BAAA;EvFs6ZZ;EuFh7ZM;IAUM,gCAAA;IAAA,+BAAA;EvF06ZZ;EuFp7ZM;IAUM,8BAAA;IAAA,6BAAA;EvF86ZZ;EuFx7ZM;IAUM,yBAAA;IAAA,4BAAA;EvFk7ZZ;EuF57ZM;IAUM,+BAAA;IAAA,kCAAA;EvFs7ZZ;EuFh8ZM;IAUM,8BAAA;IAAA,iCAAA;EvF07ZZ;EuFp8ZM;IAUM,4BAAA;IAAA,+BAAA;EvF87ZZ;EuFx8ZM;IAUM,8BAAA;IAAA,iCAAA;EvFk8ZZ;EuF58ZM;IAUM,4BAAA;IAAA,+BAAA;EvFs8ZZ;EuFh9ZM;IAUM,yBAAA;EvFy8ZZ;EuFn9ZM;IAUM,+BAAA;EvF48ZZ;EuFt9ZM;IAUM,8BAAA;EvF+8ZZ;EuFz9ZM;IAUM,4BAAA;EvFk9ZZ;EuF59ZM;IAUM,8BAAA;EvFq9ZZ;EuF/9ZM;IAUM,4BAAA;EvFw9ZZ;EQriaE;IAgCE,2BAAA;ERwgaJ;EQhiaE;IA+BI,0BAAA;ERogaN;EQ3iaE;IAgCE,iCAAA;ER8gaJ;EQtiaE;IA+BI,gCAAA;ER0gaN;EQjjaE;IAgCE,gCAAA;ERohaJ;EQ5iaE;IA+BI,+BAAA;ERghaN;EQvjaE;IAgCE,8BAAA;ER0haJ;EQljaE;IA+BI,6BAAA;ERshaN;EQ7jaE;IAgCE,gCAAA;ERgiaJ;EQxjaE;IA+BI,+BAAA;ER4haN;EQnkaE;IAgCE,8BAAA;ERsiaJ;EQ9jaE;IA+BI,6BAAA;ERkiaN;EuFtgaM;IAUM,4BAAA;EvF+/ZZ;EuFzgaM;IAUM,kCAAA;EvFkgaZ;EuF5gaM;IAUM,iCAAA;EvFqgaZ;EuF/gaM;IAUM,+BAAA;EvFwgaZ;EuFlhaM;IAUM,iCAAA;EvF2gaZ;EuFrhaM;IAUM,+BAAA;EvF8gaZ;EQ3laE;IAgCE,0BAAA;ER8jaJ;EQtlaE;IA+BI,2BAAA;ER0jaN;EQjmaE;IAgCE,gCAAA;ERokaJ;EQ5laE;IA+BI,iCAAA;ERgkaN;EQvmaE;IAgCE,+BAAA;ER0kaJ;EQlmaE;IA+BI,gCAAA;ERskaN;EQ7maE;IAgCE,6BAAA;ERglaJ;EQxmaE;IA+BI,8BAAA;ER4kaN;EQnnaE;IAgCE,+BAAA;ERslaJ;EQ9maE;IA+BI,gCAAA;ERklaN;EQznaE;IAgCE,6BAAA;ER4laJ;EQpnaE;IA+BI,8BAAA;ERwlaN;EuF5jaM;IAUM,iBAAA;EvFqjaZ;EuF/jaM;IAUM,uBAAA;EvFwjaZ;EuFlkaM;IAUM,sBAAA;EvF2jaZ;EuFrkaM;IAUM,oBAAA;EvF8jaZ;EuFxkaM;IAUM,sBAAA;EvFikaZ;EuF3kaM;IAUM,oBAAA;EvFokaZ;EuF9kaM;IAUM,qBAAA;EvFukaZ;EuFjlaM;IAUM,2BAAA;EvF0kaZ;EuFplaM;IAUM,0BAAA;EvF6kaZ;EuFvlaM;IAUM,wBAAA;EvFglaZ;EuF1laM;IAUM,0BAAA;EvFmlaZ;EuF7laM;IAUM,wBAAA;EvFslaZ;EuFhmaM;IAUM,wBAAA;EvFylaZ;EuFnmaM;IAUM,8BAAA;EvF4laZ;EuFtmaM;IAUM,6BAAA;EvF+laZ;EuFzmaM;IAUM,2BAAA;EvFkmaZ;EuF5maM;IAUM,6BAAA;EvFqmaZ;EuF/maM;IAUM,2BAAA;EvFwmaZ;EQrraE;IAgCE,2BAAA;ERwpaJ;EQhraE;IA+BI,4BAAA;ERopaN;EQ3raE;IAgCE,4BAAA;ER8paJ;EQtraE;IA+BI,2BAAA;ER0paN;EQjsaE;IAgCE,6BAAA;ERoqaJ;EQ5raE;IA+BI,6BAAA;ERgqaN;AACF;AiB3oaI;ET7DA;IAgCE,sBAAA;ER4qaJ;EQpsaE;IA+BI,uBAAA;ERwqaN;EQ/saE;IAgCE,uBAAA;ERkraJ;EQ1saE;IA+BI,sBAAA;ER8qaN;EQrtaE;IAgCE,sBAAA;ERwraJ;EQhtaE;IA+BI,sBAAA;ERoraN;EuFxpaM;IAUM,8BAAA;EvFipaZ;EuF3paM;IAUM,4BAAA;EvFopaZ;EuF9paM;IAUM,2BAAA;EvFupaZ;EuFjqaM;IAUM,iCAAA;EvF0paZ;EuFpqaM;IAUM,2BAAA;EvF6paZ;EuFvqaM;IAUM,0BAAA;EvFgqaZ;EuF1qaM;IAUM,gCAAA;EvFmqaZ;EuF7qaM;IAUM,yBAAA;EvFsqaZ;EuFhraM;IAUM,wBAAA;EvFyqaZ;EuFnraM;IAUM,+BAAA;EvF4qaZ;EuFtraM;IAUM,yBAAA;EvF+qaZ;EuFzraM;IAUM,6BAAA;EvFkraZ;EuF5raM;IAUM,8BAAA;EvFqraZ;EuF/raM;IAUM,wBAAA;EvFwraZ;EuFlsaM;IAUM,+BAAA;EvF2raZ;EuFrsaM;IAUM,wBAAA;EvF8raZ;EuFxsaM;IAUM,yBAAA;EvFisaZ;EuF3saM;IAUM,8BAAA;EvFosaZ;EuF9saM;IAUM,iCAAA;EvFusaZ;EuFjtaM;IAUM,sCAAA;EvF0saZ;EuFptaM;IAUM,yCAAA;EvF6saZ;EuFvtaM;IAUM,uBAAA;EvFgtaZ;EuF1taM;IAUM,uBAAA;EvFmtaZ;EuF7taM;IAUM,yBAAA;EvFstaZ;EuFhuaM;IAUM,yBAAA;EvFytaZ;EuFnuaM;IAUM,0BAAA;EvF4taZ;EuFtuaM;IAUM,4BAAA;EvF+taZ;EuFzuaM;IAUM,kCAAA;EvFkuaZ;EuF5uaM;IAUM,sCAAA;EvFquaZ;EuF/uaM;IAUM,oCAAA;EvFwuaZ;EuFlvaM;IAUM,kCAAA;EvF2uaZ;EuFrvaM;IAUM,yCAAA;EvF8uaZ;EuFxvaM;IAUM,wCAAA;EvFivaZ;EuF3vaM;IAUM,wCAAA;EvFovaZ;EuF9vaM;IAUM,kCAAA;EvFuvaZ;EuFjwaM;IAUM,gCAAA;EvF0vaZ;EuFpwaM;IAUM,8BAAA;EvF6vaZ;EuFvwaM;IAUM,gCAAA;EvFgwaZ;EuF1waM;IAUM,+BAAA;EvFmwaZ;EuF7waM;IAUM,oCAAA;EvFswaZ;EuFhxaM;IAUM,kCAAA;EvFywaZ;EuFnxaM;IAUM,gCAAA;EvF4waZ;EuFtxaM;IAUM,uCAAA;EvF+waZ;EuFzxaM;IAUM,sCAAA;EvFkxaZ;EuF5xaM;IAUM,iCAAA;EvFqxaZ;EuF/xaM;IAUM,2BAAA;EvFwxaZ;EuFlyaM;IAUM,iCAAA;EvF2xaZ;EuFryaM;IAUM,+BAAA;EvF8xaZ;EuFxyaM;IAUM,6BAAA;EvFiyaZ;EuF3yaM;IAUM,+BAAA;EvFoyaZ;EuF9yaM;IAUM,8BAAA;EvFuyaZ;EuFjzaM;IAUM,oBAAA;EvF0yaZ;EuFpzaM;IAUM,mBAAA;EvF6yaZ;EuFvzaM;IAUM,mBAAA;EvFgzaZ;EuF1zaM;IAUM,mBAAA;EvFmzaZ;EuF7zaM;IAUM,mBAAA;EvFszaZ;EuFh0aM;IAUM,mBAAA;EvFyzaZ;EuFn0aM;IAUM,mBAAA;EvF4zaZ;EuFt0aM;IAUM,mBAAA;EvF+zaZ;EuFz0aM;IAUM,oBAAA;EvFk0aZ;EuF50aM;IAUM,0BAAA;EvFq0aZ;EuF/0aM;IAUM,yBAAA;EvFw0aZ;EuFl1aM;IAUM,uBAAA;EvF20aZ;EuFr1aM;IAUM,yBAAA;EvF80aZ;EuFx1aM;IAUM,uBAAA;EvFi1aZ;EuF31aM;IAUM,uBAAA;EvFo1aZ;EuF91aM;IAUM,0BAAA;IAAA,yBAAA;EvFw1aZ;EuFl2aM;IAUM,gCAAA;IAAA,+BAAA;EvF41aZ;EuFt2aM;IAUM,+BAAA;IAAA,8BAAA;EvFg2aZ;EuF12aM;IAUM,6BAAA;IAAA,4BAAA;EvFo2aZ;EuF92aM;IAUM,+BAAA;IAAA,8BAAA;EvFw2aZ;EuFl3aM;IAUM,6BAAA;IAAA,4BAAA;EvF42aZ;EuFt3aM;IAUM,6BAAA;IAAA,4BAAA;EvFg3aZ;EuF13aM;IAUM,wBAAA;IAAA,2BAAA;EvFo3aZ;EuF93aM;IAUM,8BAAA;IAAA,iCAAA;EvFw3aZ;EuFl4aM;IAUM,6BAAA;IAAA,gCAAA;EvF43aZ;EuFt4aM;IAUM,2BAAA;IAAA,8BAAA;EvFg4aZ;EuF14aM;IAUM,6BAAA;IAAA,gCAAA;EvFo4aZ;EuF94aM;IAUM,2BAAA;IAAA,8BAAA;EvFw4aZ;EuFl5aM;IAUM,2BAAA;IAAA,8BAAA;EvF44aZ;EuFt5aM;IAUM,wBAAA;EvF+4aZ;EuFz5aM;IAUM,8BAAA;EvFk5aZ;EuF55aM;IAUM,6BAAA;EvFq5aZ;EuF/5aM;IAUM,2BAAA;EvFw5aZ;EuFl6aM;IAUM,6BAAA;EvF25aZ;EuFr6aM;IAUM,2BAAA;EvF85aZ;EuFx6aM;IAUM,2BAAA;EvFi6aZ;EQ9+aE;IAgCE,0BAAA;ERi9aJ;EQz+aE;IA+BI,yBAAA;ER68aN;EQp/aE;IAgCE,gCAAA;ERu9aJ;EQ/+aE;IA+BI,+BAAA;ERm9aN;EQ1/aE;IAgCE,+BAAA;ER69aJ;EQr/aE;IA+BI,8BAAA;ERy9aN;EQhgbE;IAgCE,6BAAA;ERm+aJ;EQ3/aE;IA+BI,4BAAA;ER+9aN;EQtgbE;IAgCE,+BAAA;ERy+aJ;EQjgbE;IA+BI,8BAAA;ERq+aN;EQ5gbE;IAgCE,6BAAA;ER++aJ;EQvgbE;IA+BI,4BAAA;ER2+aN;EQlhbE;IAgCE,6BAAA;ERq/aJ;EQ7gbE;IA+BI,4BAAA;ERi/aN;EuFr9aM;IAUM,2BAAA;EvF88aZ;EuFx9aM;IAUM,iCAAA;EvFi9aZ;EuF39aM;IAUM,gCAAA;EvFo9aZ;EuF99aM;IAUM,8BAAA;EvFu9aZ;EuFj+aM;IAUM,gCAAA;EvF09aZ;EuFp+aM;IAUM,8BAAA;EvF69aZ;EuFv+aM;IAUM,8BAAA;EvFg+aZ;EQ7ibE;IAgCE,yBAAA;ERghbJ;EQxibE;IA+BI,0BAAA;ER4gbN;EQnjbE;IAgCE,+BAAA;ERshbJ;EQ9ibE;IA+BI,gCAAA;ERkhbN;EQzjbE;IAgCE,8BAAA;ER4hbJ;EQpjbE;IA+BI,+BAAA;ERwhbN;EQ/jbE;IAgCE,4BAAA;ERkibJ;EQ1jbE;IA+BI,6BAAA;ER8hbN;EQrkbE;IAgCE,8BAAA;ERwibJ;EQhkbE;IA+BI,+BAAA;ERoibN;EQ3kbE;IAgCE,4BAAA;ER8ibJ;EQtkbE;IA+BI,6BAAA;ER0ibN;EQjlbE;IAgCE,4BAAA;ERojbJ;EQ5kbE;IA+BI,6BAAA;ERgjbN;EuFphbM;IAUM,qBAAA;EvF6gbZ;EuFvhbM;IAUM,2BAAA;EvFghbZ;EuF1hbM;IAUM,0BAAA;EvFmhbZ;EuF7hbM;IAUM,wBAAA;EvFshbZ;EuFhibM;IAUM,0BAAA;EvFyhbZ;EuFnibM;IAUM,wBAAA;EvF4hbZ;EuFtibM;IAUM,2BAAA;IAAA,0BAAA;EvFgibZ;EuF1ibM;IAUM,iCAAA;IAAA,gCAAA;EvFoibZ;EuF9ibM;IAUM,gCAAA;IAAA,+BAAA;EvFwibZ;EuFljbM;IAUM,8BAAA;IAAA,6BAAA;EvF4ibZ;EuFtjbM;IAUM,gCAAA;IAAA,+BAAA;EvFgjbZ;EuF1jbM;IAUM,8BAAA;IAAA,6BAAA;EvFojbZ;EuF9jbM;IAUM,yBAAA;IAAA,4BAAA;EvFwjbZ;EuFlkbM;IAUM,+BAAA;IAAA,kCAAA;EvF4jbZ;EuFtkbM;IAUM,8BAAA;IAAA,iCAAA;EvFgkbZ;EuF1kbM;IAUM,4BAAA;IAAA,+BAAA;EvFokbZ;EuF9kbM;IAUM,8BAAA;IAAA,iCAAA;EvFwkbZ;EuFllbM;IAUM,4BAAA;IAAA,+BAAA;EvF4kbZ;EuFtlbM;IAUM,yBAAA;EvF+kbZ;EuFzlbM;IAUM,+BAAA;EvFklbZ;EuF5lbM;IAUM,8BAAA;EvFqlbZ;EuF/lbM;IAUM,4BAAA;EvFwlbZ;EuFlmbM;IAUM,8BAAA;EvF2lbZ;EuFrmbM;IAUM,4BAAA;EvF8lbZ;EQ3qbE;IAgCE,2BAAA;ER8obJ;EQtqbE;IA+BI,0BAAA;ER0obN;EQjrbE;IAgCE,iCAAA;ERopbJ;EQ5qbE;IA+BI,gCAAA;ERgpbN;EQvrbE;IAgCE,gCAAA;ER0pbJ;EQlrbE;IA+BI,+BAAA;ERspbN;EQ7rbE;IAgCE,8BAAA;ERgqbJ;EQxrbE;IA+BI,6BAAA;ER4pbN;EQnsbE;IAgCE,gCAAA;ERsqbJ;EQ9rbE;IA+BI,+BAAA;ERkqbN;EQzsbE;IAgCE,8BAAA;ER4qbJ;EQpsbE;IA+BI,6BAAA;ERwqbN;EuF5obM;IAUM,4BAAA;EvFqobZ;EuF/obM;IAUM,kCAAA;EvFwobZ;EuFlpbM;IAUM,iCAAA;EvF2obZ;EuFrpbM;IAUM,+BAAA;EvF8obZ;EuFxpbM;IAUM,iCAAA;EvFipbZ;EuF3pbM;IAUM,+BAAA;EvFopbZ;EQjubE;IAgCE,0BAAA;ERosbJ;EQ5tbE;IA+BI,2BAAA;ERgsbN;EQvubE;IAgCE,gCAAA;ER0sbJ;EQlubE;IA+BI,iCAAA;ERssbN;EQ7ubE;IAgCE,+BAAA;ERgtbJ;EQxubE;IA+BI,gCAAA;ER4sbN;EQnvbE;IAgCE,6BAAA;ERstbJ;EQ9ubE;IA+BI,8BAAA;ERktbN;EQzvbE;IAgCE,+BAAA;ER4tbJ;EQpvbE;IA+BI,gCAAA;ERwtbN;EQ/vbE;IAgCE,6BAAA;ERkubJ;EQ1vbE;IA+BI,8BAAA;ER8tbN;EuFlsbM;IAUM,iBAAA;EvF2rbZ;EuFrsbM;IAUM,uBAAA;EvF8rbZ;EuFxsbM;IAUM,sBAAA;EvFisbZ;EuF3sbM;IAUM,oBAAA;EvFosbZ;EuF9sbM;IAUM,sBAAA;EvFusbZ;EuFjtbM;IAUM,oBAAA;EvF0sbZ;EuFptbM;IAUM,qBAAA;EvF6sbZ;EuFvtbM;IAUM,2BAAA;EvFgtbZ;EuF1tbM;IAUM,0BAAA;EvFmtbZ;EuF7tbM;IAUM,wBAAA;EvFstbZ;EuFhubM;IAUM,0BAAA;EvFytbZ;EuFnubM;IAUM,wBAAA;EvF4tbZ;EuFtubM;IAUM,wBAAA;EvF+tbZ;EuFzubM;IAUM,8BAAA;EvFkubZ;EuF5ubM;IAUM,6BAAA;EvFqubZ;EuF/ubM;IAUM,2BAAA;EvFwubZ;EuFlvbM;IAUM,6BAAA;EvF2ubZ;EuFrvbM;IAUM,2BAAA;EvF8ubZ;EQ3zbE;IAgCE,2BAAA;ER8xbJ;EQtzbE;IA+BI,4BAAA;ER0xbN;EQj0bE;IAgCE,4BAAA;ERoybJ;EQ5zbE;IA+BI,2BAAA;ERgybN;EQv0bE;IAgCE,6BAAA;ER0ybJ;EQl0bE;IA+BI,6BAAA;ERsybN;AACF;AiBjxbI;ET7DA;IAgCE,sBAAA;ERkzbJ;EQ10bE;IA+BI,uBAAA;ER8ybN;EQr1bE;IAgCE,uBAAA;ERwzbJ;EQh1bE;IA+BI,sBAAA;ERozbN;EQ31bE;IAgCE,sBAAA;ER8zbJ;EQt1bE;IA+BI,sBAAA;ER0zbN;EuF9xbM;IAUM,8BAAA;EvFuxbZ;EuFjybM;IAUM,4BAAA;EvF0xbZ;EuFpybM;IAUM,2BAAA;EvF6xbZ;EuFvybM;IAUM,iCAAA;EvFgybZ;EuF1ybM;IAUM,2BAAA;EvFmybZ;EuF7ybM;IAUM,0BAAA;EvFsybZ;EuFhzbM;IAUM,gCAAA;EvFyybZ;EuFnzbM;IAUM,yBAAA;EvF4ybZ;EuFtzbM;IAUM,wBAAA;EvF+ybZ;EuFzzbM;IAUM,+BAAA;EvFkzbZ;EuF5zbM;IAUM,yBAAA;EvFqzbZ;EuF/zbM;IAUM,6BAAA;EvFwzbZ;EuFl0bM;IAUM,8BAAA;EvF2zbZ;EuFr0bM;IAUM,wBAAA;EvF8zbZ;EuFx0bM;IAUM,+BAAA;EvFi0bZ;EuF30bM;IAUM,wBAAA;EvFo0bZ;EuF90bM;IAUM,yBAAA;EvFu0bZ;EuFj1bM;IAUM,8BAAA;EvF00bZ;EuFp1bM;IAUM,iCAAA;EvF60bZ;EuFv1bM;IAUM,sCAAA;EvFg1bZ;EuF11bM;IAUM,yCAAA;EvFm1bZ;EuF71bM;IAUM,uBAAA;EvFs1bZ;EuFh2bM;IAUM,uBAAA;EvFy1bZ;EuFn2bM;IAUM,yBAAA;EvF41bZ;EuFt2bM;IAUM,yBAAA;EvF+1bZ;EuFz2bM;IAUM,0BAAA;EvFk2bZ;EuF52bM;IAUM,4BAAA;EvFq2bZ;EuF/2bM;IAUM,kCAAA;EvFw2bZ;EuFl3bM;IAUM,sCAAA;EvF22bZ;EuFr3bM;IAUM,oCAAA;EvF82bZ;EuFx3bM;IAUM,kCAAA;EvFi3bZ;EuF33bM;IAUM,yCAAA;EvFo3bZ;EuF93bM;IAUM,wCAAA;EvFu3bZ;EuFj4bM;IAUM,wCAAA;EvF03bZ;EuFp4bM;IAUM,kCAAA;EvF63bZ;EuFv4bM;IAUM,gCAAA;EvFg4bZ;EuF14bM;IAUM,8BAAA;EvFm4bZ;EuF74bM;IAUM,gCAAA;EvFs4bZ;EuFh5bM;IAUM,+BAAA;EvFy4bZ;EuFn5bM;IAUM,oCAAA;EvF44bZ;EuFt5bM;IAUM,kCAAA;EvF+4bZ;EuFz5bM;IAUM,gCAAA;EvFk5bZ;EuF55bM;IAUM,uCAAA;EvFq5bZ;EuF/5bM;IAUM,sCAAA;EvFw5bZ;EuFl6bM;IAUM,iCAAA;EvF25bZ;EuFr6bM;IAUM,2BAAA;EvF85bZ;EuFx6bM;IAUM,iCAAA;EvFi6bZ;EuF36bM;IAUM,+BAAA;EvFo6bZ;EuF96bM;IAUM,6BAAA;EvFu6bZ;EuFj7bM;IAUM,+BAAA;EvF06bZ;EuFp7bM;IAUM,8BAAA;EvF66bZ;EuFv7bM;IAUM,oBAAA;EvFg7bZ;EuF17bM;IAUM,mBAAA;EvFm7bZ;EuF77bM;IAUM,mBAAA;EvFs7bZ;EuFh8bM;IAUM,mBAAA;EvFy7bZ;EuFn8bM;IAUM,mBAAA;EvF47bZ;EuFt8bM;IAUM,mBAAA;EvF+7bZ;EuFz8bM;IAUM,mBAAA;EvFk8bZ;EuF58bM;IAUM,mBAAA;EvFq8bZ;EuF/8bM;IAUM,oBAAA;EvFw8bZ;EuFl9bM;IAUM,0BAAA;EvF28bZ;EuFr9bM;IAUM,yBAAA;EvF88bZ;EuFx9bM;IAUM,uBAAA;EvFi9bZ;EuF39bM;IAUM,yBAAA;EvFo9bZ;EuF99bM;IAUM,uBAAA;EvFu9bZ;EuFj+bM;IAUM,uBAAA;EvF09bZ;EuFp+bM;IAUM,0BAAA;IAAA,yBAAA;EvF89bZ;EuFx+bM;IAUM,gCAAA;IAAA,+BAAA;EvFk+bZ;EuF5+bM;IAUM,+BAAA;IAAA,8BAAA;EvFs+bZ;EuFh/bM;IAUM,6BAAA;IAAA,4BAAA;EvF0+bZ;EuFp/bM;IAUM,+BAAA;IAAA,8BAAA;EvF8+bZ;EuFx/bM;IAUM,6BAAA;IAAA,4BAAA;EvFk/bZ;EuF5/bM;IAUM,6BAAA;IAAA,4BAAA;EvFs/bZ;EuFhgcM;IAUM,wBAAA;IAAA,2BAAA;EvF0/bZ;EuFpgcM;IAUM,8BAAA;IAAA,iCAAA;EvF8/bZ;EuFxgcM;IAUM,6BAAA;IAAA,gCAAA;EvFkgcZ;EuF5gcM;IAUM,2BAAA;IAAA,8BAAA;EvFsgcZ;EuFhhcM;IAUM,6BAAA;IAAA,gCAAA;EvF0gcZ;EuFphcM;IAUM,2BAAA;IAAA,8BAAA;EvF8gcZ;EuFxhcM;IAUM,2BAAA;IAAA,8BAAA;EvFkhcZ;EuF5hcM;IAUM,wBAAA;EvFqhcZ;EuF/hcM;IAUM,8BAAA;EvFwhcZ;EuFlicM;IAUM,6BAAA;EvF2hcZ;EuFricM;IAUM,2BAAA;EvF8hcZ;EuFxicM;IAUM,6BAAA;EvFiicZ;EuF3icM;IAUM,2BAAA;EvFoicZ;EuF9icM;IAUM,2BAAA;EvFuicZ;EQpncE;IAgCE,0BAAA;ERulcJ;EQ/mcE;IA+BI,yBAAA;ERmlcN;EQ1ncE;IAgCE,gCAAA;ER6lcJ;EQrncE;IA+BI,+BAAA;ERylcN;EQhocE;IAgCE,+BAAA;ERmmcJ;EQ3ncE;IA+BI,8BAAA;ER+lcN;EQtocE;IAgCE,6BAAA;ERymcJ;EQjocE;IA+BI,4BAAA;ERqmcN;EQ5ocE;IAgCE,+BAAA;ER+mcJ;EQvocE;IA+BI,8BAAA;ER2mcN;EQlpcE;IAgCE,6BAAA;ERqncJ;EQ7ocE;IA+BI,4BAAA;ERincN;EQxpcE;IAgCE,6BAAA;ER2ncJ;EQnpcE;IA+BI,4BAAA;ERuncN;EuF3lcM;IAUM,2BAAA;EvFolcZ;EuF9lcM;IAUM,iCAAA;EvFulcZ;EuFjmcM;IAUM,gCAAA;EvF0lcZ;EuFpmcM;IAUM,8BAAA;EvF6lcZ;EuFvmcM;IAUM,gCAAA;EvFgmcZ;EuF1mcM;IAUM,8BAAA;EvFmmcZ;EuF7mcM;IAUM,8BAAA;EvFsmcZ;EQnrcE;IAgCE,yBAAA;ERspcJ;EQ9qcE;IA+BI,0BAAA;ERkpcN;EQzrcE;IAgCE,+BAAA;ER4pcJ;EQprcE;IA+BI,gCAAA;ERwpcN;EQ/rcE;IAgCE,8BAAA;ERkqcJ;EQ1rcE;IA+BI,+BAAA;ER8pcN;EQrscE;IAgCE,4BAAA;ERwqcJ;EQhscE;IA+BI,6BAAA;ERoqcN;EQ3scE;IAgCE,8BAAA;ER8qcJ;EQtscE;IA+BI,+BAAA;ER0qcN;EQjtcE;IAgCE,4BAAA;ERorcJ;EQ5scE;IA+BI,6BAAA;ERgrcN;EQvtcE;IAgCE,4BAAA;ER0rcJ;EQltcE;IA+BI,6BAAA;ERsrcN;EuF1pcM;IAUM,qBAAA;EvFmpcZ;EuF7pcM;IAUM,2BAAA;EvFspcZ;EuFhqcM;IAUM,0BAAA;EvFypcZ;EuFnqcM;IAUM,wBAAA;EvF4pcZ;EuFtqcM;IAUM,0BAAA;EvF+pcZ;EuFzqcM;IAUM,wBAAA;EvFkqcZ;EuF5qcM;IAUM,2BAAA;IAAA,0BAAA;EvFsqcZ;EuFhrcM;IAUM,iCAAA;IAAA,gCAAA;EvF0qcZ;EuFprcM;IAUM,gCAAA;IAAA,+BAAA;EvF8qcZ;EuFxrcM;IAUM,8BAAA;IAAA,6BAAA;EvFkrcZ;EuF5rcM;IAUM,gCAAA;IAAA,+BAAA;EvFsrcZ;EuFhscM;IAUM,8BAAA;IAAA,6BAAA;EvF0rcZ;EuFpscM;IAUM,yBAAA;IAAA,4BAAA;EvF8rcZ;EuFxscM;IAUM,+BAAA;IAAA,kCAAA;EvFkscZ;EuF5scM;IAUM,8BAAA;IAAA,iCAAA;EvFsscZ;EuFhtcM;IAUM,4BAAA;IAAA,+BAAA;EvF0scZ;EuFptcM;IAUM,8BAAA;IAAA,iCAAA;EvF8scZ;EuFxtcM;IAUM,4BAAA;IAAA,+BAAA;EvFktcZ;EuF5tcM;IAUM,yBAAA;EvFqtcZ;EuF/tcM;IAUM,+BAAA;EvFwtcZ;EuFlucM;IAUM,8BAAA;EvF2tcZ;EuFrucM;IAUM,4BAAA;EvF8tcZ;EuFxucM;IAUM,8BAAA;EvFiucZ;EuF3ucM;IAUM,4BAAA;EvFoucZ;EQjzcE;IAgCE,2BAAA;ERoxcJ;EQ5ycE;IA+BI,0BAAA;ERgxcN;EQvzcE;IAgCE,iCAAA;ER0xcJ;EQlzcE;IA+BI,gCAAA;ERsxcN;EQ7zcE;IAgCE,gCAAA;ERgycJ;EQxzcE;IA+BI,+BAAA;ER4xcN;EQn0cE;IAgCE,8BAAA;ERsycJ;EQ9zcE;IA+BI,6BAAA;ERkycN;EQz0cE;IAgCE,gCAAA;ER4ycJ;EQp0cE;IA+BI,+BAAA;ERwycN;EQ/0cE;IAgCE,8BAAA;ERkzcJ;EQ10cE;IA+BI,6BAAA;ER8ycN;EuFlxcM;IAUM,4BAAA;EvF2wcZ;EuFrxcM;IAUM,kCAAA;EvF8wcZ;EuFxxcM;IAUM,iCAAA;EvFixcZ;EuF3xcM;IAUM,+BAAA;EvFoxcZ;EuF9xcM;IAUM,iCAAA;EvFuxcZ;EuFjycM;IAUM,+BAAA;EvF0xcZ;EQv2cE;IAgCE,0BAAA;ER00cJ;EQl2cE;IA+BI,2BAAA;ERs0cN;EQ72cE;IAgCE,gCAAA;ERg1cJ;EQx2cE;IA+BI,iCAAA;ER40cN;EQn3cE;IAgCE,+BAAA;ERs1cJ;EQ92cE;IA+BI,gCAAA;ERk1cN;EQz3cE;IAgCE,6BAAA;ER41cJ;EQp3cE;IA+BI,8BAAA;ERw1cN;EQ/3cE;IAgCE,+BAAA;ERk2cJ;EQ13cE;IA+BI,gCAAA;ER81cN;EQr4cE;IAgCE,6BAAA;ERw2cJ;EQh4cE;IA+BI,8BAAA;ERo2cN;EuFx0cM;IAUM,iBAAA;EvFi0cZ;EuF30cM;IAUM,uBAAA;EvFo0cZ;EuF90cM;IAUM,sBAAA;EvFu0cZ;EuFj1cM;IAUM,oBAAA;EvF00cZ;EuFp1cM;IAUM,sBAAA;EvF60cZ;EuFv1cM;IAUM,oBAAA;EvFg1cZ;EuF11cM;IAUM,qBAAA;EvFm1cZ;EuF71cM;IAUM,2BAAA;EvFs1cZ;EuFh2cM;IAUM,0BAAA;EvFy1cZ;EuFn2cM;IAUM,wBAAA;EvF41cZ;EuFt2cM;IAUM,0BAAA;EvF+1cZ;EuFz2cM;IAUM,wBAAA;EvFk2cZ;EuF52cM;IAUM,wBAAA;EvFq2cZ;EuF/2cM;IAUM,8BAAA;EvFw2cZ;EuFl3cM;IAUM,6BAAA;EvF22cZ;EuFr3cM;IAUM,2BAAA;EvF82cZ;EuFx3cM;IAUM,6BAAA;EvFi3cZ;EuF33cM;IAUM,2BAAA;EvFo3cZ;EQj8cE;IAgCE,2BAAA;ERo6cJ;EQ57cE;IA+BI,4BAAA;ERg6cN;EQv8cE;IAgCE,4BAAA;ER06cJ;EQl8cE;IA+BI,2BAAA;ERs6cN;EQ78cE;IAgCE,6BAAA;ERg7cJ;EQx8cE;IA+BI,6BAAA;ER46cN;AACF;AiBv5cI;ET7DA;IAgCE,sBAAA;ERw7cJ;EQh9cE;IA+BI,uBAAA;ERo7cN;EQ39cE;IAgCE,uBAAA;ER87cJ;EQt9cE;IA+BI,sBAAA;ER07cN;EQj+cE;IAgCE,sBAAA;ERo8cJ;EQ59cE;IA+BI,sBAAA;ERg8cN;EuFp6cM;IAUM,8BAAA;EvF65cZ;EuFv6cM;IAUM,4BAAA;EvFg6cZ;EuF16cM;IAUM,2BAAA;EvFm6cZ;EuF76cM;IAUM,iCAAA;EvFs6cZ;EuFh7cM;IAUM,2BAAA;EvFy6cZ;EuFn7cM;IAUM,0BAAA;EvF46cZ;EuFt7cM;IAUM,gCAAA;EvF+6cZ;EuFz7cM;IAUM,yBAAA;EvFk7cZ;EuF57cM;IAUM,wBAAA;EvFq7cZ;EuF/7cM;IAUM,+BAAA;EvFw7cZ;EuFl8cM;IAUM,yBAAA;EvF27cZ;EuFr8cM;IAUM,6BAAA;EvF87cZ;EuFx8cM;IAUM,8BAAA;EvFi8cZ;EuF38cM;IAUM,wBAAA;EvFo8cZ;EuF98cM;IAUM,+BAAA;EvFu8cZ;EuFj9cM;IAUM,wBAAA;EvF08cZ;EuFp9cM;IAUM,yBAAA;EvF68cZ;EuFv9cM;IAUM,8BAAA;EvFg9cZ;EuF19cM;IAUM,iCAAA;EvFm9cZ;EuF79cM;IAUM,sCAAA;EvFs9cZ;EuFh+cM;IAUM,yCAAA;EvFy9cZ;EuFn+cM;IAUM,uBAAA;EvF49cZ;EuFt+cM;IAUM,uBAAA;EvF+9cZ;EuFz+cM;IAUM,yBAAA;EvFk+cZ;EuF5+cM;IAUM,yBAAA;EvFq+cZ;EuF/+cM;IAUM,0BAAA;EvFw+cZ;EuFl/cM;IAUM,4BAAA;EvF2+cZ;EuFr/cM;IAUM,kCAAA;EvF8+cZ;EuFx/cM;IAUM,sCAAA;EvFi/cZ;EuF3/cM;IAUM,oCAAA;EvFo/cZ;EuF9/cM;IAUM,kCAAA;EvFu/cZ;EuFjgdM;IAUM,yCAAA;EvF0/cZ;EuFpgdM;IAUM,wCAAA;EvF6/cZ;EuFvgdM;IAUM,wCAAA;EvFggdZ;EuF1gdM;IAUM,kCAAA;EvFmgdZ;EuF7gdM;IAUM,gCAAA;EvFsgdZ;EuFhhdM;IAUM,8BAAA;EvFygdZ;EuFnhdM;IAUM,gCAAA;EvF4gdZ;EuFthdM;IAUM,+BAAA;EvF+gdZ;EuFzhdM;IAUM,oCAAA;EvFkhdZ;EuF5hdM;IAUM,kCAAA;EvFqhdZ;EuF/hdM;IAUM,gCAAA;EvFwhdZ;EuFlidM;IAUM,uCAAA;EvF2hdZ;EuFridM;IAUM,sCAAA;EvF8hdZ;EuFxidM;IAUM,iCAAA;EvFiidZ;EuF3idM;IAUM,2BAAA;EvFoidZ;EuF9idM;IAUM,iCAAA;EvFuidZ;EuFjjdM;IAUM,+BAAA;EvF0idZ;EuFpjdM;IAUM,6BAAA;EvF6idZ;EuFvjdM;IAUM,+BAAA;EvFgjdZ;EuF1jdM;IAUM,8BAAA;EvFmjdZ;EuF7jdM;IAUM,oBAAA;EvFsjdZ;EuFhkdM;IAUM,mBAAA;EvFyjdZ;EuFnkdM;IAUM,mBAAA;EvF4jdZ;EuFtkdM;IAUM,mBAAA;EvF+jdZ;EuFzkdM;IAUM,mBAAA;EvFkkdZ;EuF5kdM;IAUM,mBAAA;EvFqkdZ;EuF/kdM;IAUM,mBAAA;EvFwkdZ;EuFlldM;IAUM,mBAAA;EvF2kdZ;EuFrldM;IAUM,oBAAA;EvF8kdZ;EuFxldM;IAUM,0BAAA;EvFildZ;EuF3ldM;IAUM,yBAAA;EvFoldZ;EuF9ldM;IAUM,uBAAA;EvFuldZ;EuFjmdM;IAUM,yBAAA;EvF0ldZ;EuFpmdM;IAUM,uBAAA;EvF6ldZ;EuFvmdM;IAUM,uBAAA;EvFgmdZ;EuF1mdM;IAUM,0BAAA;IAAA,yBAAA;EvFomdZ;EuF9mdM;IAUM,gCAAA;IAAA,+BAAA;EvFwmdZ;EuFlndM;IAUM,+BAAA;IAAA,8BAAA;EvF4mdZ;EuFtndM;IAUM,6BAAA;IAAA,4BAAA;EvFgndZ;EuF1ndM;IAUM,+BAAA;IAAA,8BAAA;EvFondZ;EuF9ndM;IAUM,6BAAA;IAAA,4BAAA;EvFwndZ;EuFlodM;IAUM,6BAAA;IAAA,4BAAA;EvF4ndZ;EuFtodM;IAUM,wBAAA;IAAA,2BAAA;EvFgodZ;EuF1odM;IAUM,8BAAA;IAAA,iCAAA;EvFoodZ;EuF9odM;IAUM,6BAAA;IAAA,gCAAA;EvFwodZ;EuFlpdM;IAUM,2BAAA;IAAA,8BAAA;EvF4odZ;EuFtpdM;IAUM,6BAAA;IAAA,gCAAA;EvFgpdZ;EuF1pdM;IAUM,2BAAA;IAAA,8BAAA;EvFopdZ;EuF9pdM;IAUM,2BAAA;IAAA,8BAAA;EvFwpdZ;EuFlqdM;IAUM,wBAAA;EvF2pdZ;EuFrqdM;IAUM,8BAAA;EvF8pdZ;EuFxqdM;IAUM,6BAAA;EvFiqdZ;EuF3qdM;IAUM,2BAAA;EvFoqdZ;EuF9qdM;IAUM,6BAAA;EvFuqdZ;EuFjrdM;IAUM,2BAAA;EvF0qdZ;EuFprdM;IAUM,2BAAA;EvF6qdZ;EQ1vdE;IAgCE,0BAAA;ER6tdJ;EQrvdE;IA+BI,yBAAA;ERytdN;EQhwdE;IAgCE,gCAAA;ERmudJ;EQ3vdE;IA+BI,+BAAA;ER+tdN;EQtwdE;IAgCE,+BAAA;ERyudJ;EQjwdE;IA+BI,8BAAA;ERqudN;EQ5wdE;IAgCE,6BAAA;ER+udJ;EQvwdE;IA+BI,4BAAA;ER2udN;EQlxdE;IAgCE,+BAAA;ERqvdJ;EQ7wdE;IA+BI,8BAAA;ERivdN;EQxxdE;IAgCE,6BAAA;ER2vdJ;EQnxdE;IA+BI,4BAAA;ERuvdN;EQ9xdE;IAgCE,6BAAA;ERiwdJ;EQzxdE;IA+BI,4BAAA;ER6vdN;EuFjudM;IAUM,2BAAA;EvF0tdZ;EuFpudM;IAUM,iCAAA;EvF6tdZ;EuFvudM;IAUM,gCAAA;EvFgudZ;EuF1udM;IAUM,8BAAA;EvFmudZ;EuF7udM;IAUM,gCAAA;EvFsudZ;EuFhvdM;IAUM,8BAAA;EvFyudZ;EuFnvdM;IAUM,8BAAA;EvF4udZ;EQzzdE;IAgCE,yBAAA;ER4xdJ;EQpzdE;IA+BI,0BAAA;ERwxdN;EQ/zdE;IAgCE,+BAAA;ERkydJ;EQ1zdE;IA+BI,gCAAA;ER8xdN;EQr0dE;IAgCE,8BAAA;ERwydJ;EQh0dE;IA+BI,+BAAA;ERoydN;EQ30dE;IAgCE,4BAAA;ER8ydJ;EQt0dE;IA+BI,6BAAA;ER0ydN;EQj1dE;IAgCE,8BAAA;ERozdJ;EQ50dE;IA+BI,+BAAA;ERgzdN;EQv1dE;IAgCE,4BAAA;ER0zdJ;EQl1dE;IA+BI,6BAAA;ERszdN;EQ71dE;IAgCE,4BAAA;ERg0dJ;EQx1dE;IA+BI,6BAAA;ER4zdN;EuFhydM;IAUM,qBAAA;EvFyxdZ;EuFnydM;IAUM,2BAAA;EvF4xdZ;EuFtydM;IAUM,0BAAA;EvF+xdZ;EuFzydM;IAUM,wBAAA;EvFkydZ;EuF5ydM;IAUM,0BAAA;EvFqydZ;EuF/ydM;IAUM,wBAAA;EvFwydZ;EuFlzdM;IAUM,2BAAA;IAAA,0BAAA;EvF4ydZ;EuFtzdM;IAUM,iCAAA;IAAA,gCAAA;EvFgzdZ;EuF1zdM;IAUM,gCAAA;IAAA,+BAAA;EvFozdZ;EuF9zdM;IAUM,8BAAA;IAAA,6BAAA;EvFwzdZ;EuFl0dM;IAUM,gCAAA;IAAA,+BAAA;EvF4zdZ;EuFt0dM;IAUM,8BAAA;IAAA,6BAAA;EvFg0dZ;EuF10dM;IAUM,yBAAA;IAAA,4BAAA;EvFo0dZ;EuF90dM;IAUM,+BAAA;IAAA,kCAAA;EvFw0dZ;EuFl1dM;IAUM,8BAAA;IAAA,iCAAA;EvF40dZ;EuFt1dM;IAUM,4BAAA;IAAA,+BAAA;EvFg1dZ;EuF11dM;IAUM,8BAAA;IAAA,iCAAA;EvFo1dZ;EuF91dM;IAUM,4BAAA;IAAA,+BAAA;EvFw1dZ;EuFl2dM;IAUM,yBAAA;EvF21dZ;EuFr2dM;IAUM,+BAAA;EvF81dZ;EuFx2dM;IAUM,8BAAA;EvFi2dZ;EuF32dM;IAUM,4BAAA;EvFo2dZ;EuF92dM;IAUM,8BAAA;EvFu2dZ;EuFj3dM;IAUM,4BAAA;EvF02dZ;EQv7dE;IAgCE,2BAAA;ER05dJ;EQl7dE;IA+BI,0BAAA;ERs5dN;EQ77dE;IAgCE,iCAAA;ERg6dJ;EQx7dE;IA+BI,gCAAA;ER45dN;EQn8dE;IAgCE,gCAAA;ERs6dJ;EQ97dE;IA+BI,+BAAA;ERk6dN;EQz8dE;IAgCE,8BAAA;ER46dJ;EQp8dE;IA+BI,6BAAA;ERw6dN;EQ/8dE;IAgCE,gCAAA;ERk7dJ;EQ18dE;IA+BI,+BAAA;ER86dN;EQr9dE;IAgCE,8BAAA;ERw7dJ;EQh9dE;IA+BI,6BAAA;ERo7dN;EuFx5dM;IAUM,4BAAA;EvFi5dZ;EuF35dM;IAUM,kCAAA;EvFo5dZ;EuF95dM;IAUM,iCAAA;EvFu5dZ;EuFj6dM;IAUM,+BAAA;EvF05dZ;EuFp6dM;IAUM,iCAAA;EvF65dZ;EuFv6dM;IAUM,+BAAA;EvFg6dZ;EQ7+dE;IAgCE,0BAAA;ERg9dJ;EQx+dE;IA+BI,2BAAA;ER48dN;EQn/dE;IAgCE,gCAAA;ERs9dJ;EQ9+dE;IA+BI,iCAAA;ERk9dN;EQz/dE;IAgCE,+BAAA;ER49dJ;EQp/dE;IA+BI,gCAAA;ERw9dN;EQ//dE;IAgCE,6BAAA;ERk+dJ;EQ1/dE;IA+BI,8BAAA;ER89dN;EQrgeE;IAgCE,+BAAA;ERw+dJ;EQhgeE;IA+BI,gCAAA;ERo+dN;EQ3geE;IAgCE,6BAAA;ER8+dJ;EQtgeE;IA+BI,8BAAA;ER0+dN;EuF98dM;IAUM,iBAAA;EvFu8dZ;EuFj9dM;IAUM,uBAAA;EvF08dZ;EuFp9dM;IAUM,sBAAA;EvF68dZ;EuFv9dM;IAUM,oBAAA;EvFg9dZ;EuF19dM;IAUM,sBAAA;EvFm9dZ;EuF79dM;IAUM,oBAAA;EvFs9dZ;EuFh+dM;IAUM,qBAAA;EvFy9dZ;EuFn+dM;IAUM,2BAAA;EvF49dZ;EuFt+dM;IAUM,0BAAA;EvF+9dZ;EuFz+dM;IAUM,wBAAA;EvFk+dZ;EuF5+dM;IAUM,0BAAA;EvFq+dZ;EuF/+dM;IAUM,wBAAA;EvFw+dZ;EuFl/dM;IAUM,wBAAA;EvF2+dZ;EuFr/dM;IAUM,8BAAA;EvF8+dZ;EuFx/dM;IAUM,6BAAA;EvFi/dZ;EuF3/dM;IAUM,2BAAA;EvFo/dZ;EuF9/dM;IAUM,6BAAA;EvFu/dZ;EuFjgeM;IAUM,2BAAA;EvF0/dZ;EQvkeE;IAgCE,2BAAA;ER0ieJ;EQlkeE;IA+BI,4BAAA;ERsieN;EQ7keE;IAgCE,4BAAA;ERgjeJ;EQxkeE;IA+BI,2BAAA;ER4ieN;EQnleE;IAgCE,6BAAA;ERsjeJ;EQ9keE;IA+BI,6BAAA;ERkjeN;AACF;AwFzkeA;EDkDQ;IAUM,+BAAA;EvFiheZ;EuF3heM;IAUM,6BAAA;EvFoheZ;EuF9heM;IAUM,gCAAA;EvFuheZ;EuFjieM;IAUM,+BAAA;EvF0heZ;AACF;AwFpkeA;ED+BQ;IAUM,0BAAA;EvF+heZ;EuFzieM;IAUM,gCAAA;EvFkieZ;EuF5ieM;IAUM,yBAAA;EvFqieZ;EuF/ieM;IAUM,wBAAA;EvFwieZ;EuFljeM;IAUM,+BAAA;EvF2ieZ;EuFrjeM;IAUM,yBAAA;EvF8ieZ;EuFxjeM;IAUM,6BAAA;EvFijeZ;EuF3jeM;IAUM,8BAAA;EvFojeZ;EuF9jeM;IAUM,wBAAA;EvFujeZ;EuFjkeM;IAUM,+BAAA;EvF0jeZ;EuFpkeM;IAUM,wBAAA;EvF6jeZ;AACF;AyF7oeA;;;;;;EAAA;ACEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,UAAA;EjEOI,0BiENJ;A1FopeF;AyB1oeM;EiElBN;IjEmBQ,gBAAA;EzB6oeN;AACF;A0FjqeA;EASE,6BAAA;EjFQE,kBAAA;ATopeJ;;A0FxpeA;EACE,qBAAA;A1F2peF;;A0FxpeA;EACE,ezFmEa;EyFlEb,gBzFuEiB;ADolenB;;A0FxpeA;EACE,mBAAA;EACA,ezF6Da;EyF5Db,mBAAA;A1F2peF;;A2FtreA;EACE,WAAA;A3FyreF;AQxreI;EAgCE,gDAAA;AR2peN;AQnreI;EA+BI,iDAAA;ARupeR;A2FhseA;EAGE,iBAAA;ElEaI,yBkEZJ;A3FgseF;AyBhreM;EkEpBN;IlEqBQ,gBAAA;EzBmreN;AACF;;A4FxseE;EACE,kBAAA;A5F2seJ;A4FxseE;EACE,mDAAA;A5F0seJ;A4Fxsea;EACP,qDAAA;A5F0seN;;A4FtseE;;EAEE,8BAAA;A5FyseJ;A4FtseE;;EAEE,uBAAA;A5FwseJ;A4FrseE;EACE,kBAAA;A5FuseJ;A4FjseI;;EACE,gBAAA;A5FoseN;A4FhseM;;EACE,kBAAA;A5FmseR;A4F/reI;;;;;;;;EAIE,gBAAA;A5FqseN;A4FlseI;;EACE,gBAAA;EACA,cAAA;A5FqseN;A4FlseI;;EACE,gBAAA;A5FqseN;A4FjseI;;;;EAEE,mBAAA;A5FqseN;A4FjseI;;;;EAEE,wBAAA;A5FqseN;A4FnseI;;EACE,kBAAA;A5FsseN;A4FlseI;;EACE,gBAAA;A5FqseN;A4FlseI;;EACE,eAAA;A5FqseN;A4FjseI;;;;EAEE,gBAAA;EACA,wBAAA;A5FqseN;A4FlseI;;EACE,gBAAA;EACA,wBAAA;A5FqseN;AiB/teI;E2E8BE;;;;IAEE,4BAAA;E5FsseN;E4FpseI;;IACE,4BAAA;E5FuseN;AACF;A4FnseI;;EACE,kBAAA;EACA,qBAAA;A5FsseN;;A6F7yeI;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;A7FgzeN;A6F9yeM;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;A7FgzeR;A6F7yeM;EACE,iBAAA;EACA,WAAA;EACA,iBAAA;A7F+yeR;A6F1yeE;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;A7F4yeJ;A6F1yeI;EACE,yBAAA;EACA,cAAA;A7F4yeN;A6FzyeI;EACE,yBAAA;EACA,cAAA;A7F2yeN;A6FxyeI;EACE,yBAAA;EACA,cAAA;A7F0yeN;A6FvyeI;EACE,yBAAA;EACA,cAAA;A7FyyeN;A6FlyeQ;EACE,yBAAA;A7FoyeV;A6F9xeE;EACE,gBAAA;A7FgyeJ;A6F9xeI;EACE,iBAAA;A7FgyeN;A6F5xeE;EACE,mBAAA;A7F8xeJ;A6F5xeI;EACE,iBAAA;A7F8xeN;A6F1xeE;EACE,cAAA;A7F4xeJ;A6F1xeI;EACE,aAAA;EACA,eAAA;EACA,SAAA;A7F4xeN;A6FvxeI;EACE,gBAAA;EACA,gBAAA;A7FyxeN;A6FrxeE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;A7FuxeJ;A6FpxeE;EACE,WAAA;EACA,iBAAA;A7FsxeJ;A6FlxeI;EACE,iBAAA;EACA,WAAA;A7FoxeN;;A8Fh4eA;EACE,cAAA;EACA,iBAAA;A9Fm4eF;A8Fh4eE;EACE,QAAA;EACA,UAAA;A9Fk4eJ;A8F/3eE;EACE,eAAA;EACA,cAAA;A9Fi4eJ;A8F53eI;EACE,yBAAA;EACA,6BAAA;A9F83eN;A8F33eI;EACE,0BAAA;EACA,4BAAA;A9F63eN;A8Fx3eE;EACE,iBAAA;A9F03eJ;A8Fv3eE;;EAEE,iBAAA;A9Fy3eJ;A8Fr3eE;EACE,iBAAA;A9Fu3eJ;A8Fn3eE;EACE,cAAA;A9Fq3eJ;A8Fj3eE;EACE,cAAA;EACA,iBAAA;A9Fm3eJ;A8F92eI;EACE,cAAA;EACA,kBAAA;A9Fg3eN;A8F32eE;EACE,cAAA;A9F62eJ;A8Fz2eE;EACE,cAAA;A9F22eJ;A8Fv2eE;EACE,iBAAA;A9Fy2eJ;A8Fr2eE;EACE,iBAAA;A9Fu2eJ;A8Fn2eE;;EAEE,cAAA;A9Fq2eJ;A8Fj2eE;EACE,mBAAA;EACA,eAAA;A9Fm2eJ;A8F/1eE;EACE,cAAA;A9Fi2eJ;A8F/1eI;EACE,cAAA;EACA,+BAAA;A9Fi2eN;A8F91eI;EACE,eAAA;EACA,8BAAA;A9Fg2eN;A8F31eE;EACE,2BAAA;A9F61eJ;A8Fz1eE;EACE,4BAAA;A9F21eJ;A8Fx1eE;EACE,2BAAA;A9F01eJ;A8Ft1eE;EACE,6BAAA;EACA,yBAAA;A9Fw1eJ;A8Fr1eE;EACE,4BAAA;EACA,0BAAA;A9Fu1eJ;A8Fn1eE;EACE,uBAAA;A9Fq1eJ;A8Fl1eE;EACE,sBAAA;A9Fo1eJ;A8F/0eI;EACE,gCAAA;EACA,yBAAA;A9Fi1eN;A8F90eI;EACE,+BAAA;EACA,0BAAA;A9Fg1eN;A8F70eI;EACE,iCAAA;EACA,0BAAA;A9F+0eN;A8F50eI;EACE,gCAAA;EACA,2BAAA;A9F80eN;A8F/1eI;EACE,+BAAA;EACA,yBAAA;A9Fi2eN;A8F91eI;EACE,8BAAA;EACA,0BAAA;A9Fg2eN;A8F71eI;EACE,gCAAA;EACA,0BAAA;A9F+1eN;A8F51eI;EACE,+BAAA;EACA,2BAAA;A9F81eN;A8F/2eI;EACE,gCAAA;EACA,yBAAA;A9Fi3eN;A8F92eI;EACE,+BAAA;EACA,0BAAA;A9Fg3eN;A8F72eI;EACE,iCAAA;EACA,0BAAA;A9F+2eN;A8F52eI;EACE,gCAAA;EACA,2BAAA;A9F82eN;A8F/3eI;EACE,6BAAA;EACA,yBAAA;A9Fi4eN;A8F93eI;EACE,4BAAA;EACA,0BAAA;A9Fg4eN;A8F73eI;EACE,8BAAA;EACA,0BAAA;A9F+3eN;A8F53eI;EACE,6BAAA;EACA,2BAAA;A9F83eN;A8F/4eI;EACE,gCAAA;EACA,yBAAA;A9Fi5eN;A8F94eI;EACE,+BAAA;EACA,0BAAA;A9Fg5eN;A8F74eI;EACE,iCAAA;EACA,0BAAA;A9F+4eN;A8F54eI;EACE,gCAAA;EACA,2BAAA;A9F84eN;;A8Fx4eA;EACE,cAAA;EACA,gBAAA;A9F24eF;;AC38eA;EACE,uCAAA;EACA,+BAAA;EACA,sCAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EAEA,8BAAA;EACA,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,qCAAA;EAEA,4BAAA;EACA,sCAAA;EACA,kCAAA;EAEA,+BAAA;EACA,oCAAA;EACA,8BAAA;EACA,mCAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,oCAAA;EAEA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EAEA,mDAAA;EACA,iDAAA;EACA,oDAAA;EACA,oDAAA;EACA,2DAAA;EAEA,uKAAA;EACA,oCAAA;EACA,oCAAA;ADu8eF;;A+FnlfA;EACE,gCAAA;EACA,e9FqEe;ADihfjB;A+FplfE;EACE,yB9FOqB;AD+kfzB;A+FplfI;EACE,yB9FImB;E8FHnB,gB9FmEiB;E8FlEjB,c9FSmB;E8FRnB,sBAAA;A/FslfN;A+FllfE;EACE,4B9FFqB;ADslfzB;A+FjlfE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;A/FmlfJ;;A+F/kfA;;EAEE,oCAAA;EACA,uCAAA;A/FklfF;;A+F9kfA;EACE,gBAAA;A/FilfF;;A+F5kfE;EACE,kB9FQU;E8FPV,kFAAA;A/F+kfJ;A+F7kfI;EACE,yB9FvCmB;E8FwCnB,c9F3CmB;AD0nfzB;;A+FzkfA;EACE,oB9FDY;E8FEZ,yDAAA;A/F4kfF;A+F1kfE;EACE,yB9FnDqB;E8FoDrB,c9FvDqB;ADmofzB;;A+FjkfA;;;;EAIE,mEAAA;EACA,gCAAA;EACA,yC9FjBW;E8FkBX,oFAAA;A/FokfF;A+FlkfE;;;;EACE,4C9FpBS;E8FqBT,mEAAA;A/FukfJ;A+FpkfE;;;;EACE,0BAAA;A/FykfJ;A+FtkfE;;;;;;;EAEE,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;A/F6kfJ;;A+FzkfA;;;EAGE,kFAAA;A/F4kfF;;A+FtkfA;;;EAGE,oB9F1DY;E8F2DZ,gB9FnCqB;E8FoCrB,sBAAA;A/FykfF;;A+FtkfA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,e9F/Ca;E8FgDb,yB9FzFuB;E8F0FvB,c9FzFuB;ADkqfzB;A+FvkfE;EACE,yB9F9FqB;E8F+FrB,c9FhGqB;ADyqfzB;A+FtkfE;EAGE,yB9FzGqB;E8F0GrB,c9F3GqB;ADirfzB;A+FnkfE;EAGE,yB9F9GqB;E8F+GrB,c9FhHqB;ADmrfzB;;A+FzjfA;;EAEE,e9FjFwB;E8FkFxB,gB9F7EmB;E8F8EnB,c9FtIuB;E8FuIvB,sB9F1EqB;E8F2ErB,kB9FtHQ;E8FuHR,qBAAA;A/F4jfF;;A+FzjfA;EACE,mB9FxHQ;ADorfV;;A+FxjfA;;;;;;EAME,2BAAA;EACA,gCAAA;EACA,uFAAA;A/F2jfF;;A+FxjfA;;EAEE,iBAAA;EACA,e9F3Ge;ADsqfjB;;A+FnjfA;;EAEE,yBAAA;A/FsjfF;;A+FjjfA;;;;;EAME,gCAAA;A/FmjfF;;A+F3ifA;;;;EAKC,6BAAA;EACC,2BAAA;EACA,wBAAA;A/F6ifF;;A+F3ifA;;;;;EAKE,gCAAA;EACA,sDAAA;EACA,wBAAA;A/F8ifF;;A+FzifA;;;EAGE,oCAAA;EACA,oCAAA;EAEA,yBAAA;EACA,mBAAA;EACA,UAAA;A/F2ifF;;A+FvifA;EACE,2BAAA;EACA,4C9FvLW;E8FwLX,gBAAA;A/F0ifF;;A+FvifA;;;EAGE,oCAAA;EACA,yBAAA;A/F0ifF;;A+FtifA;EACE,kB9F9MY;ADuvfd;;A+FtifA;EACE,kB9FlNY;E8FmNZ,gB9FxLqB;ADiufvB;;A+FrifA;;EAEE,uFAAA;A/FwifF;;A+FrifA;EACE,6BAAA;A/FwifF;;A+FrifA;;EAEE,gCAAA;A/FwifF;;A+FpifA;EACE,2BAAA;EACA,gCAAA;EACA,0DAAA;A/FuifF;A+FrifE;EACE,gCAAA;EACA,sDAAA;A/FuifJ;A+FpifE;EACE,yB9FtRqB;E8FuRrB,c9FhRqB;ADszfzB;;A+F3hfE;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;A/F8hfJ;A+F3hfE;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,0DAAA;A/F6hfJ;A+F1hfE;EAEE,2C9FjQgB;AD4xfpB;A+FzhfI;;;EAEE,qB9F7TmB;ADy1fzB;;A+FphfA;;EAEE,uDAAA;A/FuhfF;;A+FjhfA;EACE;IACE,UAAA;IACA,0BAAA;E/FohfF;E+FlhfA;IACE,UAAA;IACA,wBAAA;E/FohfF;AACF;A+F9gfA;EACE,yCAAA;A/FghfF;;A+F7gfA;EACE;IACE,eAAA;E/FghfF;AACF;AA32fA;EACE,aAAA;EACA,mBAAA;AA62fF;AA52fE;EACE,gBAAA;AA82fJ;;AA12fA;;;;EAIE,YAAA;EACA,WAAA;EACA,SAAA;AA62fF;;AA12fA;EACE,YAAA;EACA,WAAA;EACA,SAAA;AA62fF;;AA12fA;EACE,yBCjCuB;AD84fzB;;AA32fA;EACE,yCAAA;AA82fF;AA72fE;EACE,oCAAA;AA+2fJ;AA72fE;EAGE,2BAAA;EACA,2BAAA;AA+2fJ;AAt2fE;EACE,WAAA;EACA,0BAAA;AAw2fJ;AAh2fI;EACE,4BAAA;AAk2fN;AAp2fE;EAIE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,aAAA;AAm2fJ;AAh2fE;EACE,kCAAA;EACA,yBAAA;EACA,0DAAA;AAk2fJ;AA10fE;EACE,yBAAA;AA40fJ;AA10fE;EACE,0BAAA;AA40fJ;AA10fE;EACE,sBUtHI;EVuHJ,cUlGE;EVmGF,UAAA;EACA,YAAA;AA40fJ;AA10fE;EACE,oCAAA;EACA,yBAAA;EACA,sCAAA;AA40fJ;AA10fE;EACE,oCAAA;EACA,yBAAA;EACA,sCAAA;AA40fJ;AAz0fE;EACE,0BAAA;EACA,yBAAA;EACA,iCAAA;AA20fJ;AAz0fE;EACE,yBAAA;AA20fJ;AAz0fE;EACE,oCAAA;EACA,sBAAA;EACA,oCAAA;EACA,+CAAA;EACA,eAAA;AA20fJ;AAz0fE;EACE,iCAAA;EACA,yBAAA;EACA,yBAAA;AA20fJ;AAz0fE;EACE,oCArKS;EAsKT,yBAAA;EACA,cCvJqB;ADk+fzB;AAz0fE;EACE,yBC1JqB;ED2JrB,oCAAA;EACA,yBAAA;AA20fJ;AAz0fE;EACE,sBUrKI;EVsKJ,cChKqB;EDiKrB,yBAAA;EACA,kBAAA;AA20fJ;AAx0fE;;;EAGE,yBAAA;AA00fJ;AAv0fE;EACE,qBAAA;EACA,0BAAA;EACA,cC9KqB;ADu/fzB;AA/zfE;EACE,cCzLqB;ED0LrB,mBAAA;AAi0fJ;AA/zfE;EACE,cC7LqB;AD8/fzB;AA/zfE;EACE,qBAAA;EACA,0BAAA;EACA,yBAAA;EACA,iCAAA;EACA,oCAAA;AAi0fJ;AA/zfE;EACE,cCvMqB;ADwggBzB;AA/zfE;EACE,yBCrMqB;ADsggBzB;AA/zfE;;EAEE,gCAAA;EACA,oCAAA;AAi0fJ;AA/zfE;EACE,YAAA;AAi0fJ;AAh/fA;EAkLE,0CAAA;AAi0fF;AAh0fE;EACE,yBCvNqB;EDwNrB,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,uBAAA;AAk0fJ;AAh0fE;EACE,wBAAA;AAk0fJ;AAh0fE;EACE,cCjOqB;EDkOrB,iCAAA;EACA,oCAAA;EACA,mBCpOqB;ADsigBzB;AAh0fE;;;;EAIE,cC1OqB;AD4igBzB;AAh0fE;EACE,cC7OqB;AD+igBzB;AA7zfE;EACE,cCnPqB;ADkjgBzB;AA7zfE;EACE,cCtPqB;ADqjgBzB;AA7zfE;EACE,yBAAA;AA+zfJ;AA5zfE;EACE,uBAAA;AA8zfJ;AA1yfE;;EAKE,cCtRqB;AD+jgBzB;AAvyfE;EACE,sBAAA;AAyyfJ;AAtyfE;EACE,cC7RqB;ADqkgBzB;AAtyfE;EACE,oCAAA;AAwyfJ;AAtyfE;;EAEE,oCAAA;AAwyfJ;AAryfE;EACE,gCAAA;EACA,gBAAA;AAuyfJ;;AAnyfA;EACE,wBAAA;EACA,0BAAA;EACA,yBAAA;AAsyfF;;AAnyfA;EACE,wBAAA;AAsyfF;;AApyfA;EACE,cCvTuB;EDwTvB,iCAAA;EACA,oCAAA;EACA,mBC1TuB;ADimgBzB;;AAryfA;;;;EAIE,cChUuB;ADwmgBzB;;AAtyfA;EACE,yBAAA;AAyyfF;;AApyfA;EACE,cCzUuB;ADgngBzB;;AAryfA;EACE,cC5UuB;ADongBzB;;AAtyfA;EACE,yBAAA;AAyyfF;;AAvyfA;EACE,yBAAA;AA0yfF;;AAtxfA;;EAEE,cCxWuB;ADiogBzB;;AAvxfA;EACE,sBAAA;AA0xfF;;AAvxfA;EACE,cC/WuB;ADyogBzB;;AAxxfA;EACE,oCAAA;AA2xfF;;AAzxfA;;EAEE,oCAAA;AA4xfF;;AA1xfA;EACE,yBAAA;EACA,mBAAA;AA6xfF;;AA3xfA;;;;EAIE,yBAAA;EACA,mBAAA;EACA,gCAAA;AA8xfF;;AA5xfA;EACE,oCAAA;EACA,sBAAA;EACA,oCAAA;EACA,+CAAA;EACA,eAAA;EACA,eAAA;AA+xfF;;AA7xfA;EACE,iCAAA;EACA,yBAAA;EACA,yBAAA;AAgyfF;;AA9xfA;EACE,sBUxZM;EVyZN,WAAA;AAiyfF;;AA9xfA;EACE,sBAAA;EACA,WU9ZM;AV+rgBR;;AA7xfA;;;EAKE,6BAAA;EACA,YAAA;EAIA,oCAAA;EACA,6BAAA;AA2xfF;;AAvxfA;EACE,iCAAA;EACA,gCAAA;EACA,sBAAA;AA0xfF;;AAxxfA;EACE,iCAAA;EACA,gCAAA;EACA,sBAAA;AA2xfF;;AAzxfA;EACE,iCAAA;EACA,gCAAA;EACA,sBAAA;AA4xfF;;AA1xfA;EACE,eAAA;AA6xfF;;AA3xfA;EACE,uBAAA;AA8xfF;;AAnwfA;;EAQE,oCAAA;AAgwfF;;AA9vfA;;EAQE,oCAAA;AA2vfF;;AAzvfA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,oCAAA;AA4vfF;;AA1vfA;EACE,oCAAA;AA6vfF;;AA1vfA;EACE,oCAAA;AA6vfF;;AA3vfA;EACE,yBAAA;AA8vfF;;AA5vfA;EACE,4BAAA;AA+vfF;;AA3vfA;EACE,oCAAA;EACA,wBAAA;AA8vfF;;AA5vfA;EACE,oCAAA;EACA,wBAAA;AA+vfF;;AA5vfA;;;EAGE,oCAAA;AA+vfF;;AA7vfA;EAEE,6BAAA;AAgwfF;;AA9vfA;EACE,oCAAA;AAiwfF;;AA/vfA;EACE,oCAAA;AAkwfF;;AAhwfA;EACE,qBCxhBuB;AD2xgBzB;;AAjwfA;EACE,gCAAA;AAowfF;;AAjwfA;EACQ,yBAAA;EACJ,iCAAA;EACA,oCAAA;EACA,8BAAA;EACA,6BAAA;AAowfJ","sourcesContent":["// If you want to override variables do it here\n@import 'variables';\n$base-color: rgb(255, 255, 255);\n$button-color: $button-color;\n$enable-ltr: true;\n$enable-rtl: true;\n\n// Import CoreUI for React components library\n@import 'rsuite/dist/rsuite.css';\n@import 'components/rsuite-overrides.scss';\n@import '@coreui/coreui/scss/coreui';\n\n// Import Chart.js custom tooltips styles\n@import '@coreui/chartjs/scss/coreui-chartjs';\n\n@import 'layout';\n@import 'example';\n@import 'components/meddra-preview';\n\n// If you want to add custom CSS you can put it here.\n@import 'custom';\n@import 'rtl';\n\n// Premium UI theme layer — imported last so its (non-!important) polish wins\n// the cascade over the legacy overrides above it.\n@import 'components/premium-ui';\n\n.toaster {\n  display: flex;\n  align-items: center;\n  .toaster-msg {\n    margin-left: 8px;\n  }\n}\n\nhtml,\nbody,\n#app,\n#app > div {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n}\n\n.base_button {\n  background-color: $button-color;\n}\nbody {\n  font-family: 'Source Sans Pro' !important;\n  .rs-table-cell-content:hover {\n    border: 0px $outline-color solid !important;\n  }\n  .rs-table-cell-full-text:hover {\n    -webkit-box-shadow: none !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  // .profile-avatar {\n  //   margin-top: 10px;\n  //   // height: inherit !important;\n  //   color: $white;\n  //   background-color:$primary ;\n  // }\n  .avatar-img {\n    width: 100%;\n    height: inherit !important;\n  }\n  // case form label\n  // .case_form_label{\n  //   font-size: 10px !important;\n  // }\n  //all page loader\n  .common-loader-wrapper {\n    &.delayed {\n      animation-delay: 2s forwards;\n    }\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 2000;\n  }\n  // all table excel download\n  .comon-excel-download {\n    background-color: white !important;\n    color: $button-color !important;\n    box-shadow: 0 6px 6px 0 rgb(106 44 118 / 40%) !important;\n  }\n  // .admin_status_select {\n  //   border: 1px $button-color solid !important;\n  //   border-radius: 6px !important;\n  // }\n  //All page table  Edit button sass\n  // .icon_size {\n  //   font-size: small;\n  //   background-color: $button-color;\n  // }\n  // .table_action_edit {\n  //   background-color: $button-color !important;\n  //   border: 1px solid $button-color !important ;\n  //   color: white !important;\n  //   font-size: 14px;\n  //   padding: 3px 8px 4px 8px !important;\n  // }\n  // .table_action_edit :hover{\n\n  //   border: 1px solid $button-color;\n  //   padding: 0px 8px 4px 8px !important;\n  // }\n  // End\n  .rs-picker-select-menu-item {\n    color: $button-color !important;\n  }\n  .rs-picker-toggle-placeholder {\n    font-size: 12px !important;\n  }\n  .tooltip-fields {\n    background-color: $white;\n    color: $red;\n    z-index: 0;\n    padding: 0px;\n  }\n  .rs-pagination-btn.rs-pagination-btn-active {\n    border: 1px $button-color solid !important;\n    color: $button-color !important;\n    box-shadow: 0 0 0 0 $button-color !important;\n  }\n  .rs-pagination-btn.rs-pagination-btn-active:hover {\n    border: 1px $button-color solid !important;\n    color: $button-color !important;\n    box-shadow: 0 0 0 0 $button-color !important;\n  }\n\n  .rs-picker-toggle-value {\n    font-size: 12px !important;\n    color: $button-color !important;\n    outline-color: $outline-color !important;\n  }\n  .rs-checkbox-inner {\n    background-color: #47114d;\n  }\n  .submit_btn {\n    background-color: $button-color !important;\n    color: $white !important;\n    border: 1px solid $button-color !important ;\n    box-shadow: 0 6px 6px 0 rgb(106 44 118 / 40%);\n    font-size: 14px;\n  }\n  .submit_btn:hover {\n    background-color: $white !important;\n    color: $button-color !important;\n    border: 1px solid $button-color;\n  }\n  .close_btn {\n    background-color: $base-color;\n    border: $button-color 1px solid;\n    color: $button-color;\n  }\n  .close_btn:hover {\n    background-color: $button-color;\n    color: $base-color !important;\n    border: $button-color 1px solid;\n  }\n  .medDra-close-btn[type='button']:not(:disabled) {\n    background-color: $white;\n    color: $button-color;\n    border: 1px $button-color solid;\n    margin-right: 10px;\n  }\n\n  .rs-table-hover .rs-table-row:hover .rs-table-cell,\n  .rs-table-hover .rs-table-row:hover .rs-table-cell-group,\n  .rs-table-hover .rs-table-row:not(.rs-table-row-header):hover {\n    background-color: #faf0fb;\n  }\n\n  .rs-form-group .rs-input {\n    display: inline-block;\n    font-size: 12px !important;\n    color: $button-color;\n    // outline-color: $outline-color !important;\n\n    //border: 0.1px $button-color solid !important;\n  }\n  // .rs-input-number {\n  //   color: $button-color;\n  //   outline-color: $outline-color !important;\n  //   border: 1px $button-color solid !important;\n  // }\n  .rs-btn-close .rs-icon {\n    color: $button-color;\n    font-weight: bolder;\n  }\n  .rs-panel-header {\n    color: $button-color;\n  }\n  .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input {\n    display: inline-block;\n    font-size: 12px !important;\n    color: $button-color !important;\n    outline-color: $outline-color !important;\n    border: 1px $button-color solid !important;\n  }\n  .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-search-icon {\n    color: $button-color;\n  }\n  .message_box {\n    background-color: $outline-color;\n  }\n  .rs-checkbox-checked .rs-checkbox-wrapper .rs-checkbox-inner:before,\n  .rs-checkbox-indeterminate .rs-checkbox-wrapper .rs-checkbox-inner:before {\n    border-color: $button-color !important;\n    background-color: $button-color !important;\n  }\n  .tooltip {\n    color: white;\n  }\n\n  /* Apply the custom class to the tooltip */\n  .tooltip-inner {\n    background-color: $button-color;\n    color: $white !important;\n    border: 1px solid $white;\n    box-shadow: 0 6px 6px 0 rgb(106 44 118 / 40%);\n    border: 1px solid white;\n  }\n  .tooltip-arrow {\n    display: none !important;\n  }\n  .group-input-fields.rs-picker.rs-picker-input.rs-picker-default.rs-picker-toggle-wrapper.rs-picker-cleanable.rs-picker-block.rs-picker-focused {\n    color: $button-color;\n    outline-color: $outline-color !important;\n    border: 1px $button-color solid !important;\n    box-shadow: $button-color;\n  }\n  .button:not(:disabled),\n  [type='button']:not(:disabled),\n  [type='reset']:not(:disabled),\n  [type='submit']:not(:disabled) {\n    color: $button-color;\n  }\n  .breadcrumb-item.active.breadCrumb-path-name {\n    color: $button-color;\n  }\n  // .header-nav .show > .nav-link, .header-nav .nav-link.active{\n  //   color: $button-color !important;\n  // }\n  .rs-message.rs-message-has-title .rs-message-icon-wrapper .rs-icon {\n    color: $button-color;\n  }\n  .rs-message-info .rs-message-body {\n    color: $button-color;\n  }\n  .rs-message-info .rs-message-header {\n    color: $button-color !important;\n  }\n\n  .icon_size {\n    color: white !important;\n  }\n  // .rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active{\n  //   color: $button-color !important;\n  //   outline-color: $outline-color !important;\n  //   border: 1px $button-color solid !important;\n  //   box-shadow: $button-color !important;\n  // }\n  // .rs-picker.rs-picker-focused{\n  //   color: $button-color !important;\n  //   outline-color: $outline-color !important;\n  //   border: 1px $button-color solid !important;\n  //   box-shadow: $button-color !important;\n  // }\n  // .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover{\n  //   color: $button-color !important;\n  //   outline-color: $outline-color !important;\n  //   border: 1px $button-color solid !important;\n  //   box-shadow: $button-color !important;\n  // }\n  .rs-navbar-default\n    .rs-dropdown\n    .rs-dropdown-menu-active\n    ~ .rs-dropdown-toggle,\n  .rs-navbar-default .rs-navbar-item.rs-navbar-item-active {\n    color: $button-color;\n  }\n  .rs-steps-item-icon-wrapper > .rs-steps-item-icon .rs-icon {\n    color: $white !important;\n  }\n\n  .rs-drawer-title {\n    color: $button-color;\n  }\n  .header-nav .dropdown-menu {\n    border: 1px solid $button-color !important;\n  }\n  .rs-badge-independent,\n  .rs-badge-content {\n    background-color: $button-color !important;\n  }\n\n  .sidebar-brand {\n    border-bottom: 1px solid $button-color;\n    background: #fff;\n  }\n}\n\n.loader_common_style{\n  z-index: 2000 !important;\n  position: fixed !important;\n  color: $button-color !important;\n}\n\n.tooltip-arrow {\n  display: none !important;\n}\n.group-input-fields.rs-picker.rs-picker-input.rs-picker-default.rs-picker-toggle-wrapper.rs-picker-cleanable.rs-picker-block.rs-picker-focused {\n  color: $button-color;\n  outline-color: $outline-color !important;\n  border: 1px $button-color solid !important;\n  box-shadow: $button-color;\n}\n.button:not(:disabled),\n[type='button']:not(:disabled),\n[type='reset']:not(:disabled),\n[type='submit']:not(:disabled) {\n  color: $button-color;\n}\n.breadcrumb-item.active.breadCrumb-path-name {\n  color: $button-color !important;\n}\n// .header-nav .show > .nav-link, .header-nav .nav-link.active{\n//   color: $button-color !important;\n// }\n.rs-message.rs-message-has-title .rs-message-icon-wrapper .rs-icon {\n  color: $button-color;\n}\n.rs-message-info .rs-message-body {\n  color: $button-color;\n}\n.rs-message-info .rs-message-header {\n  color: $button-color !important;\n}\n.header-nav .nav-link {\n  color: $button-color !important;\n}\n// .rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active{\n//   color: $button-color !important;\n//   outline-color: $outline-color !important;\n//   border: 1px $button-color solid !important;\n//   box-shadow: $button-color !important;\n// }\n// .rs-picker.rs-picker-focused{\n//   color: $button-color !important;\n//   outline-color: $outline-color !important;\n//   border: 1px $button-color solid !important;\n//   box-shadow: $button-color !important;\n// }\n// .rs-picker-default:not(.rs-picker-disabled) .rs-btn:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-btn:hover, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus, .rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover{\n//   color: $button-color !important;\n//   outline-color: $outline-color !important;\n//   border: 1px $button-color solid !important;\n//   box-shadow: $button-color !important;\n// }\n.rs-navbar-default .rs-dropdown .rs-dropdown-menu-active ~ .rs-dropdown-toggle,\n.rs-navbar-default .rs-navbar-item.rs-navbar-item-active {\n  color: $button-color;\n}\n.rs-steps-item-icon-wrapper > .rs-steps-item-icon .rs-icon {\n  color: $white !important;\n}\n\n.rs-drawer-title {\n  color: $button-color;\n}\n.header-nav .dropdown-menu {\n  border: 1px solid $button-color !important;\n}\n.rs-badge-independent,\n.rs-badge-content {\n  background-color: $button-color !important;\n}\n.rs-modal-title {\n  color: $button-color !important;\n  font-weight: bolder;\n}\n.react-flow__node-default,\n.react-flow__node-input,\n.react-flow__node-output,\n.react-flow__node-group {\n  color: $button-color !important;\n  font-weight: bolder;\n  border-color: $button-color !important;\n}\n.view-wrapper {\n  background-color: $button-color !important;\n  color: $white !important;\n  border: 1px solid $button-color !important ;\n  box-shadow: 0 6px 6px 0 rgb(106 44 118 / 40%);\n  font-size: 14px;\n  cursor: pointer;\n}\n.view-wrapper:hover {\n  background-color: $white !important;\n  color: $button-color !important;\n  border: $button-color 1px solid;\n}\n#root .light {\n  background-color: $white;\n  color: #000;\n}\n\n#root .dark {\n  background-color: #333;\n  color: $white;\n}\n// Inputpicker hover color\n\n.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:hover,\n.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle:focus,\n.rs-picker-default:not(.rs-picker-disabled) .rs-picker-toggle-active {\n\n  // outline-style: groove;\n  outline-width: 4px !important;\n  opacity: 0.9;\n  // outline-color: $outline-color !important;\n  // outline-color: rgba(170, 50, 220, 0.6);\n  // outline: 0.1em solid $outline-color;\n  border: 1px solid $button-color !important;\n  border-radius: 0px !important;\n}\n//end\n//password outline color change\n.iconbtn_outline_clr:hover {\n  outline-color: $outline-color !important;\n  border-color: $outline-color !important;\n  width: 100% !important;\n}\n.iconbtn_outline_clr:focus {\n  outline-color: $outline-color !important;\n  border-color: $outline-color !important;\n  width: 100% !important;\n}\n.iconbtn_outline_clr {\n  outline-color: $outline-color !important;\n  border-color: $outline-color !important;\n  width: 100% !important;\n}\n.sidebar-brand.d-none.d-md-flex {\n  min-width: 100%;\n}\n.rs-table-cell.rs-table-cell-full-text {\n  height: 46px !important;\n}\n// .rs-table-cell-content {\n//   height: 45.4px !important;\n// }\n\n//breadcrum\n// .breadcrumb-item.active.breadCrumb-path-name{\n//   padding: 0px 0px 0px 0px !important;\n// }\n// .breadcrumb-item.breadcrumb-item::before {\n//   padding-right:0px !important;\n\n// }\n// .breadcrumb-item.breadcrumb-item{\n//   padding-left:0px !important;\n// }\n\n// .rs-picker-check-menu-items\n//   .rs-check-item.rs-checkbox-checked\n//   .rs-checkbox-checker\n//   > label {\n//   background-color: #47114d !important;\n// }\n\n////  CheckPicker\n\n.rs-picker-check-menu-items\n  .rs-check-item.rs-checkbox-checked\n  .rs-checkbox-checker\n  > label,\n.rs-picker-check-menu-items\n  .rs-check-item.rs-checkbox-checked\n  .rs-checkbox-checker\n  > label:hover {\n  background-color: $outline-color !important;\n}\n.rs-picker-check-menu-items\n  .rs-check-item.rs-checkbox-uncheck\n  .rs-checkbox-checker\n  > label,\n.rs-picker-check-menu-items\n  .rs-check-item.rs-checkbox-uncheck\n  .rs-checkbox-checker\n  > label:hover {\n  background-color: $outline-color !important;\n}\n.rs-check-item .rs-checkbox-checker > label:hover {\n  cursor: pointer;\n  display: block;\n  line-height: 20px;\n  padding: 8px 12px 8px 38px;\n  position: relative;\n  background-color: $outline-color !important;\n}\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {\n  background-color: $outline-color !important;\n}\n\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content:hover {\n  background-color: $outline-color !important;\n}\n.rs-calendar-month-dropdown-year-active {\n  color: $outline-color !important;\n}\n.rs-check-item-rs-check-item-focus-rs-checkbox {\n  border-color: red !important;\n}\n\n//// SelectPicker\n.rs-picker-select-menu-item.rs-picker-select-menu-item-active {\n  background-color: #faf0fb !important;\n  opacity: 20px !important;\n}\n.rs-picker-select-menu-item:hover {\n  background-color: #faf0fb !important;\n  opacity: 40px !important;\n}\n\n.rs-picker-select-menu-item.rs-picker-select-menu-item-focus,\n.rs-picker-select-menu-item:focus,\n.rs-picker-select-menu-item:hover {\n  background-color: #faf0fb !important;\n}\n.rs-radio [type='radio']:focus ~ .rs-radio-inner::before {\n  -webkit-box-shadow: 0 0 0 3px $outline-color;\n  box-shadow: 0 0 0 3px $outline-color;\n}\n.rs-picker-menu .rs-calender .rs-calender-table-cell-content:hover {\n  background-color: $outline-color !important;\n}\n.rs-check-item .rs-checkbox-checker > label:hover {\n  background-color: $outline-color !important;\n}\n.rs-checkbox-inner:hover {\n  border-color: $outline-color;\n}\nlabel:hover .rs-checkbox-wrapper .rs-checkbox-inner::before {\n  border-color: $button-color !important;\n}\n.rs-search-box{\n.rs-input-group.rs-input-group-inside{\n        color: $button-color !important;\n    outline-color: $outline-color !important;\n    border: 1px $button-color solid !important;\n    box-shadow: $button-color !important;\n    border-radius: 0px !important;\n}}","// =============================================================================\n// THRANA DESIGN TOKENS\n// -----------------------------------------------------------------------------\n// Single source of truth for the visual theme layer (colors, spacing, radius,\n// shadow, typography). Pure styling tokens only — nothing here should encode\n// layout structure, routes, or business logic.\n//\n// Consumed by:\n//   - _variables.scss   (Bootstrap/CoreUI variable overrides, compiled once)\n//   - :root CSS custom properties below (usable at runtime by CoreUI's\n//     --cui-* vars, rsuite's --rs-* vars, and any component-level CSS/inline\n//     style that wants to read a token, e.g. var(--thrana-color-primary))\n// =============================================================================\n\n// -----------------------------------------------------------------------------\n// Color — brand tonal scale\n// -----------------------------------------------------------------------------\n$color-primary-darkest:  #2a0040; // sidebar / nav background\n$color-primary:          #3c005a; // brand primary (buttons, links, active states)\n$color-primary-strong:   #5c1680; // hover / pressed depth\n$color-primary-light:    #7a2ba3; // lighter accent, secondary hovers\n$color-primary-tint:     #f3ecf7; // soft background / badges / selected rows\n$color-primary-tint-2:   #faf5fc; // even softer wash (table hover, subtle panels)\n$color-outline:          #efc7f5; // focus/outline accents (legacy alias, kept)\n\n// Neutral canvas\n$color-canvas:           #fafafa;\n$color-canvas-alt:       #f8f7fa;\n$color-surface:          #ffffff;\n$color-border:           #eeeeee;\n$color-border-strong:    #e0e0e0;\n\n// Text\n$color-text:             #1f1224; // near-black with a hint of brand hue\n$color-text-secondary:   #6b6470;\n$color-text-muted:       #9a93a0;\n$color-text-inverse:     rgba(255, 255, 255, 0.92);\n$color-text-inverse-muted: rgba(255, 255, 255, 0.65);\n\n// Status\n$color-success:          #1a7f4b;\n$color-success-tint:     #e6f4ec;\n$color-danger:           #b3261e;\n$color-danger-tint:      #fbeceb;\n$color-warning:          #9a6700;\n$color-warning-tint:     #fdf3d9;\n$color-neutral-tint:     #eef0f2;\n$color-neutral-text:     #5f6368;\n\n// -----------------------------------------------------------------------------\n// Spacing (8px grid)\n// -----------------------------------------------------------------------------\n$space-1: 4px;   // half-step, use sparingly (icon gaps)\n$space-2: 8px;\n$space-3: 12px;\n$space-4: 16px;\n$space-5: 24px;\n$space-6: 32px;\n$space-7: 40px;\n$space-8: 48px;\n\n// -----------------------------------------------------------------------------\n// Radius\n// -----------------------------------------------------------------------------\n$radius-sm:   6px;  // chips, small badges\n$radius-md:   8px;  // buttons, inputs\n$radius-lg:   12px; // cards, modals, panels\n$radius-pill: 999px;\n\n// -----------------------------------------------------------------------------\n// Shadow (soft depth, not harsh borders)\n// -----------------------------------------------------------------------------\n$shadow-xs:  0 1px 2px rgba(20, 0, 30, 0.04);\n$shadow-sm:  0 1px 3px rgba(0, 0, 0, 0.06);\n$shadow-md:  0 4px 12px rgba(60, 0, 90, 0.08);\n$shadow-lg:  0 8px 24px rgba(60, 0, 90, 0.14);\n$shadow-focus-ring: 0 0 0 3px rgba(60, 0, 90, 0.18);\n\n// -----------------------------------------------------------------------------\n// Typography\n// -----------------------------------------------------------------------------\n$font-family-base: 'Inter', 'Source Sans Pro', -apple-system, BlinkMacSystemFont,\n  'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';\n\n$font-size-page-title: 22px; // 20-24px semi-bold\n$font-size-section-label: 13px; // uppercase tracked\n$font-size-body: 14px;\n$font-size-sm: 12px;\n\n$font-weight-regular: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n$line-height-base: 1.5;\n$letter-spacing-label: 0.04em;\n\n// -----------------------------------------------------------------------------\n// Motion\n// -----------------------------------------------------------------------------\n$transition-fast: 150ms ease;\n$transition-base: 200ms ease;\n\n// -----------------------------------------------------------------------------\n// Runtime CSS custom properties\n// -----------------------------------------------------------------------------\n// Exposed on :root so JS / inline styles / third-party widgets (rsuite, CoreUI)\n// can reference the same values without a SCSS recompile.\n:root {\n  --thrana-color-primary-darkest: #{$color-primary-darkest};\n  --thrana-color-primary: #{$color-primary};\n  --thrana-color-primary-strong: #{$color-primary-strong};\n  --thrana-color-primary-light: #{$color-primary-light};\n  --thrana-color-primary-tint: #{$color-primary-tint};\n  --thrana-color-primary-tint-2: #{$color-primary-tint-2};\n\n  --thrana-color-canvas: #{$color-canvas};\n  --thrana-color-canvas-alt: #{$color-canvas-alt};\n  --thrana-color-surface: #{$color-surface};\n  --thrana-color-border: #{$color-border};\n  --thrana-color-border-strong: #{$color-border-strong};\n\n  --thrana-color-text: #{$color-text};\n  --thrana-color-text-secondary: #{$color-text-secondary};\n  --thrana-color-text-muted: #{$color-text-muted};\n\n  --thrana-color-success: #{$color-success};\n  --thrana-color-success-tint: #{$color-success-tint};\n  --thrana-color-danger: #{$color-danger};\n  --thrana-color-danger-tint: #{$color-danger-tint};\n  --thrana-color-warning: #{$color-warning};\n  --thrana-color-warning-tint: #{$color-warning-tint};\n  --thrana-color-neutral-tint: #{$color-neutral-tint};\n  --thrana-color-neutral-text: #{$color-neutral-text};\n\n  --thrana-space-1: #{$space-1};\n  --thrana-space-2: #{$space-2};\n  --thrana-space-3: #{$space-3};\n  --thrana-space-4: #{$space-4};\n  --thrana-space-5: #{$space-5};\n  --thrana-space-6: #{$space-6};\n\n  --thrana-radius-sm: #{$radius-sm};\n  --thrana-radius-md: #{$radius-md};\n  --thrana-radius-lg: #{$radius-lg};\n  --thrana-radius-pill: #{$radius-pill};\n\n  --thrana-shadow-xs: #{$shadow-xs};\n  --thrana-shadow-sm: #{$shadow-sm};\n  --thrana-shadow-md: #{$shadow-md};\n  --thrana-shadow-lg: #{$shadow-lg};\n  --thrana-shadow-focus-ring: #{$shadow-focus-ring};\n\n  --thrana-font-family-base: #{$font-family-base};\n  --thrana-transition-fast: #{$transition-fast};\n  --thrana-transition-base: #{$transition-base};\n}\n","/* RSuite Checkbox Overrides */\n:root {\n  --rs-primary-500: #3c005a !important;\n  --rs-primary-600: #3c005a !important;\n  --rs-primary-700: #3c005a !important;\n}\n\n.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker::before {\n  background-color: var(--rs-primary-500) !important;\n}\n\n.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker:hover {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker:focus {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker:active {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n/* Override the checkmark */\n.rs-checkbox-wrapper .rs-checkbox-checked .rs-checkbox-checker::before {\n  background-color: var(--rs-primary-500) !important;\n}\n\n/* Override the checkbox input */\n.rs-checkbox-wrapper .rs-checkbox input[type=\"checkbox\"]:checked + .rs-checkbox-checker {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n/* Override any inline styles */\n[style*=\"background-color: rgb(51, 153, 255)\"],\n[style*=\"background-color: #3399ff\"],\n[style*=\"border-color: rgb(51, 153, 255)\"],\n[style*=\"border-color: #3399ff\"] {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n/* RSuite Radio Button Overrides */\n.rs-radio-wrapper .rs-radio-checked .rs-radio-checker {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n.rs-radio-wrapper .rs-radio-checked .rs-radio-checker::before {\n  background-color: var(--rs-primary-500) !important;\n}\n\n.rs-radio-wrapper .rs-radio-checked .rs-radio-checker:hover {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n.rs-radio-wrapper .rs-radio-checked .rs-radio-checker:focus {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n.rs-radio-wrapper .rs-radio-checked .rs-radio-checker:active {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n/* Override the radio input */\n.rs-radio-wrapper .rs-radio input[type=\"radio\"]:checked + .rs-radio-checker {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n}\n\n/* Override radio button inline styles */\n.rs-radio-wrapper [style*=\"background-color: rgb(51, 153, 255)\"],\n.rs-radio-wrapper [style*=\"background-color: #3399ff\"],\n.rs-radio-wrapper [style*=\"border-color: rgb(51, 153, 255)\"],\n.rs-radio-wrapper [style*=\"border-color: #3399ff\"] {\n  background-color: var(--rs-primary-500) !important;\n  border-color: var(--rs-primary-500) !important;\n} ","@mixin bsBanner($file) {\n  /*!\n   * CoreUI #{$file} v4.3.0 (https://coreui.io)\n   * Copyright (c) 2023 creativeLabs Łukasz Holeczek\n   * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)\n   */\n}\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}high-emphasis: #{$text-high-emphasis};\n  --#{$prefix}medium-emphasis: #{$text-medium-emphasis};\n  --#{$prefix}disabled: #{$text-disabled};\n\n  --#{$prefix}high-emphasis-inverse: #{$text-high-emphasis-inverse};\n  --#{$prefix}medium-emphasis-inverse: #{$text-medium-emphasis-inverse};\n  --#{$prefix}disabled-inverse: #{$text-disabled-inverse};\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\n// ol,\n// ul {\n//   @include ltr-rtl(\"padding-left\", 2rem); // TODO: find solution\n// }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  @include ltr-rtl(\"margin-left\", 0); // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  @include ltr-rtl(\"float\", left); // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #3c4b64 !default;\n$gray-100:  #ebedef !default;\n$gray-200:  #d8dbe0 !default;\n$gray-300:  #c4c9d0 !default;\n$gray-400:  #b1b7c1 !default;\n$gray-500:  #9da5b1 !default;\n$gray-600:  #8a93a2 !default;\n$gray-700:  #768192 !default;\n$gray-800:  #636f83 !default;\n$gray-900:  #4f5d73 !default;\n$black:     #000015 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default;\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default;\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default;\n\n$high-emphasis-inverse:    rgba($white, .87) !default;\n$medium-emphasis-inverse:  rgba($white, .6) !default;\n$disabled-inverse:         rgba($white, .38) !default;\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// fusv-disable\n$primary-dark:  #1f1498 !default;\n$primary-base:  #321fdb !default;\n$primary-50:    #988fed !default;\n$primary-25:    #ccc7f6 !default;\n\n$secondary-dark:  #212233 !default;\n$secondary-base:  #9da5b1 !default;\n$secondary-50:    #9da5b1 !default;\n$secondary-25:    #ced2d8 !default;\n\n$success-dark:  #1b9e3e !default;\n$success-base:  #2eb85c !default;\n$success-50:    #96dbad !default;\n$success-25:    #cbedd6 !default;\n\n$info-dark:  #2982cc !default;\n$info-base:  #39f !default;\n$info-50:    #80c6ff !default;\n$info-25:    #c0e6ff !default;\n\n$warning-dark:  #f6960b !default;\n$warning-base:  #f9b115 !default;\n$warning-50:    #fcd88a !default;\n$warning-25:    #feecc5 !default;\n\n$danger-dark:  #d93737 !default;\n$danger-base:  #e55353 !default;\n$danger-50:    #f2a9a9 !default;\n$danger-25:    #f9d4d4 !default;\n\n$light-dark:     $gray-100 !default;\n$light-base:     $gray-100 !default;\n$light-50:       shift-color($light-base, -70%) !default;\n$light-25:       shift-color($light-base, -80%) !default;\n\n$dark-dark:      $gray-900 !default;\n$dark-base:      $gray-900 !default;\n$dark-50:        shift-color($dark-base, -70%) !default;\n$dark-25:        shift-color($dark-base, -80%) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $primary-base !default;\n$secondary:     $secondary-base !default;\n$success:       $success-base !default;\n$info:          $info-base !default;\n$warning:       $warning-base !default;\n$danger:        $danger-base !default;\n$light:         $light-base !default;\n$dark:          $dark-base !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $high-emphasis-inverse !default;\n$color-contrast-light:     $high-emphasis !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.3.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           md !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $high-emphasis !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      $medium-emphasis !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       $disabled !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-200 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $high-emphasis-inverse !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n$text-high-emphasis:            $high-emphasis !default;\n$text-medium-emphasis:          $medium-emphasis !default;\n$text-disabled:                 $disabled !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 4.3.0\n// fusv-enable\n\n$text-high-emphasis-inverse:    $high-emphasis-inverse !default;\n$text-medium-emphasis-inverse:  $medium-emphasis-inverse !default;\n$text-disabled-inverse:         $disabled-inverse !default;\n\n$initialism-font-size:          $small-font-size !default;\n\n$blockquote-margin-y:           $spacer !default;\n$blockquote-font-size:          $font-size-base * 1.25 !default;\n$blockquote-footer-color:       $gray-600 !default;\n$blockquote-footer-font-size:   $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n\n// scss-docs-start button-variants\n$button-variants: (\n  \"primary\": btn-color-map($primary, $primary),\n  \"secondary\": btn-color-map($secondary, $secondary),\n  \"success\": btn-color-map($success, $success),\n  \"danger\": btn-color-map($danger, $danger),\n  \"warning\": btn-color-map($warning, $warning),\n  \"info\": btn-color-map($info, $info),\n  \"light\": btn-color-map($light, $light),\n  \"dark\": btn-color-map($dark, $dark)\n) !default;\n\n$button-outline-ghost-variants: (\n  \"primary\": btn-outline-color-map($primary),\n  \"secondary\": btn-outline-color-map($secondary),\n  \"success\": btn-outline-color-map($success),\n  \"danger\": btn-outline-color-map($danger),\n  \"warning\": btn-outline-color-map($warning),\n  \"info\": btn-outline-color-map($info),\n  \"light\": btn-outline-color-map($light),\n  \"dark\": btn-outline-color-map($dark)\n) !default;\n// scss-docs-end button-variants\n// scss-docs-end btn-variables\n\n\n// Forms\n// scss-docs-start form-variables\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 1.75em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 2em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n// scss-docs-end form-variables\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $high-emphasis-inverse !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $high-emphasis-inverse !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:  2rem !default;\n\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n\n$avatar-transition: margin .15s !default;\n// scss-docs-end avatar-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// scss-docs-start alert-variants\n$alert-variants: () !default;\n@each $state, $value in $theme-colors {\n  $map: ();\n  $alert-variants: map-merge($alert-variants, map-merge($map, ($state: alert-color-map($value))));\n}\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc($callout-border-width * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $high-emphasis-inverse !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n$list-group-variants: (\n  \"primary\": list-group-color-map($primary),\n  \"secondary\": list-group-color-map($secondary),\n  \"success\": list-group-color-map($success),\n  \"danger\": list-group-color-map($danger),\n  \"warning\": list-group-color-map($warning),\n  \"info\": list-group-color-map($info),\n  \"light\": list-group-color-map($light),\n  \"dark\": list-group-color-map($dark)\n) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-min-height:             4rem !default;\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-color:        currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-icon-bg:           url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-color:  currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-hover-icon-bg:     url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-hover-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n// Subheader\n// scss-docs-start subheader-variables\n$subheader-min-height:           3rem !default;\n$subheader-padding-y:            $spacer * .5 !default;\n$subheader-padding-x:            $spacer !default;\n$subheader-border-color:         var(--#{$prefix}border-color) !default;\n$subheader-border-width:         var(--#{$prefix}border-width) !default;\n\n$subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader-variables\n\n// Default theme\n// scss-docs-start subheader-default-themes\n$subheader-bg:                     $white !default;\n$subheader-color:                  var(--#{$prefix}secondary-color) !default;\n$subheader-hover-color:            var(--#{$prefix}body-color) !default;\n$subheader-active-color:           var(--#{$prefix}body-color) !default;\n$subheader-disabled-color:         $disabled !default;\n// scss-docs-end subheader-default-themes\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n// scss-docs-start carousel-variables\n$carousel-control-color:             $high-emphasis-inverse !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $high-emphasis-inverse !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $high-emphasis !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-padding-y:                        0 !default;\n$sidebar-padding-x:                        0 !default;\n$sidebar-color:                            $high-emphasis-inverse !default;\n$sidebar-bg:                               $gray-base !default;\n$sidebar-border-width:                     0 !default;\n$sidebar-border-color:                     transparent !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n\n$sidebar-brand-height:                     4rem !default;\n$sidebar-brand-color:                      $high-emphasis-inverse !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n\n$sidebar-header-height:                    4rem !default;\n$sidebar-header-padding-y:                 .75rem !default;\n$sidebar-header-padding-x:                 1rem !default;\n$sidebar-header-bg:                        rgba($black, .2) !default;\n$sidebar-header-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-narrow-width:                     4rem !default;\n\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n\n$sidebar-nav-title-padding-y:              .75rem !default;\n$sidebar-nav-title-padding-x:              1rem !default;\n$sidebar-nav-title-margin-top:             1rem !default;\n$sidebar-nav-title-color:                  $medium-emphasis-inverse !default;\n$sidebar-nav-title-transition:             height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:               .8445rem !default;\n$sidebar-nav-link-padding-x:               1rem !default;\n$sidebar-nav-link-color:                   $medium-emphasis-inverse !default;\n$sidebar-nav-link-bg:                      transparent !default;\n$sidebar-nav-link-border-width:            0 !default;\n$sidebar-nav-link-border-color:            transparent !default;\n$sidebar-nav-link-border-radius:           0 !default;\n$sidebar-nav-link-transition:              background .15s ease, color .15s ease !default;\n$sidebar-nav-link-icon-color:              $medium-emphasis-inverse !default;\n\n$sidebar-nav-link-hover-color:             $high-emphasis-inverse !default;\n$sidebar-nav-link-hover-bg:                rgba($white, .05) !default;\n$sidebar-nav-link-hover-icon-color:        $high-emphasis-inverse !default;\n\n$sidebar-nav-link-active-color:            $high-emphasis-inverse !default;\n$sidebar-nav-link-active-bg:               rgba($white, .05) !default;\n$sidebar-nav-link-active-icon-color:       $high-emphasis-inverse !default;\n\n$sidebar-nav-link-disabled-color:          $disabled-inverse !default;\n$sidebar-nav-link-disabled-icon-color:     $sidebar-nav-link-icon-color !default;\n\n$sidebar-nav-icon-width:                   4rem !default;\n$sidebar-nav-icon-height:                  1.25rem !default;\n$sidebar-nav-icon-font-size:               $sidebar-nav-icon-height !default;\n\n$sidebar-nav-group-bg:                     rgba(0, 0, 0, .2) !default;\n$sidebar-nav-group-transition:             background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:      $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:        0 !default;\n$sidebar-nav-group-items-padding-x:        0 !default;\n$sidebar-nav-group-items-transition:       height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:        $medium-emphasis-inverse !default;\n$sidebar-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:  $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-transition:   transform .15s !default;\n\n$sidebar-footer-height:                    auto !default;\n$sidebar-footer-padding-y:                 .75rem !default;\n$sidebar-footer-padding-x:                 1rem !default;\n$sidebar-footer-bg:                        rgba($black, .2) !default;\n$sidebar-footer-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-toggler-height:                   3rem !default;\n$sidebar-toggler-bg:                       rgba($black, .2) !default;\n$sidebar-toggler-transition:               transform .15s !default;\n\n$sidebar-toggler-indicator-width:          4rem !default;\n$sidebar-toggler-indicator-height:         3rem !default;\n$sidebar-toggler-indicator-color:          $disabled-inverse !default;\n$sidebar-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n$sidebar-toggler-hover-bg:                 rgba(0, 0, 0, .3) !default;\n$sidebar-toggler-indicator-hover-color:    $sidebar-nav-link-hover-color !default;\n$sidebar-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// scss-docs-end sidebar-variables\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $high-emphasis !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n","@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n@function reflect($element) {\n  $string: #{$element};\n  @if str-index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if str-index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return unquote($string);\n}\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: null) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n    @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: null) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    } @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-left-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n// scss-docs-end border-radius-mixins\n","\n@import 'tokens';\n\n// ---------------------------------------------------------------------------\n// Brand palette — sourced from _tokens.scss. Kept as the same variable names\n// already used throughout the app (button-color, outline-color, purple-*)\n// so no call sites needed to change, only the values feeding a premium,\n// consistent tonal scale.\n// ---------------------------------------------------------------------------\n$primary: $color-primary;\n$secondary:#8a8388;\n\n$white: #fff !default;\n$black: #000015 !default;\n$button-color: $color-primary !default;\n$button-color-strong: $color-primary-strong !default;\n$button-color-darkest: $color-primary-darkest !default;\n$button-disabled-color: #eeebef;\n$outline-color: $color-outline !default;\n$purple-base: #391265 !default;\n$purple-100: $color-primary-tint !default;\n$purple-200: #ca7fe3 !default;\n$purple-300: #dc79e6 !default;\n$purple-400: #9161be !default;\n$purple-500: #5a3293 !default;\n$purple-600: #580d5a !default;\n$purple-700: #521963 !default;\n$purple-800: #360636 !default;\n$purple-900: #15021f !default;\n$blue: #0d6efd !default;\n$indigo: #6610f2 !default;\n$purple: #6f42c1 !default;\n$pink: #d63384 !default;\n$red: #dc3545 !default;\n$orange: #fd7e14 !default;\n$yellow: #ffc107 !default;\n$green: #198754 !default;\n$teal: #20c997 !default;\n$cyan: #0dcaf0 !default;\n$purple_light: $color-outline !default;\n$grey:#f2f2f3;\n\n// =============================================================================\n// THRANA THEME — active CoreUI/Bootstrap variable overrides\n// -----------------------------------------------------------------------------\n// These feed the actual coreui.scss compile (imported right after this file),\n// so changes here reach every CoreUI component (buttons, cards, badges,\n// tables, modals, sidebar, pagination, dropdowns...) without per-component CSS.\n// All values trace back to _tokens.scss — do not hardcode new colors here.\n// =============================================================================\n\n// Body / canvas\n$body-bg: $color-canvas;\n$body-color: $color-text;\n\n// Typography\n$font-family-sans-serif: $font-family-base;\n$font-size-base: 0.875rem; // 14px body\n$headings-font-weight: $font-weight-semibold;\n\n// Radius\n$border-radius: $radius-md;\n$border-radius-sm: $radius-sm;\n$border-radius-lg: $radius-lg;\n$border-radius-pill: $radius-pill;\n$border-color: $color-border;\n\n// Shadows (soft depth instead of harsh borders)\n$box-shadow-sm: $shadow-sm;\n$box-shadow: $shadow-md;\n$box-shadow-lg: $shadow-lg;\n\n// Buttons + form controls — comfortable 8-10px vertical padding, rounded corners\n$input-btn-padding-y: 0.5rem;   // 8px\n$input-btn-padding-x: 1rem;\n$input-btn-padding-y-sm: 0.375rem;\n$input-btn-padding-x-sm: 0.75rem;\n$input-btn-focus-color: rgba($color-primary, 0.18);\n$input-btn-focus-box-shadow: $shadow-focus-ring;\n$btn-border-radius: $radius-md;\n$btn-border-radius-sm: $radius-sm;\n$btn-border-radius-lg: $radius-lg;\n$btn-transition: color $transition-fast, background-color $transition-fast,\n  border-color $transition-fast, box-shadow $transition-fast, transform $transition-fast;\n\n$input-border-radius: $radius-md;\n$input-border-radius-sm: $radius-sm;\n$input-border-radius-lg: $radius-lg;\n$input-border-color: $color-border-strong;\n$input-focus-border-color: $color-primary-light;\n$input-focus-box-shadow: $shadow-focus-ring;\n$input-disabled-bg: #f2f0f3;\n$input-disabled-border-color: $color-border-strong;\n\n// Cards\n$card-border-radius: $radius-lg;\n$card-border-color: $color-border;\n$card-cap-bg: $color-surface;\n$card-bg: $color-surface;\n$card-spacer-y: $space-5;\n$card-spacer-x: $space-5;\n\n// Badges — pill-shaped, restrained color (fills come from status classes, see _custom.scss)\n$badge-border-radius: $radius-pill;\n$badge-font-weight: $font-weight-semibold;\n$badge-padding-y: 0.3em;\n$badge-padding-x: 0.75em;\n\n// Dropdowns / popovers\n$dropdown-border-radius: $radius-md;\n$dropdown-border-color: $color-border;\n$dropdown-box-shadow: $shadow-md;\n$dropdown-link-active-color: $color-primary;\n$dropdown-link-active-bg: $color-primary-tint;\n$dropdown-link-hover-bg: $color-primary-tint-2;\n$popover-border-radius: $radius-lg;\n$popover-box-shadow: $shadow-lg;\n\n// Modals\n$modal-content-border-radius: $radius-lg;\n$modal-content-box-shadow-sm-up: $shadow-lg;\n$modal-header-border-color: $color-border;\n$modal-footer-border-color: $color-border;\n\n// Pagination\n$pagination-border-radius: $radius-md;\n$pagination-color: $color-primary;\n$pagination-hover-bg: $color-primary-tint;\n$pagination-hover-border-color: $color-primary-tint;\n$pagination-active-bg: $color-primary;\n$pagination-active-border-color: $color-primary;\n$pagination-border-color: $color-border-strong;\n\n// Tables\n$table-hover-bg: $color-primary-tint-2;\n$table-border-color: $color-border;\n$table-th-font-weight: $font-weight-semibold;\n$table-cell-padding-y: 0.875rem; // ~14px -> ~48-52px row height with content\n$table-cell-padding-x: 1rem;\n\n// Breadcrumb\n$breadcrumb-active-color: $color-primary;\n$breadcrumb-divider-color: $color-text-muted;\n$breadcrumb-item-padding-x: 0.5rem;\n\n// Header / topbar\n$header-bg: $color-surface;\n$header-border-color: $color-border;\n$header-color: $color-text-secondary;\n$header-hover-color: $color-primary;\n$header-active-color: $color-primary;\n\n// Sidebar — deep purple nav, soft rounded active pill, smooth transitions\n$sidebar-bg: $color-primary-darkest;\n$sidebar-color: $color-text-inverse;\n$sidebar-brand-bg: $color-primary-darkest;\n$sidebar-brand-color: $color-text-inverse;\n$sidebar-header-bg: rgba(0, 0, 0, 0.15);\n$sidebar-footer-bg: rgba(0, 0, 0, 0.15);\n$sidebar-toggler-bg: rgba(0, 0, 0, 0.15);\n\n$sidebar-nav-title-color: $color-text-inverse-muted;\n$sidebar-nav-link-color: $color-text-inverse-muted;\n$sidebar-nav-link-icon-color: $color-text-inverse-muted;\n$sidebar-nav-link-transition: background $transition-base, color $transition-base;\n\n$sidebar-nav-link-hover-color: $color-text-inverse;\n$sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.08);\n$sidebar-nav-link-hover-icon-color: $color-text-inverse;\n\n$sidebar-nav-link-active-color: $color-text-inverse;\n$sidebar-nav-link-active-bg: $color-primary-strong;\n$sidebar-nav-link-active-icon-color: $color-text-inverse;\n\n$sidebar-nav-group-bg: rgba(0, 0, 0, 0.12);\n$sidebar-nav-group-toggle-show-color: $color-text-inverse;\n$sidebar-nav-group-indicator-color: $color-text-inverse-muted;\n$sidebar-nav-group-indicator-hover-color: $color-text-inverse;\n\n// Variables\n//\n// If you want to customize your project please uncomment and update one of the following variables.\n\n// Color system\n\n// scss-docs-start purple-color-variables\n\n// scss-docs-end purple-color-variables\n\n//Custom Style\n\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// $high-emphasis:            rgba(shift-color($gray-base, +26), .95) !default;\n// $medium-emphasis:          rgba(shift-color($gray-base, +26), .681) !default;\n// $disabled:                 rgba(shift-color($gray-base, +26), .38) !default;\n\n// $high-emphasis-inverse:    rgba($white, .87) !default;\n// $medium-emphasis-inverse:  rgba($white, .6) !default;\n// $disabled-inverse:         rgba($white, .38) !default;\n\n// scss-docs-start color-variables\n\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n// $colors: (\n//   \"blue\":       $blue,\n//   \"indigo\":     $indigo,\n//   \"purple\":     $purple,\n//   \"pink\":       $pink,\n//   \"red\":        $red,\n//   \"orange\":     $orange,\n//   \"yellow\":     $yellow,\n//   \"green\":      $green,\n//   \"teal\":       $teal,\n//   \"cyan\":       $cyan,\n//   \"white\":      $white,\n//   \"gray\":       $gray-600,\n//   \"gray-dark\":  $gray-800\n// ) !default;\n// scss-docs-end colors-map\n\n// fusv-disable\n// $primary-dark:  #1f1498 !default;\n// $primary-base:  #321fdb !default;\n// $primary-50:    #988fed !default;\n// $primary-25:    #ccc7f6 !default;\n\n// $secondary-dark:  #212233 !default;\n// $secondary-base:  #9da5b1 !default;\n// $secondary-50:    #9da5b1 !default;\n// $secondary-25:    #ced2d8 !default;\n\n// $success-dark:  #1b9e3e !default;\n// $success-base:  #2eb85c !default;\n// $success-50:    #96dbad !default;\n// $success-25:    #cbedd6 !default;\n\n// $info-dark:  #2982cc !default;\n// $info-base:  #39f !default;\n// $info-50:    #80c6ff !default;\n// $info-25:    #c0e6ff !default;\n\n// $warning-dark:  #f6960b !default;\n// $warning-base:  #f9b115 !default;\n// $warning-50:    #fcd88a !default;\n// $warning-25:    #feecc5 !default;\n\n// $danger-dark:  #d93737 !default;\n// $danger-base:  #e55353 !default;\n// $danger-50:    #f2a9a9 !default;\n// $danger-25:    #f9d4d4 !default;\n\n// $light-dark:     $gray-100 !default;\n// $light-base:     $gray-100 !default;\n// $light-50:       shift-color($light-base, -70) !default;\n// $light-25:       shift-color($light-base, -80) !default;\n\n// $dark-dark:      $gray-900 !default;\n// $dark-base:      $gray-900 !default;\n// $dark-50:        shift-color($dark-base, -70) !default;\n// $dark-25:        shift-color($dark-base, -80) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n// $primary:       $primary-base !default;\n// $secondary:     $secondary-base !default;\n// $success:       $success-base !default;\n// $info:          $info-base !default;\n// $warning:       $warning-base !default;\n// $danger:        $danger-base !default;\n// $light:         $light-base !default;\n// $dark:          $dark-base !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n// $theme-colors: (\n//   \"primary\":    $primary,\n//   \"secondary\":  $secondary,\n//   \"success\":    $success,\n//   \"info\":       $info,\n//   \"warning\":    $warning,\n//   \"danger\":     $danger,\n//   \"light\":      $light,\n//   \"dark\":       $dark\n// ) !default;\n// scss-docs-end theme-colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n// $min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n// $color-contrast-dark:      $high-emphasis-inverse !default;\n// $color-contrast-light:     $high-emphasis !default;\n\n// fusv-disable\n// $blue-100: tint-color($blue, 80%) !default;\n// $blue-200: tint-color($blue, 60%) !default;\n// $blue-300: tint-color($blue, 40%) !default;\n// $blue-400: tint-color($blue, 20%) !default;\n// $blue-500: $blue !default;\n// $blue-600: shade-color($blue, 20%) !default;\n// $blue-700: shade-color($blue, 40%) !default;\n// $blue-800: shade-color($blue, 60%) !default;\n// $blue-900: shade-color($blue, 80%) !default;\n\n// $indigo-100: tint-color($indigo, 80%) !default;\n// $indigo-200: tint-color($indigo, 60%) !default;\n// $indigo-300: tint-color($indigo, 40%) !default;\n// $indigo-400: tint-color($indigo, 20%) !default;\n// $indigo-500: $indigo !default;\n// $indigo-600: shade-color($indigo, 20%) !default;\n// $indigo-700: shade-color($indigo, 40%) !default;\n// $indigo-800: shade-color($indigo, 60%) !default;\n// $indigo-900: shade-color($indigo, 80%) !default;\n\n// $purple-100: tint-color($purple, 80%) !default;\n// $purple-200: tint-color($purple, 60%) !default;\n// $purple-300: tint-color($purple, 40%) !default;\n// $purple-400: tint-color($purple, 20%) !default;\n// $purple-500: $purple !default;\n// $purple-600: shade-color($purple, 20%) !default;\n// $purple-700: shade-color($purple, 40%) !default;\n// $purple-800: shade-color($purple, 60%) !default;\n// $purple-900: shade-color($purple, 80%) !default;\n\n// $pink-100: tint-color($pink, 80%) !default;\n// $pink-200: tint-color($pink, 60%) !default;\n// $pink-300: tint-color($pink, 40%) !default;\n// $pink-400: tint-color($pink, 20%) !default;\n// $pink-500: $pink !default;\n// $pink-600: shade-color($pink, 20%) !default;\n// $pink-700: shade-color($pink, 40%) !default;\n// $pink-800: shade-color($pink, 60%) !default;\n// $pink-900: shade-color($pink, 80%) !default;\n\n// $red-100: tint-color($red, 80%) !default;\n// $red-200: tint-color($red, 60%) !default;\n// $red-300: tint-color($red, 40%) !default;\n// $red-400: tint-color($red, 20%) !default;\n// $red-500: $red !default;\n// $red-600: shade-color($red, 20%) !default;\n// $red-700: shade-color($red, 40%) !default;\n// $red-800: shade-color($red, 60%) !default;\n// $red-900: shade-color($red, 80%) !default;\n\n// $orange-100: tint-color($orange, 80%) !default;\n// $orange-200: tint-color($orange, 60%) !default;\n// $orange-300: tint-color($orange, 40%) !default;\n// $orange-400: tint-color($orange, 20%) !default;\n// $orange-500: $orange !default;\n// $orange-600: shade-color($orange, 20%) !default;\n// $orange-700: shade-color($orange, 40%) !default;\n// $orange-800: shade-color($orange, 60%) !default;\n// $orange-900: shade-color($orange, 80%) !default;\n\n// $yellow-100: tint-color($yellow, 80%) !default;\n// $yellow-200: tint-color($yellow, 60%) !default;\n// $yellow-300: tint-color($yellow, 40%) !default;\n// $yellow-400: tint-color($yellow, 20%) !default;\n// $yellow-500: $yellow !default;\n// $yellow-600: shade-color($yellow, 20%) !default;\n// $yellow-700: shade-color($yellow, 40%) !default;\n// $yellow-800: shade-color($yellow, 60%) !default;\n// $yellow-900: shade-color($yellow, 80%) !default;\n\n// $green-100: tint-color($green, 80%) !default;\n// $green-200: tint-color($green, 60%) !default;\n// $green-300: tint-color($green, 40%) !default;\n// $green-400: tint-color($green, 20%) !default;\n// $green-500: $green !default;\n// $green-600: shade-color($green, 20%) !default;\n// $green-700: shade-color($green, 40%) !default;\n// $green-800: shade-color($green, 60%) !default;\n// $green-900: shade-color($green, 80%) !default;\n\n// $teal-100: tint-color($teal, 80%) !default;\n// $teal-200: tint-color($teal, 60%) !default;\n// $teal-300: tint-color($teal, 40%) !default;\n// $teal-400: tint-color($teal, 20%) !default;\n// $teal-500: $teal !default;\n// $teal-600: shade-color($teal, 20%) !default;\n// $teal-700: shade-color($teal, 40%) !default;\n// $teal-800: shade-color($teal, 60%) !default;\n// $teal-900: shade-color($teal, 80%) !default;\n\n// $cyan-100: tint-color($cyan, 80%) !default;\n// $cyan-200: tint-color($cyan, 60%) !default;\n// $cyan-300: tint-color($cyan, 40%) !default;\n// $cyan-400: tint-color($cyan, 20%) !default;\n// $cyan-500: $cyan !default;\n// $cyan-600: shade-color($cyan, 20%) !default;\n// $cyan-700: shade-color($cyan, 40%) !default;\n// $cyan-800: shade-color($cyan, 60%) !default;\n// $cyan-900: shade-color($cyan, 80%) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n// $escaped-characters: (\n//   (\"<\", \"%3c\"),\n//   (\">\", \"%3e\"),\n//   (\"#\", \"%23\"),\n//   (\"(\", \"%28\"),\n//   (\")\", \"%29\"),\n// ) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n// $enable-caret:                      true !default;\n// $enable-rounded:                    true !default;\n// $enable-shadows:                    false !default;\n// $enable-gradients:                  false !default;\n// $enable-transitions:                true !default;\n// $enable-reduced-motion:             true !default;\n// $enable-smooth-scroll:              true !default;\n// $enable-grid-classes:               true !default;\n// $enable-button-pointers:            true !default;\n// $enable-rfs:                        true !default;\n// $enable-validation-icons:           true !default;\n// $enable-negative-margins:           false !default;\n// $enable-deprecation-messages:       true !default;\n// $enable-important-utilities:        true !default;\n// $enable-contrast-ratio-correction:  true !default;\n// $enable-contrast-ratio-warnings:    false !default;\n// $enable-ltr:                        true !default;\n// $enable-rtl:                        false !default;\n\n// Set mobile breakpoint\n\n// $mobile-breakpoint:           md !default;\n\n// Prefix for :root CSS variables\n\n// $variable-prefix:             cui- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n// $gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n// $spacer: 1rem !default;\n// $spacers: (\n//   0: 0,\n//   1: $spacer / 4,\n//   2: $spacer / 2,\n//   3: $spacer,\n//   4: $spacer * 1.5,\n//   5: $spacer * 3,\n// ) !default;\n\n// $negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n// $position-values: (\n//   0: 0,\n//   50: 50%,\n//   100: 100%\n// ) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n// $body-bg:                   $white !default;\n// $body-color:                $high-emphasis !default;\n// $body-text-align:           null !default;\n\n// Links\n//\n// Style anchor elements.\n\n// $link-color:                              $primary !default;\n// $link-decoration:                         underline !default;\n// $link-shade-percentage:                   20% !default;\n// $link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n// $link-hover-decoration:                   null !default;\n\n// $stretched-link-pseudo-element:           after !default;\n// $stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n// $paragraph-margin-bottom:   1rem !default;\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n// $grid-breakpoints: (\n//   xs: 0,\n//   sm: 576px,\n//   md: 768px,\n//   lg: 992px,\n//   xl: 1200px,\n//   xxl: 1400px\n// ) !default;\n// scss-docs-end grid-breakpoints\n\n// @include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n// @include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n// $container-max-widths: (\n//   sm: 540px,\n//   md: 720px,\n//   lg: 960px,\n//   xl: 1140px,\n//   xxl: 1320px\n// ) !default;\n// scss-docs-end container-max-widths\n\n// @include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n// $grid-columns:                12 !default;\n// $grid-gutter-width:           1.5rem !default;\n// $grid-row-columns:            6 !default;\n\n// $gutters: $spacers !default;\n\n// Container padding\n\n// $container-padding-x: $grid-gutter-width / 2 !default;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n// $border-width:                1px !default;\n// $border-widths: (\n//   1: 1px,\n//   2: 2px,\n//   3: 3px,\n//   4: 4px,\n//   5: 5px\n// ) !default;\n\n// $border-color:                $gray-200 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n// $border-radius:               .25rem !default;\n// $border-radius-sm:            .2rem !default;\n// $border-radius-lg:            .3rem !default;\n// $border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n// $box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n// $box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n// $box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n// $box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n// $component-active-color:      $high-emphasis-inverse !default;\n// $component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n// $caret-width:                 .3em !default;\n// $caret-vertical-align:        $caret-width * .85 !default;\n// $caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n// $transition-base:             all .2s ease-in-out !default;\n// $transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n// $transition-collapse:         height .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n// $aspect-ratios: (\n//   \"1x1\": 100%,\n//   \"4x3\": calc(3 / 4 * 100%),\n//   \"16x9\": calc(9 / 16 * 100%),\n//   \"21x9\": calc(9 / 21 * 100%)\n// ) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n// $font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n// $font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n// $font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n// $font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root effects the value of `rem`, which is used for as well font sizes, paddings and margins\n// $font-size-base effects the font size of the body text\n// $font-size-root:              null !default;\n// $font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n// $font-size-sm:                $font-size-base * .875 !default;\n// $font-size-lg:                $font-size-base * 1.25 !default;\n\n// $font-weight-lighter:         lighter !default;\n// $font-weight-light:           300 !default;\n// $font-weight-normal:          400 !default;\n// $font-weight-medium:          500 !default;\n// $font-weight-semibold:        600 !default;\n// $font-weight-bold:            700 !default;\n// $font-weight-bolder:          bolder !default;\n\n// $font-weight-base:            $font-weight-normal !default;\n\n// $line-height-base:            1.5 !default;\n// $line-height-sm:              1.25 !default;\n// $line-height-lg:              2 !default;\n\n// $h1-font-size:                $font-size-base * 2.5 !default;\n// $h2-font-size:                $font-size-base * 2 !default;\n// $h3-font-size:                $font-size-base * 1.75 !default;\n// $h4-font-size:                $font-size-base * 1.5 !default;\n// $h5-font-size:                $font-size-base * 1.25 !default;\n// $h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n// $font-sizes: (\n//   1: $h1-font-size,\n//   2: $h2-font-size,\n//   3: $h3-font-size,\n//   4: $h4-font-size,\n//   5: $h5-font-size,\n//   6: $h6-font-size\n// ) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n// $headings-margin-bottom:      $spacer / 2 !default;\n// $headings-font-family:        null !default;\n// $headings-font-style:         null !default;\n// $headings-font-weight:        500 !default;\n// $headings-line-height:        1.2 !default;\n// $headings-color:              unset !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n// $display-font-sizes: (\n//   1: 5rem,\n//   2: 4.5rem,\n//   3: 4rem,\n//   4: 3.5rem,\n//   5: 3rem,\n//   6: 2.5rem\n// ) !default;\n\n// $display-font-weight: 300 !default;\n// $display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n// $lead-font-size:                $font-size-base * 1.25 !default;\n// $lead-font-weight:              300 !default;\n\n// $small-font-size:               .875em !default;\n\n// $sub-sup-font-size:             .75em !default;\n\n// $text-high-emphasis:            $high-emphasis !default;\n// $text-medium-emphasis:          $medium-emphasis !default;\n// $text-disabled:                 $disabled !default;\n// $text-muted:                    $disabled !default;\n\n// $text-high-emphasis-inverse:    $high-emphasis-inverse !default;\n// $text-medium-emphasis-inverse:  $medium-emphasis-inverse !default;\n// $text-disabled-inverse:         $disabled-inverse !default;\n\n// $initialism-font-size:          $small-font-size !default;\n\n// $blockquote-margin-y:           $spacer !default;\n// $blockquote-font-size:          $font-size-base * 1.25 !default;\n// $blockquote-footer-color:       $gray-600 !default;\n// $blockquote-footer-font-size:   $small-font-size !default;\n\n// $hr-margin-y:                   $spacer !default;\n// $hr-color:                      inherit !default;\n// $hr-height:                     $border-width !default;\n// $hr-opacity:                    .25 !default;\n\n// $vr-color:                      inherit !default;\n// $vr-width:                      $border-width !default;\n// $vr-opacity:                    .25 !default;\n\n// $legend-margin-bottom:          .5rem !default;\n// $legend-font-size:              1.5rem !default;\n// $legend-font-weight:            null !default;\n\n// $mark-padding:                  .2em !default;\n\n// $dt-font-weight:                $font-weight-bold !default;\n\n// $nested-kbd-font-weight:        $font-weight-bold !default;\n\n// $list-inline-padding:           .5rem !default;\n\n// $mark-bg:                      #fcf8e3 !default;\n// scss-docs-end type-variables\n\n// Icons\n// $icon-size-base:  1rem !default;\n// $icon-size-sm:    $icon-size-base * .875 !default;\n// $icon-size-lg:    $icon-size-base * 1.25 !default;\n// $icon-size-xl:    $icon-size-base * 1.5 !default;\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n// $table-cell-padding-y:        .5rem !default;\n// $table-cell-padding-x:        .5rem !default;\n// $table-cell-padding-y-sm:     .25rem !default;\n// $table-cell-padding-x-sm:     .25rem !default;\n\n// $table-cell-vertical-align:   top !default;\n\n// $table-color:                 $body-color !default;\n// $table-bg:                    transparent !default;\n\n// $table-th-font-weight:        600 !default;\n\n// $table-striped-color:         $table-color !default;\n// $table-striped-bg-factor:     .05 !default;\n// $table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n// $table-active-color:          $table-color !default;\n// $table-active-bg-factor:      .1 !default;\n// $table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n// $table-hover-color:           $table-color !default;\n// $table-hover-bg-factor:       .075 !default;\n// $table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n// $table-border-factor:         .1 !default;\n// $table-border-width:          $border-width !default;\n// $table-border-color:          $border-color !default;\n\n// $table-striped-order:         odd !default;\n\n// $table-group-separator-color: currentColor !default;\n\n// $table-caption-color:         $text-muted !default;\n\n// $table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n// $table-variants: (\n//   \"primary\":    table-color-map(shift-color($primary, $table-bg-scale)),\n//   \"secondary\":  table-color-map(shift-color($secondary, $table-bg-scale)),\n//   \"success\":    table-color-map(shift-color($success, $table-bg-scale)),\n//   \"danger\":     table-color-map(shift-color($danger, $table-bg-scale)),\n//   \"warning\":    table-color-map(shift-color($warning, $table-bg-scale)),\n//   \"info\":       table-color-map(shift-color($info, $table-bg-scale)),\n//   \"light\":      table-color-map(shift-color($light, $table-bg-scale)),\n//   \"dark\":       table-color-map(shift-color($dark, $table-bg-scale))\n// ) !default;\n// scss-docs-end table-loop\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n// $input-btn-padding-y:         .375rem !default;\n// $input-btn-padding-x:         .75rem !default;\n// $input-btn-font-family:       null !default;\n// $input-btn-font-size:         $font-size-base !default;\n// $input-btn-line-height:       $line-height-base !default;\n\n// $input-btn-focus-width:         .25rem !default;\n// $input-btn-focus-color-opacity: .25 !default;\n// $input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n// $input-btn-focus-blur:          0 !default;\n// $input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n// $input-btn-padding-y-sm:      .25rem !default;\n// $input-btn-padding-x-sm:      .5rem !default;\n// $input-btn-font-size-sm:      $font-size-sm !default;\n\n// $input-btn-padding-y-lg:      .5rem !default;\n// $input-btn-padding-x-lg:      1rem !default;\n// $input-btn-font-size-lg:      $font-size-lg !default;\n\n// $input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n// $btn-padding-y:               $input-btn-padding-y !default;\n// $btn-padding-x:               $input-btn-padding-x !default;\n// $btn-font-family:             $input-btn-font-family !default;\n// $btn-font-size:               $input-btn-font-size !default;\n// $btn-line-height:             $input-btn-line-height !default;\n// $btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n// $btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n// $btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n// $btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n// $btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n// $btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n// $btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n// $btn-border-width:            $input-btn-border-width !default;\n\n// $btn-font-weight:             $font-weight-normal !default;\n// $btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n// $btn-focus-width:             $input-btn-focus-width !default;\n// $btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n// $btn-disabled-opacity:        .65 !default;\n// $btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n// $btn-link-color:              $link-color !default;\n// $btn-link-hover-color:        $link-hover-color !default;\n// $btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n// $btn-border-radius:           $border-radius !default;\n// $btn-border-radius-sm:        $border-radius-sm !default;\n// $btn-border-radius-lg:        $border-radius-lg !default;\n\n// $btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n// $btn-hover-bg-shade-amount:       15% !default;\n// $btn-hover-bg-tint-amount:        15% !default;\n// $btn-hover-border-shade-amount:   20% !default;\n// $btn-hover-border-tint-amount:    10% !default;\n// $btn-active-bg-shade-amount:      20% !default;\n// $btn-active-bg-tint-amount:       20% !default;\n// $btn-active-border-shade-amount:  25% !default;\n// $btn-active-border-tint-amount:   10% !default;\n\n// $button-variants: (\n//   \"primary\": btn-color-map($primary, $primary),\n//   \"secondary\": btn-color-map($secondary, $secondary),\n//   \"success\": btn-color-map($success, $success),\n//   \"danger\": btn-color-map($danger, $danger),\n//   \"warning\": btn-color-map($warning, $warning),\n//   \"info\": btn-color-map($info, $info),\n//   \"light\": btn-color-map($light, $light),\n//   \"dark\": btn-color-map($dark, $dark)\n// ) !default;\n\n// $button-outline-ghost-variants: (\n//   \"primary\": btn-outline-color-map($primary),\n//   \"secondary\": btn-outline-color-map($secondary),\n//   \"success\": btn-outline-color-map($success),\n//   \"danger\": btn-outline-color-map($danger),\n//   \"warning\": btn-outline-color-map($warning),\n//   \"info\": btn-outline-color-map($info),\n//   \"light\": btn-outline-color-map($light),\n//   \"dark\": btn-outline-color-map($dark)\n// ) !default;\n// scss-docs-end btn-variables\n\n// Forms\n// scss-docs-start form-variables\n// scss-docs-start form-text-variables\n// $form-text-margin-top:                  .25rem !default;\n// $form-text-font-size:                   $small-font-size !default;\n// $form-text-font-style:                  null !default;\n// $form-text-font-weight:                 null !default;\n// $form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n// $form-label-margin-bottom:              .5rem !default;\n// $form-label-font-size:                  null !default;\n// $form-label-font-style:                 null !default;\n// $form-label-font-weight:                null !default;\n// $form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n// $input-padding-y:                       $input-btn-padding-y !default;\n// $input-padding-x:                       $input-btn-padding-x !default;\n// $input-font-family:                     $input-btn-font-family !default;\n// $input-font-size:                       $input-btn-font-size !default;\n// $input-font-weight:                     $font-weight-base !default;\n// $input-line-height:                     $input-btn-line-height !default;\n\n// $input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n// $input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n// $input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n// $input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n// $input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n// $input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n// $input-bg:                              $white !default;\n// $input-disabled-bg:                     $gray-200 !default;\n// $input-disabled-border-color:           $gray-400 !default;\n\n// $input-color:                           $body-color !default;\n// $input-border-color:                    $gray-400 !default;\n// $input-border-width:                    $input-btn-border-width !default;\n// $input-box-shadow:                      $box-shadow-inset !default;\n\n// $input-border-radius:                   $border-radius !default;\n// $input-border-radius-sm:                $border-radius-sm !default;\n// $input-border-radius-lg:                $border-radius-lg !default;\n\n// $input-focus-bg:                        $input-bg !default;\n// $input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n// $input-focus-color:                     $input-color !default;\n// $input-focus-width:                     $input-btn-focus-width !default;\n// $input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n// $input-placeholder-color:               $gray-600 !default;\n// $input-plaintext-color:                 $body-color !default;\n\n// $input-height-border:                   $input-border-width * 2 !default;\n\n// $input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n// $input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n// $input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y / 2) !default;\n\n// $input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n// $input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n// $input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n// $input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n// $form-check-input-width:                  1em !default;\n// $form-check-min-height:                   $font-size-base * $line-height-base !default;\n// $form-check-padding-start:                $form-check-input-width + .5em !default;\n// $form-check-margin-bottom:                .125rem !default;\n// $form-check-label-color:                  unset !default;\n// $form-check-label-cursor:                 null !default;\n// $form-check-transition:                   null !default;\n\n// $form-check-input-active-filter:          brightness(90%) !default;\n\n// $form-check-input-bg:                     $input-bg !default;\n// $form-check-input-border:                 1px solid rgba($black, .25) !default;\n// $form-check-input-border-radius:          .25em !default;\n// $form-check-radio-border-radius:          50% !default;\n// $form-check-input-focus-border:           $input-focus-border-color !default;\n// $form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n// $form-check-input-checked-color:          $component-active-color !default;\n// $form-check-input-checked-bg-color:       $component-active-bg !default;\n// $form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n// $form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n// $form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n// $form-check-input-indeterminate-color:          $component-active-color !default;\n// $form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n// $form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n// $form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n// $form-check-input-disabled-opacity:        .5 !default;\n// $form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n// $form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n// $form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n// $form-switch-color:               rgba(0, 0, 0, .25) !default;\n// $form-switch-width:               1.5em !default;\n// $form-switch-padding-start:       $form-switch-width + .5em !default;\n// $form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n// $form-switch-border-radius:       $form-switch-width !default;\n// $form-switch-transition:          background-position .15s ease-in-out !default;\n\n// $form-switch-focus-color:         $input-focus-border-color !default;\n// $form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n// $form-switch-checked-color:       $component-active-color !default;\n// $form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n// $form-switch-checked-bg-position: right center !default;\n\n// $form-switch-widths: (\n//   lg: (\n//     width: 1.75em,\n//     height: 1.25em\n//   ),\n//   xl: (\n//     width: 2em,\n//     height: 1.5em\n//   )\n// ) !default;\n// scss-docs-end form-switch-variables\n\n// $form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n// $input-group-addon-padding-y:           $input-padding-y !default;\n// $input-group-addon-padding-x:           $input-padding-x !default;\n// $input-group-addon-font-weight:         $input-font-weight !default;\n// $input-group-addon-color:               $input-color !default;\n// $input-group-addon-bg:                  $gray-200 !default;\n// $input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n// $form-select-padding-y:             $input-padding-y !default;\n// $form-select-padding-x:             $input-padding-x !default;\n// $form-select-font-family:           $input-font-family !default;\n// $form-select-font-size:             $input-font-size !default;\n// $form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n// $form-select-font-weight:           $input-font-weight !default;\n// $form-select-line-height:           $input-line-height !default;\n// $form-select-color:                 $input-color !default;\n// $form-select-bg:                    $input-bg !default;\n// $form-select-disabled-color:        null !default;\n// $form-select-disabled-bg:           $gray-200 !default;\n// $form-select-disabled-border-color: $input-disabled-border-color !default;\n// $form-select-bg-position:           right $form-select-padding-x center !default;\n// $form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n// $form-select-indicator-color:       $gray-800 !default;\n// $form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n// $form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n// $form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n// $form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n// $form-select-border-width:        $input-border-width !default;\n// $form-select-border-color:        $input-border-color !default;\n// $form-select-border-radius:       $border-radius !default;\n// $form-select-box-shadow:          $box-shadow-inset !default;\n\n// $form-select-focus-border-color:  $input-focus-border-color !default;\n// $form-select-focus-width:         $input-focus-width !default;\n// $form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n// $form-select-padding-y-sm:        $input-padding-y-sm !default;\n// $form-select-padding-x-sm:        $input-padding-x-sm !default;\n// $form-select-font-size-sm:        $input-font-size-sm !default;\n\n// $form-select-padding-y-lg:        $input-padding-y-lg !default;\n// $form-select-padding-x-lg:        $input-padding-x-lg !default;\n// $form-select-font-size-lg:        $input-font-size-lg !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n// $form-range-track-width:          100% !default;\n// $form-range-track-height:         .5rem !default;\n// $form-range-track-cursor:         pointer !default;\n// $form-range-track-bg:             $gray-300 !default;\n// $form-range-track-border-radius:  1rem !default;\n// $form-range-track-box-shadow:     $box-shadow-inset !default;\n\n// $form-range-thumb-width:                   1rem !default;\n// $form-range-thumb-height:                  $form-range-thumb-width !default;\n// $form-range-thumb-bg:                      $component-active-bg !default;\n// $form-range-thumb-border:                  0 !default;\n// $form-range-thumb-border-radius:           1rem !default;\n// $form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n// $form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n// $form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n// $form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n// $form-range-thumb-disabled-bg:             $gray-500 !default;\n// $form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n// $form-file-button-color:          $input-color !default;\n// $form-file-button-bg:             $input-group-addon-bg !default;\n// $form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n// $form-floating-height:            add(3.5rem, $input-height-border) !default;\n// $form-floating-padding-x:         $input-padding-x !default;\n// $form-floating-padding-y:         1rem !default;\n// $form-floating-input-padding-t:   1.625rem !default;\n// $form-floating-input-padding-b:   .625rem !default;\n// $form-floating-label-opacity:     .65 !default;\n// $form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n// $form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n// $form-feedback-margin-top:          $form-text-margin-top !default;\n// $form-feedback-font-size:           $form-text-font-size !default;\n// $form-feedback-font-style:          $form-text-font-style !default;\n// $form-feedback-valid-color:         $success !default;\n// $form-feedback-invalid-color:       $danger !default;\n\n// $form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n// $form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n// $form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n// $form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n// $form-validation-states: (\n//   \"valid\": (\n//     \"color\": $form-feedback-valid-color,\n//     \"icon\": $form-feedback-icon-valid\n//   ),\n//   \"invalid\": (\n//     \"color\": $form-feedback-invalid-color,\n//     \"icon\": $form-feedback-icon-invalid\n//   )\n// ) !default;\n// scss-docs-end form-validation-states\n// scss-docs-end form-variables\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n// $zindex-dropdown:                   1000 !default;\n// $zindex-sticky:                     1020 !default;\n// $zindex-fixed:                      1030 !default;\n// $zindex-modal-backdrop:             1040 !default;\n// $zindex-offcanvas:                  1050 !default;\n// $zindex-modal:                      1060 !default;\n// $zindex-popover:                    1070 !default;\n// $zindex-tooltip:                    1080 !default;\n// $zindex-toaster:                    1090 !default;\n// scss-docs-end zindex-stack\n\n// Navs\n// scss-docs-start nav-variables\n// $nav-link-padding-y:                .5rem !default;\n// $nav-link-padding-x:                1rem !default;\n// $nav-link-font-size:                null !default;\n// $nav-link-font-weight:              null !default;\n// $nav-link-color:                    $link-color !default;\n// $nav-link-hover-color:              $link-hover-color !default;\n// $nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n// $nav-link-disabled-color:           $gray-600 !default;\n\n// $nav-tabs-border-color:             $gray-300 !default;\n// $nav-tabs-border-width:             $border-width !default;\n// $nav-tabs-border-radius:            $border-radius !default;\n// $nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n// $nav-tabs-link-active-color:        $gray-700 !default;\n// $nav-tabs-link-active-bg:           $body-bg !default;\n// $nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n// $nav-pills-border-radius:           $border-radius !default;\n// $nav-pills-link-active-color:       $component-active-color !default;\n// $nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n// Navbar\n\n// scss-docs-start navbar-variables\n// $navbar-padding-y:                  $spacer / 2 !default;\n// $navbar-padding-x:                  null !default;\n\n// $navbar-nav-link-padding-x:         .5rem !default;\n\n// $navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n// $nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n// $navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n// $navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\n// $navbar-brand-margin-end:           1rem !default;\n\n// $navbar-toggler-padding-y:          .25rem !default;\n// $navbar-toggler-padding-x:          .75rem !default;\n// $navbar-toggler-font-size:          $font-size-lg !default;\n// $navbar-toggler-border-radius:      $btn-border-radius !default;\n// $navbar-toggler-focus-width:        $btn-focus-width !default;\n// $navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n// $navbar-dark-color:                 $medium-emphasis-inverse !default;\n// $navbar-dark-hover-color:           $high-emphasis-inverse !default;\n// $navbar-dark-active-color:          $high-emphasis-inverse !default;\n// $navbar-dark-disabled-color:        $disabled-inverse !default;\n// $navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n// $navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n// $navbar-light-color:                $medium-emphasis !default;\n// $navbar-light-hover-color:          $high-emphasis !default;\n// $navbar-light-active-color:         $high-emphasis !default;\n// $navbar-light-disabled-color:       $disabled !default;\n// $navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n// $navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n// $navbar-light-brand-color:                $navbar-light-active-color !default;\n// $navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n// $navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n// $navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n// scss-docs-start dropdown-variables\n// $dropdown-min-width:                10rem !default;\n// $dropdown-padding-x:                0 !default;\n// $dropdown-padding-y:                .5rem !default;\n// $dropdown-spacer:                   .125rem !default;\n// $dropdown-font-size:                $font-size-base !default;\n// $dropdown-color:                    $body-color !default;\n// $dropdown-bg:                       $white !default;\n// $dropdown-border-color:             rgba($black, .15) !default;\n// $dropdown-border-radius:            $border-radius !default;\n// $dropdown-border-width:             $border-width !default;\n// $dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n// $dropdown-divider-bg:               $dropdown-border-color !default;\n// $dropdown-divider-margin-y:         $spacer / 2 !default;\n// $dropdown-box-shadow:               $box-shadow !default;\n\n// $dropdown-link-color:               $gray-900 !default;\n// $dropdown-link-hover-color:         shade-color($gray-900, 10%) !default;\n// $dropdown-link-hover-bg:            $gray-200 !default;\n\n// $dropdown-link-active-color:        $component-active-color !default;\n// $dropdown-link-active-bg:           $component-active-bg !default;\n\n// $dropdown-link-disabled-color:      $gray-500 !default;\n\n// $dropdown-item-padding-y:           $spacer / 4 !default;\n// $dropdown-item-padding-x:           $spacer !default;\n\n// $dropdown-header-color:             $gray-600 !default;\n// $dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n// $dropdown-dark-color:               $gray-300 !default;\n// $dropdown-dark-bg:                  $gray-800 !default;\n// $dropdown-dark-border-color:        $dropdown-border-color !default;\n// $dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n// $dropdown-dark-box-shadow:          null !default;\n// $dropdown-dark-link-color:          $dropdown-dark-color !default;\n// $dropdown-dark-link-hover-color:    $high-emphasis-inverse !default;\n// $dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n// $dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n// $dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n// $dropdown-dark-link-disabled-color: $gray-500 !default;\n// $dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n// Pagination\n\n// scss-docs-start pagination-variables\n// $pagination-padding-y:              .375rem !default;\n// $pagination-padding-x:              .75rem !default;\n// $pagination-padding-y-sm:           .25rem !default;\n// $pagination-padding-x-sm:           .5rem !default;\n// $pagination-padding-y-lg:           .75rem !default;\n// $pagination-padding-x-lg:           1.5rem !default;\n\n// $pagination-color:                  $link-color !default;\n// $pagination-bg:                     $white !default;\n// $pagination-border-width:           $border-width !default;\n// $pagination-border-radius:          $border-radius !default;\n// $pagination-margin-start:           -$pagination-border-width !default;\n// $pagination-border-color:           $gray-300 !default;\n\n// $pagination-focus-color:            $link-hover-color !default;\n// $pagination-focus-bg:               $gray-200 !default;\n// $pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n// $pagination-focus-outline:          0 !default;\n\n// $pagination-hover-color:            $link-hover-color !default;\n// $pagination-hover-bg:               $gray-200 !default;\n// $pagination-hover-border-color:     $gray-300 !default;\n\n// $pagination-active-color:           $component-active-color !default;\n// $pagination-active-bg:              $component-active-bg !default;\n// $pagination-active-border-color:    $pagination-active-bg !default;\n\n// $pagination-disabled-color:         $gray-600 !default;\n// $pagination-disabled-bg:            $white !default;\n// $pagination-disabled-border-color:  $gray-300 !default;\n\n// $pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end pagination-variables\n\n// $pagination-border-radius-sm:       $border-radius-sm !default;\n// $pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n// Cards\n// scss-docs-start card-variables\n// $card-spacer-y:                     $spacer !default;\n// $card-spacer-x:                     $spacer !default;\n// $card-title-spacer-y:               $spacer / 2 !default;\n// $card-border-width:                 $border-width !default;\n// $card-border-radius:                $border-radius !default;\n// $card-border-color:                 rgba($black, .125) !default;\n// $card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n// $card-cap-padding-y:                $card-spacer-y / 2 !default;\n// $card-cap-padding-x:                $card-spacer-x !default;\n// $card-cap-bg:                       rgba($black, .03) !default;\n// $card-cap-color:                    unset !default;\n// $card-height:                       null !default;\n// $card-color:                        unset !default;\n// $card-bg:                           $white !default;\n// $card-img-overlay-padding:          $spacer !default;\n// $card-group-margin:                 $grid-gutter-width / 2 !default;\n// scss-docs-end card-variables\n\n// Accordion\n// scss-docs-start accordion-variables\n// $accordion-padding-y:                     1rem !default;\n// $accordion-padding-x:                     1.25rem !default;\n// $accordion-color:                         $body-color !default;\n// $accordion-bg:                            $body-bg !default;\n// $accordion-border-width:                  $border-width !default;\n// $accordion-border-color:                  rgba($black, .125) !default;\n// $accordion-border-radius:                 $border-radius !default;\n// $accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n// $accordion-body-padding-y:                $accordion-padding-y !default;\n// $accordion-body-padding-x:                $accordion-padding-x !default;\n\n// $accordion-button-padding-y:              $accordion-padding-y !default;\n// $accordion-button-padding-x:              $accordion-padding-x !default;\n// $accordion-button-color:                  $accordion-color !default;\n// $accordion-button-bg:                     $accordion-bg !default;\n// $accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n// $accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n// $accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n// $accordion-button-focus-border-color:     $input-focus-border-color !default;\n// $accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n// $accordion-icon-width:                    1.25rem !default;\n// $accordion-icon-color:                    $accordion-color !default;\n// $accordion-icon-active-color:             $accordion-button-active-color !default;\n// $accordion-icon-transition:               transform .2s ease-in-out !default;\n// $accordion-icon-transform:                rotate(-180deg) !default;\n\n// $accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// $accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n// $tooltip-font-size:                 $font-size-sm !default;\n// $tooltip-max-width:                 200px !default;\n// $tooltip-color:                     $high-emphasis-inverse !default;\n// $tooltip-bg:                        $black !default;\n// $tooltip-border-radius:             $border-radius !default;\n// $tooltip-opacity:                   .9 !default;\n// $tooltip-padding-y:                 $spacer / 4 !default;\n// $tooltip-padding-x:                 $spacer / 2 !default;\n// $tooltip-margin:                    0 !default;\n\n// $tooltip-arrow-width:               .8rem !default;\n// $tooltip-arrow-height:              .4rem !default;\n// $tooltip-arrow-color:               $tooltip-bg !default;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n// $form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n// $form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n// $form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n// $form-feedback-tooltip-line-height:   null !default;\n// $form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n// $form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n// Popovers\n// scss-docs-start popover-variables\n// $popover-font-size:                 $font-size-sm !default;\n// $popover-bg:                        $white !default;\n// $popover-max-width:                 276px !default;\n// $popover-border-width:              $border-width !default;\n// $popover-border-color:              rgba($black, .2) !default;\n// $popover-border-radius:             $border-radius-lg !default;\n// $popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n// $popover-box-shadow:                $box-shadow !default;\n\n// $popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n// $popover-header-color:              $headings-color !default;\n// $popover-header-padding-y:          .5rem !default;\n// $popover-header-padding-x:          $spacer !default;\n\n// $popover-body-color:                $body-color !default;\n// $popover-body-padding-y:            $spacer !default;\n// $popover-body-padding-x:            $spacer !default;\n\n// $popover-arrow-width:               1rem !default;\n// $popover-arrow-height:              .5rem !default;\n// $popover-arrow-color:               $popover-bg !default;\n\n// $popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n// scss-docs-end popover-variables\n\n// Toasts\n// scss-docs-start toast-variables\n// $toast-max-width:                   350px !default;\n// $toast-padding-x:                   .75rem !default;\n// $toast-padding-y:                   .5rem !default;\n// $toast-font-size:                   .875rem !default;\n// $toast-color:                       unset !default;\n// $toast-background-color:            rgba($white, .85) !default;\n// $toast-border-width:                1px !default;\n// $toast-border-color:                rgba(0, 0, 0, .1) !default;\n// $toast-border-radius:               $border-radius !default;\n// $toast-box-shadow:                  $box-shadow !default;\n// $toast-spacing:                     $container-padding-x !default;\n\n// $toast-header-color:                $gray-600 !default;\n// $toast-header-background-color:     rgba($white, .85) !default;\n// $toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n// scss-docs-end toast-variables\n\n// Badges\n// scss-docs-start badge-variables\n// $badge-font-size:                   .75em !default;\n// $badge-font-weight:                 $font-weight-bold !default;\n// $badge-color:                       $high-emphasis-inverse !default;\n// $badge-padding-y:                   .35em !default;\n// $badge-padding-x:                   .65em !default;\n// $badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n// $badge-font-size-sm:                .65em !default;\n// $badge-padding-y-sm:                .3em !default;\n// $badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n// Modals\n\n// scss-docs-start modal-variables\n// $modal-inner-padding:               $spacer !default;\n\n// $modal-footer-margin-between:       .5rem !default;\n\n// $modal-dialog-margin:               .5rem !default;\n// $modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n// $modal-title-line-height:           $line-height-base !default;\n\n// $modal-content-color:               unset !default;\n// $modal-content-bg:                  $white !default;\n// $modal-content-border-color:        rgba($black, .2) !default;\n// $modal-content-border-width:        $border-width !default;\n// $modal-content-border-radius:       $border-radius-lg !default;\n// $modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n// $modal-content-box-shadow-xs:       $box-shadow-sm !default;\n// $modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n// $modal-backdrop-bg:                 $black !default;\n// $modal-backdrop-opacity:            .5 !default;\n// $modal-header-border-color:         $border-color !default;\n// $modal-footer-border-color:         $modal-header-border-color !default;\n// $modal-header-border-width:         $modal-content-border-width !default;\n// $modal-footer-border-width:         $modal-header-border-width !default;\n// $modal-header-padding-y:            $modal-inner-padding !default;\n// $modal-header-padding-x:            $modal-inner-padding !default;\n// $modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n// $modal-sm:                          300px !default;\n// $modal-md:                          500px !default;\n// $modal-lg:                          800px !default;\n// $modal-xl:                          1140px !default;\n\n// $modal-fade-transform:              translate(0, -50px) !default;\n// $modal-show-transform:              none !default;\n// $modal-transition:                  transform .3s ease-out !default;\n// $modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n// Avatars\n// scss-docs-start avatar-variables\n// $avatar-width:  2rem !default;\n\n// $avatar-widths: (\n//   sm: 1.5rem,\n//   md: 2.5rem,\n//   lg: 3rem,\n//   xl: 4rem\n// ) !default;\n\n// $avatar-transition: margin .15s !default;\n// scss-docs-end avatar-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n// $alert-padding-y:               $spacer !default;\n// $alert-padding-x:               $spacer !default;\n// $alert-margin-bottom:           1rem !default;\n// $alert-border-radius:           $border-radius !default;\n// $alert-link-font-weight:        $font-weight-bold !default;\n// $alert-border-width:            $border-width !default;\n// $alert-bg-scale:                -80% !default;\n// $alert-border-scale:            -70% !default;\n// $alert-color-scale:             40% !default;\n// $alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// $alert-variants: (\n//   \"primary\": alert-color-map($primary),\n//   \"secondary\": alert-color-map($secondary),\n//   \"success\": alert-color-map($success),\n//   \"danger\": alert-color-map($danger),\n//   \"warning\": alert-color-map($warning),\n//   \"info\": alert-color-map($info),\n//   \"light\": alert-color-map($light),\n//   \"dark\": alert-color-map($dark)\n// ) !default;\n// scss-docs-end alert-variables\n\n// Callouts\n// scss-docs-start callout-variables\n// $callout-padding-y:                 $spacer !default;\n// $callout-padding-x:                 $spacer !default;\n// $callout-margin-y:                  $spacer !default;\n// $callout-margin-x:                  0 !default;\n// $callout-border-radius:             $border-radius !default;\n// $callout-border-width:              $border-width !default;\n// $callout-border-color:              $border-color !default;\n// $callout-border-left-width:         (4 * $callout-border-width) !default;\n\n// $callout-variants: (\n//   \"primary\":    $primary,\n//   \"secondary\":  $secondary,\n//   \"success\":    $success,\n//   \"danger\":     $danger,\n//   \"warning\":    $warning,\n//   \"info\":       $info,\n//   \"light\":      $light,\n//   \"dark\":       $dark\n// ) !default;\n// scss-docs-end callout-variables\n\n// Progress bars\n\n// scss-docs-start progress-variables\n// $progress-height:                   1rem !default;\n// $progress-font-size:                $font-size-base * .75 !default;\n// $progress-bg:                       $gray-200 !default;\n// $progress-border-radius:            $border-radius !default;\n// $progress-box-shadow:               $box-shadow-inset !default;\n// $progress-bar-color:                $high-emphasis-inverse !default;\n// $progress-bar-bg:                   $primary !default;\n// $progress-bar-animation-timing:     1s linear infinite !default;\n// $progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n// $list-group-color:                  unset !default;\n// $list-group-bg:                     $white !default;\n// $list-group-border-color:           rgba($black, .125) !default;\n// $list-group-border-width:           $border-width !default;\n// $list-group-border-radius:          $border-radius !default;\n\n// $list-group-item-padding-y:         $spacer / 2 !default;\n// $list-group-item-padding-x:         $spacer !default;\n// $list-group-item-bg-scale:          -80% !default;\n// $list-group-item-color-scale:       40% !default;\n\n// $list-group-hover-bg:               $gray-100 !default;\n// $list-group-active-color:           $component-active-color !default;\n// $list-group-active-bg:              $component-active-bg !default;\n// $list-group-active-border-color:    $list-group-active-bg !default;\n\n// $list-group-disabled-color:         $gray-600 !default;\n// $list-group-disabled-bg:            $list-group-bg !default;\n\n// $list-group-action-color:           $gray-700 !default;\n// $list-group-action-hover-color:     $list-group-action-color !default;\n\n// $list-group-action-active-color:    $body-color !default;\n// $list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n// $list-group-variants: (\n//   \"primary\": list-group-color-map($primary),\n//   \"secondary\": list-group-color-map($secondary),\n//   \"success\": list-group-color-map($success),\n//   \"danger\": list-group-color-map($danger),\n//   \"warning\": list-group-color-map($warning),\n//   \"info\": list-group-color-map($info),\n//   \"light\": list-group-color-map($light),\n//   \"dark\": list-group-color-map($dark)\n// ) !default;\n// scss-docs-end list-group-variables\n\n// Header\n// scss-docs-start header-variables\n// $header-min-height:             4rem !default;\n// $header-padding-y:              $spacer / 2 !default;\n// $header-padding-x:              $spacer / 2 !default;\n// $header-brand-font-size:        $font-size-lg !default;\n// $header-color:                  $medium-emphasis !default;\n// $header-bg:                     $white !default;\n// $header-border-color:           $border-color !default;\n// $header-border-width:           1px !default;\n// $header-hover-color:            $high-emphasis !default;\n// $header-active-color:           $high-emphasis !default;\n// $header-disabled-color:         $disabled !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n// $nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n// $header-brand-height:           $header-brand-font-size * $line-height-base !default;\n// $header-brand-padding-y:        ($nav-link-height - $header-brand-height) / 2 !default;\n// $header-brand-margin-end:       1rem !default;\n// $header-brand-font-size:        $font-size-lg !default;\n// $header-brand-color:            $gray-900 !default;\n// $header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n// $header-toggler-padding-y:      .25rem !default;\n// $header-toggler-padding-x:      .75rem !default;\n// $header-toggler-font-size:      $font-size-lg !default;\n// $header-toggler-bg:             transparent !default;\n// $header-toggler-border:         0 !default;\n// $header-toggler-border-radius:  $btn-border-radius !default;\n\n// $header-toggler-icon-bg:        url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n// $header-toggler-hover-icon-bg:  url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-hover-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n// $header-toggler-border-color:   rgba($black, .1) !default;\n\n// $header-nav-link-padding-x:     .5rem !default;\n\n// $header-divider-border-width:   1px !default;\n// $header-divider-border-color:   $header-border-color !default;\n// scss-docs-end header-variables\n\n// Subheader\n// scss-docs-start subheader-variables\n// $subheader-min-height:           3rem !default;\n// $subheader-padding-y:            $spacer / 2 !default;\n// $subheader-padding-x:            $spacer !default;\n// $subheader-border-color:         $border-color !default;\n// $subheader-border-width:         1px !default;\n\n// $subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader-variables\n\n// Default theme\n// scss-docs-start subheader-default-themes\n// $subheader-bg:                     $white !default;\n// $subheader-color:                  $medium-emphasis !default;\n// $subheader-hover-color:            $high-emphasis !default;\n// $subheader-active-color:           $high-emphasis !default;\n// $subheader-disabled-color:         $disabled !default;\n// scss-docs-end subheader-default-themes\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n// $thumbnail-padding:                 .25rem !default;\n// $thumbnail-bg:                      $body-bg !default;\n// $thumbnail-border-width:            $border-width !default;\n// $thumbnail-border-color:            $gray-300 !default;\n// $thumbnail-border-radius:           $border-radius !default;\n// $thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n// Figures\n\n// scss-docs-start figure-variables\n// $figure-caption-font-size:          $small-font-size !default;\n// $figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n// Breadcrumbs\n// scss-docs-start breadcrumb-variables\n// $breadcrumb-font-size:              null !default;\n// $breadcrumb-padding-y:              0 !default;\n// $breadcrumb-padding-x:              0 !default;\n// $breadcrumb-item-padding-x:         .5rem !default;\n// $breadcrumb-margin-bottom:          1rem !default;\n// $breadcrumb-bg:                     unset !default;\n// $breadcrumb-divider-color:          $gray-600 !default;\n// $breadcrumb-active-color:           $gray-600 !default;\n// $breadcrumb-divider:                quote(\"/\") !default;\n// $breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n// $breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n// scss-docs-start carousel-variables\n// $carousel-control-color:             $high-emphasis-inverse !default;\n// $carousel-control-width:             15% !default;\n// $carousel-control-opacity:           .5 !default;\n// $carousel-control-hover-opacity:     .9 !default;\n// $carousel-control-transition:        opacity .15s ease !default;\n\n// $carousel-indicator-width:           30px !default;\n// $carousel-indicator-height:          3px !default;\n// $carousel-indicator-hit-area-height: 10px !default;\n// $carousel-indicator-spacer:          3px !default;\n// $carousel-indicator-opacity:         .5 !default;\n// $carousel-indicator-active-bg:       $white !default;\n// $carousel-indicator-active-opacity:  1 !default;\n// $carousel-indicator-transition:      opacity .6s ease !default;\n\n// $carousel-caption-width:             70% !default;\n// $carousel-caption-color:             $high-emphasis-inverse !default;\n// $carousel-caption-padding-y:         1.25rem !default;\n// $carousel-caption-spacer:            1.25rem !default;\n\n// $carousel-control-icon-width:        2rem !default;\n\n// $carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n// $carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n// $carousel-transition-duration:       .6s !default;\n// $carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n// $carousel-dark-indicator-active-bg:  $black !default;\n// $carousel-dark-caption-color:        $high-emphasis !default;\n// $carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n// scss-docs-start sidebar-variables\n// $sidebar-width:                            16rem !default;\n// $sidebar-widths: (\n//   sm: 12rem,\n//   lg: 20rem,\n//   xl: 24rem\n// ) !default;\n// $sidebar-padding-y:                        0 !default;\n// $sidebar-padding-x:                        0 !default;\n// $sidebar-color:                            $high-emphasis-inverse !default;\n// $sidebar-bg:                               $gray-base !default;\n// $sidebar-border-width:                     0 !default;\n// $sidebar-border-color:                     transparent !default;\n// $sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n\n// $sidebar-brand-height:                     4rem !default;\n// $sidebar-brand-color:                      $high-emphasis-inverse !default;\n// $sidebar-brand-bg:                         rgba($black, .2) !default;\n\n// $sidebar-header-height:                    4rem !default;\n// $sidebar-header-padding-y:                 .75rem !default;\n// $sidebar-header-padding-x:                 1rem !default;\n// $sidebar-header-bg:                        rgba($black, .2) !default;\n// $sidebar-header-height-transition:         height .15s, padding .15s !default;\n\n// $sidebar-narrow-width:                     4rem !default;\n\n// $sidebar-backdrop-bg:                      $black !default;\n// $sidebar-backdrop-opacity:                 .5 !default;\n// $sidebar-backdrop-transition:              opacity .15s linear !default;\n\n// $sidebar-nav-title-padding-y:              .75rem !default;\n// $sidebar-nav-title-padding-x:              1rem !default;\n// $sidebar-nav-title-margin-top:             1rem !default;\n// $sidebar-nav-title-color:                  $medium-emphasis-inverse !default;\n// $sidebar-nav-title-transition:             height .15s, margin .15s !default;\n\n// $sidebar-nav-link-padding-y:               .8445rem !default;\n// $sidebar-nav-link-padding-x:               1rem !default;\n// $sidebar-nav-link-color:                   $medium-emphasis-inverse !default;\n// $sidebar-nav-link-bg:                      transparent !default;\n// $sidebar-nav-link-transition:              background .15s ease, color .15s ease !default;\n// $sidebar-nav-link-icon-color:              $medium-emphasis-inverse !default;\n\n// $sidebar-nav-link-hover-color:             $high-emphasis-inverse !default;\n// $sidebar-nav-link-hover-bg:                rgba($white, .05) !default;\n// $sidebar-nav-link-hover-icon-color:        $high-emphasis-inverse !default;\n\n// $sidebar-nav-link-active-color:            $high-emphasis-inverse !default;\n// $sidebar-nav-link-active-bg:               rgba($white, .05) !default;\n// $sidebar-nav-link-active-icon-color:       $high-emphasis-inverse !default;\n\n// $sidebar-nav-link-disabled-color:          $disabled-inverse !default;\n// $sidebar-nav-link-disabled-icon-color:     $sidebar-nav-link-icon-color !default;\n\n// $sidebar-nav-icon-width:                   4rem !default;\n// $sidebar-nav-icon-height:                  1.25rem !default;\n// $sidebar-nav-icon-font-size:               $sidebar-nav-icon-height !default;\n\n// $sidebar-nav-group-bg:                     rgba(0, 0, 0, .2) !default;\n// $sidebar-nav-group-transition:             background .15s ease-in-out !default;\n// $sidebar-nav-group-items-transition:       height .15s ease !default;\n// $sidebar-nav-group-toggle-show-color:      $sidebar-nav-link-color !default;\n\n// $sidebar-nav-group-indicator-color:        $medium-emphasis-inverse !default;\n// $sidebar-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// $sidebar-nav-group-indicator-hover-color:  $sidebar-nav-link-hover-color !default;\n// $sidebar-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// $sidebar-nav-group-indicator-transition:   transform .15s !default;\n\n// $sidebar-footer-height:                    auto !default;\n// $sidebar-footer-padding-y:                 .75rem !default;\n// $sidebar-footer-padding-x:                 1rem !default;\n// $sidebar-footer-bg:                        rgba($black, .2) !default;\n// $sidebar-footer-height-transition:         height .15s, padding .15s !default;\n\n// $sidebar-toggler-height:                   3rem !default;\n// $sidebar-toggler-bg:                       rgba($black, .2) !default;\n// $sidebar-toggler-transition:               transform .15s !default;\n\n// $sidebar-toggler-indicator-width:          4rem !default;\n// $sidebar-toggler-indicator-height:         3rem !default;\n// $sidebar-toggler-indicator-color:          $gray-600 !default;\n// $sidebar-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// $sidebar-toggler-hover-bg:                 rgba(0, 0, 0, .3) !default;\n// $sidebar-toggler-indicator-hover-color:    $sidebar-nav-link-hover-color !default;\n// $sidebar-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// scss-docs-end sidebar-variables\n\n// Footer\n// scss-docs-start footer-variables\n// $footer-min-height:    3rem !default;\n// $footer-padding-y:     $spacer / 2 !default;\n// $footer-padding-x:     $spacer !default;\n// $footer-bg:            $gray-100 !default;\n// $footer-color:         $body-color !default;\n// $footer-border-width:  1px !default;\n// $footer-border-color:  $border-color !default;\n// scss-docs-end footer-variables\n\n// Spinners\n// scss-docs-start spinner-variables\n// $spinner-width:           2rem !default;\n// $spinner-height:          $spinner-width !default;\n// $spinner-vertical-align:  -.125em !default;\n// $spinner-border-width:    .25em !default;\n// $spinner-animation-speed: .75s !default;\n\n// $spinner-width-sm:        1rem !default;\n// $spinner-height-sm:       $spinner-width-sm !default;\n// $spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n// Close\n// scss-docs-start close-variables\n// $btn-close-width:            1em !default;\n// $btn-close-height:           $btn-close-width !default;\n// $btn-close-padding-x:        .25em !default;\n// $btn-close-padding-y:        $btn-close-padding-x !default;\n// $btn-close-color:            $high-emphasis !default;\n// $btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n// $btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n// $btn-close-opacity:          .5 !default;\n// $btn-close-hover-opacity:    .75 !default;\n// $btn-close-focus-opacity:    1 !default;\n// $btn-close-disabled-opacity: .25 !default;\n// $btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n// $offcanvas-padding-y:               $modal-inner-padding !default;\n// $offcanvas-padding-x:               $modal-inner-padding !default;\n// $offcanvas-horizontal-width:        400px !default;\n// $offcanvas-vertical-height:         30vh !default;\n// $offcanvas-transition-duration:     .3s !default;\n// $offcanvas-border-color:            $modal-content-border-color !default;\n// $offcanvas-border-width:            $modal-content-border-width !default;\n// $offcanvas-title-line-height:       $modal-title-line-height !default;\n// $offcanvas-bg-color:                $modal-content-bg !default;\n// $offcanvas-color:                   $modal-content-color !default;\n// $offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n// $code-font-size:                    $small-font-size !default;\n// $code-color:                        $pink !default;\n\n// $kbd-padding-y:                     .2rem !default;\n// $kbd-padding-x:                     .4rem !default;\n// $kbd-font-size:                     $code-font-size !default;\n// $kbd-color:                         $high-emphasis-inverse !default;\n// $kbd-bg:                            $gray-900 !default;\n\n// $pre-color:                         unset !default;\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    @include ltr-rtl(\"margin-right\", $list-inline-padding);\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  @include ltr-rtl(\"padding-left\", 0);\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  @include ltr-rtl(\"margin-left\", if($num == 0, 0, percentage($num)));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: var(--#{$prefix}form-text-color, $form-text-color);\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-color, $input-color);\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: var(--#{$prefix}input-bg, $input-bg);\n  background-clip: padding-box;\n  border: $input-border-width solid var(--#{$prefix}input-border-color, $input-border-color);\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: var(--#{$prefix}input-focus-color, $input-focus-color);\n    background-color: var(--#{$prefix}input-focus-bg, $input-focus-bg);\n    border-color: var(--#{$prefix}input-focus-border-color, $input-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: var(--#{$prefix}form-file-button-color, $form-file-button-color);\n    @include gradient-bg(var(--#{$prefix}form-file-button-bg, $form-file-button-bg));\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: var(--#{$prefix}form-file-button-hover-bg, $form-file-button-hover-bg);\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-plaintext-color, $input-plaintext-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  @include ltr-rtl-value-only(\"padding\", $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x, $form-select-padding-y $form-select-padding-x $form-select-padding-y $form-select-indicator-padding);\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: var(--#{$prefix}form-select-color, $form-select-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-select-bg, $form-select-bg);\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid var(--#{$prefix}form-select-border-color, $form-select-border-color);\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: var(--#{$prefix}form-select-focus-border-color, $form-select-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    @include ltr-rtl(\"padding-right\", $form-select-padding-x);\n    background-image: none;\n  }\n\n  &:disabled {\n    color: var(--#{$prefix}form-select-disabled-color, $form-select-disabled-color);\n    background-color: var(--#{$prefix}form-select-disabled-bg, $form-select-disabled-bg);\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 var(--#{$prefix}form-select-color, $form-select-color);\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-sm);\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-lg);\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  @include ltr-rtl(\"padding-left\", $form-check-padding-start);\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", left);\n    @include ltr-rtl(\"margin-left\", $form-check-padding-start * -1);\n  }\n}\n\n.form-check-reverse {\n  @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n  @include ltr-rtl(\"padding-left\", 0);\n  @include ltr-rtl(\"text-align\", right);\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", right);\n    @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  @include ltr-rtl(\"padding-left\", $form-switch-padding-start);\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    @include ltr-rtl(\"margin-left\", $form-switch-padding-start * -1);\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n    @include ltr-rtl(\"padding-left\", 0);\n\n    .form-check-input {\n      @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map-get($map, \"width\");\n  $height: map-get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    @include ltr-rtl(\"padding-left\", $width + .5em);\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      @include ltr-rtl(\"margin-left\", ($width + .5em) * -1);\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  @include ltr-rtl(\"margin-right\", $form-check-inline-margin-end);\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n\n    &::-moz-range-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  @include ltr-rtl(\"padding-right\", $form-select-padding-x + $form-select-indicator-padding);\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    @include ltr-rtl(\"margin-left\", calc(#{$input-border-width} * -1));\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          @include ltr-rtl(\"padding-right\", $form-select-feedback-icon-padding-end);\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      @include ltr-rtl(\"margin-left\", .5em);\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n}\n\n// scss-docs-start btn-variant-loops\n@each $state, $variant in $button-variants {\n  .btn-#{$state} {\n    @include button-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-outline-#{$state} {\n    @include button-outline-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-ghost-#{$state} {\n    @include button-ghost-variant($variant);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant($variant) {\n  $background: map-get($variant, \"bg\");\n  $border-color: map-get($variant, \"border-color\");\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-background: map-get($variant, \"disabled-bg\");\n  $disabled-border-color: map-get($variant, \"disabled-border-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border-color, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border-color};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-shadow: #{$shadow};\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-coreui-popper] {\n    top: 100%;\n    @include ltr-rtl(\"left\", 0);\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --cui-position: start;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", auto);\n        @include ltr-rtl(\"left\", 0);\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --cui-position: end;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", 0);\n        @include ltr-rtl(\"left\", auto);\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-coreui-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", auto);\n    @include ltr-rtl(\"left\", 100%);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", 100%);\n    @include ltr-rtl(\"left\", auto);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-right\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      @include ltr-rtl(\"margin-left\", $spacing);\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        @include ltr-rtl(\"margin-right\", $spacing);\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    @include ltr-rtl(\"margin-left\", calc(#{$btn-border-width} * -1));\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n\n  .dropstart &::before {\n    @include ltr-rtl(\"margin-right\", 0);\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", var(--#{$prefix}navbar-brand-margin-end));\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.3.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}card-spacer-x));\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        @include ltr-rtl(\"margin-left\", 0);\n        @include ltr-rtl(\"border-left\", 0);\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    @include ltr-rtl(\"padding-left\",  var(--#{$prefix}breadcrumb-item-padding-x));\n\n    &::before {\n      @include ltr-rtl(\"float\", left); // Suppress inline spacings and underlining of the separator\n      @include ltr-rtl(\"padding-right\", var(--#{$prefix}breadcrumb-item-padding-x));\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    @include ltr-rtl(\"margin-left\", $pagination-margin-start);\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  @include ltr-rtl(\"padding-right\", $alert-dismissible-padding-r);\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"right\", 0);\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state, $value in $alert-variants {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: #{map-get($value, \"alert-color\")};\n    --#{$prefix}alert-bg: #{map-get($value, \"alert-bg\")};\n    --#{$prefix}alert-border-color: #{map-get($value, \"alert-border\")};\n    --#{$prefix}alert-link-color: #{shade-color(map-get($value, \"alert-color\"), 20%)};\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  @include ltr-rtl(\"padding-left\", 0); // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          @include ltr-rtl(\"border-left-width\", 0);\n\n          &.active {\n            @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}list-group-border-width)));\n            @include ltr-rtl(\"border-left-width\", var(--#{$prefix}list-group-border-width));\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $variant in $list-group-variants {\n  .list-group-item-#{$state} {\n    @include list-group-item-variant($state, $variant);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@include deprecate(\"`list-group-item-variant()`\", \"v4.3.0\", \"v6.0.0\");\n\n// List Groups\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $variant) {\n  $background: map-get($variant, \"bg\");\n  $background-hover: map-get($variant, \"bg-hover\");\n  $color: contrast-ratio-correction(map-get($variant, \"color\"), map-get($variant, \"bg\"), abs($alert-color-scale), $state);\n\n  --#{$prefix}list-group-color: #{$color};\n  --#{$prefix}list-group-bg: #{$background};\n  --#{$prefix}list-group-hover-bg: #{$background-hover};\n  --#{$prefix}list-group-action-hover-color: #{$color};\n  --#{$prefix}list-group-action-active-color: #{$white};\n  --#{$prefix}list-group-action-active-bg: #{$color};\n  --#{$prefix}list-group-action-active-border-color: #{$color};\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n.btn-close-white {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}toast-padding-x)));\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}toast-padding-x));\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  @include ltr-rtl(\"left\", 0);\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    @include ltr-rtl-value-only(\"margin\", calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto, calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-coreui-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-coreui-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg, $carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color, $carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-dark-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-dark-caption-color};\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-coreui-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        @include ltr-rtl(\"left\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-right\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        @include ltr-rtl(\"right\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-left\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}offcanvas-padding-x)));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n",".avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  @include border-radius(50em);\n  @include transition($avatar-transition);\n  @include avatar($avatar-width);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(50em);\n}\n\n.avatar-status {\n  position: absolute;\n  @include ltr-rtl(\"right\", 0);\n  bottom: 0;\n  display: block;\n  border: 1px solid $white;\n  @include border-radius(50em);\n}\n\n@each $width, $value in $avatar-widths {\n  .avatar-#{$width} {\n    @include avatar($value);\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    @include ltr-rtl(\"margin-right\", - ($avatar-width * .4));\n\n    &:hover {\n      @include ltr-rtl(\"margin-right\", 0);\n    }\n  }\n\n  @each $width, $value in $avatar-widths {\n    .avatar-#{$width} {\n      @include ltr-rtl(\"margin-right\", - ($value * .4));\n    }\n  }\n}\n","@mixin avatar($width) {\n  width: $width;\n  height: $width;\n  font-size: $width * .4;\n\n  .avatar-status {\n    width: divide($width, 3.75);\n    height: divide($width, 3.75);\n  }\n}\n",".callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  @include ltr-rtl(\"border-left-width\", var(--#{$prefix}callout-border-left-width));\n  @include ltr-rtl(\"border-left-color\", var(--#{$prefix}callout-border-left-color));\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n",".footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-fixed {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n}\n",".header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-min-height: #{$header-min-height};\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  --#{$prefix}subheader-min-height: #{$subheader-min-height};\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: var(--#{$prefix}header-min-height);\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  .container:first-child,\n  .container-fluid:first-child {\n    min-height: calc(var(--#{$prefix}header-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  .container:nth-child(n+2),\n  .container-fluid:nth-child(n+2) {\n    min-height: calc(var(--#{$prefix}subheader-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-fixed - 1;\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(var(--#{$prefix}header-padding-x) * -1); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", $header-brand-margin-end);\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n",".icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n",".sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-border-width: #{$sidebar-border-width};\n  --#{$prefix}sidebar-border-color: #{$sidebar-border-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-height: #{$sidebar-brand-height};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  --#{$prefix}sidebar-header-height: #{$sidebar-header-height};\n  --#{$prefix}sidebar-header-bg: #{$sidebar-header-bg};\n  --#{$prefix}sidebar-header-padding-x: #{$sidebar-header-padding-x};\n  --#{$prefix}sidebar-header-padding-y: #{$sidebar-header-padding-y};\n  --#{$prefix}sidebar-footer-bg: #{$sidebar-footer-bg};\n  --#{$prefix}sidebar-footer-height: #{$sidebar-footer-height};\n  --#{$prefix}sidebar-footer-padding-x: #{$sidebar-footer-padding-x};\n  --#{$prefix}sidebar-footer-padding-y: #{$sidebar-footer-padding-y};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  --#{$prefix}sidebar-toggler-indicator: #{escape-svg($sidebar-toggler-indicator-icon)};\n  --#{$prefix}sidebar-toggler-indicator-width: #{$sidebar-toggler-indicator-width};\n  --#{$prefix}sidebar-toggler-indicator-height: #{$sidebar-toggler-indicator-height};\n  --#{$prefix}sidebar-toggler-hover-bg: #{$sidebar-toggler-hover-bg};\n  --#{$prefix}sidebar-toggler-indicator-hover: #{escape-svg($sidebar-toggler-indicator-hover-icon)};\n\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border: #{$sidebar-nav-link-border-width} solid var(--#{$prefix}sidebar-nav-link-border-color);\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n  --#{$prefix}sidebar-nav-icon-width: #{$sidebar-nav-icon-width};\n  --#{$prefix}sidebar-nav-icon-height: #{$sidebar-nav-icon-height};\n  --#{$prefix}sidebar-nav-icon-font-size: #{$sidebar-nav-icon-font-size};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  // $sidebar-width is the width of the columns\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  @include ltr-rtl(\"border-right\", var(--#{$prefix}sidebar-border-width) solid var(--#{$prefix}sidebar-border-color));\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end){\n    @include ltr-rtl(\"margin-left\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n    }\n  }\n\n  &.sidebar-end {\n    order: 99;\n    @include ltr-rtl(\"margin-right\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n    }\n  }\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  @each $width, $value in $sidebar-widths {\n    &.sidebar-#{$width} {\n      --#{$prefix}sidebar-width: #{$value};\n      @include media-breakpoint-up($mobile-breakpoint) {\n        &:not(.sidebar-end):not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-start: #{$value};\n          }\n        }\n        &.sidebar-end:not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-end: #{$value};\n          }\n        }\n      }\n    }\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &.hide {\n      &:not(.sidebar-end){\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-start: 0;\n        }\n      }\n      &.sidebar-end {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-end: 0;\n        }\n      }\n    }\n  }\n\n  &.sidebar-fixed {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: $zindex-fixed;\n\n      &:not(.sidebar-end) {\n        @include ltr-rtl(\"left\", 0);\n      }\n\n      &.sidebar-end {\n        @include ltr-rtl(\"right\", 0);\n      }\n    }\n  }\n\n  &.sidebar-sticky {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: sticky;\n      top: 0;\n      height: 100vh;\n    }\n  }\n\n  &.sidebar-overlaid {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 2;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0;\n      }\n    }\n\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0;\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 1;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n  }\n}\n\n.sidebar-close {\n  position: absolute;\n  top: 0;\n  @include ltr-rtl(\"right\", 0);\n  width: var(--#{$prefix}sidebar-width);\n  height: var(--#{$prefix}sidebar-header-height);\n  color: var(--#{$prefix}sidebar-color);\n  background: transparent;\n  border: 0;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.sidebar-brand {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-brand-height);\n  align-items: center;\n  justify-content: center;\n  color: var(--#{$prefix}sidebar-brand-color);\n  background: var(--#{$prefix}sidebar-brand-bg);\n\n  .sidebar-brand-narrow {\n    display: none;\n  }\n}\n\n.sidebar-header {\n  flex: 0 0 var(--#{$prefix}sidebar-header-height);\n  padding: var(--#{$prefix}sidebar-header-padding-y) var(--#{$prefix}sidebar-header-padding-x);\n  text-align: center;\n  background: var(--#{$prefix}sidebar-header-bg);\n  @include transition($sidebar-header-height-transition);\n\n  .nav-link {\n    display: flex;\n    align-items: center;\n    min-height: var(--#{$prefix}sidebar-header-height);\n  }\n}\n\n.sidebar-footer {\n  flex: 0 0 var(--#{$prefix}sidebar-footer-height);\n  padding: var(--#{$prefix}sidebar-footer-padding-y) var(--#{$prefix}sidebar-footer-padding-x);\n  background: var(--#{$prefix}sidebar-footer-bg);\n  @include transition($sidebar-footer-height-transition);\n}\n\n.sidebar-toggler {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-toggler-height);\n  justify-content: flex-end;\n  width: inherit;\n  padding: 0;\n  cursor: pointer;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n\n  &::before {\n    display: block;\n    width: var(--#{$prefix}sidebar-toggler-indicator-width);\n    height: var(--#{$prefix}sidebar-toggler-indicator-height);\n    content: \"\";\n    background-image: var(--#{$prefix}sidebar-toggler-indicator);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: calc(var(--#{$prefix}sidebar-toggler-indicator-height) * .25); // stylelint-disable-line function-disallowed-list\n    @include transition($sidebar-toggler-transition);\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: var(--#{$prefix}sidebar-toggler-hover-bg);\n    &::before {\n      background-image: var(--#{$prefix}sidebar-toggler-indicator-hover);\n    }\n  }\n\n  .sidebar-end & {\n    justify-content: flex-start;\n    &::before {\n      transform: rotate(-180deg);\n    }\n  }\n}\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n","// Sidebar navigation\n\n.sidebar-nav {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n        }\n\n        &.nav-dropdown-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        &.nav-group-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    flex: 0 0 var(--#{$prefix}sidebar-nav-icon-width);\n    height: var(--#{$prefix}sidebar-nav-icon-height);\n    font-size: var(--#{$prefix}sidebar-nav-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n\n    &:first-child {\n      @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-link-padding-x) * -1));\n    }\n  }\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    position: relative;\n    @include transition($sidebar-nav-group-transition);\n\n    .nav-group-items {\n      padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n      overflow: hidden;\n      @include transition($sidebar-nav-group-items-transition);\n    }\n\n    &:not(.show) .nav-group-items {\n      display: none;\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle::after {\n        transform: rotate(180deg);\n      }\n\n      + .show {\n        margin-top: 1px;\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      @include ltr-rtl(\"margin-left\", auto);\n      content: \"\";\n      background-image: var(--#{$prefix}sidebar-nav-group-indicator);\n      background-repeat: no-repeat;\n      background-position: center;\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n  }\n\n  .nav-group-items {\n    padding: 0;\n    list-style: none;\n\n    .nav-link {\n      @include ltr-rtl(\"padding-left\", var(--#{$prefix}sidebar-nav-icon-width));\n\n      .nav-icon {\n        @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-icon-width) * -1));\n      }\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      padding-top: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n      padding-bottom: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n    }\n  }\n}\n","%sidebar-narrow {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    z-index: $zindex-fixed + 1;\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    &.sidebar-fixed {\n      z-index: $zindex-fixed + 1;\n      width: var(--#{$prefix}sidebar-narrow-width);\n    }\n\n    .sidebar-brand-full {\n      display: none;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n    }\n\n    .d-narrow-none,\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .nav-group.show .nav-group-items,\n    .sidebar-footer,\n    .sidebar-form,\n    .sidebar-header {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0;\n      margin: 0;\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .sidebar-toggler {\n      position: fixed;\n      bottom: 0;\n\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow {\n  @extend %sidebar-narrow;\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  position: fixed;\n  z-index: $zindex-fixed + 1;\n\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n\n  &:not(:hover) {\n    @extend %sidebar-narrow;\n  }\n\n  &:hover {\n    .sidebar-toggler {\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n// Responsive behavior\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-down($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .sidebar:not(.show).sidebar-self-hiding#{$infix} {\n      &.sidebar-narrow,\n      &.sidebar-narrow-unfoldable {\n        &:not(.sidebar-end) {\n          @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n        &.sidebar-end {\n          @include ltr-rtl(\"margin-right\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n      }\n    }\n  }\n}\n",".subheader {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: $subheader-min-height;\n  padding: $subheader-padding-y $subheader-padding-x;\n  background: var(--#{$prefix}subheader-bg, $subheader-bg);\n  border-bottom: var(--#{$prefix}subheader-border-width, $subheader-border-width) solid var(--#{$prefix}subheader-border-color, $subheader-border-color);\n}\n\n.subheader-sticky {\n  position: sticky;\n  top: 0;\n  z-index: $zindex-fixed - 1;\n}\n\n// Subheader nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.subheader-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: $subheader-nav-link-padding-x;\n    padding-left: $subheader-nav-link-padding-x;\n    color: var(--#{$prefix}subheader-color, $subheader-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-hover-color, $subheader-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}subheader-disabled-color, $subheader-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n// Subheader text\n//\n//\n\n.subheader-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}subheader-color, $subheader-color);\n\n  a {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n    }\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    // Generate RTL version\n    $generate-rtl: if(map-has-key($utility, rtl), map-get($utility, rtl), false);\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            @if $generate-rtl == true {\n              @include ltr-rtl($property, $value, null, null, if($enable-important-utilities, !important, null));\n            } @else {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*!\n * CoreUI Plugins - Chart.js for CoreUI 3\n * @version v3.1.2\n * @link https://coreui.io\n * Copyright (c) 2021 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)\n */\n\n\n@import \"@coreui/coreui/scss/functions\";\n@import \"@coreui/coreui/scss/variables\";\n@import \"@coreui/coreui/scss/mixins\";\n@import \"tooltips\";\n","// Custom tooltips\n\n.chartjs-tooltip {\n  position: absolute;\n  z-index: $zindex-sticky + 1;\n  padding: ($spacer * .25) ($spacer * .5);\n  color: #fff;\n  pointer-events: none;\n  background: rgba(0, 0, 0, .7);\n  opacity: 0;\n  @include transition(all .15s ease);\n  transform: translate(-50%, 0);\n  @include border-radius($border-radius);\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: ($spacer * .5);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-bold;\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: $font-size-sm;\n  white-space: nowrap;\n}\n",".wrapper {\n  width: 100%;\n  @include ltr-rtl(\"padding-left\", var(--cui-sidebar-occupy-start, 0));\n  will-change: auto;\n  @include transition(padding .15s);\n}\n",".example {\n  &:not(:first-child) {\n    margin-top: 1.5rem;\n  }\n\n  .tab-content {\n    background-color: $light-50 !important;\n\n    @at-root .dark-theme & {\n      background-color: rgba(255, 255, 255, .1) !important;\n    }\n  }\n\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    font-size: .875rem !important;\n  }\n\n  :not(pre) > code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    background: transparent;\n  }\n\n  & + p {\n    margin-top: 1.5rem\n  }\n\n  // Components examples\n  .preview,\n  .preview .col {\n    + p {\n      margin-top: 2rem;\n    }\n\n    > .form-control {\n      + .form-control {\n        margin-top: .5rem;\n      }\n    }\n\n    > .nav + .nav,\n    > .alert + .alert,\n    > .navbar + .navbar,\n    > .progress + .progress {\n      margin-top: 1rem;\n    }\n\n    > .dropdown-menu {\n      position: static;\n      display: block;\n    }\n\n    > :last-child {\n      margin-bottom: 0;\n    }\n\n    // Images\n    > svg + svg,\n    > img + img {\n      margin-left: .5rem;\n    }\n\n    // Buttons\n    > .btn,\n    > .btn-group {\n      margin: .25rem .125rem;\n    }\n    > .btn-toolbar + .btn-toolbar {\n      margin-top: .5rem;\n    }\n\n    // List groups\n    > .list-group {\n      max-width: 400px;\n    }\n\n    > [class*=\"list-group-horizontal\"] {\n      max-width: 100%;\n    }\n\n    // Navbars\n    .fixed-top,\n    .sticky-top {\n      position: static;\n      margin: -1rem -1rem 1rem;\n    }\n\n    .fixed-bottom {\n      position: static;\n      margin: 1rem -1rem -1rem;\n    }\n\n    @include media-breakpoint-up(sm) {\n      .fixed-top,\n      .sticky-top {\n        margin: -1.5rem -1.5rem 1rem;\n      }\n      .fixed-bottom {\n        margin: 1rem -1.5rem -1.5rem;\n      }\n    }\n\n    // Pagination\n    .pagination {\n      margin-top: .5rem;\n      margin-bottom: .5rem;\n    }\n  }\n}\n",".meddra-preview {\n  .preview-summary {\n    .summary-card {\n      text-align: center;\n      padding: 20px;\n      border-radius: 8px;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      \n      h3 {\n        margin: 0;\n        font-size: 2rem;\n        font-weight: bold;\n        color: #333;\n      }\n      \n      p {\n        margin: 8px 0 0 0;\n        color: #666;\n        font-size: 0.9rem;\n      }\n    }\n  }\n\n  .impact-level {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    \n    &.low {\n      background-color: #e3f2fd;\n      color: #1976d2;\n    }\n    \n    &.medium {\n      background-color: #fff3e0;\n      color: #f57c00;\n    }\n    \n    &.high {\n      background-color: #ffebee;\n      color: #d32f2f;\n    }\n    \n    &.none {\n      background-color: #e8f5e8;\n      color: #388e3c;\n    }\n  }\n\n  .change-table {\n    .rs-table {\n      .rs-table-row {\n        &:hover {\n          background-color: #f5f5f5;\n        }\n      }\n    }\n  }\n\n  .action-buttons {\n    margin-top: 24px;\n    \n    .rs-btn {\n      margin-right: 8px;\n    }\n  }\n\n  .warning-alert {\n    margin-bottom: 16px;\n    \n    .rs-alert-icon {\n      margin-right: 8px;\n    }\n  }\n\n  .case-types-selection {\n    margin: 16px 0;\n    \n    .rs-checkbox-group {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 12px;\n    }\n  }\n\n  .detailed-changes-modal {\n    .rs-modal-body {\n      max-height: 60vh;\n      overflow-y: auto;\n    }\n  }\n\n  .form-label {\n    font-weight: 600;\n    margin-bottom: 8px;\n    display: block;\n    color: #333;\n  }\n\n  .text-muted {\n    color: #666;\n    font-size: 0.9rem;\n  }\n\n  .card-header {\n    h4 {\n      margin: 0 0 8px 0;\n      color: #333;\n    }\n  }\n} ","// RTL (Right-to-Left) Support for Arabic\n\nbody.rtl {\n  direction: rtl;\n  text-align: right;\n\n  // CoreUI Components RTL Support\n  .sidebar {\n    right: 0;\n    left: auto;\n  }\n\n  .wrapper {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  // Header adjustments\n  .header {\n    .ms-3 {\n      margin-left: 0 !important;\n      margin-right: 1rem !important;\n    }\n\n    .me-auto {\n      margin-right: 0 !important;\n      margin-left: auto !important;\n    }\n  }\n\n  // Form elements\n  .form-label {\n    text-align: right;\n  }\n\n  .form-control,\n  .form-select {\n    text-align: right;\n  }\n\n  // Dropdowns\n  .dropdown-menu {\n    text-align: right;\n  }\n\n  // Buttons\n  .btn-group {\n    direction: rtl;\n  }\n\n  // Tables\n  table {\n    direction: rtl;\n    text-align: right;\n  }\n\n  // Modals\n  .modal-header {\n    .btn-close {\n      margin-left: 0;\n      margin-right: auto;\n    }\n  }\n\n  // Navigation\n  .nav {\n    direction: rtl;\n  }\n\n  // Breadcrumb\n  .breadcrumb {\n    direction: rtl;\n  }\n\n  // Cards\n  .card {\n    text-align: right;\n  }\n\n  // Lists\n  .list-group {\n    text-align: right;\n  }\n\n  // Badges and labels\n  .badge,\n  .label {\n    direction: rtl;\n  }\n\n  // Icons alignment\n  .icon {\n    margin-left: 0.5rem;\n    margin-right: 0;\n  }\n\n  // Input groups\n  .input-group {\n    direction: rtl;\n\n    .input-group-text {\n      border-left: 0;\n      border-right: 1px solid #ced4da;\n    }\n\n    .form-control {\n      border-right: 0;\n      border-left: 1px solid #ced4da;\n    }\n  }\n\n  // Flex utilities\n  .flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n\n  // Text alignment\n  .text-start {\n    text-align: right !important;\n  }\n\n  .text-end {\n    text-align: left !important;\n  }\n\n  // Margin and padding utilities\n  .ms-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .me-auto {\n    margin-left: auto !important;\n    margin-right: 0 !important;\n  }\n\n  // Float utilities\n  .float-start {\n    float: right !important;\n  }\n\n  .float-end {\n    float: left !important;\n  }\n\n  // Spacing utilities\n  @for $i from 1 through 5 {\n    .ms-#{$i} {\n      margin-right: #{$i * 0.25}rem !important;\n      margin-left: 0 !important;\n    }\n\n    .me-#{$i} {\n      margin-left: #{$i * 0.25}rem !important;\n      margin-right: 0 !important;\n    }\n\n    .ps-#{$i} {\n      padding-right: #{$i * 0.25}rem !important;\n      padding-left: 0 !important;\n    }\n\n    .pe-#{$i} {\n      padding-left: #{$i * 0.25}rem !important;\n      padding-right: 0 !important;\n    }\n  }\n}\n\n// LTR (Left-to-Right) - Default\nbody.ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n","// =============================================================================\n// PREMIUM UI THEME LAYER\n// -----------------------------------------------------------------------------\n// Global, class-based polish for rsuite + CoreUI primitives shared across\n// every page: data tables, pagination, buttons, badges/status pills, inputs,\n// icon buttons, and lightweight page/element transitions.\n//\n// Pure presentation — no markup, route, or data changes. Built entirely on\n// tokens from _tokens.scss so the palette / spacing / radius stay centralized.\n// =============================================================================\n@import '../variables';\n\n// -----------------------------------------------------------------------------\n// Data tables (rsuite Table)\n// -----------------------------------------------------------------------------\n.rs-table {\n  --rs-table-border-color: #{$color-border};\n  font-size: $font-size-body;\n\n  .rs-table-row-header {\n    background-color: $color-canvas-alt;\n\n    .rs-table-cell {\n      background-color: $color-canvas-alt;\n      font-weight: $font-weight-semibold;\n      color: $color-text-secondary;\n      letter-spacing: 0.02em;\n    }\n  }\n\n  .rs-table-cell {\n    border-bottom-color: $color-border;\n  }\n\n  .rs-table-cell-content {\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n.rs-table-hover .rs-table-row:not(.rs-table-row-header):hover .rs-table-cell,\n.rs-table-hover .rs-table-row:not(.rs-table-row-header):hover .rs-table-cell-group {\n  background-color: $color-primary-tint-2 !important;\n  transition: background-color $transition-fast;\n}\n\n// Comfortable row height (48-56px)\n.rs-table-row:not(.rs-table-row-header) {\n  min-height: 48px;\n}\n\n// Pagination controls\n.rs-pagination {\n  .rs-pagination-btn {\n    border-radius: $radius-sm;\n    transition: background-color $transition-fast, color $transition-fast, border-color $transition-fast;\n\n    &:hover {\n      background-color: $color-primary-tint;\n      color: $color-primary;\n    }\n  }\n}\n\n// Icon buttons — hover circle\n.rs-btn-icon:not(.rs-btn-icon-placement-left):not(.rs-btn-icon-placement-right) {\n  border-radius: $radius-pill;\n  transition: background-color $transition-fast, color $transition-fast;\n\n  &:hover {\n    background-color: $color-primary-tint;\n    color: $color-primary;\n  }\n}\n\n// -----------------------------------------------------------------------------\n// Buttons\n// -----------------------------------------------------------------------------\n// `.add_new_btn` is excluded: several pages (group/patient/product/staticForm)\n// deliberately paint it white-on-purple so a small \"+\" control reads clearly\n// against a solid purple section header — a background-image gradient here\n// would paint over that white fill and make the button disappear.\n.rs-btn-primary:not(.add_new_btn),\n.submit_btn,\n.add-button,\n.base_button {\n  background-image: linear-gradient(180deg, $color-primary-strong 0%, $color-primary 100%);\n  border-color: $color-primary !important;\n  box-shadow: $shadow-sm;\n  transition: box-shadow $transition-fast, transform $transition-fast, background-color $transition-fast;\n\n  &:hover:not(:disabled) {\n    box-shadow: $shadow-md;\n    background-image: linear-gradient(180deg, $color-primary-light 0%, $color-primary-strong 100%);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(1px);\n  }\n\n  &:disabled,\n  &.disabled {\n    background-image: none;\n    background-color: $button-disabled-color !important;\n    border-color: $button-disabled-color !important;\n    color: $color-text-muted !important;\n    box-shadow: none;\n    cursor: not-allowed;\n  }\n}\n\n.rs-btn-ghost,\n.rs-btn-subtle,\n.close_btn {\n  transition: background-color $transition-fast, color $transition-fast, border-color $transition-fast;\n}\n\n// -----------------------------------------------------------------------------\n// Badges / status pills (Active, Inactive, Processing, ...)\n// -----------------------------------------------------------------------------\n.badge,\n.rs-badge-content,\n.status-badge {\n  border-radius: $radius-pill;\n  font-weight: $font-weight-semibold;\n  letter-spacing: 0.02em;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  font-size: $font-size-sm;\n  background-color: $color-neutral-tint;\n  color: $color-neutral-text;\n\n  &.processing {\n    background-color: $color-warning-tint;\n    color: $color-warning;\n  }\n\n  &.active,\n  &.success,\n  &.completed { \n    background-color: $color-success-tint;\n    color: $color-success;\n  }\n\n  &.inactive,\n  &.failed,\n  &.error {\n    background-color: $color-danger-tint;\n    color: $color-danger;\n  }\n}\n\n// -----------------------------------------------------------------------------\n// Forms / inputs\n// -----------------------------------------------------------------------------\n// Field labels — the \"form-body-field-label\" className is applied by every\n// case form (Form.ControlLabel), and rsuite's own control-label class covers\n// the rest. Section-label treatment: small, medium weight, muted, tracked.\n.form-body-field-label,\n.rs-form-control-label {\n  font-size: $font-size-section-label;\n  font-weight: $font-weight-medium;\n  color: $color-text-secondary;\n  letter-spacing: $letter-spacing-label;\n  margin-bottom: $space-1;\n  display: inline-block;\n}\n\n.rs-form-group {\n  margin-bottom: $space-4;\n}\n\n// Consistent control height/shape across every field type\n.rs-input,\n.rs-input-number,\n.rs-textarea,\n.rs-picker-toggle.rs-btn,\n.rs-picker-toggle.rs-picker-toggle-md,\n.form-control {\n  border-radius: 0 !important;\n  border-color: $color-border-strong !important;\n  transition: border-color $transition-fast, box-shadow $transition-fast, background-color $transition-fast;\n}\n\n.rs-input,\n.form-control {\n  padding: 8px 12px;\n  font-size: $font-size-body;\n}\n\n// .rs-picker-toggle.rs-btn {\n//   padding-top: 8px !important;\n//   padding-bottom: 8px !important;\n// }\n\n.rs-input::placeholder,\n.rs-picker-toggle-placeholder {\n  color: $color-text-muted !important;\n}\n\n// Hover — subtle darkening before focus\n// .rs-input:hover,\n.rs-picker-date:focus,\n.rs-input-number:hover,\n.rs-textarea:hover,\n.rs-picker:not(.rs-picker-disabled):hover .rs-picker-toggle,\n.form-control:hover {\n  // border:1px solid $color-border  !important;\n  border-color: $color-primary-light !important;\n}\n// dropdown hover hiding border\n// .rs-picker-default .rs-picker-toggle {\n//   border:none !important;\n// }\n// Focus — 2px semi-transparent brand ring\n// .rs-input:focus,\n.rs-picker-input-group,\n .rs-input-group,\n  .rs-input-group-sm ,\n  .rs-input-group-inside\n  {\n border-color: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n  }\n.rs-picker-date:focus,\n.rs-input-number:focus-within,\n.rs-textarea:focus,\n.rs-picker-focused .rs-picker-toggle,\n.form-control:focus {\n  border-color: $color-primary-light !important;\n  box-shadow: $shadow-focus-ring !important;\n  outline: none !important;\n}\n\n// Disabled — muted, not-allowed, no false affordances\n// .rs-input:disabled,\n.rs-textarea:disabled,\n.rs-picker-disabled .rs-picker-toggle,\n.form-control:disabled {\n  border:1px solid $color-border  !important;\n  background-color: $color-canvas-alt !important;\n  // border-color: $color-border !important;\n  color: $color-text-muted !important;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n// Dropdown / picker menus — soft elevation, tinted selection\n.rs-picker-menu {\n  border-radius: 0 !important;\n  box-shadow: $shadow-md;\n  overflow: hidden;\n}\n\n.rs-picker-select-menu-item.rs-picker-select-menu-item-active,\n.rs-picker-select-menu-item.rs-picker-select-menu-item-focus,\n.rs-picker-select-menu-item:hover {\n  background-color: $color-primary-tint-2 !important;\n  color: $color-primary !important;\n}\n\n// Date/time picker calendar\n.rs-calendar-table-cell-content:hover {\n  border-radius: $radius-sm;\n}\n\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {\n  border-radius: $radius-sm;\n  font-weight: $font-weight-semibold;\n}\n\n// Checkbox / radio — smooth check-in, matching radius\n.rs-checkbox-checker,\n.rs-radio-checker {\n  transition: background-color $transition-fast, border-color $transition-fast, box-shadow $transition-fast;\n}\n\n.rs-checkbox-inner {\n  border-radius: $radius-sm !important;\n}\n\n.rs-checkbox:hover .rs-checkbox-inner::before,\n.rs-radio:hover .rs-radio-inner::before {\n  border-color: $color-primary-light !important;\n}\n\n// Input groups (addons)\n.rs-input-group {\n  border-radius: 0 !important;\n  border-color: $color-border-strong !important;\n  transition: border-color $transition-fast, box-shadow $transition-fast;\n\n  &.rs-input-group-focus {\n    border-color: $color-primary-light !important;\n    box-shadow: $shadow-focus-ring !important;\n  }\n\n  .rs-input-group-addon {\n    background-color: $color-canvas-alt;\n    color: $color-text-secondary;\n  }\n}\n\n// Phone number field (react-international-phone) — a third-party widget with\n// its own CSS, used across case forms/org settings/profile/user admin. This\n// is a fallback baseline for any usage that has no page-specific override; a\n// handful of pages (group.scss, user.scss, senderDetails.scss, patient.scss,\n// profile.scss) size this field to their own layout and already carry a\n// matching, updated version of this same treatment.\n.react-international-phone-input-container {\n  .react-international-phone-country-selector-button {\n    height: 36px;\n    border: 1px solid $color-border-strong;\n    border-right: none;\n    border-radius: 0px;\n  }\n\n  .react-international-phone-input {\n    height: 36px;\n    border: 1px solid $color-border-strong;\n    border-radius: 0 $radius-sm $radius-sm 0;\n    transition: border-color $transition-fast, box-shadow $transition-fast;\n  }\n\n  &:hover,\n  &:focus-within {\n    box-shadow: $shadow-focus-ring;\n\n    .react-international-phone-input,\n    .react-international-phone-country-selector-button {\n      border-color: $color-primary-light;\n    }\n  }\n}\n\n// -----------------------------------------------------------------------------\n// Cards — soft lift on hover (generic hook; company/product cards refine further)\n// -----------------------------------------------------------------------------\n.card,\n.rs-panel {\n  transition: box-shadow $transition-base, transform $transition-base;\n}\n\n// -----------------------------------------------------------------------------\n// Motion — tasteful, non-blocking micro-interactions\n// -----------------------------------------------------------------------------\n@keyframes thrana-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Targets the routed page's root node (re-mounted on navigation by\n// react-router), so each page transition gets a subtle fade without\n// re-triggering on ordinary in-page re-renders/state updates.\n.body.flex-grow-1 .container-fluid > * {\n  animation: thrana-fade-in 220ms ease both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .body.flex-grow-1 .container-fluid > * {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
